/**
 * 该文件为自动生成，请不要修改、如果该文件中的方法与类型不满足业务要求，请另起文件编写您的代码
 * 该代码生成时间：2024-03-18 16:19:53.163
 **/
import {
  PageParam,
  BaseEntity,
  HallResult,
  Page
} from '@/api/interface/hallFramework'
import { http } from '@/utils/http/index'
/** 以下是生成的VO对象 **/
/** 门诊检验申请项目 VO **/
export interface HopsLisApplyItemVO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 门诊检验申请单id
   **/
  hopsApplyId? : string;

  /**
   * lis检验申请单id
   * lis检验申请单id不允许为空
   **/
  lisApplyId : string;

  /**
   * lis检验申请单项目id
   * lis检验申请单项目id不允许为空
   **/
  lisApplyItemId : string;

  /**
   * 检验医嘱id
   **/
  orderId? : string;

  /**
   * 检验项目id;lis系统中的项目id
   **/
  lisItemId? : string;

  /**
   * 检验项目编码;lis系统中的项目编码
   **/
  lisItemCode? : string;

  /**
   * 检验项目名称;lis系统中的项目名称
   **/
  lisItemName? : string;

  /**
   * 检验次数序号;lis系统中记录的同一个医嘱同一个项目的执行次数序号
   **/
  lisTimeNo? : number;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   * 采样方式;字典：LIS_COLLECT_METHOD
   **/
  collectMethod? : string;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 执行人工号
   **/
  exeUserAccount? : string;

  /**
   * 执行时间
   **/
  exeTime? : string;

  /**
   * 检验人id
   **/
  checkUserIs? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 审核科室id
   **/
  auditDeptId? : string;

  /**
   * 审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 审核医生id
   **/
  auditUserId? : string;

  /**
   * 审核医生名称
   **/
  auditUserName? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 申请单信息
   **/
  apply? : HopsLisApplyDTO;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

}

/**  **/
export interface PacsReportDetailsVO  {
  /**
   *    **/
  id? : string;

  /**
   * 检查申请id
   * 检查申请id不允许为空
   **/
  applyId : string;

  /**
   * 检验申请项目id
   * 检验申请项目id不允许为空
   **/
  applyItemId : string;

  /**
   * 模板id
   * 模板id不允许为空
   **/
  templateId : string;

  /**
   * 报告签名;MD5(apply_item_id+content)
   **/
  reportSign? : string;

  /**
   * 报告内容
   **/
  content? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 模板名称
   **/
  templateName? : string;

  /**
   * 医学影像taskId
   **/
  medicalImageTaskId? : string;

  /**
   * 医学影像url
   **/
  medicalImageUrl? : string;

  /**
   * 医学影像文件名称
   **/
  medicalImageFileName? : string;

}

/** 门诊检查申请分页查询条件 **/
export interface HopsPacsApplyPageParam extends PageParam{
  /**
   * 检查申请单id;pacs系统返回的id
   **/
  pacsApplyId? : string;

  /**
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号
   **/
  registerId? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 患者名称
   **/
  name? : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   **/
  applyDeptId? : string;

  /**
   * 申请科室名称
   **/
  applyDeptName? : string;

  /**
   * 申请医生id
   **/
  applyDoctorId? : string;

  /**
   * 申请医生名称
   **/
  applyDoctorName? : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/**  **/
export interface PacsApplyAndItemDetailVO  {
  /**
   *    **/
  id? : string;

  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 检查项目id
   **/
  itemId? : string;

  /**
   * 检查项目编码
   **/
  itemCode? : string;

  /**
   * 检查项目名称
   **/
  itemName? : string;

  /**
   * 次数;一个医嘱执行多次时，保存多条记录并且从1开始递增次数
   **/
  timeNo? : number;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 报告审核科室id
   **/
  auditDeptId? : string;

  /**
   * 报告审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 报告审核医生id
   **/
  auditUserId? : string;

  /**
   * 报告审核医生名称
   **/
  auditUserName? : string;

  /**
   * 报告审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 执行人工号
   **/
  exeUserAccount? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 申请渠道;1：门诊，2：住院，3：体检.字典：LIS_APPLY_CHANNEL
   * 申请渠道;1：门诊，2：住院，3：体检.字典：LIS_APPLY_CHANNEL不允许为空
   **/
  applyChannel : string;

  /**
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号不允许为空
   **/
  busiId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 患者名称
   * 患者名称不允许为空
   **/
  name : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   * 申请科室ID;申请科室id不允许为空
   **/
  applyDeptId : string;

  /**
   * 申请科室名称
   * 申请科室名称不允许为空
   **/
  applyDeptName : string;

  /**
   * 申请医生id
   * 申请医生id不允许为空
   **/
  applyDoctorId : string;

  /**
   * 申请医生名称
   * 申请医生名称不允许为空
   **/
  applyDoctorName : string;

  /**
   * 申请医生工号
   * 申请医生工号不允许为空
   **/
  applyDoctorAccount : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 头像url
   **/
  headImageUrl? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/** 检验项目 **/
export interface TaLisBaseItem extends BaseEntity{
  /**
   * 项目编码
   * 项目编码不允许为空
   **/
  code : string;

  /**
   * 项目名称
   * 项目名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   * 采样方式;字典：LIS_COLLECT_METHOD
   **/
  collectMethod? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 窗口配置 VO **/
export interface BaseWindowVO  {
  /**
   * 窗口id
   **/
  id? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 药房id;关联药房配置
   **/
  dispensaryId? : string;

  /**
   * 药房名称
   **/
  dispensaryName? : string;

  /**
   * 是否开启;0：开启 ,1：关闭
   **/
  invalid? : number;

}

/** 职务 **/
export interface TaAuthDuty extends BaseEntity{
  /**
   * 组织机构id;0表示公共职务
   **/
  orgId? : string;

  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 门诊病历字段数据 **/
export interface TaHopsMrecordField extends BaseEntity{
  /**
   * 病历id
   * 病历id不允许为空
   **/
  mrecordId : string;

  /**
   * 字段id;关联模板字段
   * 字段id;关联模板字段不允许为空
   **/
  fieldId : string;

  /**
   * 字段编码
   * 字段编码不允许为空
   **/
  code : string;

  /**
   * 字段名称
   * 字段名称不允许为空
   **/
  name : string;

  /**
   * 字段值
   **/
  dataValue? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * JsonValue
   **/
  jsonValue? : string;

}

/** 门诊检查申请 DTO **/
export interface HopsPacsApplyDTO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 检查申请单id;pacs系统返回的id
   **/
  pacsApplyId? : string;

  /**
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号不允许为空
   **/
  registerId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 患者名称
   * 患者名称不允许为空
   **/
  name : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   * 申请科室ID;申请科室id不允许为空
   **/
  applyDeptId : string;

  /**
   * 申请科室名称
   * 申请科室名称不允许为空
   **/
  applyDeptName : string;

  /**
   * 申请医生id
   * 申请医生id不允许为空
   **/
  applyDoctorId : string;

  /**
   * 申请医生名称
   * 申请医生名称不允许为空
   **/
  applyDoctorName : string;

  /**
   * 申请医生工号
   * 申请医生工号不允许为空
   **/
  applyDoctorAccount : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

}

/** 门诊检验结果 **/
export interface TaHopsLisResult extends BaseEntity{
  /**
   * 门诊检验申请id
   * 门诊检验申请id不允许为空
   **/
  hopsApplyId : string;

  /**
   * 门诊检验项目id
   * 门诊检验项目id不允许为空
   **/
  hopsApplyItemId : string;

  /**
   * 申请id;lis系统返回数据
   * 申请id;lis系统返回数据不允许为空
   **/
  lisApplyId : string;

  /**
   * 申请项目id;lis系统返回数据
   * 申请项目id;lis系统返回数据不允许为空
   **/
  lisApplyItemId : string;

  /**
   * 检验子项目id
   * 检验子项目id不允许为空
   **/
  subItemId : string;

  /**
   * 检验子项目名称
   **/
  subItemName? : string;

  /**
   * 检验子项目编码
   **/
  subItemCode? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 结果签名;lis系统返回
   * 结果签名;lis系统返回不允许为空
   **/
  resultSign : string;

  /**
   * 结果
   **/
  result? : string;

  /**
   * 结果单位
   **/
  unit? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : string;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : string;

  /**
   * 结果比较标记;字典：LIS_RESULT_COMPARE_FLAG
   **/
  compareFlag? : string;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

  /**
   * 同步时间
   **/
  syncTime? : string;

}

/** 应用创建入参 **/
export interface AuthAppCreateParam  {
  /**
   * 中文名
   * 中文名不允许为空
   **/
  chnName : string;

  /**
   * 应用名
   * 应用名不允许为空
   **/
  appName : string;

  /**
   * 应用类型;字典：AUTH_APP_TYPE
   * 应用类型;字典：AUTH_APP_TYPE不允许为空
   **/
  appType : number;

  /**
   * 应用版本
   * 应用版本不允许为空
   **/
  appVersion : string;

  /**
   * 应用协议;字典：COMMON_HTTP_PROTOCOL
   **/
  protocol? : string;

  /**
   * 应用域名
   **/
  appHost? : string;

  /**
   * 应用端口
   **/
  appPort? : number;

  /**
   * 应用端点
   **/
  contextPath? : string;

  /**
   * 图标
   **/
  icon? : string;

  /**
   * 样式
   **/
  styleClass? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否展示
   **/
  isShow? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 辅材带出规则项目明细分页查询条件 **/
export interface BaseMaterialRuleItemPageParam extends PageParam{
  /**
   * 辅材带出规则id
   * 辅材带出规则id不允许为空
   **/
  materialRuleId : string;

}

/** 单据记录字段 **/
export interface TaDdocRecordField extends BaseEntity{
  /**
   * 单据id;关联单据模板
   * 单据id;关联单据模板不允许为空
   **/
  recordId : string;

  /**
   * 单据字段定义id
   * 单据字段定义id不允许为空
   **/
  fieldId : string;

  /**
   * 字段编码
   * 字段编码不允许为空
   **/
  code : string;

  /**
   * 字段名称
   * 字段名称不允许为空
   **/
  name : string;

  /**
   * 字段值
   **/
  dataValue? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/**  **/
export interface ApiHisPatientDTO  {
  /**
   *    **/
  id? : string;

  /**
   * 门诊号;采用分布式序列递增
   **/
  hopsId? : string;

  /**
   * 住院号;采用分布式序列递增
   **/
  hipsId? : string;

  /**
   * 病案号;采用分布式序列递增
   **/
  caseId? : string;

  /**
   * 是否三无人员
   * 是否三无人员不允许未空
   **/
  noInfoPatient : number;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 建档渠道;字典：PATIENT_CHANNEL
   **/
  createChannel? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像url
   **/
  headImageUrl? : string;

  /**
   * 婚姻状况;字典：COMMON_MARITAL_STATUS
   **/
  maritalStatus? : string;

}

/** 皮试 VO **/
export interface HopsSkinTestVO  {
  /**
   *    **/
  id? : string;

  /**
   * 执行定义id
   **/
  exeDefineId? : string;

  /**
   * 执行定义与医嘱关系id
   **/
  defineOrderId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 医嘱项目名称
   **/
  itemName? : string;

  /**
   * 皮试结果;1：阳性，0：阴性
   **/
  skinTestResult? : number;

  /**
   * 皮试开始时间
   **/
  startTime? : string;

  /**
   * 皮试结束时间
   **/
  endTime? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人账号
   **/
  exeUserAccount? : string;

  /**
   * 执行人姓名
   * 执行人姓名不允许为空
   **/
  exeUserName : string;

  /**
   * 核验人id
   **/
  checkUserId? : string;

  /**
   * 核验人姓名
   **/
  checkUserName? : string;

  /**
   * 核验时间
   **/
  checkTime? : string;

  /**
   * 核验状态
   **/
  checkStatus? : string;

  /**
   * 是否允许取消皮试 1=允许 0=不允许
   **/
  invalidFlag? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 无效原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效操作人id
   **/
  invalidUserId? : string;

  /**
   * 无效操作人姓名
   **/
  invalidUserName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 皮试执行状态;1：执行中、2：执行完成，3：执行中断,字典：HOPS_SKIN_TEST_STATUS
   **/
  status? : string;

}

/** 门诊医嘱信息预创建入参 **/
export interface HopsOrderSetPreCreateCommand  {
  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 医嘱单类型;诊疗医嘱单、西药医嘱单、中药医嘱单：字典：HOPS_ORDER_SET_TYPE
   * 医嘱单类型;诊疗医嘱单、西药医嘱单、中药医嘱单：字典：HOPS_ORDER_SET_TYPE不允许为空
   **/
  orderSetType : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 中草药-煎法;字典：TCM_BOIL_TYPE
   **/
  tcmBoilType? : string;

  /**
   * 草药剂数
   **/
  tcmExeCount? : number;

  /**
   * 用法 中药医嘱单必传
   **/
  usageId? : string;

  /**
   * 医嘱列表
   **/
  orders? : any;

}

/** 患者动态记录分页查询条件 **/
export interface HisPatientDynamicRecordsPageParam extends PageParam{
  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 业务id
   **/
  busiId? : string;

  /**
   * 业务类型 1：门诊，2：住院，3：体检
   **/
  busiType? : number;

  /**
   * 模块名称
   **/
  moduleName? : string;

  /**
   * 类型;字典：DYNAMIC_RECORDS_TYPE
   **/
  type? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 发起人id
   **/
  originateUserId? : string;

  /**
   * 发起人姓名
   **/
  originateUserName? : string;

  /**
   * 发起时间
   **/
  originateTiem? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  patientGender? : string;

  /**
   * 出生日期
   **/
  patientBirthday? : string;

  /**
   * 年龄
   **/
  patientAge? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  patientIdcardType? : string;

  /**
   * 证件号码
   **/
  patientIdcardNo? : string;

  /**
   * 联系电话
   **/
  patientMobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

}

/** 药房配置 VO **/
export interface BaseDispensaryVO  {
  /**
   * 药房id
   **/
  id? : string;

  /**
   * 药房名称
   **/
  name? : string;

  /**
   * 关联科室id
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 药品类型;字典：DISPENSARY_DRUG_TYPE
   **/
  drugType? : any;

  /**
   * 药品性质;字典：DISPENSARY_DRUG_QUALITY
   **/
  drugQuality? : any;

  /**
   * 门诊住院标志;字典：DISPENSARY_HOPS_HIPS_FLAG
   **/
  hopsHipsFlag? : any;

  /**
   * 渠道;字典：DISPENSARY_CHANNEL
   **/
  channel? : any;

  /**
   * 发货方式;字典：DISPENSARY_DELIVERY_TYPE
   **/
  deliveryType? : any;

  /**
   * 库存标记;0：禁用库存, 1：启用库存
   **/
  inventoryFlag? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 药品类型
   **/
  drugTypeDict? : string;

  /**
   * 药品性质;字典：DISPENSARY_DRUG_QUALITY
   **/
  drugQualityDict? : string;

  /**
   * 门诊住院标志;字典：DISPENSARY_HOPS_HIPS_FLAG
   **/
  hopsHipsFlagDict? : string;

  /**
   * 渠道;字典：DISPENSARY_CHANNEL
   **/
  channelDict? : string;

  /**
   * 发货方式;字典：DISPENSARY_DELIVERY_TYPE
   **/
  deliveryTypeDict? : string;

}

/**  **/
export interface ExcelReadErrorMsgDTO  {
  /**
   *    **/
  rowIndex? : number;

  /**
   *    **/
  errMsg? : string;

}

/** 门诊医嘱患者配发药 VO **/
export interface HopsDispensePatientVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 窗口id
   **/
  windowId? : string;

  /**
   * 单日号;当日递增序列算法
   **/
  daySeqNum? : number;

  /**
   * 医嘱单类型;诊疗医嘱单、西药医嘱单、中药医嘱单：字典：HOPS_ORDER_SET_TYPE
   **/
  orderSetType? : string;

  /**
   * 处方id
   **/
  recipeId? : string;

  /**
   * 处方编号
   **/
  recipeCode? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 状态;0：未配，1：已配/未发，2：已发，3：作废
   **/
  status? : string;

  /**
   * 配药时间
   **/
  dispensingTime? : string;

  /**
   * 配药用户id
   **/
  dispensingUserId? : string;

  /**
   * 配药用户账号
   **/
  dispensingUserAccount? : string;

  /**
   * 配药用户名称
   **/
  dispensingUserName? : string;

  /**
   * 发药时间
   **/
  deliveryTime? : string;

  /**
   * 发药用户id
   **/
  deliveryUserId? : string;

  /**
   * 发药用户账号
   **/
  deliveryUserAccount? : string;

  /**
   * 发药用户名称
   **/
  deliveryUserName? : string;

  /**
   * 退药时间
   **/
  returnTime? : string;

  /**
   * 退药用户id
   **/
  returnUserId? : string;

  /**
   * 退药用户账号
   **/
  returnUserAccount? : string;

  /**
   * 退药药用户名称
   **/
  returnUserName? : string;

  /**
   * 挂号编号;兼容非字符串挂号编号，默认为id
   **/
  registerNo? : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 是否加号
   **/
  appendFlag? : number;

  /**
   * 是否急诊
   **/
  emergencyFlag? : number;

  /**
   * 是否加急
   **/
  urgentFlag? : number;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 处方创建时间
   **/
  recipeCreateTime? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/**  **/
export interface LisApplyResultContrastVO  {
  /**
   * 单位
   **/
  unit? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : string;

  /**
   * 检验结果
   **/
  resultList? : any;

}

/** 平台标题配置 **/
export interface TitleVO  {
  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 平台名称
   **/
  platformName? : string;

}

/** 门诊检验结果分页查询条件 **/
export interface HopsLisResultPageParam extends PageParam{
  /**
   * 门诊检验申请id
   **/
  hopsApplyId? : string;

  /**
   * 门诊检验项目id
   **/
  hopsApplyItemId? : string;

  /**
   * 申请id;lis系统返回数据
   **/
  lisApplyId? : string;

  /**
   * 申请项目id;lis系统返回数据
   **/
  lisApplyItemId? : string;

  /**
   * 检验子项目id
   **/
  subItemId? : string;

  /**
   * 检验子项目名称
   **/
  subItemName? : string;

  /**
   * 检验子项目编码
   **/
  subItemCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 结果签名;lis系统返回
   **/
  resultSign? : string;

  /**
   * 结果
   **/
  result? : string;

  /**
   * 结果单位
   **/
  unit? : string;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 结果比较标记;字典：LIS_RESULT_COMPARE_FLAG
   **/
  compareFlag? : string;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

  /**
   * 同步时间
   **/
  syncTime? : string;

}

/** 门诊费用明细 **/
export interface HopsFeeDetailVO  {
  /**
   * 账单ID
   **/
  billId? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 门诊id
   **/
  registerId? : string;

  /**
   * 患者唯一号
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 费用项目名称
   **/
  feeItemName? : string;

  /**
   * 单价
   **/
  feeItemPrice? : string;

  /**
   * 数量
   **/
  feeItemCount? : number;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 费用时间
   **/
  feeTime? : string;

}

/** 医嘱模板查询入参 **/
export interface HopsOrderTemplateSearchParam  {
  /**
   * 模板名称
   **/
  name? : string;

  /**
   * 是否目录 1=是,0=否
   **/
  isDirectory? : number;

}

/** 动态类增加参数 **/
export interface ClazzAddParam  {
  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 字段
   **/
  fields? : any;

}

/** 登录信息切换入参 **/
export interface AuthLoginChangeParam  {
  /**
   * 应用id
   * 应用id不能为空
   **/
  appId : string;

  /**
   * 角色ID
   **/
  roleId? : string;

  /**
   * 组织机构
   **/
  orgId? : string;

}

/** 挂号费 **/
export interface TaBaseRegisterFee extends BaseEntity{
  /**
   * 挂号级别id;关联挂号级别
   * 挂号级别id;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 项目id;关联非药品项目
   * 项目id;关联非药品项目不允许为空
   **/
  nondrugId : string;

  /**
   * 必须收取
   **/
  mustCharge? : number;

}

/** 组织机构 **/
export interface TaAuthOrg extends BaseEntity{
  /**
   * 上级组织机构id
   **/
  parentId? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 类型;字典：AUTH_ORG_TYPE
   * 类型;字典：AUTH_ORG_TYPE不允许为空
   **/
  orgType : number;

  /**
   * 地址
   **/
  address? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 医生排班创建入参 **/
export interface ScheduleDoctorCreateParam  {
  /**
   * 排班日期
   * 排班日期不允许为空
   **/
  scheduleDate : string;

  /**
   * 医生;关联用户
   * 医生;关联用户不允许为空
   **/
  doctorId : string;

  /**
   * 科室;关联组织架构
   * 科室;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   * 时间段名称;镜像排班时间段的名称不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   * 预约限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  bookingVolume : number;

  /**
   * 诊室;关联诊室
   * 诊室;关联诊室不允许为空
   **/
  roomId : string;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 供应商入库提交参数 **/
export interface SupplyInSubmitParam  {
  /**
   * 供应商ID
   * 供应商不允许为空
   **/
  companyId : string;

  /**
   * 发票号
   * 发票号不允许为空
   **/
  invoiceNo : string;

  /**
   * 发票日期
   * 发票日期不允许为空
   **/
  invoiceDate : string;

  /**
   * 供货单号
   * 供货单号不允许为空
   **/
  supplyCode : string;

  /**
   * 入库类型
   * 入库类型不允许为空
   **/
  inType : string;

  /**
   * 采购员ID
   **/
  buyerId? : string;

  /**
   * 仓库员ID
   **/
  storageUserId? : string;

  /**
   * 制单备注
   **/
  makeRemark? : string;

  /**
   * 入库药品
   **/
  items? : any;

}

/** 门诊收据明细 **/
export interface HopsFeeDetailDocVO  {
  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 流水号
   **/
  billId? : string;

  /**
   * 发票号
   **/
  invoiceNo? : string;

  /**
   * 收据日期
   **/
  billDateText? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 性别
   **/
  genderText? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 结算类型
   **/
  billingTypeText? : string;

  /**
   * 总金额
   **/
  totalPriceText? : string;

  /**
   * 费用项目
   **/
  feeItems? : any;

}

/** 发票初始化入参 **/
export interface FeeInvoiceInitParam  {
  /**
   * 起始号
   * 起始号不允许为空
   **/
  begin : number;

  /**
   * 数量
   **/
  num? : number;

  /**
   * 前缀
   **/
  pre? : string;

}

/** 配置信息 **/
export interface ConfigVO  {
  /**
   * 医院名称
   * 医院名称不允许为空
   **/
  hospitalName : string;

  /**
   * 平台名称
   * 平台名称不允许为空
   **/
  platformName : string;

  /**
   * 互联网医院域名
   * 互联网医院域名不允许为空
   **/
  host : string;

  /**
   * 接入key
   * 接入key不允许为空
   **/
  accessKey : string;

  /**
   * 接入密钥
   * 接入密钥不允许为空
   **/
  accessSecret : string;

}

/** 电子病历上医嘱组合 **/
export interface HopsMrecordOrderAssemblyDocVO  {
  /**
   * 组合类型:1:西药处方,2:中药处方,3:诊疗医嘱
   **/
  type? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 中草药-煎法;字典：TCM_BOIL_TYPE,字典转换后数据
   **/
  tcmBoilTypeText? : string;

  /**
   * 草药剂数
   **/
  tcmExeCount? : number;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 医嘱
   **/
  orders? : any;

}

/** 应用 **/
export interface AuthAppDTO extends BaseEntity{
  /**
   * 中文名
   * 中文名不允许为空
   **/
  chnName : string;

  /**
   * 应用名
   * 应用名不允许为空
   **/
  appName : string;

  /**
   * 应用类型;字典：AUTH_APP_TYPE
   * 应用类型;字典：AUTH_APP_TYPE不允许为空
   **/
  appType : number;

  /**
   * 应用版本
   * 应用版本不允许为空
   **/
  appVersion : string;

  /**
   * 应用协议;字典：COMMON_HTTP_PROTOCOL
   **/
  protocol? : string;

  /**
   * 应用域名
   **/
  appHost? : string;

  /**
   * 应用端口
   **/
  appPort? : number;

  /**
   * 应用端点
   **/
  contextPath? : string;

  /**
   * 应用地址
   **/
  address? : string;

  /**
   * 图标
   **/
  icon? : string;

  /**
   * 图标地址
   **/
  iconUrl? : string;

  /**
   * 样式
   **/
  styleClass? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否展示
   **/
  isShow? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 角色信息
   **/
  roles? : any;

}

/** 检查申请与医嘱关联分页查询条件 **/
export interface HopsPacsApplyOrderPageParam extends PageParam{
  /**
   * 门诊检查申请单id
   **/
  hopsApplyId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

}

/** 行政区划 **/
export interface TaDictArea  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 
   **/
  deleted? : number;

  /**
   * 
   **/
  version? : string;

  /**
   * 
   **/
  tenantId? : string;

  /**
   * 
   **/
  createUserId? : string;

  /**
   * 
   **/
  createUserName? : string;

  /**
   * 
   **/
  createTime? : string;

  /**
   * 
   **/
  lastUserId? : string;

  /**
   * 
   **/
  lastTime? : string;

  /**
   * 
   **/
  lastUserName? : string;

  /**
   * 上级行政区划编码
   **/
  parentId? : string;

  /**
   * 类型;字典：COMMON_AREA_TYPE
   * 类型;字典：COMMON_AREA_TYPE不允许为空
   **/
  type : number;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 全称
   **/
  fullName? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 是否作废
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 消息发送入参 **/
export interface MessageSendGlobalParam  {
  /**
   * 发送者ID
   **/
  senderId? : string;

  /**
   * 消息内容
   * 消息内容不允许为空
   **/
  content : string;

  /**
   * 消息类型
   * 消息类型不允许为空
   **/
  messageType : string;

  /**
   * 消息渠道类型
   * 消息渠道类型不允许为空
   **/
  channelType : string;

  /**
   * 通知样式
   * 通知样式不允许为空
   **/
  notificationStyle : string;

  /**
   * 附件的URL
   **/
  attachmentUrl? : string;

}

/** 门诊检查报告 VO **/
export interface HopsPacsReportVO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 门诊检查申请id
   * 门诊检查申请id不允许为空
   **/
  hopsApplyId : string;

  /**
   * 门诊检查项目id
   * 门诊检查项目id不允许为空
   **/
  hopsApplyItemId : string;

  /**
   * PACS检查申请id;PACS系统返回
   * PACS检查申请id;PACS系统返回不允许为空
   **/
  pacsApplyId : string;

  /**
   * PACS检验申请项目id;PACS系统返回
   * PACS检验申请项目id;PACS系统返回不允许为空
   **/
  pacsApplyItemId : string;

  /**
   * 报告签名;PACS系统返回
   * 报告签名;PACS系统返回不允许为空
   **/
  reportSign : string;

  /**
   * 报告内容
   **/
  content? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 同步时间
   **/
  syncTime? : string;

  /**
   * 医学影像taskId
   **/
  medicalImageTaskId? : string;

  /**
   * 医学影像下载地址
   **/
  medicalImageUrl? : string;

  /**
   * 医学影像文件名称
   **/
  medicalImageFileName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

}

/** 门诊中医症候分页查询条件 **/
export interface HopsTcmSymptomPageParam extends PageParam{
  /**
   * 门诊挂号id
   **/
  registerId? : number;

  /**
   * 患者id
   **/
  patientId? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : number;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : number;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : number;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 作废人id
   **/
  invalidUserId? : number;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

}

/** 仓库日志分页查询参数 **/
export interface WarehouseLogSearchPageParam extends PageParam{
  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

  /**
   * 药品ID
   * 请选择一种药品进行查询
   **/
  drugId : string;

}

/** 门诊医嘱配发药项目 **/
export interface TaHopsDispenseItem extends BaseEntity{
  /**
   * 配发药id
   * 配发药id不允许为空
   **/
  dispenseId : string;

  /**
   * 医嘱id
   * 医嘱id不允许为空
   **/
  orderId : string;

  /**
   * 组号
   * 组号不允许为空
   **/
  groupNo : number;

  /**
   * 项目id
   * 项目id不允许为空
   **/
  itemId : string;

  /**
   * 项目编码
   * 项目编码不允许为空
   **/
  itemCode : string;

  /**
   * 项目类型;字典：FEE_ITEM_TYPE
   * 项目类型;字典：FEE_ITEM_TYPE不允许为空
   **/
  itemType : string;

  /**
   * 项目名称
   * 项目名称不允许为空
   **/
  itemName : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   * 项目分类;字典：ITEM_SYS_TYPE不允许为空
   **/
  itemSysType : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   * 费用分类;字典：ITEM_FEE_TYPE不允许为空
   **/
  itemFeeType : string;

  /**
   * 规格
   **/
  itemSpecs? : string;

  /**
   * 批次号
   * 批次号不允许为空
   **/
  batchNo : string;

  /**
   * 药品有效期
   **/
  validDate? : string;

  /**
   * 货架号
   * 货架号不允许为空
   **/
  shelfCode : string;

  /**
   * 出库单id
   * 出库单id不允许为空
   **/
  warehouseOutId : string;

  /**
   * 中药用法;字典：TCM_USAGE_TYPE
   **/
  tcmUsageType? : string;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 总量
   * 总量不允许为空
   **/
  totalQuantity : number;

  /**
   * 总量单位
   * 总量单位不允许为空
   **/
  totalUnit : string;

  /**
   * 单价
   * 单价不允许为空
   **/
  retailPrice : string;

  /**
   * 总价
   * 总价不允许为空
   **/
  totalPrice : string;

  /**
   * 批次信息签名
   **/
  batchSign? : string;

  /**
   * 退药标志
   **/
  isReturn? : number;

  /**
   * 关联id;退药则关联原发药项目
   **/
  relationId? : string;

  /**
   * 退药时间
   **/
  returnTime? : string;

  /**
   * 退药用户id
   **/
  returnUserId? : string;

  /**
   * 退药用户账号
   **/
  returnUserAccount? : string;

  /**
   * 退药用户名称
   **/
  returnUserName? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/**  **/
export interface TimeBucketDto  {
  /**
   * 时间段名称
   **/
  timeName? : string;

  /**
   * 开始时间
   **/
  startTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

  /**
   * 时间段名称
   **/
  timeBucketName? : string;

}

/** 个人病历模板字段修改参数 **/
export interface MrecordPersonalCaseEditParam  {
  /**
   * id
   * 模板ID不允许为空
   **/
  id : string;

  /**
   * 字段数组
   **/
  fields? : any;

}

/** 角色管辖科室范围创建入参 **/
export interface AuthRoleOrgCreateParam  {
  /**
   * 角色id
   * 角色id不允许为空
   **/
  roleId : string;

  /**
   * 角色管辖科室范围列表
   **/
  orgIds? : any;

}

/** 门诊检查申请项目 **/
export interface TaHopsPacsApplyItem extends BaseEntity{
  /**
   * 门诊检查申请id
   * 门诊检查申请id不允许为空
   **/
  hopsApplyId : string;

  /**
   * PACS检查申请id;pacs系统返回
   * PACS检查申请id;pacs系统返回不允许为空
   **/
  pacsApplyId : string;

  /**
   * PACS检查项目id;pacs系统返回
   * PACS检查项目id;pacs系统返回不允许为空
   **/
  pacsApplyItemId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 检查项目id
   **/
  pacsItemId? : string;

  /**
   * 检查项目编码
   **/
  pacsItemCode? : string;

  /**
   * 检查项目名称
   **/
  pacsItemName? : string;

  /**
   * 次数;一个医嘱执行多次时，保存多条记录并且从1开始递增次数
   **/
  timeNo? : number;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 报告审核科室id
   **/
  auditDeptId? : string;

  /**
   * 报告审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 报告审核医生id
   **/
  auditUserId? : string;

  /**
   * 报告审核医生名称
   **/
  auditUserName? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 报告审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 是否需要报告，如果申请时没有项目则不需要报告
   **/
  needReport? : number;

  /**
   * 是否需要执行后才出报告
   **/
  needExe? : number;

}

/** dicom浏览器分页查询条件 **/
export interface PacsDicomViewerPageParam extends PageParam{
  /**
   * StudyInstanceUID
   **/
  studyInstanceUid? : string;

  /**
   * dicom浏览器url
   **/
  viewerUrl? : string;

}

/** 用户BaseVO **/
export interface AuthBaseUserVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 账号
   **/
  account? : string;

  /**
   * 姓名
   **/
  name? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 生日
   **/
  birthday? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 邮箱
   **/
  email? : string;

  /**
   * 最后修改密码时间
   **/
  lastEditPwd? : string;

  /**
   * 密码状态;0:初始密码，1：正常
   **/
  pwdStatus? : number;

  /**
   * 允许连续错误密码次数;-1：系统全局限制
   **/
  pwdErrCount? : number;

  /**
   * 允许同时登陆次数;0：不受限制
   **/
  loginSameTimeCount? : number;

  /**
   * 账号状态;1：正常，2：锁定
   **/
  accountStatus? : number;

  /**
   * 组织机构ID
   **/
  orgId? : string;

  /**
   * 职务ID
   **/
  dutyId? : string;

  /**
   * 职称
   **/
  title? : string;

  /**
   * 婚姻状态
   **/
  maritalStatus? : string;

  /**
   * 教育程度
   **/
  eduLevel? : string;

  /**
   * 联系人
   **/
  linkPerson? : string;

  /**
   * 联系人电话
   **/
  linkPersonTel? : string;

  /**
   * 联系人地址
   **/
  linkPersonAddress? : string;

  /**
   * 描述
   **/
  description? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 头像Url
   **/
  headImageUrl? : string;

  /**
   * 签名图片
   **/
  signImage? : string;

  /**
   * 签名图片签名图片url
   **/
  signImageUrl? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 挂号级别分页查询条件 **/
export interface BaseRegisterLevelPageParam extends PageParam{
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/**  **/
export interface OutpatientsCreatePayParam  {
  /**
   * 账单id
   **/
  billId? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 支付类型 11:现金支付，12:微信主动支付，21:医保支付，31:预交金支付，41:优惠，字典：FEE_PAY_TYPE
   **/
  payType? : string;

  /**
   * 支付金额(单位：元)
   **/
  price? : string;

}

/** 门诊医嘱配发药项目分页查询条件 **/
export interface HopsDispenseItemPageParam extends PageParam{
  /**
   * 配发药id
   **/
  dispenseId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目类型;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 批次号
   **/
  batchNo? : string;

  /**
   * 货架号
   **/
  shelfCode? : string;

  /**
   * 出库单id
   **/
  warehouseOutId? : string;

  /**
   * 中药用法;字典：TCM_USAGE_TYPE
   **/
  tcmUsageType? : string;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 总量
   **/
  totalQuantity? : number;

  /**
   * 总量单位
   **/
  totalUnit? : string;

  /**
   * 单价
   **/
  retailPrice? : string;

  /**
   * 总价
   **/
  totalPrice? : string;

}

/** 组织机构DTO **/
export interface AuthOrgDTO  {
  /**
   * 组织机构id
   **/
  id? : string;

  /**
   * 上级组织机构id
   **/
  parentId? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 类型;字典：AUTH_ORG_TYPE
   * 类型;字典：AUTH_ORG_TYPE不允许为空
   **/
  orgType : number;

  /**
   * 地址
   **/
  address? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 子组织机构
   **/
  children? : any;

}

/** 门诊检验申请分页查询条件 **/
export interface HopsLisApplyPageParam extends PageParam{
  /**
   * lis检验申请id;lis系统返回
   **/
  lisApplyId? : string;

  /**
   * 挂号id
   **/
  registerId? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 患者名称
   **/
  name? : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   **/
  applyDeptId? : string;

  /**
   * 申请科室名称
   **/
  applyDeptName? : string;

  /**
   * 申请医生id
   **/
  applyDoctorId? : string;

  /**
   * 申请医生名称
   **/
  applyDoctorName? : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊病历模板 **/
export interface TaHopsMrecordTemplate extends BaseEntity{
  /**
   * 病历模板编码
   * 病历模板编码不允许为空
   **/
  code : string;

  /**
   * 病历模板名称
   * 病历模板名称不允许为空
   **/
  name : string;

  /**
   * 病历类型;字典：HOPS_MRECORD_TYPE
   * 病历类型;字典：HOPS_MRECORD_TYPE不允许为空
   **/
  mrecordType : string;

  /**
   * 模板版本号
   * 模板版本号不允许为空
   **/
  templateVersion : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 检验申请入参 **/
export interface HopsLisApplyCreateParam  {
  /**
   * 挂号id
   * 挂号id不允许为空
   **/
  registerId : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 检验医嘱id
   * 检验医嘱id不允许为空
   **/
  orderIds : any;

}

/** 用户创建或更新入参 **/
export interface AuthUserCreateParam  {
  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 密码
   * 密码不允许为空
   **/
  pwd : string;

  /**
   * 姓名
   **/
  name? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 手机
   * 手机不允许为空
   **/
  mobile : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 生日
   **/
  birthday? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 邮箱
   **/
  email? : string;

  /**
   * 允许同时登陆次数;0：不受限制
   **/
  loginSameTimeCount? : number;

  /**
   * 归属组织机构id
   * 归属组织机构id不允许为空
   **/
  orgId : string;

  /**
   * 职务id
   **/
  dutyId? : string;

  /**
   * 职称
   **/
  title? : string;

  /**
   * 婚姻状态
   **/
  maritalStatus? : string;

  /**
   * 教育程度
   **/
  eduLevel? : string;

  /**
   * 联系人
   **/
  linkPerson? : string;

  /**
   * 联系人电话
   **/
  linkPersonTel? : string;

  /**
   * 联系人地址
   **/
  linkPersonAddress? : string;

  /**
   * 描述
   **/
  description? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 签名图片
   **/
  signImage? : string;

  /**
   * 用户角色列表
   **/
  roleIds? : any;

}

/** 检验项目子项目分页查询条件 **/
export interface LisBaseSubItemPageParam extends PageParam{
  /**
   * 项目id;关联项目
   **/
  itemId? : string;

  /**
   * 子项目编码
   **/
  code? : string;

  /**
   * 子项目名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : number;

  /**
   * 参考值最大值
   **/
  referenceMax? : number;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

  /**
   * 是否必录
   **/
  required? : number;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 辅材带出规则项目明细 DTO **/
export interface HopsMaterialItemDTO  {
  /**
   * 辅材项目主键
   **/
  id? : string;

  /**
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE不允许为空
   **/
  ruleBusiType : string;

  /**
   * 规则业务id
   * 规则业务id不允许为空
   **/
  ruleBusiId : string;

  /**
   * 规则名称
   * 规则名称不允许为空
   **/
  name : string;

  /**
   * 备注
   * 备注不允许为空
   **/
  remark : string;

  /**
   * 辅材带出规则id
   **/
  materialRuleId? : string;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 允许开立科室;科室id以,分割拼接;空为所有科室
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室啊名称;科室名称以,分割拼接;
   **/
  openDeptNames? : string;

  /**
   * 门诊执行科室
   **/
  hopsExeDept? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptName? : string;

  /**
   * 住院执行科室
   **/
  hipsExeDept? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptName? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 项目类型;1：非药品项目、2药品项目 3复合项目 ;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 辅材数量
   **/
  itemCount? : number;

  /**
   * 项目规格
   **/
  itemSpecs? : string;

  /**
   * 项目单位
   **/
  itemUnit? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 基本用量
   **/
  itemBaseUsageVolume? : number;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 零售价（单位：毫，1分=100毫））
   **/
  retailPrice? : string;

  /**
   * 辅材计算类型;1:固定数量、2、执行次数、3、按执行天数 字典：MATERIAL_ITEM_CAL_TYPE
   **/
  itemCalType? : string;

  /**
   * 带出总量
   **/
  totalCount? : number;

  /**
   * 是否默认带出;0：否 1：是
   **/
  isDefault? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 收费工作站患者分页查询参数 **/
export interface HopsOrderPatientPageParam extends PageParam{
  /**
   * 开始日期
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * 结束日期
   * 结束日期不允许为空
   **/
  endDate : string;

  /**
   * 1=未收费 2=已收费 3=已退费
   **/
  type? : string;

  /**
   * 关键字：唯一号、姓名、手机号、证件号码
   **/
  keyword? : string;

}

/** 用法详情 **/
export interface BaseUsageDetailVO  {
  /**
   * 用法ID
   **/
  id? : string;

  /**
   * 用法名称
   * 用法名称不允许为空
   **/
  name : string;

  /**
   * 执行分类;字典：USAGE_EXE_TYPE
   **/
  exeType? : string;

  /**
   * 项目分类，多选;字典：ITEM_SYS_TYPE
   **/
  itemSysTypes? : any;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/**  **/
export interface BaseRegisterFeePageVo  {
  /**
   *    **/
  id? : string;

  /**
   *    **/
  regLevelId? : string;

  /**
   *    **/
  nondrugId? : string;

  /**
   *    **/
  mustCharge? : number;

  /**
   *    **/
  itemFeeType? : string;

  /**
   *    **/
  nondrugCode? : string;

  /**
   *    **/
  nondrugName? : string;

  /**
   *    **/
  retailPrice? : string;

}

/** 登录入参 **/
export interface AuthLoginParam  {
  /**
   * 应用id
   **/
  appId? : string;

  /**
   * 账号
   * 账号信息不能为空
   **/
  account : string;

  /**
   * 随机数
   * 随机数不能为空
   **/
  random : string;

  /**
   * 登陆令牌
   * 登陆令牌不能为空
   **/
  token : string;

  /**
   * 验证码令牌
   **/
  captchaToken? : string;

}

/** 会诊 **/
export interface TaPacsConsultation extends BaseEntity{
  /**
   * 检查申请ID
   * 检查申请ID不允许为空
   **/
  applyItemId : string;

  /**
   * 发起人id
   * 发起人id不允许为空
   **/
  srcUserId : string;

  /**
   * 发起人姓名
   * 发起人姓名不允许为空
   **/
  srcUserName : string;

  /**
   * 发起科室id
   * 发起科室id不允许为空
   **/
  srcDeptId : string;

  /**
   * 发起科室名称
   * 发起科室名称不允许为空
   **/
  srcDeptName : string;

  /**
   * 发起时间
   * 发起时间不允许为空
   **/
  startTime : string;

  /**
   * 会诊描述
   **/
  remark? : string;

  /**
   * 受邀人id
   * 受邀人id不允许为空
   **/
  targetUserId : string;

  /**
   * 受邀人姓名
   * 受邀人姓名不允许为空
   **/
  targetUserName : string;

  /**
   * 受邀科室id
   * 受邀科室id不允许为空
   **/
  targetDeptId : string;

  /**
   * 受邀科室名称
   * 受邀科室名称不允许为空
   **/
  targetDeptName : string;

  /**
   * 状态;1: 待处理，2：完成，字典：PACS_CONSULTATION_STATUS
   **/
  status? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

  /**
   * 会诊建议
   **/
  advice? : string;

  /**
   * 是否紧急
   **/
  urgentFlag? : number;

}

/** 所有资源和应用 **/
export interface AllResourceExportVO  {
  /**
   * 所有应用
   **/
  apps? : any;

  /**
   * 所有资源
   **/
  resources? : any;

}

/** 医生排班资源号 **/
export interface TaScheduleDoctorResource extends BaseEntity{
  /**
   * 排班id;关联科室排班表
   * 排班id;关联科室排班表不允许为空
   **/
  scheduleId : string;

  /**
   * 看诊序号
   * 看诊序号不允许为空
   **/
  seqNum : number;

  /**
   * 预估时间
   * 预估时间不允许为空
   **/
  estimatedTime : string;

  /**
   * 看诊开始时间（预估）
   * 看诊开始时间（预估）不允许为空
   **/
  startTime : string;

  /**
   * 看诊结束时间（预估）
   * 看诊结束时间（预估）不允许为空
   **/
  endTime : string;

  /**
   * 是否可预约
   **/
  bookingFlag? : number;

  /**
   * 挂号预约渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  channel? : string;

  /**
   * 预约挂号确认时间
   **/
  sureTime? : string;

  /**
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS不允许为空
   **/
  status : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 锁号时间
   **/
  lockTime? : string;

  /**
   * 解锁时间
   **/
  unlockTime? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 排班资源号DTO **/
export interface ScheduleResourceDTO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班id;关联科室排班表
   **/
  scheduleId? : string;

  /**
   * 看诊序号
   **/
  seqNum? : number;

  /**
   * 预估时间
   **/
  estimatedTime? : string;

  /**
   * 看诊开始时间（预估）
   **/
  startTime? : string;

  /**
   * 看诊结束时间（预估）
   **/
  endTime? : string;

  /**
   * 是否可预约
   **/
  bookingFlag? : number;

  /**
   * 挂号预约渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  channel? : string;

  /**
   * 预约挂号确认时间
   **/
  sureTime? : string;

  /**
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS不允许为空
   **/
  status : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 锁号时间
   **/
  lockTime? : string;

  /**
   * 解锁时间
   **/
  unlockTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 个人病历模板目录新增修改提交参数 **/
export interface MrecordPersonalCaseDirSubmitParam  {
  /**
   * 目录ID,修改时必填
   **/
  id? : string;

  /**
   * 目录上级,为空表示顶级目录
   **/
  parentId? : string;

  /**
   * 目录名称
   * 目录名称不允许为空
   **/
  name : string;

}

/** 科室排班资源号分页查询条件 **/
export interface ScheduleDeptResourcePageParam extends PageParam{
  /**
   * 排班id;关联科室排班表
   **/
  scheduleId? : string;

  /**
   * 看诊序号
   **/
  seqNum? : number;

  /**
   * 预估时间
   **/
  estimatedTime? : string;

  /**
   * 看诊开始时间（预估）
   **/
  startTime? : string;

  /**
   * 看诊结束时间（预估）
   **/
  endTime? : string;

  /**
   * 是否可预约
   **/
  bookingFlag? : number;

  /**
   * 挂号预约渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  channel? : string;

  /**
   * 预约挂号确认时间
   **/
  sureTime? : string;

  /**
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS
   **/
  status? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 锁号时间
   **/
  lockTime? : string;

  /**
   * 解锁时间
   **/
  unlockTime? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 复合项目 **/
export interface TaBaseComposite extends BaseEntity{
  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名称
   **/
  commonName? : string;

  /**
   * 通用名称五笔码
   **/
  commonWubiCode? : string;

  /**
   * 通用名称拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 自定义编码
   **/
  customCode? : string;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 默认天数
   **/
  defaultUsageDays? : number;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 用法id;关联用法表
   **/
  usageId? : string;

  /**
   * 基本用量
   **/
  baseUsageVolume? : number;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 零售价（分）
   **/
  retailPrice? : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 采购价格（分）
   **/
  purchasePrice? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 报告说明
   **/
  reportMemo? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 检查部位是否必填
   **/
  isCheckPointRequired? : number;

  /**
   * 检验样本是否必填
   **/
  isSpecimenRequired? : number;

}

/** 科室标签对应的科室信息列表VO **/
export interface TagDeptListVo  {
  /**
   * 科室id
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 科室标签编码;字典：DEPT_TAG
   **/
  deptTag? : string;

}

/** 挂号通知单数据 **/
export interface RegistNotifyDocVO  {
  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 单日号
   **/
  registerDayNo? : string;

  /**
   * 就诊序号
   **/
  registerSeqNum? : number;

  /**
   * 患者唯一号
   **/
  patientId? : string;

  /**
   * 姓名
   **/
  patientName? : string;

  /**
   * 性别
   **/
  patientGender? : string;

  /**
   * 年龄
   **/
  patientAge? : string;

  /**
   * 就诊科室
   **/
  registerDeptName? : string;

  /**
   * 就诊医生
   **/
  registerDoctorName? : string;

  /**
   * 就诊地址
   **/
  registerDeptAddress? : string;

  /**
   * 结算类型
   **/
  registerBillingType? : string;

  /**
   * 就诊时间
   **/
  registerSeeTime? : string;

  /**
   * 收据号
   **/
  registerBillInvoiceNo? : string;

  /**
   * 挂号收费
   **/
  registerFee? : string;

  /**
   * 挂号时间
   **/
  registerTime? : string;

  /**
   * 挂号人
   **/
  registerUser? : string;

}

/** 历史患者诊疗信息分页查询参数 **/
export interface HistoryPatientCureInfoPageParam extends PageParam{
  /**
   * 关键字
   **/
  keyword? : string;

}

/** 药品导入入参 **/
export interface BaseDrugImportParam  {
  /**
   * 文件id
   **/
  fileId? : string;

}

/** 历史患者诊疗信息VO **/
export interface HistoryPatientCureInfoVO  {
  /**
   * 患者id;关联患者
   * 患者id;关联患者不允许为空
   **/
  patientId : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 上次门诊日期
   **/
  lastRegistDate? : string;

  /**
   * 上次门诊诊断
   **/
  lastDiagnose? : string;

  /**
   * 门诊次数
   **/
  registerCount? : number;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

}

/** 动态字段VO **/
export interface FieldVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 动态类id
   **/
  clazzId? : string;

  /**
   * 字典编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 是否自定义类型
   **/
  isSelfType? : number;

  /**
   * 类型
   **/
  type? : string;

  /**
   * 自定义类型id
   **/
  selfTypeId? : string;

  /**
   * 数据源类型
   **/
  datasourceType? : string;

  /**
   * 表达式
   **/
  elExpression? : string;

  /**
   * 是否数组
   **/
  isArray? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/**  **/
export interface OutpatientsPrintTreeDetailDTO  {
  /**
   * 打印清单id
   **/
  id? : string;

  /**
   * 上级组织机构id
   **/
  parentId? : string;

  /**
   * 打印清单名称
   **/
  name? : string;

  /**
   * 打印清单类型
   **/
  type? : string;

  /**
   * 子打印清单列表
   **/
  children? : any;

}

/**  **/
export interface PacsReportSaveOrUpdateParam  {
  /**
   *    **/
  id? : string;

  /**
   * 检查申请id
   * 检查申请id不允许为空
   **/
  applyId : string;

  /**
   * 检验申请项目id
   * 检验申请项目id不允许为空
   **/
  applyItemId : string;

  /**
   * 模板id
   * 模板id不允许为空
   **/
  templateId : string;

  /**
   * 报告签名;MD5(apply_item_id+content)
   **/
  reportSign? : string;

  /**
   * 报告内容
   **/
  content? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 医学影像taskId
   **/
  medicalImageTaskId? : string;

}

/** 对账入参 **/
export interface TJMedinsReconciliationParam  {
  /**
   * 账单id
   * 账单id不允许为空
   **/
  billId : string;

  /**
   * 支付id
   * 支付id不允许为空
   **/
  payId : string;

  /**
   * 社保对帐标志;0’ 门诊结算未上 传 ‘1’ 门诊结算上传 成功 ‘2’ 家庭签约结算 信息确认交易成功 ‘3’ 门诊结算确认 成功 ‘4’ 家庭签约对总 帐交易成功 ‘5’门诊对账成功
   **/
  reconciliationFlag? : string;

}

/** 医生排班更新入参 **/
export interface ScheduleUpdateParam  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班日期
   * 排班日期不允许为空
   **/
  scheduleDate : string;

  /**
   * 医生;关联用户
   **/
  doctorId? : string;

  /**
   * 科室;关联组织架构
   * 科室;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   * 时间段名称;镜像排班时间段的名称不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 科室排班停诊入参 **/
export interface ScheduleDeptCloseParam  {
  /**
   * 科室排班ID
   * 科室排班ID为空
   **/
  id : string;

  /**
   * 停诊原因
   **/
  reason? : string;

}

/** 非药品 **/
export interface TaBaseNondrug extends BaseEntity{
  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名称
   **/
  commonName? : string;

  /**
   * 通用名称五笔码
   **/
  commonWubiCode? : string;

  /**
   * 通用名称拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 自定义编码
   **/
  customCode? : string;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 国家编码
   **/
  nationCode? : string;

  /**
   * 国际标准编码
   **/
  internationalCode? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 病案分类;字典：ITEM_CASE_TYPE
   **/
  itemCaseType? : string;

  /**
   * 医保分类;字典：MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 默认天数
   **/
  defaultUsageDays? : number;

  /**
   * 基本用量
   * 基本用量不允许为空
   **/
  baseUsageVolume : number;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 单位
   * 单位不允许为空
   **/
  unit : string;

  /**
   * 零售价（单位：毫，1分=100毫））
   * 零售价不允许为空
   **/
  retailPrice : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 采购价格（单位：毫，1分=100毫）
   **/
  purchasePrice? : string;

  /**
   * 生产厂家id
   **/
  supplyProducerId? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 注册码
   **/
  registerCode? : string;

  /**
   * 注册日期
   **/
  registerDate? : string;

  /**
   * 注册证有效期
   **/
  registerValidDay? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 报告说明
   **/
  reportMemo? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 是否贵重辅材
   **/
  isPrecious? : number;

  /**
   * 检查部位是否必填
   **/
  isCheckPointRequired? : number;

  /**
   * 检验样本是否必填
   **/
  isSpecimenRequired? : number;

}

/** 排班整合分页请求参数 **/
export interface ScheduleAssemblePageParam extends PageParam{
  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 时间段名称
   **/
  timeName? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 会诊医生 **/
export interface ConsultationDoctorVO  {
  /**
   * 医生id
   **/
  id? : string;

  /**
   * 医生名称
   **/
  name? : string;

}

/** 非药品条件Vo **/
export interface BaseNondrugVo  {
  /**
   *    **/
  id? : string;

  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名称
   **/
  commonName? : string;

  /**
   * 通用名称五笔码
   **/
  commonWubiCode? : string;

  /**
   * 通用名称拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 自定义编码
   **/
  customCode? : string;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 国家编码
   **/
  nationCode? : string;

  /**
   * 国际标准编码
   **/
  internationalCode? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 病案分类;字典：ITEM_CASE_TYPE
   **/
  itemCaseType? : string;

  /**
   * 医保分类;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 默认天数
   **/
  defaultUsageDays? : number;

  /**
   * 基本用量
   **/
  baseUsageVolume? : number;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 零售价（单位：毫，1分=100毫）
   **/
  retailPrice? : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 采购价格（单位：毫，1分=100毫）
   **/
  purchasePrice? : string;

  /**
   * 生产厂家id
   **/
  supplyProducerId? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 注册码
   **/
  registerCode? : string;

  /**
   * 注册日期
   **/
  registerDate? : string;

  /**
   * 注册证有效期
   **/
  registerValidDay? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 报告说明
   **/
  reportMemo? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室名称
   **/
  openDeptNames? : any;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptNames? : any;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptNames? : any;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 是否贵重辅材
   **/
  isPrecious? : number;

  /**
   * 检查部位是否必填
   **/
  isCheckPointRequired? : number;

  /**
   * 检验样本是否必填
   **/
  isSpecimenRequired? : number;

}

/** 挂号退费申请反馈数据 **/
export interface RegisterRefundVO  {
  /**
   * 挂号ID
   **/
  registerId? : string;

  /**
   * 退费账单ID
   **/
  refundBillId? : string;

  /**
   * 收费账单ID
   **/
  chargeBillId? : string;

  /**
   * 患者ID
   **/
  patientId? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 收费结算类型;字典：BILLING_TYPE
   **/
  chargeBillingType? : string;

  /**
   * 总收费用
   **/
  totalChargePrice? : string;

  /**
   * 收费信息说明
   **/
  chargeInfo? : string;

  /**
   * 收费发票信息
   **/
  chargeInvoice? : string;

  /**
   * 总金额
   **/
  totalPrice? : string;

  /**
   * 支付金额
   **/
  payTotalPrice? : string;

  /**
   * 待支付金额
   **/
  waitPayPrice? : string;

  /**
   * 退费账单支付信息
   **/
  pays? : any;

  /**
   * 支付总状态;1：待支付，2：支付中, 31：支付成功，32：支付取消，字典：FEE_PAY_STATUS
   **/
  payTotalStatus? : string;

  /**
   * 退费项目
   **/
  feeItems? : any;

}

/** 门诊医嘱预创建 DTO **/
export interface HopsOrderGroupPreDTO  {
  /**
   * 组号
   **/
  groupNo? : number;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 天数
   **/
  exeDays? : number;

  /**
   * 总执行次数
   **/
  totalExeCount? : number;

  /**
   * 用法带出辅材信息
   **/
  usageMaterials? : any;

  /**
   * 医嘱信息
   **/
  orders? : any;

  /**
   * 总价
   **/
  totalPrice? : string;

}

/** 执行实例 VO **/
export interface HopsExeInstanceVO  {
  /**
   *    **/
  id? : string;

  /**
   * 执行实例类型;1：院内执行。2：退费拟执行，字典：HOPS_EXE_INSTANCE_TYPE
   **/
  instanceType? : string;

  /**
   * 执行定义id
   **/
  exeDefineId? : string;

  /**
   * 执行次数
   **/
  exeTimeNo? : number;

  /**
   * 执行开始时间
   **/
  startTime? : string;

  /**
   * 执行结束时间
   **/
  endTime? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人账号
   **/
  exeUserAccount? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 状态;字典：HOPS_EXE_INSTANCE_STATUS
   **/
  status? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效操作人id
   **/
  invalidUserId? : string;

  /**
   * 无效操作人姓名
   **/
  invalidUserName? : string;

}

/**  **/
export interface HopsRegisterDTO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 挂号编号;兼容非字符串挂号编号，默认为id
   **/
  registerNo? : string;

  /**
   * 当日号;挂号当日递增序列算法
   **/
  daySeqNum? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址行政区划编码
   **/
  linkmanAreaCode? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 挂号类型;字典：HOPS_REGISTER_TYPE
   **/
  registerType? : string;

  /**
   * 号源;关联科室医生排班
   **/
  resourceId? : string;

  /**
   * 挂号日期
   **/
  registerDate? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  levelId? : string;

  /**
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  registerChannel? : string;

  /**
   * 排班id;关联排班表
   **/
  scheduleId? : string;

  /**
   * 排班类型;1：科室排班，2：医生排班；字典：HOPS_SCHEDULE_TYPE
   **/
  scheduleType? : string;

  /**
   * 排班段名称
   **/
  timeName? : string;

  /**
   * 看诊时间段开始时间
   **/
  seeStartTime? : string;

  /**
   * 看诊时间段结束时间
   **/
  seeEndTime? : string;

  /**
   * 看诊断预估时间
   **/
  seeEstimatedTime? : string;

  /**
   * 看诊断序号
   **/
  seeSeqNum? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 预约id
   **/
  bookingId? : number;

  /**
   * 是否初诊
   **/
  firstSeeFlag? : number;

  /**
   * 是否加号
   **/
  appendFlag? : number;

  /**
   * 是否急诊
   **/
  emergencyFlag? : number;

  /**
   * 是否加急
   **/
  urgentFlag? : number;

  /**
   * 状态;0：无效、1：锁号待支付、21.支付成功、20.支付取消、3.待看诊、4.已接诊 5.已完成就诊
   **/
  status? : number;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 创建人
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 科室地址
   **/
  deptAddress? : string;

  /**
   * 头像url
   **/
  headImageUrl? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

  /**
   * 诊断
   **/
  diagnoseStr? : string;

  /**
   * 过敏史
   **/
  allergicHistory? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 挂号级别名称
   **/
  levelName? : string;

  /**
   * 账单信息
   **/
  feeBillDTOList? : any;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   *    **/
  lastTime? : string;

  /**
   *    **/
  realStartSeeTime? : string;

  /**
   *    **/
  realEndSeeTime? : string;

  /**
   * 诊台id
   **/
  deskId? : string;

  /**
   * 诊室id
   **/
  roomId? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/** 门诊挂号查询结果 **/
export interface HopsRegisterSearchResultVO  {
  /**
   *    **/
  id? : string;

  /**
   * 患者id;关联患者
   * 患者id;关联患者不允许为空
   **/
  patientId : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 状态;字典:HOPS_REGISTER_STATUS
   **/
  status? : number;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 挂号级别名称
   **/
  levelName? : string;

  /**
   * 看诊时间段开始时间
   **/
  seeStartTime? : string;

  /**
   * 看诊时间段结束时间
   **/
  seeEndTime? : string;

  /**
   * 看诊断序号
   **/
  seeSeqNum? : number;

  /**
   * 看诊地址，科室地址+诊室诊台
   **/
  seeAddress? : string;

  /**
   * 费用项目
   **/
  feeItems? : any;

  /**
   * 头像
   **/
  headImage? : string;

}

/** 批量记录项目费用分割入参 **/
export interface TJMedinsBatchItemSplitParam  {
  /**
   *  医保类型;2=城乡居民;3=城镇职工 
   *  医保类型不允许为空
   **/
  medinsType : string;

  /**
   * 账单id
   * 账单id不允许为空
   **/
  billId : string;

  /**
   * 支付id
   * 支付id不允许为空
   **/
  payId : string;

  /**
   * 分割详情
   * 分割详情不允许为空
   **/
  items : any;

}

/** 药品过敏源修改参数 **/
export interface DrugAllergySourceEditParam  {
  /**
   * id
   * id不允许为空
   **/
  id : string;

  /**
   * 皮试时效
   * 皮试时效不允许为空
   **/
  skinTestValidHour : number;

}

/** 排班时间段分页查询条件 **/
export interface BaseHopsScheduleTimePageParam extends PageParam{
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 查询关键字
   **/
  keyword? : string;

}

/**  **/
export interface OutpatientsPrintTreeVO  {
  /**
   * 打印清单列表
   **/
  printTree? : any;

}

/**  **/
export interface HopsRegisterCountByStatusVO  {
  /**
   * 
   **/
  status? : number;

  /**
   * 总数
   **/
  count? : string;

}

/** 个人病历模板提交参数(增加,修改使用) **/
export interface MrecordPersonalCaseSubmitParam  {
  /**
   * id,修改时不允许为空
   **/
  id? : string;

  /**
   * 上级目录id
   **/
  parentId? : string;

  /**
   * 病历名称
   * 病历名称不允许为空
   **/
  name : string;

  /**
   *    * 模板不允许为空
   **/
  templateId : string;

}

/** 供应商id和名字的VO **/
export interface SupplyCompanyIdNameVO  {
  /**
   * 供应商id
   **/
  id? : string;

  /**
   * 供应商名称
   **/
  name? : string;

}

/** 患者费用分类分页查询参数 **/
export interface PatientFeeTypePageParam extends PageParam{
  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

  /**
   * 关键字：科室名称、医生名称、患者名称、患者ID、门诊号
   **/
  keyword? : string;

}

/** 应用导出信息 **/
export interface AppExportVO  {
  /**
   * 应用id
   **/
  id? : string;

  /**
   * 中文名
   * 中文名不允许为空
   **/
  chnName : string;

  /**
   * 应用名
   * 应用名不允许为空
   **/
  appName : string;

  /**
   * 应用类型;字典：AUTH_APP_TYPE
   * 应用类型;字典：AUTH_APP_TYPE不允许为空
   **/
  appType : number;

  /**
   * 应用版本
   * 应用版本不允许为空
   **/
  appVersion : string;

  /**
   * 应用协议;字典：COMMON_HTTP_PROTOCOL
   **/
  protocol? : string;

  /**
   * 应用域名
   **/
  appHost? : string;

  /**
   * 应用端口
   **/
  appPort? : number;

  /**
   * 应用端点
   **/
  contextPath? : string;

  /**
   * 图标
   **/
  icon? : string;

  /**
   * 样式
   **/
  styleClass? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否展示
   **/
  isShow? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 资源 **/
export interface TaAuthResource extends BaseEntity{
  /**
   * 应用id;关联资源表
   * 应用ID不允许为空
   **/
  appId : string;

  /**
   * 上级资源id
   **/
  parentId? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 组件名称
   **/
  component? : string;

  /**
   * 组件重定向地址
   **/
  redirect? : string;

  /**
   * 界面打开target
   **/
  target? : string;

  /**
   * 资源类型;字典：AUTH_RESOURCE_TYPE
   **/
  resourceType? : number;

  /**
   * 资源键
   **/
  resourceKey? : string;

  /**
   * 请求地址
   **/
  requestUrl? : string;

  /**
   * 请求方法;字典：COMMON_HTTP_METHOD
   **/
  requestMethod? : number;

  /**
   * 是否外链
   **/
  isFrame? : number;

  /**
   * 是否展示
   * 是否展示不允许为空
   **/
  visible : number;

  /**
   * icon
   **/
  icon? : string;

  /**
   * 排序字段
   * 排序字段不允许为空
   **/
  sortNo : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 患者费用分类报表结果 **/
export interface PatientFeeTypeReportResult  {
  /**
   * 分页数据
   **/
  page? : Page<PatientFeeTypeItemVO>; 
  /**
   * 患者数
   **/
  patientCount? : string;

  /**
   * 门诊数
   **/
  hopsCount? : string;

  /**
   * 西药费
   **/
  westernMedicineTotalPrice? : string;

  /**
   * 中成药
   **/
  cpmTotalPrice? : string;

  /**
   * 中草药
   **/
  tcmTotalPrice? : string;

  /**
   * 诊察费
   **/
  examinationTotalPrice? : string;

  /**
   * 化验费
   **/
  lisTotalPrice? : string;

  /**
   * 检查费
   **/
  pacsTotalPrice? : string;

  /**
   * 手术费
   **/
  opsTotalPrice? : string;

  /**
   * 治疗费
   **/
  cureTotakPrice? : string;

  /**
   * 材料费
   **/
  materialTotalPrice? : string;

  /**
   * 护理费
   **/
  nurseTotalPrice? : string;

  /**
   * 其他费
   **/
  otherTotalPrice? : string;

  /**
   * 总费用
   **/
  totalPrice? : string;

}

/** 门诊配发药窗口配置 DTO **/
export interface HopsWindowDTO  {
  /**
   * 窗口id
   **/
  id? : string;

  /**
   * 药房id
   **/
  dispensaryId? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 是否开启;0：开启 ,1：关闭
   **/
  invalid? : number;

}

/** 入库项详情 **/
export interface DrugInItemDetailVO  {
  /**
   * 入库项id
   **/
  id? : string;

  /**
   * 药品id
   **/
  drugId? : string;

  /**
   * 药品编码
   **/
  drugCode? : string;

  /**
   * 药品名称
   **/
  drugName? : string;

  /**
   * 药品通用名
   **/
  drugCommonName? : string;

  /**
   * 药品规格
   **/
  drugSpecs? : string;

  /**
   * 生产厂家
   **/
  companyName? : string;

  /**
   * 入库数量
   **/
  inQuantity? : number;

  /**
   * 入库单位
   **/
  inUnit? : string;

  /**
   * 批次
   **/
  batchNo? : string;

  /**
   * 有效期
   **/
  validDate? : string;

  /**
   * 入库单价
   **/
  inPrice? : string;

  /**
   * 入库总价
   **/
  inTotalPrice? : string;

  /**
   * 零售单价
   **/
  retailPrice? : string;

  /**
   * 零售总价
   **/
  retailTotalPrice? : string;

  /**
   * 差价
   **/
  profitPrice? : string;

  /**
   * 差价金额
   **/
  profitTotalPrice? : string;

}

/** 中医症候分页查询条件 **/
export interface BaseTcmSymptomPageParam extends PageParam{
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 关键字
   **/
  keyword? : string;

}

/** 支付入参 **/
export interface OutpatientsPayParam  {
  /**
   * 支付id
   * 支付id不能为空
   **/
  payId : string;

  /**
   * 支付金额(单位：元)
   **/
  price? : string;

  /**
   *  发票号，用于账单全部支付完成后，记录发票信息
   **/
  invoiceNo? : string;

}

/** 支付信息 **/
export interface HopsChargePayInfoVO  {
  /**
   * 支付名称
   **/
  name? : string;

  /**
   * 收取金额
   **/
  receivePrice? : string;

  /**
   * 找零
   **/
  returnPrice? : string;

  /**
   * 支付金额
   **/
  price? : string;

}

/** 执行定义签名账号入参 **/
export interface HopsExeAccountParam  {
  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 随机数
   * 登陆签名错误
   **/
  random : string;

  /**
   * 令牌
   * 登陆签名错误
   **/
  token : string;

}

/** 检验结果分页查询条件 **/
export interface LisResultPageParam extends PageParam{
  /**
   * 申请id
   **/
  applyId? : string;

  /**
   * 申请项目id
   **/
  applyItemId? : string;

  /**
   * 检验子项目id
   **/
  subItemId? : string;

  /**
   * 检验子项目名称
   **/
  subItemName? : string;

  /**
   * 检验子项目编码
   **/
  subItemCode? : string;

  /**
   * 检验机器id
   **/
  machineId? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 结果
   **/
  result? : string;

  /**
   * 结果单位
   **/
  unit? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : number;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : number;

  /**
   * 结果比较标记;字典：LIS_RESULT_COMPARE_FLAG
   **/
  compareFlag? : string;

  /**
   * 是否必录
   **/
  required? : number;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

}

/** 处方项信息 **/
export interface RecipeItemDTO  {
  /**
   * 处方明细ID
   **/
  itemId? : string;

  /**
   * 处方编号
   **/
  outpatientNo? : string;

  /**
   * 药品名称
   **/
  medicineName? : string;

  /**
   * 每次用量
   **/
  useQty? : number;

  /**
   * 每次用量单位
   **/
  phruom? : string;

  /**
   * 用法
   **/
  usage? : string;

  /**
   * 用药频次
   **/
  usageFrequency? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 规格
   **/
  specification? : string;

  /**
   * 使用天数
   **/
  useDays? : number;

  /**
   * 开药数量
   **/
  qty? : number;

  /**
   * 门诊单位
   **/
  diagUnit? : string;

  /**
   * 煎药备注
   **/
  decoctingRemark? : string;

}

/** 电子病历字段 **/
export interface HopsMrecordFieldDocVO  {
  /**
   * 字段编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 字段值
   **/
  dataValue? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 字典组包含父级数据的VO **/
export interface DictGroupFullVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 上级节点id
   **/
  parentId? : string;

  /**
   * 上级节点名称
   **/
  parentName? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 树信息
   **/
  treeInfo? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 门诊执行定义 VO **/
export interface HopsExeDefineVO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 患者ID
   **/
  patientId? : string;

  /**
   * 门诊ID
   **/
  registerId? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室id
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 总共需要执行的次数
   **/
  totalExeCount? : number;

  /**
   * 已执行次数
   **/
  exeCount? : number;

  /**
   * 执行实例列表
   **/
  instances? : any;

  /**
   * 用法ID
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 执行类型;字典：USAGE_EXE_TYPE
   **/
  exeType? : string;

  /**
   * 频次ID
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 频次周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 执行天数
   **/
  exeDays? : number;

  /**
   * 开始执行时间
   **/
  startTime? : string;

  /**
   * 结束执行时间
   **/
  endTime? : string;

  /**
   * 是否需要皮试
   **/
  skinTestFlag? : number;

  /**
   * 皮试结果;1阳性，0阴性
   **/
  skinTestResult? : number;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 是否支付;1：已支付 0：未支付
   **/
  isPay? : number;

  /**
   * 是否允许执行；1：是 0：否
   **/
  isAllowExe? : number;

  /**
   * 支付时间
   **/
  payTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 状态;0：待执行1：执行中，2：执行完成，3：执行中断，字典：HOPS_EXE_DEFINE_STATUS
   **/
  status? : string;

  /**
   * 执行定义关联的医嘱信息
   **/
  orders? : any;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 门诊收费凭条-费用项目 **/
export interface HopsFeeItemVoucherDocV2VO  {
  /**
   * 费用分类
   **/
  feeTypeName? : string;

  /**
   * 金额
   **/
  priceText? : string;

}

/** 患者病历 **/
export interface MrecordItem  {
  /**
   * 病人唯一ID
   **/
  hisPatId? : string;

  /**
   * 门诊号
   **/
  appointNo? : string;

  /**
   * 病人姓名
   **/
  patientName? : string;

  /**
   * 性别，1-男 2-女
   **/
  gender? : number;

  /**
   * 年龄
   **/
  age? : number;

  /**
   * 医生姓名
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  departmentName? : string;

  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 患者主诉
   **/
  patientComplaint? : string;

  /**
   * 诊断
   **/
  diagnosis? : string;

  /**
   * 体温
   **/
  temperature? : string;

  /**
   * 脉率
   **/
  pulse? : string;

  /**
   * 呼吸频率
   **/
  breath? : string;

  /**
   * 收缩压
   **/
  tsp? : string;

  /**
   * 舒张压
   **/
  tdp? : string;

  /**
   * 身高(CM)
   **/
  height? : number;

  /**
   * 体重（KG）
   **/
  weight? : number;

  /**
   * 个人史
   **/
  personalHistory? : string;

  /**
   * 过敏史
   **/
  allergy? : string;

  /**
   * 既往史
   **/
  previousHistory? : string;

  /**
   * 现病史
   **/
  medicalHistory? : string;

  /**
   * 家族病史
   **/
  familyHistory? : string;

  /**
   * 肝功能
   **/
  liverFunction? : string;

  /**
   * 肾功能
   **/
  renalFunction? : string;

  /**
   * 婚育史
   **/
  obstetricalHistory? : string;

  /**
   * 月经史
   **/
  mensrualHistory? : string;

  /**
   * 中医四诊
   **/
  fourDiagnosis? : string;

  /**
   * 体格检查
   **/
  physicalExamination? : string;

  /**
   * 辅助检查
   **/
  accessoryExamination? : string;

  /**
   * 辩证依据
   **/
  dialecticalBasis? : string;

  /**
   * 治则治法
   **/
  curativePrinciple? : string;

  /**
   * 医嘱信息
   **/
  medicalAdvice? : string;

  /**
   * 处置记录
   **/
  disposalRecord? : string;

  /**
   * 病状分类
   **/
  diseasesType? : string;

  /**
   * 治疗意见
   **/
  treatmentAdvice? : string;

  /**
   * BMI
   **/
  bmi? : string;

  /**
   * 就诊时间
   **/
  visitTime? : string;

}

/**  **/
export interface LisApplyAndItemDetailVO  {
  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 患者名称
   * 患者名称不允许为空
   **/
  name : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImageUrl? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   * 科室id;患者所在的科室id不允许为空
   **/
  deptId : string;

  /**
   * 科室名称;患者所在的科室名称
   * 科室名称;患者所在的科室名称不允许为空
   **/
  deptName : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   * 申请科室ID;申请科室id不允许为空
   **/
  applyDeptId : string;

  /**
   * 申请科室名称
   * 申请科室名称不允许为空
   **/
  applyDeptName : string;

  /**
   * 申请医生id
   * 申请医生id不允许为空
   **/
  applyDoctorId : string;

  /**
   * 申请医生名称
   * 申请医生名称不允许为空
   **/
  applyDoctorName : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 条码号
   **/
  barcode? : string;

  /**
   * 检验项目id
   **/
  itemId? : string;

  /**
   * 检验项目编码
   **/
  itemCode? : string;

  /**
   * 检验项目名称
   **/
  itemName? : string;

  /**
   * 次数;一个医嘱执行多次时，保存多条记录并且从1开始递增次数
   **/
  timeNo? : number;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   * 采样方式;字典：LIS_COLLECT_METHOD
   **/
  collectMethod? : string;

  /**
   * 样本id;涉及标本管理
   **/
  specimenId? : string;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 执行时间
   **/
  exeTime? : string;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 报告审核科室id
   **/
  auditDeptId? : string;

  /**
   * 报告审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 报告审核医生id
   **/
  auditUserId? : string;

  /**
   * 报告审核医生名称
   **/
  auditUserName? : string;

  /**
   * 报告审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * id
   **/
  id? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/** 用户id,账号，姓名VO **/
export interface UserIdAccountNameVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 账号
   **/
  account? : string;

  /**
   * 姓名
   **/
  name? : string;

}

/** 门诊收费凭条 **/
export interface HopsFeeVoucherDocVO  {
  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 发票号
   **/
  invoiceNo? : string;

  /**
   * 缴费日期
   **/
  billTime? : string;

  /**
   * 结算类型
   **/
  billingTypeText? : string;

  /**
   * 本次费用总额
   **/
  totalPriceText? : string;

  /**
   * 预收金额
   **/
  prePayPriceText? : string;

  /**
   * 医保统筹金额
   **/
  medicalInsurancePriceText? : string;

  /**
   * 个人优惠减免
   **/
  preferentialPriceText? : string;

  /**
   * 个人缴纳金额
   **/
  ownPayPriceText? : string;

  /**
   * 实际缴金额
   **/
  realPayPriceText? : string;

  /**
   * 费用项目
   **/
  feeItems? : any;

  /**
   * 取药窗口
   **/
  stockWindows? : any;

}

/** 门诊创建退费入参 **/
export interface OutpatientsRefundCreateParam  {
  /**
   * registerId
   * 挂号id不允许为空
   **/
  registerId : string;

  /**
   * billId
   * 账单id不允许为空
   **/
  billId : string;

  /**
   * 医嘱退费详情
   * 医嘱退费详情不允许为空
   **/
  details : any;

}

/** 普通出库查询结果 **/
export interface WarehouseCommonOutSearchResultVO  {
  /**
   * 出库流水号
   **/
  id? : string;

  /**
   * 出库业务
   **/
  outBusi? : string;

  /**
   * 类型
   **/
  outType? : string;

  /**
   * 出库库房名称
   **/
  warehouseName? : string;

  /**
   * 目标医院ID
   **/
  targetHospitalId? : string;

  /**
   * 目标医院名称
   **/
  targetHospitalName? : string;

  /**
   * 目标科室id
   **/
  targetDeptId? : string;

  /**
   * 目标科室名称
   **/
  targetDeptName? : string;

  /**
   * 制单人id
   **/
  makeUserId? : string;

  /**
   * 制单人姓名
   **/
  makeUserName? : string;

  /**
   * 制单时间
   **/
  makeTime? : string;

  /**
   * 制单备注
   **/
  makeRemark? : string;

  /**
   * 审核医生id
   **/
  auditUserId? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

  /**
   * 审核医生名称
   **/
  auditUserName? : string;

  /**
   * 审核备注
   **/
  auditRemark? : string;

  /**
   * 入账人id
   **/
  sureUserId? : string;

  /**
   * 入账人姓名
   **/
  sureUserName? : string;

  /**
   * 入账时间
   **/
  sureTime? : string;

  /**
   * 入账备注
   **/
  sureRemark? : string;

  /**
   * 采购总金额
   **/
  inTotalPrice? : string;

  /**
   * 差价总金额
   **/
  profitTotalPrice? : string;

  /**
   * 零售总金额
   **/
  retailTotalPrice? : string;

  /**
   * 状态;字典：WAREHOUSE_OUT_STATUS
   **/
  status? : string;

}

/** 用户分页查询条件 **/
export interface AuthUserPageParam extends PageParam{
  /**
   * 账号状态;1：正常，2：锁定
   **/
  accountStatus? : number;

  /**
   * 角色ID
   **/
  roleId? : string;

  /**
   * 归属组织机构id
   **/
  orgId? : string;

  /**
   * 关键字
   **/
  keyword? : string;

}

/**  **/
export interface DoctorDTO  {
  /**
   * 医生id
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

}

/** 门诊收费日结结果VO **/
export interface HopsChargeDailyResultVO  {
  /**
   * 开始时间
   **/
  startTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

  /**
   * 收款员
   **/
  collector? : string;

  /**
   * 收费张数
   **/
  billCount? : string;

  /**
   * 计价金额，所有的金额，到最小单位
   **/
  totalPrice? : string;

  /**
   * 应收金额，单位到分
   **/
  totalPay? : string;

  /**
   * 实收金额，所有的自费金额，单位到分
   **/
  realTotalPay? : string;

  /**
   * 最小发票
   **/
  minInvoiceCode? : string;

  /**
   * 最大发票
   **/
  maxInvoiceCode? : string;

  /**
   * 医保支付
   **/
  medinsPayPrice? : string;

  /**
   * 退费张数
   **/
  refundBillCount? : string;

  /**
   * 退费金额
   **/
  refundTotalPrice? : string;

  /**
   * 支付信息
   **/
  pays? : any;

  /**
   * 发票
   **/
  invoices? : any;

  /**
   * 费用类别
   **/
  feeTypes? : any;

}

/** excel模板 VO **/
export interface ExcelTemplateVO  {
  /**
   * 文件id
   **/
  id? : string;

  /**
   * 文件下载地址
   **/
  url? : string;

}

/**  **/
export interface HopsDispensePatientStaticVO  {
  /**
   * 类型 0=未配 1=已配 2=未发 3=已发 4=已退
   **/
  type? : string;

  /**
   * 总数
   **/
  count? : number;

}

/** 记录刷卡信息入参 **/
export interface TJMedinsCardParam  {
  /**
   *  医保类型;2=城乡居民;3=城镇职工 
   *  医保类型不允许为空
   **/
  medinsType : string;

  /**
   * 账单id
   * 账单id不允许为空
   **/
  billId : string;

  /**
   * 支付id
   * 支付id不允许为空
   **/
  payId : string;

  /**
   * 门诊序列号
   * 门诊序列号不允许为空
   **/
  seqNum : string;

  /**
   * 医保号
   * 医保号不允许为空
   **/
  medicalInsuranceNo : string;

  /**
   * 医保区域
   * 医保区域不允许为空
   **/
  medicalInsuranceArea : string;

  /**
   * 个人编码
   * 个人编码不允许为空
   **/
  personalCode : string;

  /**
   * 证件号码
   * 证件号码不允许为空
   **/
  idcardNo : string;

  /**
   * 姓名
   * 姓名不允许为空
   **/
  name : string;

  /**
   * 性别
   * 性别不允许为空
   **/
  gender : string;

  /**
   * 出生日期
   * 出生日期不允许为空
   **/
  birthday : string;

  /**
   * 实足年龄
   * 实足年龄不允许为空
   **/
  age : number;

  /**
   * 人员类别;01 学生儿童(包含院校 学生、高中以下学生儿 童) 03 新生儿 04 成年居民
   * 人员类别;01 学生儿童(包含院校 学生、高中以下学生儿 童) 03 新生儿 04 成年居民不允许为空
   **/
  personalCategory : string;

  /**
   * 待遇档次;待遇档次也叫筹资标准 01 一类 02 二类 03 三类 04 四类
   **/
  treatmentGrade? : string;

  /**
   * 单位名称
   * 单位名称不允许为空
   **/
  companyName : string;

  /**
   * 参保人员所属社保 机构
   * 参保人员所属社保 机构不允许为空
   **/
  insuredAgency : string;

  /**
   * 专项基金余额
   * 专项基金余额不允许为空
   **/
  specialFundBalance : string;

  /**
   * 自付比例
   * 自付比例不允许为空
   **/
  selfPayRatio : number;

  /**
   * 特殊人员类别;07 民政救助人员 08 优抚对象 09 非典后遗症
   **/
  specialPersonCategory? : string;

  /**
   * 特殊人员类别补充说明
   **/
  specialPersonCategoryDescription? : string;

  /**
   * 银行卡号
   **/
  bankNo? : string;

  /**
   * 单位编码
   **/
  unitNo? : string;

  /**
   * 单位代码
   **/
  unitCode? : string;

  /**
   * 单位类型
   **/
  unitType? : string;

  /**
   * 账户结余余额
   **/
  accountBalance? : string;

}

/** 账单信息DTO **/
export interface FeeBillDTO  {
  /**
   * 账单ID
   **/
  id? : string;

  /**
   * 医院ID
   **/
  hospitalId? : string;

  /**
   * 医院编码
   **/
  hospitalCode? : string;

  /**
   * 医院区域编码
   **/
  hospitalAreaCode? : string;

  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 医院医保类型;天津=tj
   **/
  hospitalAreaType? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 业务种类;1. 门诊、2.住院、3：体检，字典：FEE_BUSI_KIND
   **/
  kindType? : string;

  /**
   * 种类业务id;业务种类为门诊,则为门诊id
   **/
  kindItemId? : string;

  /**
   * 业务类型;字典：FEE_BILL_ITEM_BUSI
   **/
  busiType? : string;

  /**
   * 目标人员id;针对门诊住院体检时，为患者id
   **/
  targetPersonId? : string;

  /**
   * 目标人员快照id;关联目标人员快照表
   **/
  personSnapshotId? : string;

  /**
   * 总金额（单位：毫，1分=100毫）
   **/
  totalPrice? : string;

  /**
   * 待支付金额（单位：毫，1分=100毫）
   **/
  waitPayPrice? : string;

  /**
   * 退款金额（单位：毫，1分=100毫）
   **/
  refundPrice? : string;

  /**
   * 支付金额（单位：毫，1分=100毫）
   **/
  payTotalPrice? : string;

  /**
   * 医保金额（单位：毫，1分=100毫）
   **/
  medinsPrice? : string;

  /**
   * 支付开始时间
   **/
  payStartTime? : string;

  /**
   * 支付完成时间
   **/
  payEndTime? : string;

  /**
   * 支付总状态;1：待支付，2：支付中, 31：支付成功，32：支付取消，字典：FEE_PAY_STATUS
   **/
  payTotalStatus? : string;

  /**
   * 关联id;如果是退款单，需要关联收费账单id
   **/
  relationId? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

  /**
   * 账单的所有支付信息
   **/
  pays? : any;

  /**
   * 支付信息说明
   **/
  payInfo? : string;

  /**
   * 账单的项目信息
   **/
  items? : any;

  /**
   * 账单关联的退账账单id
   **/
  refundBillIds? : any;

  /**
   * 账单的发票信息
   **/
  invoice? : FeeBillInvoiceDTO;

}

/** 检验申请单单据 **/
export interface HopsLisApplyDocVO  {
  /**
   * 申请ID
   **/
  applyId? : string;

  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 申请单名称
   **/
  docName? : string;

  /**
   * 患者ID
   **/
  patientId? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 患者年龄
   **/
  patientAge? : string;

  /**
   * 患者性别
   **/
  patientGenderText? : string;

  /**
   * 申请科室
   **/
  applyDeptName? : string;

  /**
   * 目标科室
   **/
  targetDeptName? : string;

  /**
   * 申请医生名称
   **/
  doctorName? : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 病历信息
   **/
  mrecordFields? : any;

  /**
   * 注意事项
   **/
  attentions? : string;

  /**
   * 申请项目
   **/
  items? : any;

  /**
   * 总金额
   **/
  totalPriceText? : string;

}

/** 辅材单 **/
export interface HopsMaterialDocVO  {
  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 性别
   **/
  genderText? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 结算类型
   **/
  billingTypeText? : string;

  /**
   * 唯一号
   **/
  patientId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorNo? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 开据日期
   **/
  openDate? : string;

  /**
   * 患者地址
   **/
  patientAddress? : string;

  /**
   * 患者手机
   **/
  patientMobile? : string;

  /**
   * 诊断
   **/
  diagnoseText? : string;

  /**
   * 辅材项目
   **/
  items? : any;

  /**
   * 打印时间
   **/
  printTimeText? : string;

  /**
   * 打印时间
   **/
  printTime? : string;

  /**
   * 总金额
   **/
  totalPriceText? : string;

}

/** 医生周报表分页参数 **/
export interface DoctorIncomeWeekPageParam extends PageParam{
  /**
   * startDate
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * endDate
   * 结束日期不允许为空
   **/
  endDate : string;

}

/** 组织机构树VO **/
export interface AuthOrgTreeVO  {
  /**
   * 组织机构id
   **/
  orgTree? : any;

  /**
   * 选择的组织机构
   **/
  checks? : any;

  /**
   * 选择的组织机构
   **/
  allowedCheck? : any;

}

/** 配发药审核基础入参 **/
export interface HopsDispenseBaseAuditParam  {
  /**
   * 处方编号
   * 处方编号不允许为空
   **/
  recipeCode : string;

  /**
   * 审核类型 1：配药 2：发药
   * 审核类型不允许为空
   **/
  type : string;

}

/** 医嘱模板 VO **/
export interface HopsOrderTemplateVO  {
  /**
   * 模板id
   **/
  id? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 上级模板id
   **/
  parentId? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 医嘱信息
   **/
  sets? : any;

  /**
   * 是否目录 1=是,0=否
   **/
  isDirectory? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 组织机构查询条件 **/
export interface AuthOrgListParam  {
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 名称
   **/
  name? : string;

}

/** 供应入库详情VO **/
export interface SupplyInDetailVO  {
  /**
   * 入库单据号
   **/
  id? : string;

  /**
   * 入库业务
   **/
  inBusi? : string;

  /**
   * 入库类型
   **/
  inType? : string;

  /**
   * 仓库名称
   **/
  warehouseName? : string;

  /**
   * 供应商名称
   **/
  companyName? : string;

  /**
   * 供应商id
   **/
  companyId? : string;

  /**
   * 供应单号
   **/
  supplyCode? : string;

  /**
   * 发票号
   **/
  invoiceNo? : string;

  /**
   * 发票日期
   **/
  invoiceDate? : string;

  /**
   * 制单人
   **/
  makeUserName? : string;

  /**
   * 制单时间
   **/
  makeTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 审核人
   **/
  auditUserName? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

  /**
   * 入账人
   **/
  sureUserName? : string;

  /**
   * 入账时间
   **/
  sureTime? : string;

  /**
   * 入库时间
   **/
  storageTime? : string;

  /**
   * 仓库人员
   **/
  storageUserName? : string;

  /**
   * 仓库人员id
   **/
  storageUserId? : string;

  /**
   * 采购人员
   **/
  buyerName? : string;

  /**
   * 采购人员Id
   **/
  buyerId? : string;

  /**
   * 购入金额
   **/
  inTotalPrice? : string;

  /**
   * 零售金额
   **/
  retailTotalPrice? : string;

  /**
   * 差价总金额
   **/
  profitTotalPrice? : string;

  /**
   * 单据备注
   **/
  makeRemark? : string;

  /**
   * 入库项
   **/
  items? : any;

}

/** 普通出库查询参数 **/
export interface WarehouseCommonOutSearchParam extends PageParam{
  /**
   * 制单开始日期
   **/
  startDate? : string;

  /**
   * 制单结束
   **/
  endDate? : string;

  /**
   * 关键字：出库单号，发往部门，发往医院
   **/
  keyword? : string;

  /**
   * 出库类型
   **/
  outType? : string;

}

/** 报告模板 **/
export interface TaPacsBaseReportTemplate extends BaseEntity{
  /**
   * 检查类型;字典：PACS_TYPE
   * 检查类型;字典：PACS_TYPE不允许为空
   **/
  pacsType : string;

  /**
   * 模板编码
   * 模板编码不允许为空
   **/
  code : string;

  /**
   * 模板名称
   * 模板名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 模板内容;模板富文本内容
   * 模板内容;模板富文本内容不允许为空
   **/
  content : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊医嘱配发药 VO **/
export interface HopsDispenseVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 窗口id
   **/
  windowId? : string;

  /**
   * 窗口名称
   **/
  windowName? : string;

  /**
   * 库房id
   **/
  dispensaryId? : string;

  /**
   * 库房名称
   **/
  dispensaryName? : string;

  /**
   * 单日号;当日递增序列算法
   **/
  daySeqNum? : number;

  /**
   * 处方id
   **/
  recipeId? : string;

  /**
   * 处方编号
   **/
  recipeCode? : string;

  /**
   * 医嘱单类型;诊疗医嘱单、西药医嘱单、中药医嘱单：字典：HOPS_ORDER_SET_TYPE
   **/
  orderSetType? : string;

  /**
   * 处方备注
   **/
  remark? : string;

  /**
   * 处方中草药-煎法;字典：TCM_BOIL_TYPE
   **/
  tcmBoilType? : string;

  /**
   * 处方草药剂数
   **/
  tcmExeCount? : number;

  /**
   * 处方用法id
   **/
  usageId? : string;

  /**
   * 处方用法名称
   **/
  usageName? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 诊断
   **/
  diagnoseStr? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 状态;0：未配，1：已配/未发，2：已发，3：作废
   **/
  status? : string;

  /**
   * 配药时间
   **/
  dispensingTime? : string;

  /**
   * 配药用户id
   **/
  dispensingUserId? : string;

  /**
   * 配药用户账号
   **/
  dispensingUserAccount? : string;

  /**
   * 配药用户名称
   **/
  dispensingUserName? : string;

  /**
   * 发药时间
   **/
  deliveryTime? : string;

  /**
   * 发药用户id
   **/
  deliveryUserId? : string;

  /**
   * 发药用户账号
   **/
  deliveryUserAccount? : string;

  /**
   * 发药用户名称
   **/
  deliveryUserName? : string;

  /**
   * 配发药项目信息
   **/
  items? : any;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 打印标志
   **/
  printFlag? : number;

  /**
   * 打印时间
   **/
  printTime? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 门诊医嘱预创建 DTO **/
export interface HopsOrderPreDTO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医嘱单id;关联医嘱单
   **/
  orderSetId? : string;

  /**
   * 处方单id;关联处方单
   **/
  recipeId? : string;

  /**
   * 紧急标记
   **/
  emergencyFlag? : number;

  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目类型;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 项目是否停用
   **/
  itemInvalid? : number;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptNames? : any;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptNames? : any;

  /**
   * 检查部位是否必填
   **/
  isCheckPointRequired? : number;

  /**
   * 检验样本是否必填
   **/
  isSpecimenRequired? : number;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 取药科室id
   **/
  stockDeptId? : string;

  /**
   * 取药科室名称
   **/
  stockDeptName? : string;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 开立医生id;关联用户
   **/
  openDoctorId? : string;

  /**
   * 开立医生名称
   **/
  openDoctorName? : string;

  /**
   * 审核医生id
   **/
  approvedDoctorId? : string;

  /**
   * 审核医生名称
   **/
  approvedDoctorName? : string;

  /**
   * 审核时间
   **/
  approvedTime? : string;

  /**
   * 审核状态
   **/
  approvedStatus? : number;

  /**
   * 是否需要计费
   **/
  chargeFlag? : number;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 药品包装单位
   **/
  drugPackageUnit? : string;

  /**
   * 药品包装数量
   **/
  drugPackageCount? : number;

  /**
   * 药品散装单位
   **/
  drugBulkUnit? : string;

  /**
   * 药品标准剂量
   **/
  drugStdDosage? : number;

  /**
   * 药品标准剂量单位
   **/
  drugStdDosageUnit? : string;

  /**
   * 药品剂型
   **/
  drugDosageForm? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

  /**
   * 药品取整方式;1：散装单位每次取整，2：散装单位总量取整，3：包装单位每次取整，4：包装单位总量取整。字典：DRUG_ROUND_TYPE
   **/
  drugRoundType? : string;

  /**
   * 辅材标志
   **/
  subMaterialFlag? : number;

  /**
   * 辅材带出类型;1：用法、2、诊疗项目 字典：ORDER_MATERIAL_TYPE
   **/
  subMaterialType? : string;

  /**
   * 辅材关联医嘱id;只有是辅材时才关联医嘱
   **/
  subMaterialMainOrderId? : string;

  /**
   * 是否展示
   **/
  showFlag? : number;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 组合号
   **/
  groupNo? : number;

  /**
   * 医嘱开立每次剂量
   **/
  orderOnceDosage? : number;

  /**
   * 医嘱开立收费总剂量
   **/
  orderChargeDosage? : number;

  /**
   * 医嘱开立每次剂量单位
   **/
  orderOnceDosageUnit? : string;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 用法执行类型
   **/
  usageExeType? : string;

  /**
   * 频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 天数
   **/
  exeDays? : number;

  /**
   * 总量
   **/
  totalQuantity? : number;

  /**
   * 退款量
   **/
  refundQuantity? : number;

  /**
   * 总量单位
   **/
  totalUnit? : string;

  /**
   * 总量单位类型;1：散装单位、2包装单位
   **/
  totalUnitType? : string;

  /**
   * 总执行次数/草药剂数
   **/
  totalExeCount? : number;

  /**
   * 单价
   **/
  retailPrice? : string;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 收费总价
   **/
  totalChargePrice? : string;

  /**
   * 退款金额
   **/
  refundPrice? : string;

  /**
   * 可用库存数量
   **/
  inventoryQuantity? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 皮试标志
   **/
  skinTestFlag? : number;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验标本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 中药用法;字典：TCM_USAGE_TYPE
   **/
  tcmUsageType? : string;

  /**
   * 状态;字典：HOPS_ORDER_STATUS
   **/
  status? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : string;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 账单项目id;关联费用账单项目
   **/
  billItemId? : string;

  /**
   * 项目带出辅材信息
   **/
  itemMaterials? : any;

  /**
   * 项目子项信息
   **/
  itemSubs? : any;

}

/** 字典对码 VO **/
export interface DictItemMatchingVO  {
  /**
   * 组织机构id
   **/
  matchingId? : string;

  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   **/
  matchingType? : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   **/
  standardType? : string;

  /**
   * 内部编码
   **/
  intraCode? : string;

  /**
   * 内部名称
   **/
  intraCodeName? : string;

  /**
   * 标准编码
   **/
  standardCode? : string;

  /**
   * 标准名称
   **/
  standardName? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 处方信息 **/
export interface RecipeDTO  {
  /**
   * 处方编号
   **/
  outpatientNo? : string;

  /**
   * 处方种类，1-治疗项目；2-理疗项目；3-体检项目；4-中草药处方. 5-西药；6-附加项目；7-材料
   **/
  type? : number;

  /**
   * 处方类型，0-普通；1-急诊；2-儿科；3-麻醉、精一. 4-精二；5其他；
   **/
  recipeType? : number;

  /**
   * 门诊号
   **/
  appointNo? : string;

  /**
   * 处方医生姓名
   **/
  recipeDoctorName? : string;

  /**
   * 药师姓名
   **/
  pharmacistName? : string;

  /**
   * 煎煮方法
   **/
  decoctingMethod? : string;

  /**
   * 总剂数
   **/
  totalDosage? : string;

  /**
   * 中药用法
   **/
  usage? : string;

  /**
   * 用药频次
   **/
  usageFrequency? : string;

  /**
   * 用药时间
   **/
  medInstruct? : string;

  /**
   * 用药禁忌
   **/
  taboo? : string;

  /**
   * 备注
   **/
  memo? : string;

  /**
   * 处方明细列表
   **/
  items? : any;

}

/**  **/
export interface HopsMrecordDetailVo  {
  /**
   * 病历类型;字典：HOPS_MRECORD_TYPE
   **/
  mrecordType? : string;

  /**
   * 病历模板id;关联病历模板
   **/
  templateId? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 状态;字典：HOPS_MRECORD_STATUS
   **/
  status? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

}

/** 医生模板 VO **/
export interface ScheduleTemplateVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 星期几;1～7表示星期一到星期日
   **/
  week? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 排班时间段;关联排班时间段
   **/
  timeId? : string;

  /**
   * 排班时间段名称
   **/
  timeName? : string;

  /**
   * 开始时间;格式HH:mm
   * 开始时间;格式HH:mm不允许为空
   **/
  startTime : string;

  /**
   * 结束时间;格式HH:mm
   * 结束时间;格式HH:mm不允许为空
   **/
  endTime : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 账单基础信息 **/
export interface BillBaseParam  {
  /**
   * 医院ID
   **/
  hospitalId? : string;

  /**
   * 交易类型：1：收费，2：退费
   **/
  tradeType? : string;

  /**
   * 业务种类，1：门诊，2：住院，3：体检，允许后续拓展
   **/
  kindType? : string;

  /**
   * 种类业务ID：如果业务种类为门诊，则为门诊号registerId,如果业务种类为住院，则为住院号，如果业务种类为体检，则为体检号
   * 种类业务ID不能为空
   **/
  kindItemId : string;

  /**
   * 业务类型：字典：FEE_BILL_ITEM_BUSI，101：门诊挂号，102：门诊医嘱
   **/
  busiType? : string;

}

/** 当前登陆用户组织机构封装类 **/
export interface CurrentLoginOrgDTO  {
  /**
   * 组织机构id
   **/
  id? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 租户ID
   **/
  tenantId? : string;

}

/** 挂号信息分页查询参数 **/
export interface HopsRegisterInfoPageParam extends PageParam{
  /**
   * 日期类型 1.当天 2.配置天数
   **/
  dayType? : number;

  /**
   * 科室id
   **/
  deptId? : string;

  /**
   * 医生id
   **/
  doctorId? : string;

  /**
   * 挂号开始日期
   **/
  registerStartDate? : string;

  /**
   * 挂号结束日期
   **/
  registerEndDate? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 关键字：唯一号、姓名、手机号、证件号码
   **/
  keyword? : string;

  /**
   * 排班类型;1：科室排班，2：医生排班；字典：HOPS_SCHEDULE_TYPE
   **/
  scheduleType? : string;

}

/** 门诊检查申请项目 VO **/
export interface HopsPacsApplyItemVO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 门诊检查申请id
   * 门诊检查申请id不允许为空
   **/
  hopsApplyId : string;

  /**
   * PACS检查申请id;pacs系统返回
   * PACS检查申请id;pacs系统返回不允许为空
   **/
  pacsApplyId : string;

  /**
   * PACS检查项目id;pacs系统返回
   * PACS检查项目id;pacs系统返回不允许为空
   **/
  pacsApplyItemId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 检查项目id
   **/
  pacsItemId? : string;

  /**
   * 检查项目编码
   **/
  pacsItemCode? : string;

  /**
   * 检查项目名称
   **/
  pacsItemName? : string;

  /**
   * 次数;一个医嘱执行多次时，保存多条记录并且从1开始递增次数
   **/
  timeNo? : number;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 报告审核科室id
   **/
  auditDeptId? : string;

  /**
   * 报告审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 报告审核医生id
   **/
  auditUserId? : string;

  /**
   * 报告审核医生名称
   **/
  auditUserName? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 报告审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 申请单信息
   **/
  apply? : HopsPacsApplyDTO;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

}

/** 复合项目明细 DTO **/
export interface BaseCompositeItemDTO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 复合项目id
   * 复合项目id不允许为空
   **/
  compositeId : string;

  /**
   * 项目id
   * 项目id不允许为空
   **/
  itemId : string;

  /**
   * 项目编码
   * 编码不允许为空
   **/
  itemCode : string;

  /**
   * 项目类型;1：非药品项目、2药品项目 3复合项目 ;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目名称
   * 项目名称不允许为空
   **/
  itemName : string;

  /**
   * 数量
   **/
  itemCount? : number;

  /**
   * 通用名称
   **/
  commonName? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 医保分类;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 零售价（单位：毫，1分=100毫））
   **/
  retailPrice? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 入库单详情 **/
export interface WarehouseOutDetailVO  {
  /**
   * 入库流水号
   **/
  id? : string;

  /**
   * 出库业务
   **/
  outBusi? : string;

  /**
   * 类型
   **/
  outType? : string;

  /**
   * 出库库房名称
   **/
  warehouseName? : string;

  /**
   * 目标医院ID
   **/
  targetHospitalId? : string;

  /**
   * 目标医院名称
   **/
  targetHospitalName? : string;

  /**
   * 目标科室id
   **/
  targetDeptId? : string;

  /**
   * 目标科室名称
   **/
  targetDeptName? : string;

  /**
   * 制单人id
   **/
  makeUserId? : string;

  /**
   * 制单人姓名
   **/
  makeUserName? : string;

  /**
   * 制单时间
   **/
  makeTime? : string;

  /**
   * 制单备注
   **/
  makeRemark? : string;

  /**
   * 审核医生id
   **/
  auditUserId? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

  /**
   * 审核医生名称
   **/
  auditUserName? : string;

  /**
   * 审核备注
   **/
  auditRemark? : string;

  /**
   * 入账人id
   **/
  sureUserId? : string;

  /**
   * 入账人姓名
   **/
  sureUserName? : string;

  /**
   * 入账时间
   **/
  sureTime? : string;

  /**
   * 入账备注
   **/
  sureRemark? : string;

  /**
   * 采购总金额
   **/
  inTotalPrice? : string;

  /**
   * 差价总金额
   **/
  profitTotalPrice? : string;

  /**
   * 零售总金额
   **/
  retailTotalPrice? : string;

  /**
   * 状态;字典：WAREHOUSE_OUT_STATUS
   **/
  status? : string;

  /**
   * 出库明细项目
   **/
  items? : any;

}

/** 复合项目分页查询条件 **/
export interface BaseCompositePageParam extends PageParam{
  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : any;

  /**
   * 当前开立科室
   **/
  openDeptId? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : any;

  /**
   * 关键字
   **/
  keyword? : string;

}

/**  **/
export interface OutpatientsPrintResultVO  {
  /**
   * 清单打印时间
   **/
  printTime? : string;

}

/** 科室营收明细日报表 **/
export interface RevenueDeptDayDetailVO  {
  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 西药费
   **/
  westernMedicinePrice? : string;

  /**
   * 中成药
   **/
  cpmPrice? : string;

  /**
   * 中草药
   **/
  tcmPrice? : string;

  /**
   * 诊察费
   **/
  examinationPrice? : string;

  /**
   * 化验费
   **/
  lisPrice? : string;

  /**
   * 检查费
   **/
  pacsPrice? : string;

  /**
   * 手术费
   **/
  opsPrice? : string;

  /**
   * 治疗费
   **/
  curePrice? : string;

  /**
   * 材料费
   **/
  materialPrice? : string;

  /**
   * 护理费
   **/
  nursePrice? : string;

  /**
   * 其他费
   **/
  otherPrice? : string;

  /**
   * 总费用
   **/
  oneTotalrice? : string;

}

/** 辅材带出规则新增入参 **/
export interface BaseMaterialRuleCreateParam  {
  /**
   * 辅材带出规则列表
   * 辅材带出规则列表不允许为空
   **/
  rules : any;

}

/** 门诊病历分页查询条件 **/
export interface HopsMrecordPageParam extends PageParam{
  /**
   * 病历类型;字典：HOPS_MRECORD_TYPE
   **/
  mrecordType? : string;

  /**
   * 病历模板id;关联病历模板
   **/
  templateId? : number;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : number;

  /**
   * 状态;字典：HOPS_MRECORD_STATUS
   **/
  status? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : number;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

}

/**  **/
export interface LisResultDTO  {
  /**
   *    **/
  id? : string;

  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 申请项目id
   * 申请项目id不允许为空
   **/
  applyItemId : string;

  /**
   * 检验子项目id
   * 检验子项目id不允许为空
   **/
  subItemId : string;

  /**
   * 检验子项目名称
   **/
  subItemName? : string;

  /**
   * 检验子项目编码
   **/
  subItemCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 检验机器id
   **/
  machineId? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 结果签名;md5(apply_item_id+sub_item_id+sub_item_name+sub_item_code+result+unit+reference_min+reference_text+reference_max+compare_flag)
   **/
  resultSign? : string;

  /**
   * 结果
   **/
  result? : string;

  /**
   * 结果单位
   **/
  unit? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : string;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : string;

  /**
   * 结果比较标记;字典：LIS_RESULT_COMPARE_FLAG
   **/
  compareFlag? : string;

  /**
   * 是否必录
   **/
  required? : number;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

  /**
   * 完成时间
   **/
  completeTime? : string;

}

/** 个人病历模板VO **/
export interface MrecordPersonalCaseDetailVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 字段数据
   **/
  fields? : any;

}

/** 应用创建入参 **/
export interface AuthAppUpdateParam  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 中文名
   * 中文名不允许为空
   **/
  chnName : string;

  /**
   * 应用名
   * 应用名不允许为空
   **/
  appName : string;

  /**
   * 应用类型;字典：AUTH_APP_TYPE
   * 应用类型;字典：AUTH_APP_TYPE不允许为空
   **/
  appType : number;

  /**
   * 应用版本
   * 应用版本不允许为空
   **/
  appVersion : string;

  /**
   * 应用协议;字典：COMMON_HTTP_PROTOCOL
   **/
  protocol? : string;

  /**
   * 应用域名
   **/
  appHost? : string;

  /**
   * 应用端口
   **/
  appPort? : number;

  /**
   * 应用端点
   **/
  contextPath? : string;

  /**
   * 图标
   **/
  icon? : string;

  /**
   * 样式
   **/
  styleClass? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否展示
   **/
  isShow? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 辅材带出规则项目明细 **/
export interface TaBaseMaterialRuleItem extends BaseEntity{
  /**
   * 辅材带出规则id
   * 辅材带出规则id不允许为空
   **/
  materialRuleId : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 允许开立科室;科室id以,分割拼接;空为所有科室
   **/
  openDeptIds? : string;

  /**
   * 门诊执行科室
   **/
  hopsExeDept? : string;

  /**
   * 住院执行科室
   **/
  hipsExeDept? : string;

  /**
   * 项目类型;1：非药品项目、2药品项目 3复合项目 ;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目id
   * 项目id不允许为空
   **/
  itemId : string;

  /**
   * 辅材数量
   * {javax.validation.constraints.NotNull.message}
   **/
  itemCount : number;

  /**
   * 辅材计算类型;1:固定数量、2、执行次数、3、按执行天数 字典：MATERIAL_ITEM_CAL_TYPE
   * {javax.validation.constraints.NotNull.message}
   **/
  itemCalType : string;

  /**
   * 是否默认带出;0：否 1：是
   **/
  isDefault? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 营业收入统计月报数据项 **/
export interface IncomeFeeMonthItemVO  {
  /**
   * 日期
   **/
  dayLine? : string;

  /**
   * 西药费
   **/
  westernMedicinePrice? : string;

  /**
   * 中成药
   **/
  cpmPrice? : string;

  /**
   * 中草药
   **/
  tcmPrice? : string;

  /**
   * 诊察费
   **/
  examinationPrice? : string;

  /**
   * 化验费
   **/
  lisPrice? : string;

  /**
   * 检查费
   **/
  pacsPrice? : string;

  /**
   * 手术费
   **/
  opsPrice? : string;

  /**
   * 治疗费
   **/
  curePrice? : string;

  /**
   * 材料费
   **/
  materialPrice? : string;

  /**
   * 护理费
   **/
  nursePrice? : string;

  /**
   * 其他费
   **/
  otherPrice? : string;

  /**
   * 营业额（元）
   **/
  totalrice? : string;

  /**
   * 初诊人数
   **/
  firstVisitCount? : number;

  /**
   * 复诊人数
   **/
  againVisitCount? : number;

  /**
   * 门诊合计人数
   **/
  totalVisitCount? : number;

}

/**  **/
export interface HisPatientDto  {
  /**
   *    **/
  id? : string;

  /**
   * 门诊号;采用分布式序列递增
   **/
  hopsId? : string;

  /**
   * 住院号;采用分布式序列递增
   **/
  hipsId? : string;

  /**
   * 病案号;采用分布式序列递增
   **/
  caseId? : string;

  /**
   * 是否三无人员
   * 是否三无人员不允许未空
   **/
  noInfoPatient : number;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 建档渠道;字典：PATIENT_CHANNEL
   **/
  createChannel? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 籍贯区域名称
   **/
  nativePlaceName? : string;

  /**
   * 现住地址行政区划名称
   **/
  presentAreaName? : string;

  /**
   * 户籍地址行政区划名称
   **/
  registerAreaName? : string;

  /**
   * 工单单位行政区划名称
   **/
  unitAreaName? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像url
   **/
  headImageUrl? : string;

  /**
   * 婚姻状况;字典：COMMON_MARITAL_STATUS
   **/
  maritalStatus? : string;

  /**
   * 医保区域名称
   **/
  medicalInsuranceAreaName? : string;

}

/** 发票作废入参 **/
export interface FeeInvoiceInvalidParam  {
  /**
   * 发票id
   * 发票id不允许为空
   **/
  ids : any;

  /**
   * 备注
   **/
  remark? : string;

}

/** 药房配置分页查询条件 **/
export interface BaseDispensaryPageParam extends PageParam{
  /**
   * 药房名称
   **/
  name? : string;

  /**
   * 库存标记;0：禁用库存, 1：启用库存
   **/
  inventoryFlag? : number;

}

/** 门诊费用明细分页查询参数 **/
export interface HopsFeeDetailPageParam extends PageParam{
  /**
   * 门诊ID，患者唯一号，患者姓名关键字
   **/
  keyword? : string;

  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

}

/**  **/
export interface HopsOrderPatientCountVO  {
  /**
   * 类型 1=未收费 2=已收费 3=已退费
   **/
  type? : string;

  /**
   * 总数
   **/
  count? : number;

}

/** 基础配置 VO **/
export interface BaseMatchingVO  {
  /**
   * 对码id
   **/
  id? : string;

  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   **/
  matchingType? : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   **/
  standardType? : string;

  /**
   * 内部编码
   **/
  intraCode? : string;

  /**
   * 内部名称
   **/
  intraCodeName? : string;

  /**
   * 标准编码
   **/
  standardCode? : string;

  /**
   * 标准名称
   **/
  standardName? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 医生收入周报表VO **/
export interface DoctorIncomeWeekVO  {
  /**
   * 日期
   **/
  day? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 初诊人数
   **/
  firstVisitCount? : number;

  /**
   * 复诊人数
   **/
  againVisitCount? : number;

  /**
   * 挂号
   **/
  registerCount? : number;

  /**
   * 人均处方
   **/
  averageOrder? : number;

  /**
   * 药品业绩
   **/
  drugPrice? : string;

  /**
   * 总业绩
   **/
  totalPrice? : string;

  /**
   * 单体消费
   **/
  averagePrice? : string;

  /**
   * 药占比
   **/
  drugRatio? : string;

}

/** 排班预览查询条件 **/
export interface SchedulePreViewParam  {
  /**
   * 开始日期
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * 结束日期
   * 结束日期不允许为空
   **/
  endDate : string;

  /**
   * 查询关键字
   **/
  keyword? : string;

  /**
   * 类型
   * 预览类型不允许为空
   **/
  type : number;

}

/** 入库药品分页查询参数 **/
export interface WarehouseInDrugPageParam extends PageParam{
  /**
   * 查询关键字
   **/
  keyword? : string;

}

/** 排班整合筛选条件入参 **/
export interface ScheduleAssembleQueryConditionParam  {
  /**
   * 看诊日期（排班日期）
   **/
  scheduleDate? : string;

  /**
   * 挂号科室id
   **/
  deptId? : string;

  /**
   * 挂号级别id
   **/
  regLevelId? : string;

  /**
   * 医生id
   **/
  doctorId? : string;

  /**
   * 时间段名称
   **/
  timeName? : string;

  /**
   * 开始时间
   **/
  startTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 排班类型 1.科室排班  2.医生排班
   **/
  scheduleType? : string;

  /**
   * 排班ID
   **/
  scheduleId? : string;

}

/** 过敏史作废参数 **/
export interface AllergyHistoryInvalidParam  {
  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 密码加密令牌
   * 密码不允许为空
   **/
  token : string;

  /**
   * 随机数
   * 随机数不允许为空
   **/
  random : string;

  /**
   * 过敏史id
   * 过敏史id不允许为空
   **/
  id : string;

  /**
   * 作废理由
   **/
  reason? : string;

}

/**  **/
export interface HopsMrecordFieldDetailVo  {
  /**
   * 字段编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 字段值
   **/
  dataValue? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * jsonValue
   **/
  jsonValue? : string;

}

/** 广东省医疗收费票据 **/
export interface GdMedicalFeeDocVO  {
  /**
   * 业务流水号
   **/
  billId? : string;

  /**
   * 社会保障号
   **/
  medicalInsuranceNo? : string;

  /**
   * 病历号
   **/
  caseId? : string;

  /**
   * 科室信息
   **/
  deptName? : string;

  /**
   * 住院号
   **/
  hipsId? : string;

  /**
   * 医院类型
   **/
  hosiptalLevel? : string;

  /**
   * 年
   **/
  year? : string;

  /**
   * 月
   **/
  month? : string;

  /**
   * 日
   **/
  day? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 是否门诊
   **/
  hopsFlag? : number;

  /**
   * 是否急诊
   **/
  aeFlag? : number;

  /**
   * 是否住院
   **/
  hipsFlag? : number;

  /**
   * 开始日期:对应住院日期
   **/
  startDateText? : string;

  /**
   * 结束日期:对应出院日期
   **/
  endDateText? : string;

  /**
   * 是否男
   **/
  maleFlag? : number;

  /**
   * 是否女
   **/
  femaleFlag? : number;

  /**
   * 医保费用
   **/
  medicalInsurancePriceText? : string;

  /**
   * 自费部分
   **/
  ownPayPriceText? : string;

  /**
   * 结算方式/支付方式
   **/
  payTypeText? : string;

  /**
   * 西药费
   **/
  westernMedicinePriceText? : string;

  /**
   * 中成药
   **/
  cpmPriceText? : string;

  /**
   * 中草药
   **/
  tcmPriceText? : string;

  /**
   * 诊察费
   **/
  examinationPriceText? : string;

  /**
   * 化验费
   **/
  lisPriceText? : string;

  /**
   * 检查费
   **/
  pacsPriceText? : string;

  /**
   * 手术费
   **/
  opsPriceText? : string;

  /**
   * 治疗费
   **/
  curePriceText? : string;

  /**
   * 材料费
   **/
  materialPriceText? : string;

  /**
   * 护理费
   **/
  nursePriceText? : string;

  /**
   * 其他费
   **/
  otherPriceText? : string;

  /**
   * 预交款
   **/
  prePayPriceText? : string;

  /**
   * 补收
   **/
  rePayPriceText? : string;

  /**
   * 退款
   **/
  refundPriceText? : string;

  /**
   * 欠款
   **/
  noPayPriceText? : string;

  /**
   * 十万大写
   **/
  word10W? : string;

  /**
   * 万大写
   **/
  word1W? : string;

  /**
   * 千大写
   **/
  word1K? : string;

  /**
   * 百大写
   **/
  word100? : string;

  /**
   * 十大写
   **/
  workd10? : string;

  /**
   * 元大写
   **/
  wordYuan? : string;

  /**
   * 角大写
   **/
  wordJiao? : string;

  /**
   * 分大写
   **/
  wordFen? : string;

  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 复核
   **/
  checkUserName? : string;

  /**
   * 收款人
   **/
  receiveUserName? : string;

}

/** 科室排班分页查询条件 **/
export interface ScheduleDeptPageParam extends PageParam{
  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 科室;关联组织架构
   **/
  deptId? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   **/
  timeName? : string;

  /**
   * 开始时间;根据排班日期与排班时间段的开始时间生成具体日期时间
   **/
  startTime? : string;

  /**
   * 结束时间;根据排班日期与排班时间段的结束时间生成具体日期时间
   **/
  endTime? : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : string;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/**  **/
export interface SchedulePreViewDetail  {
  /**
   * 科室或医生名称
   **/
  name? : string;

  /**
   * 类型
   **/
  type? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 挂号数
   **/
  registeredVolume? : number;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

}

/** 天津城乡居民门诊支付统计 **/
export interface TjCxjmHopsPayStatisticsItemVO  {
  /**
   * 汇总批次号
   * 汇总批次号不允许为空
   **/
  batchNo : string;

  /**
   * 医院医保编码
   **/
  hopsMedinsCode? : string;

  /**
   * 统计类别;02 门急诊 05 基本医疗 10 民政救助 11 优抚补助 12 非典补助,字典:TJ_CXJM_STATISTICS_TYPE
   **/
  statisticsType? : string;

  /**
   * 支付银行;01 工行 02 农行 03 邮储 04 中行 05 天津银行 06 光大 07 农合行 08 其他.字典:TJ_CXJM_BANKS
   **/
  bank? : string;

  /**
   * 支付业务;11 门诊 41 门特,字典:TJ_CXJM_PAY_BUSI
   **/
  payBusi? : string;

  /**
   * 人员类别;01 学生儿童(包含院 校学生、高中以下学生 儿童) 03 新生儿 04 成年居民.字典:TJ_CXJM_PERSON_GROUP_TYPE
   **/
  personGroupType? : string;

  /**
   * 本期完成人次
   **/
  personCount? : string;

  /**
   * 本期完成金额
   **/
  totalPrice? : string;

  /**
   * 拒付人次
   **/
  refusePersonCount? : string;

  /**
   * 拒付金额
   **/
  refusePrice? : string;

  /**
   * 调整补支付金额
   **/
  adjustAddPayPrice? : string;

  /**
   * 调整减支付金额
   **/
  adjustCutPayPrice? : string;

  /**
   * 退费人次
   **/
  refundPersonCount? : string;

  /**
   * 退费金额
   **/
  refundPrice? : string;

  /**
   * 社保统筹基金支付金 额
   **/
  planBasePayPrice? : string;

  /**
   * 社保救助基金支付金额
   **/
  helpBasePayPrice? : string;

  /**
   * 民政救助人次
   **/
  civilHelpCount? : string;

  /**
   * 民政救助金额
   **/
  civilHelpPrice? : string;

  /**
   * 优抚补助人次
   **/
  careHelpCount? : string;

  /**
   * 优抚补助金额
   **/
  careHelpPrice? : string;

  /**
   * 非典后遗症人次
   **/
  sarsPersonCount? : string;

  /**
   * 非典后遗症金额
   **/
  sarsPrice? : string;

  /**
   * 联网垫付人次
   **/
  netPersonCount? : string;

  /**
   * 联网垫付金额
   **/
  netPersonPrice? : string;

  /**
   * 基金支付金额
   **/
  basePayPrice? : string;

  /**
   * 调整补支付人次
   **/
  adjustAddPersonCount? : string;

  /**
   * 调整减支付人次
   **/
  adjustCutPersonCount? : string;

}

/** 配发药项目退药审核入参 **/
export interface HopsDispenseReturnAuditParam  {
  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 随机数
   * 登陆签名错误
   **/
  random : string;

  /**
   * 令牌
   * 登陆签名错误
   **/
  token : string;

  /**
   * 退药项目详情
   * 退药项目详情不允许为空
   **/
  details : any;

}

/** 门诊清单打印入参 **/
export interface OutpatientsListPrintParam  {
  /**
   * 清单id
   * 打印清单id不允许为空
   **/
  listId : string;

  /**
   * 清单类型
   * 打印清单类型不允许为空
   **/
  type : string;

}

/** 过敏源搜索结果 **/
export interface AllergyItemSearchResultVO  {
  /**
   *    **/
  dictDefine? : string;

  /**
   * 药品过敏原，key为过敏类型，对应字典：ALL_ALLERGY_SOURCE_TYPE
   **/
  drugAllergyItems? : any;

  /**
   * 非药品过敏原，key为过敏类型，对应字典：ALL_ALLERGY_SOURCE_TYPE
   **/
  nondrugAllergyItems? : any;

}

/** 诊室 **/
export interface TaBaseHopsRoom extends BaseEntity{
  /**
   * 护士站id;关联组织机构
   * 护士站id;关联组织机构不允许为空
   **/
  stationId : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 检查项目 **/
export interface HopsPacsOrderApplyDocVO  {
  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 检查部位
   **/
  pacsCheckPointText? : string;

  /**
   * 检查目的
   **/
  checkPurpose? : string;

}

/** 登陆用户信息 **/
export interface CurrentLoginUserVO  {
  /**
   * 接入令牌
   **/
  accessToken? : string;

  /**
   * 版本
   **/
  version? : string;

  /**
   * 登录签名
   **/
  loginSign? : string;

  /**
   * 登陆时间
   **/
  loginTime? : string;

  /**
   * 账号
   **/
  account? : string;

  /**
   * 用户ID
   **/
  userId? : string;

  /**
   * 用户名称
   **/
  userName? : string;

  /**
   * 用户类型
   **/
  userType? : number;

  /**
   * 具有权限的应用信息
   **/
  apps? : any;

  /**
   * 当前的应用id
   **/
  currentAppId? : string;

  /**
   * 当前角色id
   **/
  currentRoleId? : string;

  /**
   * 当前角色权级
   **/
  currentRoleGrade? : number;

  /**
   * 当前租户id
   **/
  currentTenantId? : string;

  /**
   * 当前选择的组织机构id
   **/
  currentOrgId? : string;

}

/** 科室排班创建入参 **/
export interface ScheduleDeptCreateParam  {
  /**
   * 排班日期
   * 排班日期不允许为空
   **/
  scheduleDate : string;

  /**
   * 科室;关联组织架构
   * 科室;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   * 时间段名称;镜像排班时间段的名称不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   * 预约限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  bookingVolume : number;

  /**
   * 诊室;关联诊室
   * 诊室;关联诊室不允许为空
   **/
  roomId : string;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 字典项vo **/
export interface DictItemVo  {
  /**
   * id
   **/
  id? : string;

  /**
   * 字典值
   **/
  itemValue? : string;

  /**
   * 字典文本
   **/
  itemText? : string;

}

/** 用户修改密码参数 **/
export interface AuthUserEditPwdParam  {
  /**
   * 账号
   **/
  account? : string;

  /**
   * 旧的密码
   **/
  ollPwd? : string;

  /**
   * 新的密码
   **/
  newPwd? : string;

}

/** 出库药品信息 **/
export interface WarehouseOutDrugVO  {
  /**
   * 入库项ID
   **/
  inItemId? : string;

  /**
   * 药品id
   **/
  drugId? : string;

  /**
   * 药品编码
   **/
  drugCode? : string;

  /**
   * 药品名称
   **/
  drugName? : string;

  /**
   * 药品通用
   **/
  drugCommonName? : string;

  /**
   * 药品规格
   **/
  drugSpecs? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 药品批号
   **/
  batchNo? : string;

  /**
   * 药品有效期
   **/
  validDate? : string;

  /**
   * 包装数量，展示使用
   **/
  packageQuantity? : number;

  /**
   * 包装单位，展示使用
   **/
  packageUnit? : string;

  /**
   * 散装数量，展示使用
   **/
  bulkQuantity? : number;

  /**
   * 散装单位，展示使用
   **/
  bulkUnit? : string;

  /**
   * 可用数量，用于计算比较出库量使用，出库包装数量*药品包装数+出库散装数量与该值比较判断是否可以出库
   **/
  useableStocks? : number;

  /**
   * 库存单位
   **/
  stocksUnit? : string;

  /**
   * 库存单位类型
   **/
  stocksUnitType? : string;

  /**
   * 药品包装数
   **/
  packageCount? : number;

  /**
   * 零售价
   **/
  retailPrice? : string;

  /**
   * 入库价
   **/
  inPrice? : string;

}

/**  **/
export interface HopsFeeBillItemVO  {
  /**
   * 主键ID
   **/
  id? : string;

  /**
   * 账单id;关联账单，合账后更新
   **/
  billId? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 业务种类;1. 门诊、2.住院、3：体检，字典：FEE_BUSI_KIND
   **/
  kindType? : string;

  /**
   * 种类业务id;业务种类为门诊,则为门诊id,
   **/
  kindItemId? : string;

  /**
   * 业务类型;字典：FEE_BILL_ITEM_BUSI
   **/
  busiType? : string;

  /**
   * 业务id;门诊id、住院id、医嘱id
   **/
  busiItemId? : string;

  /**
   * 目标人员id;针对门诊住院体检时，为患者id
   **/
  targetPersonId? : string;

  /**
   * 费用项目类型;1：非药品项目、2药品项目：字典：FEE_ITEM_TYPE
   **/
  feeItemType? : string;

  /**
   * 费用项目id
   **/
  feeItemId? : string;

  /**
   * 费用项目快照id;确费时针对药品非药品生成快照的id
   **/
  feeItemSnapshotId? : string;

  /**
   * 费用项目名称
   **/
  feeItemName? : string;

  /**
   * 费用项目单价;（单位：毫，1分=100毫），确费时更新
   **/
  feeItemPrice? : string;

  /**
   * 费用项目数量
   **/
  feeItemCount? : string;

  /**
   * 费用项目总价;（单位：毫，1分=100毫），确费时更新
   **/
  feeItemTotalPrice? : string;

  /**
   * 预计账时间
   **/
  recordTime? : string;

  /**
   * 确费时间
   **/
  sureTime? : string;

  /**
   * 账单项目状态;1：预记账、21：确费、20：取消、3：合账，字典：FEE_BILL_STATUS
   **/
  billItemStatus? : string;

  /**
   * 关联ID;如果已退款则关联的是退款项目ID
   **/
  relationId? : string;

  /**
   * 是否已退款; 1=是 0=否
   **/
  isRefund? : number;

}

/** 用法分页查询条件 **/
export interface BaseUsagePageParam extends PageParam{
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 检验申请与医嘱关联分页查询条件 **/
export interface HopsLisApplyOrderPageParam extends PageParam{
  /**
   * 门诊检验申请单id
   **/
  hopsApplyId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

}

/** 排班 VO **/
export interface ScheduleVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 科室;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 科室地址
   **/
  deptAddress? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   **/
  timeName? : string;

  /**
   * 开始时间;根据排班日期与排班时间段的开始时间生成具体日期时间
   **/
  startTime? : string;

  /**
   * 结束时间;根据排班日期与排班时间段的结束时间生成具体日期时间
   **/
  endTime? : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 挂号数
   **/
  registeredVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 排班明细
   **/
  resources? : any;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 测试加密查询条件 **/
export interface TestEncryptSearchParam  {
  /**
   * 姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

}

/** 厂家 **/
export interface TaBaseCompany extends BaseEntity{
  /**
   * 厂家名称
   * 厂家名称不允许为空
   **/
  name : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 厂家类型;字典：COMPANY_TYPE
   * 厂家类型;字典：COMPANY_TYPE不允许为空
   **/
  companyType : string;

  /**
   * 法人
   **/
  legalPerson? : string;

  /**
   * 地址
   **/
  address? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 传真
   **/
  fax? : string;

  /**
   * 邮箱
   **/
  email? : string;

  /**
   * 联系人
   **/
  linkman? : string;

  /**
   * 联系人邮箱
   **/
  linkmanEmail? : string;

  /**
   * 联系人电话
   **/
  linkmanTel? : string;

  /**
   * ISO信息
   **/
  isoInfo? : string;

  /**
   * 开户行
   **/
  bank? : string;

  /**
   * 开户行帐号
   **/
  bankAccount? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 执行定义与医嘱关系分页查询条件 **/
export interface HopsExeDefineOrderPageParam extends PageParam{
  /**
   * 执行定义id
   **/
  exeDefineId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

}

/** 软件版本检查结果 **/
export interface SoftVersionCheckResultVO  {
  /**
   * 是否强制更新
   **/
  needUpdate? : number;

  /**
   * 软件编码
   * 软件编码不允许为空
   **/
  softCode : string;

  /**
   * 软件名称
   * 软件名称不允许为空
   **/
  softName : string;

  /**
   * 软件版本
   * 软件版本不允许为空
   **/
  softVersion : string;

  /**
   * 下载地址
   * 下载地址不允许为空
   **/
  downloadUrl : string;

  /**
   * 是否强制更新
   **/
  forceUpdateFlag? : number;

  /**
   * 是否是当前版本
   **/
  currentFlag? : number;

  /**
   * 更新内容说明
   **/
  updateNote? : string;

  /**
   * 更新详细说明
   **/
  updateNoteHtml? : string;

  /**
   * 安装详细说明
   **/
  initNoteHtml? : string;

}

/**  **/
export interface DynamicRecordsItemDTO  {
  /**
   *    **/
  name? : string;

  /**
   *    **/
  code? : string;

  /**
   *    **/
  value? : any;

}

/** 科室排班模板VO **/
export interface ScheduleDeptTemplateVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 星期几;1～7表示星期一到星期日
   **/
  week? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 排班时间段;关联排班时间段
   **/
  timeId? : string;

  /**
   * 排班时间段名称
   **/
  timeName? : string;

  /**
   * 开始时间;格式HH:mm
   * 开始时间;格式HH:mm不允许为空
   **/
  startTime : string;

  /**
   * 结束时间;格式HH:mm
   * 结束时间;格式HH:mm不允许为空
   **/
  endTime : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 医生排班模板分页查询条件 **/
export interface ScheduleDoctorTemplatePageParam extends PageParam{
  /**
   * 星期几;1～7表示星期一到星期日
   **/
  week? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 排班时间段;关联排班时间段
   **/
  timeId? : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 医嘱模板修改入参 **/
export interface HopsOrderTemplateEditParam  {
  /**
   * 模板id
   * 模板id不允许为空
   **/
  id : string;

  /**
   * 模板名称
   **/
  name? : string;

  /**
   * 医嘱模板信息
   **/
  sets? : any;

}

/** 门诊收费员 **/
export interface HopsTollCollectorVO  {
  /**
   * 门诊收费员id
   **/
  id? : string;

  /**
   * 门诊收费员姓名
   **/
  name? : string;

}

/** 资源导出数据 **/
export interface ResourceExportVO  {
  /**
   * 资源id
   **/
  id? : string;

  /**
   * 应用id;关联资源表
   * 应用ID不允许为空
   **/
  appId : string;

  /**
   * 上级资源id
   **/
  parentId? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 组件名称
   **/
  component? : string;

  /**
   * 组件重定向地址
   **/
  redirect? : string;

  /**
   * 界面打开target
   **/
  target? : string;

  /**
   * 资源类型;字典：AUTH_RESOURCE_TYPE
   **/
  resourceType? : number;

  /**
   * 资源键
   **/
  resourceKey? : string;

  /**
   * 请求地址
   **/
  requestUrl? : string;

  /**
   * 请求方法;字典：COMMON_HTTP_METHOD
   **/
  requestMethod? : number;

  /**
   * 是否外链
   **/
  isFrame? : number;

  /**
   * 是否展示
   * 是否展示不允许为空
   **/
  visible : number;

  /**
   * icon
   **/
  icon? : string;

  /**
   * 排序字段
   * 排序字段不允许为空
   **/
  sortNo : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 字典定义 **/
export interface TaDictDefine extends BaseEntity{
  /**
   * 字典组id;关联字典组
   * 必选选择该字典定义的归属字典组
   **/
  groupId : string;

  /**
   * 字典标准id;关联字典标准
   * 必须选择该字典定义的标准
   **/
  standardId : string;

  /**
   * 自定义编码
   * 自定义编码不允许为空
   **/
  code : string;

  /**
   * 定义值;定义常数时使用
   **/
  defineValue? : string;

  /**
   * 标准编码
   **/
  standardCode? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 角色VO **/
export interface AuthRoleVO  {
  /**
   * 角色id
   **/
  id? : string;

  /**
   * 应用id
   **/
  appId? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 权级;字典：AUTH_ROLE_GRADE
   **/
  grade? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

  /**
   * 管辖科室范围列表
   **/
  orges? : any;

  /**
   * 资源列表
   **/
  allResources? : any;

  /**
   * 操作的资源信息
   **/
  operators? : any;

  /**
   * 菜单和菜单组信息
   **/
  menus? : any;

  /**
   * 其他资源信息
   **/
  otherResources? : any;

}

/** 辅材带出规则 **/
export interface TaBaseMaterialRule extends BaseEntity{
  /**
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE不允许为空
   **/
  ruleBusiType : string;

  /**
   * 规则业务id
   * 规则业务id不允许为空
   **/
  ruleBusiId : string;

  /**
   * 规则名称
   **/
  name? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/**  **/
export interface CacheSetParam  {
  /**
   *    * {javax.validation.constraints.NotBlank.message}
   **/
  key : string;

  /**
   *    * {javax.validation.constraints.NotBlank.message}
   **/
  value : string;

  /**
   *    **/
  second? : number;

}

/**  **/
export interface PacsReportDetailsParam  {
  /**
   * 检查申请项目id
   * 检查申请项目id不允许为空
   **/
  applyItemId : string;

  /**
   * 报告模板id
   * 报告模板id不允许为空
   **/
  reportTemplateId : string;

}

/** 字典标准分页查询条件 **/
export interface DictStandardPageParam extends PageParam{
  /**
   *    **/
  keyword? : string;

}

/** 入库药品WarehouseInDrugVO **/
export interface WarehouseInDrugVO  {
  /**
   * 药品ID
   **/
  id? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 通用名
   **/
  commonName? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 生产厂家id;关联生产厂家
   **/
  supplyProducerId? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 零售价;
   **/
  retailPrice? : string;

  /**
   * 包装单位、入库单位;
   **/
  packageUnit? : string;

}

/** 门诊诊断分页查询条件 **/
export interface HopsDiagnosePageParam extends PageParam{
  /**
   * 门诊挂号ID;关联门诊挂号
   **/
  registerId? : number;

  /**
   * 患者id;关联患者id
   **/
  patientId? : number;

  /**
   * 诊断id;关联诊断
   **/
  diagnoseId? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : number;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : number;

  /**
   * icd编码;镜像诊断字典
   **/
  icdCode? : string;

  /**
   * 诊断icd类型;镜像诊断字典，字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * icd亚目;镜像诊断字典
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称;镜像诊断字典
   **/
  icdName? : string;

  /**
   * 临床诊断名称;镜像诊断字典
   **/
  clinicalName? : string;

  /**
   * 中医症候id;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmSymptomId? : number;

  /**
   * 中医症候编码;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmClinicalName? : string;

  /**
   * 主诊断标志
   **/
  mainFlag? : number;

  /**
   * 疑诊标志
   **/
  suspectFlag? : number;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 作废时间
   **/
  invalidTime? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : number;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

}

/** 门诊收据明细项目 **/
export interface HopsFeeItemDetailDocVO  {
  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目规格
   **/
  spec? : string;

  /**
   * 数量
   **/
  count? : string;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 单价
   **/
  priceText? : string;

  /**
   * 总价
   **/
  totalPriceText? : string;

  /**
   * 费用类别
   **/
  itemFeeTypeText? : string;

  /**
   * 医保分类
   **/
  medicalInsuranceTypeText? : string;

}

/** 对码查询入参 **/
export interface BaseMatchingParam extends PageParam{
  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   * 对码类型;字典：MEDINS_MATCHING_TYPE;不允许为空
   **/
  matchingType : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   * 标准类型不允许为空
   **/
  standardType : string;

  /**
   * 关键字：编码、名称
   **/
  keyword? : string;

}

/** 对码查询入参 **/
export interface WarehouseMatchingParam extends PageParam{
  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   * 对码类型;字典：MEDINS_MATCHING_TYPE;不允许为空
   **/
  matchingType : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   * 标准类型不允许为空
   **/
  standardType : string;

  /**
   * 关键字：编码、名称
   **/
  keyword? : string;

}

/** 科室标签 **/
export interface TaBaseDeptTag extends BaseEntity{
  /**
   * 科室标签编码;字典：DEPT_TAG
   * 科室标签编码;字典：DEPT_TAG不允许为空
   **/
  deptTag : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

}

/** 门诊支付请求对象 **/
export interface HopsPayParam  {
  /**
   * 账单id
   * 账单id不允许为空
   **/
  billId : string;

  /**
   * 支付类型 11:现金支付，12:微信主动支付，21:医保支付，31:预交金支付，41:优惠，字典：FEE_PAY_TYPE
   * 支付类型不允许为空
   **/
  payType : string;

  /**
   * 支付金额
   * 支付金额不允许为空
   **/
  price : string;

  /**
   * 发票编号
   * 发票编号不允许为空
   **/
  invoiceNo : string;

  /**
   * 业务类型 3.挂号收费 42.医嘱单收费
   * 业务类型不允许为空
   **/
  busiType : string;

}

/**  **/
export interface LisApplyItemPageVO  {
  /**
   *    **/
  id? : string;

  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 条码号
   **/
  barcode? : string;

  /**
   * 检验项目id
   **/
  itemId? : string;

  /**
   * 检验项目编码
   **/
  itemCode? : string;

  /**
   * 检验项目名称
   **/
  itemName? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 患者手机号码
   **/
  patientMobile? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  patientGender? : string;

  /**
   * 年龄
   **/
  patientAge? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 患者头像url
   **/
  patientHeadImageUrl? : string;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   * 样本id;涉及标本管理
   **/
  specimenId? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

  /**
   *    **/
  busiId? : string;

}

/** 测试加密修改名字参数 **/
export interface TestEncryptEditNameParam  {
  /**
   * id
   * id不允许为空
   **/
  id : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

}

/**  **/
export interface RegFeeDTO  {
  /**
   * 费用id
   **/
  feeId? : string;

  /**
   * 非药品项目id
   **/
  nondrugId? : string;

  /**
   * 非药品项目名称
   **/
  nondrugName? : string;

  /**
   * 必须收取
   **/
  mustCharge? : number;

  /**
   * 非药品项目零售价（单位：元）
   **/
  retailPrice? : string;

}

/**  **/
export interface HopsFeePayVO  {
  /**
   *    **/
  id? : string;

  /**
   *    **/
  billId? : string;

  /**
   *    **/
  tradeType? : string;

  /**
   *    **/
  payType? : string;

  /**
   *    **/
  ownPay? : number;

  /**
   *    **/
  payTotalPrice? : string;

  /**
   *    **/
  payStatus? : string;

  /**
   *    **/
  payTime? : string;

  /**
   *    **/
  transactionId? : string;

  /**
   *    **/
  relationPayId? : string;

  /**
   *    **/
  callbackId? : string;

}

/**  **/
export interface PacsApplyItemCountByStatusDTO  {
  /**
   * 状态
   **/
  status? : string;

  /**
   * 总数
   **/
  count? : string;

}

/**  **/
export interface PatientReportDTO  {
  /**
   * 病人唯一ID
   **/
  hisPatId? : string;

  /**
   * 报告编号
   **/
  hisReportNo? : string;

  /**
   * 报告名称
   **/
  reportName? : string;

  /**
   * 报告类型 1-检验报告；2-检查报告；
   **/
  type? : number;

  /**
   * 检查时间
   **/
  examineTime? : string;

  /**
   * 报告发布时间
   **/
  reportTime? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

  /**
   * 申请医生姓名
   **/
  applyDoctorName? : string;

  /**
   * 检查医生姓名
   **/
  examineDoctorName? : string;

  /**
   * 报告医生姓名
   **/
  reportDoctorName? : string;

  /**
   * 审核医生姓名
   **/
  auditDoctorName? : string;

  /**
   * 病人姓名
   **/
  patientName? : string;

  /**
   * 性别，1-男 2-女
   **/
  patientGender? : number;

  /**
   * 年龄
   **/
  patientAge? : number;

  /**
   * 小结
   **/
  reportItems? : string;

  /**
   * 诊断
   **/
  reportDiagnoses? : string;

  /**
   * 申请科室名称
   **/
  applyDepartment? : string;

  /**
   * 检查科室名称
   **/
  examineDepartment? : string;

  /**
   * 报告明细列
   **/
  items? : any;

  /**
   * 报告图片URL地址
   **/
  reportImgUrls? : any;

  /**
   * 医学影像URL
   **/
  dicomUrl? : string;

}

/**  **/
export interface OutpatientsAssembleSaveParam  {
  /**
   * 病历
   * 病历信息不允许为空
   **/
  mrecord : TaHopsMrecord;

  /**
   * 病历字段
   * 病历字段不允许为空
   **/
  mrecordFields : any;

  /**
   * 医嘱字段
   **/
  hopsOrder? : HopsOrderCreateParam;

}

/** 病历模板字段 **/
export interface TaHopsMrecordTemplateField extends BaseEntity{
  /**
   * 模板id;关联模板
   * 模板id;关联模板不允许为空
   **/
  templateId : number;

  /**
   * 字段编码
   * 字段编码不允许为空
   **/
  code : string;

  /**
   * 字段名称
   * 字段名称不允许为空
   **/
  name : string;

  /**
   * 数据类型;与java类型匹配字典：MRECORD_FIELD_DATA_TYPE
   * 数据类型;与java类型匹配字典：MRECORD_FIELD_DATA_TYPE不允许为空
   **/
  dataType : string;

  /**
   * 表单类型;html组件与扩张自定义组件。字典：MRECORD_FIELD_FORM_TYPE
   **/
  formType? : string;

  /**
   * 字典定义;如果是单选、多选、下拉时使用的字典定义
   **/
  dictDefineCode? : string;

  /**
   * 是否在表单可见
   **/
  formVisiable? : number;

  /**
   * 表单是否可以编辑;表单元素是否可编辑。
   **/
  formEditable? : number;

  /**
   * 是否必填
   **/
  requireFlag? : number;

  /**
   * 预览是否展示
   **/
  previewShowFlag? : number;

  /**
   * 数据来源类型;如患者、诊断、医嘱等。字典：MRECORD_FIELD_DATA_SOURCE_TYPE
   **/
  dataSourceType? : string;

  /**
   * 数据来源el表达式;数据来源el表达式，如数据来源类型为患者，则#item.name表示患者的名称，如果数据来源类型为诊断，(#item.masterFlag == 1 ? '[主]':'')+ #item.name +(#item.invalid == 1 ? '[废]':'')+'。'为所有诊断的拼接
   **/
  dataSourceExpression? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 复合项目明细新增入参 **/
export interface BaseCompositeItemCreateParam  {
  /**
   * 复合项目id
   * 复合项目id不允许为空
   **/
  compositeId : string;

  /**
   * 项目明细列表
   * 项目明细列表不允许为空
   **/
  items : any;

}

/** 字典项分页查询条件 **/
export interface DictItemPageParam extends PageParam{
  /**
   * 字典定义id
   **/
  defineId? : string;

  /**
   *    **/
  keyword? : string;

}

/** 科室排班更新入参 **/
export interface ScheduleDeptUpdateParam  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班日期
   * 排班日期不允许为空
   **/
  scheduleDate : string;

  /**
   * 科室;关联组织架构
   * 科室;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   * 时间段名称;镜像排班时间段的名称不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   * 预约限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  bookingVolume : number;

  /**
   * 诊室;关联诊室
   * 诊室;关联诊室不允许为空
   **/
  roomId : string;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 门诊执行定义患者分页查询统计 **/
export interface HopsExeDefinePatientStaticParam  {
  /**
   * 开始日期
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * 结束日期
   * 结束日期不允许为空
   **/
  endDate : string;

  /**
   * 关键字：唯一号、姓名、手机号、证件号码
   **/
  keyword? : string;

}

/**  **/
export interface LisResultCreateParam  {
  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   *    **/
  resultList? : any;

}

/** 查询患者参数 **/
export interface GetPatientDTO  {
  /**
   * 患者身份证号码
   **/
  idCard? : string;

}

/** 营收环比数据项VO **/
export interface RevenueMoMItemVO  {
  /**
   * 日期
   **/
  day? : string;

  /**
   * 营收
   **/
  revenuePrice? : string;

  /**
   * 就诊人次
   **/
  registerCount? : string;

  /**
   * 上月日期
   **/
  momDayLine? : string;

  /**
   * 上月营收
   **/
  momRevenuePrice? : string;

  /**
   * 上月就诊人次
   **/
  momRegisterCount? : string;

  /**
   * 营收对比
   **/
  revenueGapPrice? : string;

  /**
   * 营收环比
   **/
  revenueMomRatio? : string;

  /**
   * 就诊人数对比
   **/
  registerGapCount? : string;

  /**
   * 就诊人数环比
   **/
  registerMomRatio? : string;

}

/** agent接入VO **/
export interface AgentAccessVO  {
  /**
   * 接入id
   **/
  accessId? : string;

  /**
   * 接入密钥
   **/
  accessSecret? : string;

}

/** 检查申请项目 **/
export interface TaLisApplyItem extends BaseEntity{
  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 条码号
   **/
  barcode? : string;

  /**
   * 检验项目id
   **/
  itemId? : string;

  /**
   * 检验项目编码
   **/
  itemCode? : string;

  /**
   * 检验项目名称
   **/
  itemName? : string;

  /**
   * 次数;一个医嘱执行多次时，保存多条记录并且从1开始递增次数
   **/
  timeNo? : number;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   * 采样方式;字典：LIS_COLLECT_METHOD
   **/
  collectMethod? : string;

  /**
   * 样本id;涉及标本管理
   **/
  specimenId? : string;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 执行时间
   **/
  exeTime? : string;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 报告审核科室id
   **/
  auditDeptId? : string;

  /**
   * 报告审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 报告审核医生id
   **/
  auditUserId? : string;

  /**
   * 报告审核医生名称
   **/
  auditUserName? : string;

  /**
   * 报告审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 执行人工号
   **/
  exeUserAccount? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 是否需要报告，如果申请时没有检查项目则不需要报告
   **/
  needReport? : number;

  /**
   * 是否需要执行后才出报告
   **/
  needExe? : number;

}

/** 检查申请单据 **/
export interface HopsPacsApplyDocVO  {
  /**
   * 检查ID
   **/
  applyId? : string;

  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 单据名称
   **/
  docName? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 患者年龄
   **/
  patientAge? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 患者性别
   **/
  patientGenderText? : string;

  /**
   * 开单科室
   **/
  applyDeptName? : string;

  /**
   * 发往科室
   **/
  targetDeptName? : string;

  /**
   * 开单医生
   **/
  doctorName? : string;

  /**
   * 申请时间
   **/
  applyTimeText? : string;

  /**
   * 病历字段内容
   **/
  mrecordFields? : any;

  /**
   * 申请注意事项
   **/
  attentions? : string;

  /**
   * 申请项目
   **/
  items? : any;

  /**
   * 总金额
   **/
  totalPriceText? : string;

}

/**  **/
export interface FeeBillItemDTO  {
  /**
   * 主键ID
   **/
  id? : string;

  /**
   * 账单id;关联账单，合账后更新
   **/
  billId? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 业务种类;1. 门诊、2.住院、3：体检，字典：FEE_BUSI_KIND
   **/
  kindType? : string;

  /**
   * 种类业务id;业务种类为门诊,则为门诊id,
   **/
  kindItemId? : string;

  /**
   * 业务类型;字典：FEE_BILL_ITEM_BUSI
   **/
  busiType? : string;

  /**
   * 业务id;门诊id、住院id、医嘱id
   **/
  busiItemId? : string;

  /**
   * 目标人员id;针对门诊住院体检时，为患者id
   **/
  targetPersonId? : string;

  /**
   * 费用项目类型;1：非药品项目、2药品项目：字典：FEE_ITEM_TYPE
   **/
  feeItemType? : string;

  /**
   * 费用项目id
   **/
  feeItemId? : string;

  /**
   * 费用项目快照id;确费时针对药品非药品生成快照的id
   **/
  feeItemSnapshotId? : string;

  /**
   * 费用项目名称
   **/
  feeItemName? : string;

  /**
   * 费用项目单价;（单位：毫，1分=100毫），确费时更新
   **/
  feeItemPrice? : string;

  /**
   * 费用项目数量
   **/
  feeItemCount? : number;

  /**
   * 费用项目总价;（单位：毫，1分=100毫），确费时更新
   **/
  feeItemTotalPrice? : string;

  /**
   * 预计账时间
   **/
  recordTime? : string;

  /**
   * 确费时间
   **/
  sureTime? : string;

  /**
   * 账单项目状态;1：预记账、21：确费、20：取消、3：合账，字典：FEE_BILL_STATUS
   **/
  billItemStatus? : string;

  /**
   * 关联ID;如果已退款则关联的是退款项目ID
   **/
  relationId? : string;

  /**
   * 费用项目编码
   **/
  feeItemCode? : string;

  /**
   * 费用项目单位
   **/
  feeItemUnit? : string;

  /**
   * 已退款数量
   **/
  refundCount? : number;

}

/** 复合项目明细 **/
export interface TaBaseCompositeItem extends BaseEntity{
  /**
   * 复合项目id
   * 复合项目id不允许为空
   **/
  compositeId : string;

  /**
   * 项目id
   * 项目id不允许为空
   **/
  itemId : string;

  /**
   * 数量
   **/
  itemCount? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 门诊医嘱配发药分页查询条件 **/
export interface HopsDispensePageParam extends PageParam{
  /**
   * 开始日期
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * 结束日期
   * 结束日期不允许为空
   **/
  endDate : string;

  /**
   * 窗口id
   * 窗口id不允许为空
   **/
  windowId : string;

  /**
   * 类型 0=未配 1=已配 2=未发 3=已发 4=已退
   **/
  type? : string;

  /**
   * 关键字：唯一号、姓名、手机号、证件号码
   **/
  keyword? : string;

}

/** 门诊检验结果对比查询条件 **/
export interface HopsLisApplyResultCompareParam  {
  /**
   * 子项目编码
   * 子项目编码不允许为空
   **/
  subItemCode : string;

  /**
   * 比对次数
   * 比对次数不允许为空
   **/
  limitNum : number;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

}

/** 库房 VO **/
export interface WarehouseMatchingVO  {
  /**
   * 对码id
   **/
  id? : string;

  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   **/
  matchingType? : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   **/
  standardType? : string;

  /**
   * 内部编码
   **/
  intraCode? : string;

  /**
   * 内部名称
   **/
  intraCodeName? : string;

  /**
   * 标准编码
   **/
  standardCode? : string;

  /**
   * 标准名称
   **/
  standardName? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 医院信息 **/
export interface HospitalParam  {
  /**
   * 医院ID,hall平台自己的ID
   **/
  id? : string;

  /**
   * 医院名称
   **/
  name? : string;

  /**
   * 医院编码,不同的医保对接编码可能不一致
   **/
  hospitalMedinsCode? : string;

  /**
   * 医院医保区域编码(社区编码),不同的医保对接编码可能不一致
   **/
  medinsAreaCode? : string;

}

/** 药品信息 **/
export interface DrugForAllergySourceSearchResutlVO  {
  /**
   *    **/
  id? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 通用名
   **/
  commonName? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 用法
   **/
  usageName? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 零售价;单位：毫，1分为100毫，除以10000为元
   **/
  retailPrice? : string;

}

/**  **/
export interface FeePayDTO  {
  /**
   *    **/
  id? : string;

  /**
   *    **/
  billId? : string;

  /**
   *    **/
  tradeType? : string;

  /**
   *    **/
  payType? : string;

  /**
   *    **/
  ownPay? : number;

  /**
   *    **/
  payTotalPrice? : string;

  /**
   *    **/
  payStatus? : string;

  /**
   *    **/
  payTime? : string;

  /**
   *    **/
  transactionId? : string;

  /**
   *    **/
  relationPayId? : string;

  /**
   *    **/
  callbackId? : string;

  /**
   * 支付参数
   **/
  payParam? : string;

  /**
   * 支付项目明细
   **/
  payItems? : any;

}

/** 检查申请 **/
export interface TaPacsApply extends BaseEntity{
  /**
   * 申请渠道;1：门诊，2：住院，3：体检.字典：LIS_APPLY_CHANNEL
   * 申请渠道;1：门诊，2：住院，3：体检.字典：LIS_APPLY_CHANNEL不允许为空
   **/
  applyChannel : string;

  /**
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号不允许为空
   **/
  busiId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 患者名称
   * 患者名称不允许为空
   **/
  name : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   * 申请科室ID;申请科室id不允许为空
   **/
  applyDeptId : string;

  /**
   * 申请科室名称
   * 申请科室名称不允许为空
   **/
  applyDeptName : string;

  /**
   * 申请医生id
   * 申请医生id不允许为空
   **/
  applyDoctorId : string;

  /**
   * 申请医生名称
   * 申请医生名称不允许为空
   **/
  applyDoctorName : string;

  /**
   * 申请医生工号
   * 申请医生工号不允许为空
   **/
  applyDoctorAccount : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

}

/** 角色DTO **/
export interface AuthRoleDTO extends BaseEntity{
  /**
   * 应用id
   **/
  appId? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 权级;字典：AUTH_ROLE_GRADE
   **/
  grade? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 管辖科室范围列表
   **/
  orges? : any;

  /**
   * 资源列表
   **/
  allResources? : any;

  /**
   * 操作的资源信息
   **/
  operators? : any;

  /**
   * 菜单和菜单组信息
   **/
  menus? : any;

  /**
   * 其他资源信息
   **/
  otherResources? : any;

}

/** 医嘱 **/
export interface HopsMrecordOrderDocVO  {
  /**
   * 组合号
   **/
  groupNo? : number;

  /**
   * 名称
   **/
  itemName? : string;

  /**
   * 规格
   **/
  itemSpec? : string;

  /**
   * 总量
   **/
  totalQuantityText? : string;

  /**
   * 每次用量
   **/
  orderOnceDosageText? : string;

  /**
   * 每次单位
   **/
  orderOnceDosageUnit? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 用法
   **/
  usageName? : string;

  /**
   * 煎法
   **/
  tcmUsageTypeText? : string;

}

/** 执行实例 DTO **/
export interface HopsExeInstanceDTO  {
  /**
   *    **/
  id? : string;

  /**
   * 执行实例类型;1：院内执行。2：退费拟执行，字典：HOPS_EXE_INSTANCE_TYPE
   **/
  instanceType? : string;

  /**
   * 执行定义id
   **/
  exeDefineId? : string;

  /**
   * 执行次数
   **/
  exeTimeNo? : number;

  /**
   * 执行开始时间
   **/
  startTime? : string;

  /**
   * 执行结束时间
   **/
  endTime? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人账号
   **/
  exeUserAccount? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 状态;字典：HOPS_EXE_INSTANCE_STATUS
   **/
  status? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效操作人id
   **/
  invalidUserId? : string;

  /**
   * 无效操作人姓名
   **/
  invalidUserName? : string;

}

/** 会诊信息for受邀医生分页查询参数 **/
export interface PacsConsultationForTargetPageParam extends PageParam{
  /**
   * 关键字
   **/
  keyword? : string;

  /**
   * 状态;1: 待处理，2：完成，字典：PACS_CONSULTATION_STATUS
   **/
  status? : string;

}

/** 账单发票 DTO **/
export interface FeeBillInvoiceDTO  {
  /**
   * 主键ID
   **/
  id? : string;

  /**
   * 账单id
   **/
  billId? : string;

  /**
   * 发票媒介;1：纸质发票、2：收据、3：电子发票，字典：FEE_INVOICE_MEDIUM
   **/
  invoiceMedium? : string;

  /**
   * 发票类型;eg:专用发票、增值税发票，字典：FEE_INVOICE_TYPE
   **/
  invoiceType? : string;

  /**
   * 发票名称
   **/
  invoiceName? : string;

  /**
   * 发票代码
   **/
  invoiceCode? : string;

  /**
   * 发票日期
   **/
  invoiceDate? : string;

  /**
   * 发票号码
   **/
  invoiceNo? : string;

  /**
   * 发票检验码
   **/
  invoiceCheckCode? : string;

  /**
   * 开票方名称
   **/
  sourceName? : string;

  /**
   * 开票方纳税人识别号
   **/
  sourceCode? : string;

  /**
   * 开票方开户行
   **/
  sourceBank? : string;

  /**
   * 开票方银行账号
   **/
  sourceBankNo? : string;

  /**
   * 开票方地址
   **/
  sourceAddress? : string;

  /**
   * 开票方电话
   **/
  sourceTel? : string;

  /**
   * 收票方名称
   **/
  targetName? : string;

  /**
   * 收票方纳税人识别号
   **/
  targetCode? : string;

  /**
   * 收票方开户行
   **/
  targetBank? : string;

  /**
   * 收票方银行账号
   **/
  targetBankNo? : string;

  /**
   * 收票方地址
   **/
  targetAddress? : string;

  /**
   * 收票方电话
   **/
  targetTel? : string;

  /**
   * 总金额（单位：毫，1分=100毫）
   **/
  totalPrice? : string;

  /**
   * 总金额大写
   **/
  totalPriceWord? : string;

  /**
   * 税额
   **/
  invoicePrice? : string;

  /**
   * 发票密码区
   **/
  invoicePassword? : string;

  /**
   * 收款人
   **/
  receiverName? : string;

  /**
   * 复合人
   **/
  checkerName? : string;

  /**
   * 开票人
   **/
  openerName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 作废时间
   **/
  invalidTime? : string;

}

/** 用户VO **/
export interface AuthUserVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 账号
   **/
  account? : string;

  /**
   * 姓名
   **/
  name? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 生日
   **/
  birthday? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 邮箱
   **/
  email? : string;

  /**
   * 最后修改密码时间
   **/
  lastEditPwd? : string;

  /**
   * 密码状态;0:初始密码，1：正常
   **/
  pwdStatus? : number;

  /**
   * 允许连续错误密码次数;-1：系统全局限制
   **/
  pwdErrCount? : number;

  /**
   * 允许同时登陆次数;0：不受限制
   **/
  loginSameTimeCount? : number;

  /**
   * 账号状态;1：正常，2：锁定
   **/
  accountStatus? : number;

  /**
   * 归属组织机构信息
   **/
  authOrg? : TaAuthOrg;

  /**
   * 职务信息
   **/
  authDuty? : TaAuthDuty;

  /**
   * 职称
   **/
  title? : string;

  /**
   * 婚姻状态
   **/
  maritalStatus? : string;

  /**
   * 教育程度
   **/
  eduLevel? : string;

  /**
   * 联系人
   **/
  linkPerson? : string;

  /**
   * 联系人电话
   **/
  linkPersonTel? : string;

  /**
   * 联系人地址
   **/
  linkPersonAddress? : string;

  /**
   * 描述
   **/
  description? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 头像Url
   **/
  headImageUrl? : string;

  /**
   * 签名图片
   **/
  signImage? : string;

  /**
   * 签名图片签名图片url
   **/
  signImageUrl? : string;

  /**
   * 所属角色列表
   **/
  roles? : any;

  /**
   * 所属角色id列表
   **/
  roleIds? : any;

  /**
   * 所属组织机构列表
   **/
  orges? : any;

  /**
   * 所属组织机构id列表
   **/
  orgIds? : any;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 医院分页查询条件 **/
export interface DictHospitalPageParam extends PageParam{
  /**
   * 医院id;关联顶级科室id
   **/
  hospitalId? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 区域编码
   **/
  areaCode? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 医保区域类型;天津=tj
   **/
  areaType? : string;

}

/** 普通出库修改单参数 **/
export interface WarehouseCommonOutEditParam  {
  /**
   * 出库单ID
   **/
  id? : string;

  /**
   * 出库类型
   **/
  outType? : string;

  /**
   * 发往部门id
   * 发往部门不允许为空
   **/
  deptId : string;

  /**
   * 单据备注
   **/
  makeRemark? : string;

  /**
   * 出库药品
   **/
  outDrugs? : any;

}

/** dicom浏览器 **/
export interface TaPacsDicomViewer extends BaseEntity{
  /**
   * StudyInstanceUID
   * StudyInstanceUID不允许为空
   **/
  studyInstanceUid : string;

  /**
   * dicom浏览器url
   * dicom浏览器url不允许为空
   **/
  viewerUrl : string;

}

/** 组织机构VO **/
export interface AuthOrgVO  {
  /**
   * 组织机构id
   **/
  id? : string;

  /**
   * 上级组织机构id
   **/
  parentId? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 类型;字典：AUTH_ORG_TYPE
   * 类型;字典：AUTH_ORG_TYPE不允许为空
   **/
  orgType : number;

  /**
   * 地址
   **/
  address? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 子组织机构
   **/
  children? : any;

}

/** 门诊日结费用类型 **/
export interface HopsChargeFeeTypeVO  {
  /**
   * 名称
   **/
  name? : string;

  /**
   * 金额
   **/
  price? : string;

}

/** 执行定义与医嘱关系 **/
export interface TaHopsExeDefineOrder extends BaseEntity{
  /**
   * 执行定义id
   * 执行定义id不允许为空
   **/
  exeDefineId : string;

  /**
   * 医嘱id
   * 医嘱id不允许为空
   **/
  orderId : string;

}

/** 门诊检验申请项目 **/
export interface TaHopsLisApplyItem extends BaseEntity{
  /**
   * 门诊检验申请单id
   * 门诊检验申请单id不允许为空
   **/
  hopsApplyId : string;

  /**
   * lis检验申请单id
   * lis检验申请单id不允许为空
   **/
  lisApplyId : string;

  /**
   * lis检验申请单项目id
   * lis检验申请单项目id不允许为空
   **/
  lisApplyItemId : string;

  /**
   * 检验医嘱id
   **/
  orderId? : string;

  /**
   * 检验项目id;lis系统中的项目id
   **/
  lisItemId? : string;

  /**
   * 检验项目编码;lis系统中的项目编码
   * 检验项目编码;lis系统中的项目编码不允许为空
   **/
  lisItemCode : string;

  /**
   * 检验项目名称;lis系统中的项目名称
   **/
  lisItemName? : string;

  /**
   * 检验次数序号;lis系统中记录的同一个医嘱同一个项目的执行次数序号
   **/
  lisTimeNo? : number;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   * 采样方式;字典：LIS_COLLECT_METHOD
   **/
  collectMethod? : string;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 执行人工号
   **/
  exeUserAccount? : string;

  /**
   * 执行时间
   **/
  exeTime? : string;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 审核科室id
   **/
  auditDeptId? : string;

  /**
   * 审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 审核医生id
   **/
  auditUserId? : string;

  /**
   * 审核医生名称
   **/
  auditUserName? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 是否需要报告，如果申请时没有检查项目则不需要报告
   **/
  needReport? : number;

  /**
   * 是否需要执行后才出报告
   **/
  needExe? : number;

}

/** 医生排班模板VO **/
export interface ScheduleDoctorTemplateVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 星期几;1～7表示星期一到星期日
   **/
  week? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 排班时间段;关联排班时间段
   **/
  timeId? : string;

  /**
   * 排班时间段名称
   **/
  timeName? : string;

  /**
   * 开始时间;格式HH:mm
   * 开始时间;格式HH:mm不允许为空
   **/
  startTime : string;

  /**
   * 结束时间;格式HH:mm
   * 结束时间;格式HH:mm不允许为空
   **/
  endTime : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 动态类VO **/
export interface ClazzVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 字段
   **/
  fields? : any;

}

/** Hall适配前端统一的结果类 **/
export interface HallCaptchaResult  {
  /**
   * 编码
   **/
  code? : number;

  /**
   * 消息
   **/
  msg? : string;

  /**
   *    **/
  repCode? : string;

  /**
   *    **/
  repMsg? : string;

  /**
   *    **/
  repData? : any;

}

/** 角色分页查询条件 **/
export interface AuthRolePageParam extends PageParam{
  /**
   * 应用id
   **/
  appId? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 关键字
   **/
  keyword? : string;

}

/** 门诊费用明细下载参数 **/
export interface HopsFeeDetailDownParam  {
  /**
   * 门诊ID，患者唯一号，患者姓名关键字
   **/
  keyword? : string;

  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

}

/** 皮试分页查询条件 **/
export interface HopsSkinTestPageParam extends PageParam{
  /**
   * 执行定义id
   **/
  exeDefineId? : string;

  /**
   * 执行定义与医嘱关系id
   **/
  defineOrderId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 皮试结果;1：阳性，0：阴性
   **/
  skinTestResult? : number;

  /**
   * 皮试开始时间
   **/
  startTime? : string;

  /**
   * 皮试结束时间
   **/
  endTime? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 核验人id
   **/
  checkUserId? : string;

  /**
   * 核验人姓名
   **/
  checkUserName? : string;

  /**
   * 核验时间
   **/
  checkTime? : string;

  /**
   * 核验状态
   **/
  checkStatus? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 无效原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效操作人id
   **/
  invalidUserId? : string;

  /**
   * 无效操作人姓名
   **/
  invalidUserName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 皮试执行状态;1：执行中、2：执行完成，3：执行中断,字典：HOPS_SKIN_TEST_STATUS
   **/
  status? : string;

}

/** 门诊医嘱信息预创建入参 **/
export interface HopsOrderCreateCommand  {
  /**
   * 门诊挂号id;关联门诊挂号
   * 门诊挂号id不允许为空
   **/
  registerId : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 创建入参不允许为空
   * 创建入参
   **/
  sets : any;

}

/** 单据业务关联分页查询条件 **/
export interface DdocBusiPageParam extends PageParam{
  /**
   * 单据id;单据编码
   **/
  ddocCode? : string;

  /**
   * 业务类型;1：非药品，2：药品，3：复合项目,4:用法，5：项目分类，6：诊断、字典：DDOC_BUSI_TYPE
   **/
  busiType? : string;

  /**
   * 业务id
   **/
  busiId? : string;

}

/** 供应入库单修改参数 **/
export interface SupplyInEditParam  {
  /**
   * 入库单ID
   **/
  id? : string;

  /**
   * 供应商ID
   * 供应商不允许为空
   **/
  companyId : string;

  /**
   * 发票号
   * 发票号不允许为空
   **/
  invoiceNo : string;

  /**
   * 发票日期
   * 发票日期不允许为空
   **/
  invoiceDate : string;

  /**
   * 供货单号
   * 供货单号不允许为空
   **/
  supplyCode : string;

  /**
   * 入库类型
   * 入库类型不允许为空
   **/
  inType : string;

  /**
   * 采购员ID
   **/
  buyerId? : string;

  /**
   * 仓库员ID
   **/
  storageUserId? : string;

  /**
   * 制单备注
   **/
  makeRemark? : string;

  /**
   * 入库药品
   **/
  items? : any;

}

/** 窗口配置 ApiDTO **/
export interface WindowApiDTO  {
  /**
   * 窗口id
   **/
  id? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 药房id;关联药房配置
   **/
  dispensaryId? : string;

  /**
   * 药房名称
   **/
  dispensaryName? : string;

  /**
   * 是否开启;0：开启 ,1：关闭
   **/
  invalid? : number;

}

/**  **/
export interface BaseHopsStationDeptVO  {
  /**
   *    **/
  id? : string;

  /**
   * 护士站id
   **/
  stationId? : string;

  /**
   * 护士站名称
   **/
  stationName? : string;

  /**
   * 科室id
   **/
  deptIds? : any;

  /**
   * 科室名称
   **/
  deptNames? : any;

}

/** 门诊检验申请项目分页查询条件 **/
export interface HopsLisApplyItemPageParam extends PageParam{
  /**
   * 开始时间
   **/
  startDate? : string;

  /**
   * 结束时间
   **/
  endDate? : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

}

/** 科室排班VO **/
export interface ScheduleDeptVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 科室;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   **/
  timeName? : string;

  /**
   * 开始时间;根据排班日期与排班时间段的开始时间生成具体日期时间
   **/
  startTime? : string;

  /**
   * 结束时间;根据排班日期与排班时间段的结束时间生成具体日期时间
   **/
  endTime? : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 挂号数
   **/
  registeredVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : number;

  /**
   * 预约数
   **/
  bookedVolume? : number;

  /**
   * 预约收费的预约数量
   **/
  usedBookingVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 排班明细
   **/
  resources? : any;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 资源信息查询条件 **/
export interface AuthResourceListParam  {
  /**
   * 名称
   **/
  name? : string;

  /**
   * appId
   **/
  appId? : string;

}

/** 发票 VO **/
export interface FeeInvoiceVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 发票编号
   **/
  no? : string;

  /**
   * 所有人id
   **/
  ownerId? : string;

  /**
   * 所有人名称
   * 所有人名称不允许为空
   **/
  ownerName : string;

  /**
   * 是否已使用;1：是 0：否
   **/
  isUse? : number;

  /**
   * 是否无效;1：是 0：否
   **/
  invalid? : number;

  /**
   * 作废时间
   **/
  invalidTime? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 检验项目子项目 **/
export interface TaLisBaseSubItem extends BaseEntity{
  /**
   * 项目id;关联项目
   * 项目id;关联项目不允许为空
   **/
  itemId : string;

  /**
   * 子项目编码
   * 子项目编码不允许为空
   **/
  code : string;

  /**
   * 子项目名称
   * 子项目名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : string;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

  /**
   * 是否必录
   **/
  required? : number;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 出库单操作参数 **/
export interface WarehouseOutOperationParam  {
  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 随机数
   * 登陆签名错误
   **/
  random : string;

  /**
   * 令牌
   * 登陆签名错误
   **/
  token : string;

  /**
   * 出库单ID
   * 出库单ID不允许为空
   **/
  warehouseOutId : string;

}

/** agent授权参数 **/
export interface AgentAuthParam  {
  /**
   * 物理地址
   * agent的物理地址不允许为空
   **/
  macAddress : string;

  /**
   * agent的编码
   * agent的编码不允许为空
   **/
  agentCode : string;

}

/** 科室标签分页查询条件 **/
export interface BaseDeptTagPageParam extends PageParam{
  /**
   * 科室标签编码;字典：DEPT_TAG
   **/
  deptTag? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

}

/** 客户端软件版本分页查询条件 **/
export interface SoftVersionPageParam extends PageParam{
  /**
   * 软件编码
   **/
  softCode? : string;

  /**
   * 软件名称
   **/
  softName? : string;

  /**
   * 软件版本
   **/
  softVersion? : string;

}

/** Excel导入结果 VO **/
export interface BaseExcelImportResultVO  {
  /**
   *    **/
  total? : number;

  /**
   *    **/
  success? : number;

  /**
   *    **/
  fail? : number;

  /**
   *    **/
  errorMsgs? : any;

}

/** 退号发起请求参数 **/
export interface RegisterRefundParam  {
  /**
   * 挂号ID
   * 挂号ID不允许为空
   **/
  registerId : string;

  /**
   * 退号的项目ID数组
   **/
  feeItemIds? : any;

}

/** 报告模板分页查询条件 **/
export interface PacsBaseReportTemplatePageParam extends PageParam{
  /**
   * 检查类型;字典：PACS_TYPE
   **/
  pacsType? : string;

  /**
   * 模板编码
   **/
  code? : string;

  /**
   * 模板名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 模板内容;模板富文本内容
   **/
  content? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊中医症候 **/
export interface TaHopsTcmSymptom extends BaseEntity{
  /**
   * 门诊挂号id
   * 门诊挂号id不允许为空
   **/
  registerId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 中医症候id
   * 中医症候id不允许为空
   **/
  tcmSymptomId : string;

  /**
   * 中医症候编码
   * 中医症候编码不允许为空
   **/
  tcmSymptomCode : string;

  /**
   * 中医症候名称
   * 中医症候名称不允许为空
   **/
  tcmSymptomName : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 作废人id
   **/
  invalidUserId? : number;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

}

/** 入库单查询分页参数 **/
export interface WarehouseInSearchPageParam extends PageParam{
  /**
   * 制单开始日期
   **/
  makeStartDate? : string;

  /**
   * 制单结束日期
   **/
  makeEndDate? : string;

  /**
   * 出入库单据号、供应商、供货单号模糊查询关键字
   **/
  keyword? : string;

  /**
   * 入库类型
   **/
  inType? : string;

}

/** 门诊病历字段数据分页查询条件 **/
export interface HopsMrecordFieldPageParam extends PageParam{
  /**
   * 病历id
   **/
  mrecordId? : number;

  /**
   * 字段id;关联模板字段
   **/
  fieldId? : number;

  /**
   * 字段编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 字段值
   **/
  dataValue? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 单据业务关联 **/
export interface TaDdocBusi extends BaseEntity{
  /**
   * 单据id;单据编码
   * 单据id;单据编码不允许为空
   **/
  ddocCode : string;

  /**
   * 业务类型;1：非药品，2：药品，3：复合项目,4:用法，5：项目分类，6：诊断、字典：DDOC_BUSI_TYPE
   * 业务类型;1：非药品，2：药品，3：复合项目,4:用法，5：项目分类，6：诊断、字典：DDOC_BUSI_TYPE不允许为空
   **/
  busiType : string;

  /**
   * 业务id
   * 业务id不允许为空
   **/
  busiId : string;

}

/** 对码分页查询条件 **/
export interface DictMatchingPageParam extends PageParam{
  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   **/
  matchingType? : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   **/
  standardType? : string;

  /**
   * 开始时间
   **/
  startTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

  /**
   * 标准名称
   **/
  standardName? : string;

  /**
   * 关键字
   **/
  keyword? : string;

}

/**  **/
export interface BaseDeptTagVO  {
  /**
   * 科室标签编码;字典：DEPT_TAG
   **/
  deptTag? : string;

  /**
   * 科室id
   **/
  deptIds? : any;

  /**
   * 科室名称
   **/
  deptNames? : any;

}

/** 出库药品查询参数类 **/
export interface WarehouseOutDrugPageParam extends PageParam{
  /**
   * 关键字
   **/
  keyword? : string;

}

/** 用户查询条件入参 **/
export interface AuthUserConditionParam  {
  /**
   * 组织机构id
   * 组织机构id不允许为空
   **/
  orgId : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 门诊收费凭条-费用项目 **/
export interface HopsFeeItemVoucherDocVO  {
  /**
   * 项目名称
   **/
  name? : string;

  /**
   * 项目规格
   **/
  spec? : string;

  /**
   * 项目单价
   **/
  priceText? : string;

  /**
   * 项目数量
   **/
  count? : string;

  /**
   * 总价
   **/
  totalPriceText? : string;

}

/** 医生排班资源号DTO **/
export interface ScheduleDoctorResourceDTO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班id;关联科室排班表
   **/
  scheduleId? : string;

  /**
   * 看诊序号
   **/
  seqNum? : number;

  /**
   * 预估时间
   **/
  estimatedTime? : string;

  /**
   * 看诊开始时间（预估）
   **/
  startTime? : string;

  /**
   * 看诊结束时间（预估）
   **/
  endTime? : string;

  /**
   * 是否可预约
   **/
  bookingFlag? : number;

  /**
   * 挂号预约渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  channel? : string;

  /**
   * 预约挂号确认时间
   **/
  sureTime? : string;

  /**
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS不允许为空
   **/
  status : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 锁号时间
   **/
  lockTime? : string;

  /**
   * 解锁时间
   **/
  unlockTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 测试加密 **/
export interface TaTestEncrypt extends BaseEntity{
  /**
   * 姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 证件号码
   **/
  idcard? : string;

  /**
   * 地址
   **/
  address? : string;

}

/** 医嘱账单信息VO **/
export interface HopsOrderFeeBillVO  {
  /**
   * 账单ID
   **/
  id? : string;

  /**
   * 医院ID
   **/
  hospitalId? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 业务种类;1. 门诊、2.住院、3：体检，字典：FEE_BUSI_KIND
   **/
  kindType? : string;

  /**
   * 种类业务id;业务种类为门诊,则为门诊id
   **/
  kindItemId? : string;

  /**
   * 业务类型;字典：FEE_BILL_ITEM_BUSI
   **/
  busiType? : string;

  /**
   * 务id;门诊id、住院id、医嘱id
   **/
  busiItemId? : string;

  /**
   * 目标人员id;针对门诊住院体检时，为患者id
   **/
  targetPersonId? : string;

  /**
   * 目标人员快照id;关联目标人员快照表
   **/
  personSnapshotId? : string;

  /**
   * 总金额（单位：毫，1分=100毫）
   **/
  totalPrice? : string;

  /**
   * 待支付金额（单位：毫，1分=100毫）
   **/
  waitPayPrice? : string;

  /**
   * 支付金额（单位：毫，1分=100毫）
   **/
  payTotalPrice? : string;

  /**
   * 支付开始时间
   **/
  payStartTime? : string;

  /**
   * 支付完成时间
   **/
  payEndTime? : string;

  /**
   * 支付总状态;1：待支付，2：支付中, 31：支付成功，32：支付取消，字典：FEE_PAY_STATUS
   **/
  payTotalStatus? : string;

  /**
   * 关联id;如果是退款单，需要关联收费账单id
   **/
  relationId? : string;

  /**
   * 账单的所有支付信息
   **/
  pays? : any;

  /**
   * 支付信息说明
   **/
  payInfo? : string;

  /**
   * 账单的项目信息
   **/
  items? : any;

  /**
   * 账单的发票信息
   **/
  invoice? : FeeBillInvoiceDTO;

}

/** 挂号新增请求对象 **/
export interface HopsRegisterSaveParam  {
  /**
   * 挂号信息
   * 挂号信息不允许为空
   **/
  taHopsRegister : TaHopsRegister;

  /**
   * 非药品项目ids
   **/
  nondrugIds? : any;

}

/** 门诊药房配置 VO **/
export interface HopsDispensaryVO  {
  /**
   * 药房id
   **/
  id? : string;

  /**
   * 药房名称
   **/
  name? : string;

  /**
   * 关联科室id
   **/
  deptId? : string;

  /**
   * 关联科室名称
   **/
  deptName? : string;

  /**
   * 药品类型;字典：DISPENSARY_DRUG_TYPE
   **/
  drugType? : any;

  /**
   * 药品性质;字典：DISPENSARY_DRUG_QUALITY
   **/
  drugQuality? : any;

  /**
   * 门诊住院标志;字典：DISPENSARY_HOPS_HIPS_FLAG
   **/
  hopsHipsFlag? : any;

  /**
   * 渠道;字典：DISPENSARY_CHANNEL
   **/
  channel? : any;

  /**
   * 发货方式;字典：DISPENSARY_DELIVERY_TYPE
   **/
  deliveryType? : any;

  /**
   * 库存标记;0：禁用库存, 1：启用库存
   **/
  inventoryFlag? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 窗口信息
   **/
  windows? : any;

}

/** 患者过敏史查询分页参数 **/
export interface PatientAllergyHistorySearchPageParam extends PageParam{
  /**
   * 患者ID
   * 患者ID不允许为空
   **/
  patientId : string;

  /**
   * 查询关键字
   **/
  keyword? : string;

  /**
   * 过敏源类型,字典：ALL_ALLERGY_SOURCE_TYPE
   **/
  allergySourceType? : string;

}

/** 号源锁操作请求对象 **/
export interface ResourceLockParam  {
  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 号源id
   * 号源id不允许为空
   **/
  id : string;

  /**
   * 排班类型 1.科室排班 2.医生排班
   * 排班类型不允许为空
   **/
  scheduleType : string;

}

/** 药品库存查询结果 **/
export interface DrugSearchResultVO  {
  /**
   * 药品id
   **/
  id? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 通用名
   **/
  commonName? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 可用库存量
   **/
  useableStocksText? : string;

  /**
   * 实际库存量
   **/
  realStocksText? : string;

  /**
   * 实际库存量（数）
   **/
  realStocks? : number;

  /**
   * 散装可用库存量
   **/
  bulkUseableStocksText? : string;

  /**
   * 散装实际库存量
   **/
  bulkRealStocksText? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 货架号
   **/
  shelfCode? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 抗生素等级;字典：DRUG_ANTIBIOTICE_LEVEL
   **/
  antibioticsLevel? : string;

  /**
   * 抗菌药等级;字典：DRUG_ANTIBACTERIAL_LEVEL
   **/
  antibacterialLevel? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

  /**
   * 是否无效（停用）1：停用，0：有效
   **/
  invalid? : number;

  /**
   * 是否缺货，1：是。0：否
   **/
  outOfStock? : number;

}

/** 患者 **/
export interface TaHisPatient extends BaseEntity{
  /**
   * 门诊号;采用分布式序列递增
   **/
  hopsId? : string;

  /**
   * 住院号;采用分布式序列递增
   **/
  hipsId? : string;

  /**
   * 病案号;采用分布式序列递增
   **/
  caseId? : string;

  /**
   * 是否三无人员
   * 是否三无人员不允许未空
   **/
  noInfoPatient : number;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 建档渠道;字典：PATIENT_CHANNEL
   **/
  createChannel? : string;

  /**
   * 婚姻状况;字典：COMMON_MARITAL_STATUS
   **/
  maritalStatus? : string;

}

/** 辅材带出规则详细项目新增入参 **/
export interface BaseMaterialRuleItemCreateParam  {
  /**
   * 辅材带出规则id
   * 辅材带出规则id不允许为空
   **/
  materialRuleId : string;

  /**
   * 项目列表
   * 项目列表不允许为空
   **/
  items : any;

}

/** 病历模板字段分页查询条件 **/
export interface HopsMrecordTemplateFieldPageParam extends PageParam{
  /**
   * 字段编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 数据类型;与java类型匹配字典：MRECORD_FIELD_DATA_TYPE
   **/
  dataType? : string;

  /**
   * 表单类型;html组件与扩张自定义组件。字典：MRECORD_FIELD_FORM_TYPE
   **/
  formType? : string;

  /**
   * 字典定义;如果是单选、多选、下拉时使用的字典定义
   **/
  dictDefineCode? : string;

  /**
   * 是否在表单可见
   **/
  formVisiable? : number;

  /**
   * 表单是否可以编辑;表单元素是否可编辑。
   **/
  formEditable? : number;

  /**
   * 是否必填
   **/
  requireFlag? : number;

  /**
   * 预览是否展示
   **/
  previewShowFlag? : number;

  /**
   * 数据来源类型;如患者、诊断、医嘱等。字典：MRECORD_FIELD_DATA_SOURCE_TYPE
   **/
  dataSourceType? : string;

  /**
   * 数据来源el表达式;数据来源el表达式，如数据来源类型为患者，则#item.name表示患者的名称，如果数据来源类型为诊断，(#item.masterFlag == 1 ? '[主]':'')+ #item.name +(#item.invalid == 1 ? '[废]':'')+'。'为所有诊断的拼接
   **/
  dataSourceExpression? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 排班模板保存入参 **/
export interface ScheduleTemplateSaveParam  {
  /**
   * 星期几;1～7表示星期一到星期日
   * 星期几;1～7表示星期一到星期日不允许为空
   **/
  week : number;

  /**
   * 科室id;关联组织架构
   * 科室id;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 排班时间段;关联排班时间段
   * 排班时间段;关联排班时间段不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 对码新增或编辑入参 **/
export interface DictMatchingSaveOrUpdateParam  {
  /**
   *    **/
  id? : string;

  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   **/
  matchingType? : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   **/
  standardType? : string;

  /**
   * 内部编码
   **/
  intraCode? : string;

  /**
   * 内部名称
   **/
  intraCodeName? : string;

  /**
   * 标准编码
   * 标准编码不允许为空
   **/
  standardCode : string;

  /**
   * 标准名称
   * 标准名称不允许为空
   **/
  standardName : string;

}

/** 门诊配药单打印 DTO **/
export interface HopsDispensePrintVO  {
  /**
   * 打印时间
   **/
  printTime? : string;

}

/** 当前登陆用户的应用封装类 **/
export interface CurrentLoginAppDTO  {
  /**
   * appId
   **/
  id? : string;

  /**
   * 中文名
   **/
  chnName? : string;

  /**
   * 应用名
   **/
  appName? : string;

  /**
   * 应用类型;字典：AUTH_APP_TYPE
   **/
  appType? : number;

  /**
   * 应用版本
   **/
  appVersion? : string;

  /**
   * 应用协议;字典：COMMON_HTTP_PROTOCOL
   **/
  protocol? : string;

  /**
   * 应用域名
   **/
  appHost? : string;

  /**
   * 应用端口
   **/
  appPort? : number;

  /**
   * 应用端点
   **/
  contextPath? : string;

  /**
   * 图标
   **/
  icon? : string;

  /**
   * 样式
   **/
  styleClass? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否展示
   **/
  isShow? : number;

  /**
   * 角色信息
   **/
  roles? : any;

}

/** 过敏历史 **/
export interface AllergyHistoryItemVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 患者ID
   **/
  patientId? : string;

  /**
   * 过敏类型
   **/
  type? : string;

  /**
   * 过敏源
   **/
  subType? : string;

  /**
   * 过敏项目
   **/
  allergyItemName? : string;

  /**
   * 上报业务，字典：PATIENT_ALLERGY_BUSI_TYPE
   **/
  submitBusi? : string;

  /**
   * 操作人
   **/
  submitUserName? : string;

  /**
   * 操作科室
   **/
  submitDeptName? : string;

  /**
   * 操作时间
   **/
  submitTime? : string;

  /**
   * 是否作废,字典：COMMON_YES_NO
   **/
  invalid? : number;

  /**
   * 作废用户姓名
   **/
  invalidUserName? : string;

  /**
   * 作废时间
   **/
  invalidTime? : string;

  /**
   * 作废人科室名称
   **/
  invalidDeptName? : string;

  /**
   * 作废理由
   **/
  invalidReason? : string;

  /**
   * 开单科室
   **/
  orderDeptName? : string;

}

/** 门诊检查报告 **/
export interface TaHopsPacsReport extends BaseEntity{
  /**
   * 门诊检查申请id
   * 门诊检查申请id不允许为空
   **/
  hopsApplyId : string;

  /**
   * 门诊检查项目id
   * 门诊检查项目id不允许为空
   **/
  hopsApplyItemId : string;

  /**
   * PACS检查申请id;PACS系统返回
   * PACS检查申请id;PACS系统返回不允许为空
   **/
  pacsApplyId : string;

  /**
   * PACS检验申请项目id;PACS系统返回
   * PACS检验申请项目id;PACS系统返回不允许为空
   **/
  pacsApplyItemId : string;

  /**
   * 报告签名;PACS系统返回
   * 报告签名;PACS系统返回不允许为空
   **/
  reportSign : string;

  /**
   * 报告内容
   **/
  content? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 同步时间
   **/
  syncTime? : string;

  /**
   * 医学影像taskId
   **/
  medicalImageTaskId? : string;

}

/** 用户角色科室创建入参 **/
export interface AuthUserRoleOrgCreateParam  {
  /**
   * 组织机构ids
   **/
  orgIds? : any;

  /**
   * 角色id
   * 角色id不允许为空
   **/
  roleId : string;

  /**
   * 用户id
   * 用户id不允许为空
   **/
  userId : string;

}

/** 复合项目 VO **/
export interface BaseCompositeVO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名称
   **/
  commonName? : string;

  /**
   * 通用名称五笔码
   **/
  commonWubiCode? : string;

  /**
   * 通用名称拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 自定义编码
   **/
  customCode? : string;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 默认天数
   **/
  defaultUsageDays? : number;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 用法id;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 基本用量
   **/
  baseUsageVolume? : number;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 零售价（分）
   **/
  retailPrice? : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 采购价格（分）
   **/
  purchasePrice? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 报告说明
   **/
  reportMemo? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室名称
   **/
  openDeptNames? : any;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptNames? : any;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptNames? : any;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 检查部位是否必填
   **/
  isCheckPointRequired? : number;

  /**
   * 检验样本是否必填
   **/
  isSpecimenRequired? : number;

}

/** 检验结果 **/
export interface TaLisResult extends BaseEntity{
  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 申请项目id
   * 申请项目id不允许为空
   **/
  applyItemId : string;

  /**
   * 检验子项目id
   * 检验子项目id不允许为空
   **/
  subItemId : string;

  /**
   * 检验子项目名称
   **/
  subItemName? : string;

  /**
   * 检验子项目编码
   **/
  subItemCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 检验机器id
   **/
  machineId? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 结果签名;md5(apply_item_id+sub_item_id+sub_item_name+sub_item_code+result+unit+reference_min+reference_text+reference_max+compare_flag)
   **/
  resultSign? : string;

  /**
   * 结果
   **/
  result? : string;

  /**
   * 结果单位
   **/
  unit? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : string;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : string;

  /**
   * 结果比较标记;字典：LIS_RESULT_COMPARE_FLAG
   **/
  compareFlag? : string;

  /**
   * 是否必录
   **/
  required? : number;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

}

/**  **/
export interface OutpatientsAssembleDetailVO  {
  /**
   * 病历基础信息
   **/
  hopsMrecordDetail? : HopsMrecordDetailVo;

  /**
   * 病历字段信息
   **/
  hopsMrecordFieldDetail? : any;

  /**
   *    **/
  hopsOrderSetDetailDTOS? : any;

  /**
   *    **/
  hopsRegisterDTO? : HopsRegisterDTO;

}

/** 门诊医嘱配发药项目 DTO **/
export interface HopsDispenseItemDTO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 配发药id
   **/
  dispenseId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 组号
   * 组号不允许为空
   **/
  groupNo : number;

  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目类型;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 规格
   **/
  itemSpecs? : string;

  /**
   * 批次号
   **/
  batchNo? : string;

  /**
   * 药品有效期
   **/
  validDate? : string;

  /**
   * 货架号
   **/
  shelfCode? : string;

  /**
   * 出库单id
   **/
  warehouseOutId? : string;

  /**
   * 中药用法;字典：TCM_USAGE_TYPE
   **/
  tcmUsageType? : string;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 每次用量
   **/
  onceDosage? : number;

  /**
   * 总量
   **/
  totalQuantity? : number;

  /**
   * 确认量
   **/
  confirmQuantity? : number;

  /**
   * 总量单位
   **/
  totalUnit? : string;

  /**
   * 单价
   **/
  retailPrice? : string;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 退药信息
   **/
  returnInfo? : HopsDispenseReturnInfoDTO;

  /**
   * 项目标识;0未配 1：已配，2：已发， 4：部分退， 5：全退
   **/
  itemFlag? : number;

  /**
   * 退药时间
   **/
  returnTime? : string;

  /**
   * 退药用户id
   **/
  returnUserId? : string;

  /**
   * 退药用户账号
   **/
  returnUserAccount? : string;

  /**
   * 退药用户名称
   **/
  returnUserName? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 账单支付 VO **/
export interface OutpatientsFeePayVO  {
  /**
   *    **/
  id? : string;

  /**
   *    **/
  billId? : string;

  /**
   *    **/
  tradeType? : string;

  /**
   *    **/
  payType? : string;

  /**
   *    **/
  ownPay? : number;

  /**
   *    **/
  payTotalPrice? : string;

  /**
   *    **/
  payStatus? : string;

  /**
   *    **/
  payTime? : string;

  /**
   *    **/
  transactionId? : string;

  /**
   *    **/
  relationPayId? : string;

  /**
   *    **/
  callbackId? : string;

  /**
   * 支付参数
   **/
  payParam? : string;

}

/** 会诊建议提交 **/
export interface PacsConsultationAdviceParam  {
  /**
   *    * 会诊ID不允许为空
   **/
  id : string;

  /**
   *    * 会诊建议不允许为空
   **/
  advice : string;

}

/** 患者检查项目VO **/
export interface PatientPacsItemVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 患者唯一号
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 诊断
   **/
  diagnose? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 申请科室
   **/
  applyDeptName? : string;

  /**
   * 申请医生
   **/
  applyDoctorName? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 检查人
   **/
  checkUserName? : string;

  /**
   * 检查时间
   **/
  checkTime? : string;

  /**
   * 报告人
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 审核人
   **/
  auditUserName? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

}

/** 资源DTO **/
export interface AuthResourceDTO  {
  /**
   * 资源id
   **/
  id? : string;

  /**
   * 应用id;关联资源表
   **/
  appId? : string;

  /**
   * 上级资源id
   **/
  parentId? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 组件名称
   **/
  component? : string;

  /**
   * 组件重定向地址
   **/
  redirect? : string;

  /**
   * 界面打开target
   **/
  target? : string;

  /**
   * 资源类型;字典：AUTH_RESOURCE_TYPE
   **/
  resourceType? : number;

  /**
   * 资源键
   **/
  resourceKey? : string;

  /**
   * 请求地址
   **/
  requestUrl? : string;

  /**
   * 请求方法;字典：COMMON_HTTP_METHOD
   **/
  requestMethod? : number;

  /**
   * 是否外链
   **/
  isFrame? : number;

  /**
   * 是否展示
   * 是否展示不允许为空
   **/
  visible : number;

  /**
   * icon
   **/
  icon? : string;

  /**
   * 排序字段
   * 排序字段不允许为空
   **/
  sortNo : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 子组织机构
   **/
  children? : any;

}

/** 药品库存查询参数 **/
export interface DrugSearchPageParam extends PageParam{
  /**
   * 关键字
   **/
  keyword? : string;

  /**
   * 库存状态,1:不为0，2:为0，3：全部
   **/
  storageStatus? : number;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 抗菌药等级;字典：DRUG_ANTIBACTERIAL_LEVEL
   **/
  antibacterialLevel? : string;

  /**
   * 抗生素等级;字典：DRUG_ANTIBIOTICE_LEVEL
   **/
  antibioticsLevel? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

}

/** 会诊科室 **/
export interface ConsultationOrgNodeVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 父级id
   **/
  parentId? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 下级结点
   **/
  children? : any;

}

/** 药品过敏源查询结果VO **/
export interface DrugAllergySourceSearchResultVo  {
  /**
   * id
   **/
  id? : string;

  /**
   * 过敏原类型,字典:DRUG_ALLERGY_SOURCE_TYPE
   **/
  allergySourceType? : string;

  /**
   * 药品ID
   **/
  drugId? : string;

  /**
   * 药品编码
   **/
  drugCode? : string;

  /**
   * 药品名称
   **/
  drugName? : string;

  /**
   * 皮试时效
   **/
  skinTestValidHour? : number;

}

/** 修改当前密码参数 **/
export interface AuthEditCurrentUserPwdParam  {
  /**
   * 旧的密码
   **/
  ollPwd? : string;

  /**
   * 新的密码
   **/
  newPwd? : string;

}

/** 资源DTO **/
export interface AuthResourceVO  {
  /**
   * 资源id
   **/
  id? : string;

  /**
   * 应用id;关联资源表
   **/
  appId? : string;

  /**
   * 上级资源id
   **/
  parentId? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 组件名称
   **/
  component? : string;

  /**
   * 组件重定向地址
   **/
  redirect? : string;

  /**
   * 界面打开target
   **/
  target? : string;

  /**
   * 资源类型;字典：AUTH_RESOURCE_TYPE
   **/
  resourceType? : number;

  /**
   * 资源键
   **/
  resourceKey? : string;

  /**
   * 请求地址
   **/
  requestUrl? : string;

  /**
   * 请求方法;字典：COMMON_HTTP_METHOD
   **/
  requestMethod? : number;

  /**
   * 是否外链
   **/
  isFrame? : number;

  /**
   * 是否展示
   * 是否展示不允许为空
   **/
  visible : number;

  /**
   * icon
   **/
  icon? : string;

  /**
   * 排序字段
   * 排序字段不允许为空
   **/
  sortNo : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 子组织机构
   **/
  children? : any;

}

/**  **/
export interface HopsRegisterInfoVO  {
  /**
   * 状态
   **/
  status? : number;

  /**
   * 挂号ID
   **/
  id? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 头像无损图片地址
   **/
  headImageUrl? : string;

  /**
   * 头像缩略图地址
   **/
  headThumbnailUrl? : string;

  /**
   * 挂号日期
   **/
  registerDate? : string;

  /**
   * 当日号;挂号当日递增序列算法
   **/
  daySeqNum? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL不允许为空
   **/
  registerChannel : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 看诊时间段开始时间
   **/
  seeStartTime? : string;

  /**
   * 看诊时间段结束时间
   **/
  seeEndTime? : string;

  /**
   * 看诊断序号
   **/
  seeSeqNum? : number;

  /**
   * 挂号操作人
   **/
  createUserName? : string;

  /**
   * 挂号时间
   **/
  createTime? : string;

  /**
   * 支付账单ID
   **/
  billId? : string;

  /**
   * 退费账单ID
   **/
  refundBillId? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

  /**
   * 医生id
   **/
  doctorId? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 挂号级别名称
   **/
  levelName? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/** 出库单项目 **/
export interface WarehouseOutItemDetailVO  {
  /**
   * 出库项id
   **/
  id? : string;

  /**
   * 入库项id
   **/
  inItemId? : string;

  /**
   * 药品id
   **/
  drugId? : string;

  /**
   * 药品编码
   **/
  drugCode? : string;

  /**
   * 药品名称
   **/
  drugName? : string;

  /**
   * 药品通用名
   **/
  drugCommonName? : string;

  /**
   * 药品规格
   **/
  drugSpecs? : string;

  /**
   * 生产厂家
   **/
  companyName? : string;

  /**
   * 批次
   **/
  batchNo? : string;

  /**
   * 有效期
   **/
  validDate? : string;

  /**
   * 出库包装数量
   **/
  packageQuantity? : number;

  /**
   * 出库包装单位
   **/
  packageUnit? : string;

  /**
   * 出库散装数量
   **/
  bulkQuantity? : number;

  /**
   * 出库散装单位
   **/
  bulkUnit? : string;

  /**
   * 包装数
   **/
  packageCount? : number;

  /**
   * 购入价
   **/
  inPrice? : string;

  /**
   * 购入金额
   **/
  inTotalPrice? : string;

  /**
   * 零售价
   **/
  retailPrice? : string;

  /**
   * 零售金额
   **/
  retailTotalPrice? : string;

  /**
   * 差价（零售单价-入库单价
   **/
  profitPrice? : string;

  /**
   * 差价金额（零售总价-入库总价）
   **/
  profitTotalPrice? : string;

}

/** 药房配置更新入参 **/
export interface BaseDispensaryUpdateParam  {
  /**
   * 药房id
   * 药房id不允许为空
   **/
  id : string;

  /**
   * 药房名称
   **/
  name? : string;

  /**
   * 科室id;关联科室
   * 科室id不允许为空
   **/
  deptId : string;

  /**
   * 药品类型;字典：DISPENSARY_DRUG_TYPE
   * 药品类型不允许为空
   **/
  drugType : any;

  /**
   * 药品性质;字典：DISPENSARY_DRUG_QUALITY
   * 药品性质不允许为空
   **/
  drugQuality : any;

  /**
   * 门诊住院标志;字典：DISPENSARY_HOPS_HIPS_FLAG
   * 门诊住院标志不允许为空
   **/
  hopsHipsFlag : any;

  /**
   * 渠道;字典：DISPENSARY_CHANNEL
   * 渠道不允许为空
   **/
  channel : any;

  /**
   * 发货方式;字典：DISPENSARY_DELIVERY_TYPE
   * 发货方式不允许为空
   **/
  deliveryType : any;

  /**
   * 库存标记;0：禁用库存, 1：启用库存
   * 库存标记不允许为空
   **/
  inventoryFlag : number;

  /**
   * 是否无效;0：否, 1：是
   * 是否无效不允许为空
   **/
  invalid : number;

}

/** 医嘱患者 VO **/
export interface HopsOrderPatientChargeVO  {
  /**
   * 患者ID
   **/
  id? : string;

  /**
   * 挂号编号;兼容非字符串挂号编号，默认为id
   **/
  registerNo? : string;

  /**
   * 当日号;挂号当日递增序列算法
   **/
  daySeqNum? : string;

  /**
   * 患者id;关联患者
   * 患者id;关联患者不允许为空
   **/
  patientId : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址行政区划编码
   **/
  linkmanAreaCode? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 挂号类型;字典：HOPS_REGISTER_TYPE
   * 挂号类型;字典：HOPS_REGISTER_TYPE不允许为空
   **/
  registerType : string;

  /**
   * 号源;关联科室医生排班
   * 号源不允许为空
   **/
  resourceId : string;

  /**
   * 挂号日期
   * 挂号日期不允许为空
   **/
  registerDate : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  levelId : string;

  /**
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL不允许为空
   **/
  registerChannel : string;

  /**
   * 排班id;关联排班表
   * 排班id;关联排班表不允许为空
   **/
  scheduleId : string;

  /**
   * 排班类型;1：科室排班，2：医生排班；字典：HOPS_SCHEDULE_TYPE
   * 排班类型;1：科室排班，2：医生排班；字典：HOPS_SCHEDULE_TYPE不允许为空
   **/
  scheduleType : string;

  /**
   * 排班段名称
   * 排班段名称不允许为空
   **/
  timeName : string;

  /**
   * 看诊时间段开始时间
   * 看诊时间段开始时间不允许为空
   **/
  seeStartTime : string;

  /**
   * 看诊时间段结束时间
   * 看诊时间段结束时间不允许为空
   **/
  seeEndTime : string;

  /**
   * 看诊断预估时间
   * 看诊断预估时间不允许为空
   **/
  seeEstimatedTime : string;

  /**
   * 看诊断序号
   * 看诊断序号不允许为空
   **/
  seeSeqNum : number;

  /**
   * 科室id;关联组织架构
   * 科室id;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 科室名称
   * 科室名称不允许为空
   **/
  deptName : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 预约id
   **/
  bookingId? : number;

  /**
   * 是否初诊
   **/
  firstSeeFlag? : number;

  /**
   * 是否加号
   **/
  appendFlag? : number;

  /**
   * 是否急诊
   **/
  emergencyFlag? : number;

  /**
   * 是否加急
   **/
  urgentFlag? : number;

  /**
   * 状态;0：退号、1：锁号待支付、21.支付成功、20.支付取消、22：退号中、3.待看诊、4.已看诊
   **/
  status? : number;

  /**
   * 支付账单ID
   **/
  billId? : string;

  /**
   * 退费账单ID
   **/
  refundBillId? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/** 行政区划分页查询条件 **/
export interface DictAreaPageParam extends PageParam{
  /**
   * 上级行政区划编码
   **/
  parentId? : string;

  /**
   * 类型;字典：COMMON_AREA_TYPE
   **/
  type? : number;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 全称
   **/
  fullName? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 是否作废
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 药品过敏源查询参数 **/
export interface DrugAllergySourceSearchPageParam extends PageParam{
  /**
   * 过敏原类型,字典:DRUG_ALLERGY_SOURCE_TYPE
   * 过敏源类型不允许为空
   **/
  allergySourceType : string;

  /**
   *    **/
  keyword? : string;

}

/** 处方查询参数 **/
export interface RecipeSearchDTO  {
  /**
   * 患者唯一ID
   **/
  hisPatId? : string;

  /**
   * 开始时间
   **/
  beginTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

}

/** 对码导入入参 **/
export interface DictMatchingImportParam  {
  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   * 对码类型;字典：MEDINS_MATCHING_TYPE;不允许为空
   **/
  matchingType : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   * 标准类型;字典：MEDINS_STANDARD_TYPE;不允许为空
   **/
  standardType : string;

  /**
   * 文件id
   **/
  fileId? : string;

}

/** 患者药品过敏检查参数 **/
export interface PatientDrugAllergyCheckParam  {
  /**
   * 患者ID
   * 患者ID不允许为空
   **/
  patientId : string;

  /**
   * 患者ID
   * 患者ID不允许为空
   **/
  drugId : string;

}

/** 天津医保支付取消入参 **/
export interface TJMedinsPayCancelParam  {
  /**
   * 支付id
   **/
  payId? : string;

}

/** 诊台 VO **/
export interface BaseHopsDeskVO  {
  /**
   *    **/
  id? : string;

  /**
   * 诊室
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 患者药品检查结果 **/
export interface PatientDrugCheckResultVO  {
  /**
   * 药品ID
   **/
  drugId? : string;

  /**
   * 药品名称
   **/
  drugName? : string;

  /**
   * 检查结果,字典：PATIENT_DRUG_ALLERGY_CHECK_RESULT
   **/
  checkResult? : string;

  /**
   * 描述信息
   **/
  msg? : string;

  /**
   * 药品是否需要皮试
   **/
  skinTestFlag? : number;

  /**
   * 皮试时效(单位小时)
   **/
  skinTestValidHour? : number;

}

/** 辅材带出规则分页查询条件 **/
export interface BaseMaterialRulePageParam extends PageParam{
  /**
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE
   * 规则业务类型不允许为空
   **/
  ruleBusiType : any;

  /**
   * 关键字
   **/
  keyword? : string;

}

/** 患者报告查询条件 **/
export interface PatientReportSearchDTO  {
  /**
   * 患者唯一ID
   **/
  hisPatId? : string;

  /**
   * 开始时间
   **/
  beginTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

}

/** 辅材带出规则项目明细 DTO **/
export interface BaseMaterialRuleItemDTO  {
  /**
   * 辅材项目主键
   **/
  id? : string;

  /**
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE不允许为空
   **/
  ruleBusiType : string;

  /**
   * 规则业务id
   * 规则业务id不允许为空
   **/
  ruleBusiId : string;

  /**
   * 规则名称
   * 规则名称不允许为空
   **/
  name : string;

  /**
   * 备注
   * 备注不允许为空
   **/
  remark : string;

  /**
   * 辅材带出规则id
   **/
  materialRuleId? : string;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 允许开立科室;科室id以,分割拼接;空为所有科室
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室啊名称;科室名称以,分割拼接;
   **/
  openDeptNames? : string;

  /**
   * 门诊执行科室
   **/
  hopsExeDept? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptName? : string;

  /**
   * 住院执行科室
   **/
  hipsExeDept? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptName? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 项目类型;1：非药品项目、2药品项目 3复合项目 ;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 辅材数量
   **/
  itemCount? : number;

  /**
   * 项目规格
   **/
  itemSpecs? : string;

  /**
   * 项目单位
   **/
  itemUnit? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 基本用量
   **/
  itemBaseUsageVolume? : number;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 零售价（单位：毫，1分=100毫））
   **/
  retailPrice? : string;

  /**
   * 辅材计算类型;1:固定数量、2、执行次数、3、按执行天数 字典：MATERIAL_ITEM_CAL_TYPE
   **/
  itemCalType? : string;

  /**
   * 带出总量
   **/
  totalCount? : number;

  /**
   * 是否默认带出;0：否 1：是
   **/
  isDefault? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 频次分页查询条件 **/
export interface BaseFrequencyPageParam extends PageParam{
  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 门诊执行定义医嘱 DTO **/
export interface HopsExeDefineOrderDTO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 执行定义id
   **/
  exeDefineId? : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 医嘱开立每次剂量
   **/
  orderOnceDosage? : number;

  /**
   * 医嘱开立每次剂量单位
   **/
  orderOnceDosageUnit? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 药品标志；0：非药品 1：药品
   **/
  drugFlag? : number;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 皮试标志
   **/
  skinTestFlag? : number;

  /**
   * 皮试结果;1：阳性，0：阴性
   **/
  skinTestResult? : number;

  /**
   * 是否带出辅材;0：否 1：是
   **/
  materialFlag? : number;

  /**
   * 发药标志;0：未发 1：已发
   **/
  deliverFlag? : number;

}

/** 配发药审核入参 **/
export interface HopsDispenseAuditParam extends HopsDispenseBaseAuditParam{
  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 随机数
   * 登陆签名错误
   **/
  random : string;

  /**
   * 令牌
   * 登陆签名错误
   **/
  token : string;

}

/** 会诊申请参数 **/
export interface PacsConsultationApplyParam  {
  /**
   *    * 会诊项目不允许为空
   **/
  applyItemId : string;

  /**
   *    * 邀请科室不允许为空
   **/
  targetOrgId : string;

  /**
   *    * 邀请医生不允许为空
   **/
  targetDoctorId : string;

  /**
   * 是否紧急
   **/
  urgentFlag? : number;

  /**
   *    * 会诊说明不允许为空
   **/
  remark : string;

}

/** 非药品分页查询条件 **/
export interface BaseNondrugPageParam extends PageParam{
  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : any;

  /**
   * 医保分类;字典：MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : any;

  /**
   * 当前开立科室
   **/
  openDeptId? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : any;

  /**
   * 搜索关键字
   **/
  keyword? : string;

  /**
   * 挂号级别id
   **/
  regLevelId? : string;

}

/** 治疗申请单 **/
export interface HopsCureApplyDocVO  {
  /**
   * 申请ID
   **/
  applyId? : string;

  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 申请单名称
   **/
  docName? : string;

  /**
   * 患者ID
   **/
  patientId? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 患者年龄
   **/
  patientAge? : string;

  /**
   * 患者性别
   **/
  patientGenderText? : string;

  /**
   * 申请科室
   **/
  applyDeptName? : string;

  /**
   * 目标科室
   **/
  targetDeptName? : string;

  /**
   * 申请医生名称
   **/
  doctorName? : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 病历信息
   **/
  mrecordFields? : any;

  /**
   * 注意事项
   **/
  attentions? : string;

  /**
   * 申请项目
   **/
  items? : any;

  /**
   * 总金额
   **/
  totalPriceText? : string;

}

/** 仓库日志查询结果 **/
export interface WarehouseLogSearchResultVO  {
  /**
   * 日志ID
   **/
  id? : string;

  /**
   * 仓库动作
   **/
  actionType? : string;

  /**
   * 业务模块
   **/
  busiModule? : string;

  /**
   * 出入库类型
   **/
  inOutType? : string;

  /**
   * 编码
   **/
  drugCode? : string;

  /**
   * 名称
   **/
  drugName? : string;

  /**
   * 规格
   **/
  drugSpecs? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 操作前可用库存量
   **/
  beforeUseableStocksText? : string;

  /**
   * 操作前实际库存量
   **/
  beforeRealStocksText? : string;

  /**
   * 影响预扣库存量
   **/
  affectStocksText? : string;

  /**
   * 影响实际库存量
   **/
  affectRealStocksText? : string;

  /**
   * 操作后可用库存量
   **/
  afterUseableStocksText? : string;

  /**
   * 操作后实际库存量
   **/
  afterRealStocksText? : string;

  /**
   * 操作数量
   **/
  busiQuantityText? : string;

  /**
   * 批次号
   **/
  batchNo? : string;

  /**
   * 有效日期
   **/
  validDate? : string;

  /**
   * 业务单号（出库单号、入库单号、医嘱号）
   **/
  busiId? : string;

  /**
   * 制单人id
   **/
  makeUserId? : string;

  /**
   * 制单人姓名
   **/
  makeUserName? : string;

  /**
   * 业务科室
   **/
  busiDeptName? : string;

  /**
   * 操作时间
   **/
  logTime? : string;

}

/** 门诊病历 **/
export interface TaHopsMrecord extends BaseEntity{
  /**
   * 病历类型;字典：HOPS_MRECORD_TYPE
   * 病历类型;字典：HOPS_MRECORD_TYPE不允许为空
   **/
  mrecordType : string;

  /**
   * 病历模板id;关联病历模板
   * 病历模板id;关联病历模板不允许为空
   **/
  templateId : string;

  /**
   * 门诊挂号id;关联门诊挂号
   * 门诊挂号id;关联门诊挂号不允许为空
   **/
  registerId : string;

  /**
   * 患者id;关联患者
   * 患者id;关联患者不允许为空
   **/
  patientId : string;

  /**
   * 状态;字典：HOPS_MRECORD_STATUS
   **/
  status? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : number;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

}

/** 动态单据字段 **/
export interface TaDdocTemplateField extends BaseEntity{
  /**
   * 单据id;单据id
   * 单据id;单据id不允许为空
   **/
  ddocId : string;

  /**
   * 字段编码
   * 字段编码不允许为空
   **/
  code : string;

  /**
   * 字段名称
   * 字段名称不允许为空
   **/
  name : string;

  /**
   * 数据类型;与java类型匹配字典：DDOC_FIELD_DATA_TYPE
   * 数据类型;与java类型匹配字典：DDOC_FIELD_DATA_TYPE不允许为空
   **/
  dataType : string;

  /**
   * 表单类型;html组件与扩张自定义组件。字典：DDOC_FIELD_FORM_TYPE
   **/
  formType? : string;

  /**
   * 字典定义;如果是单选、多选、下拉时使用的字典定义
   **/
  dictDefineCode? : string;

  /**
   * 是否在表单可见
   **/
  formVisiable? : number;

  /**
   * 表单是否可以编辑;表单元素是否可编辑。
   **/
  formEditable? : number;

  /**
   * 是否必填
   **/
  requireFlag? : number;

  /**
   * 预览是否展示
   **/
  previewShowFlag? : number;

  /**
   * 数据来源类型;如患者、诊断、医嘱等。字典：DDOC_FIELD_DATA_SOURCE_TYPE
   **/
  dataSourceType? : string;

  /**
   * 数据来源el表达式;数据来源el表达式，如数据来源类型为患者，则#item.name表示患者的名称，如果数据来源类型为诊断，(#item.masterFlag == 1 ? '[主]':'')+ #item.name +(#item.invalid == 1 ? '[废]':'')+'。'为所有诊断的拼接
   **/
  dataSourceExpression? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 用户角色科室查询条件 **/
export interface AuthUserRoleOrgListParam  {
  /**
   * 角色ID
   **/
  roleId? : string;

  /**
   * '用户id'
   **/
  userId? : string;

}

/** 门诊病历打印数据 **/
export interface HopsMrecordDocVO  {
  /**
   * 医院名字
   **/
  hospitalName? : string;

  /**
   * 挂号ID
   **/
  registerId? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 患者性别
   **/
  genderText? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 看诊时间
   **/
  seeTimeText? : string;

  /**
   * 科室
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 电子病历动态字段
   **/
  fields? : any;

  /**
   * 医嘱组:包含处方/诊疗信息
   **/
  orderAssemblys? : any;

}

/** 门诊执行定义分页查询条件 **/
export interface HopsExeDefinePageParam extends PageParam{
  /**
   * 门诊ID
   **/
  registerId? : string;

  /**
   * 总共需要执行的次数
   **/
  totalExeCount? : number;

  /**
   * 用法ID
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 执行类型;字典：USAGE_EXE_TYPE
   **/
  exeType? : string;

  /**
   * 频次ID
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 频次周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 执行天数
   **/
  exeDays? : number;

  /**
   * 开始执行时间
   **/
  startTime? : string;

  /**
   * 结束执行时间
   **/
  endTime? : string;

  /**
   * 是否需要皮试
   **/
  skinTestFlag? : number;

  /**
   * 皮试结果;1阳性，0阴性
   **/
  skinTestResult? : number;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 是否支付;1：已支付 0：未支付
   **/
  isPay? : number;

  /**
   * 支付时间
   **/
  payTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 状态;0：待执行1：执行中，2：执行完成，3：执行中断，字典：HOPS_EXE_DEFINE_STATUS
   **/
  status? : string;

}

/** 字典组分页查询条件 **/
export interface DictGroupTreeParam extends PageParam{
  /**
   * 关键字
   **/
  keyword? : string;

  /**
   * 忽略的ids
   **/
  ignoreIds? : string;

}

/** 文件 **/
export interface TaFileItem extends BaseEntity{
  /**
   * 存储类型 字典：FILE_STORAGE_TYPE
   * 存储类型 字典：FILE_STORAGE_TYPE不允许为空
   **/
  storageType : string;

  /**
   * 存储路径 如:20230101/img/demo.png
   * 存储路径 如:20230101/img/demo.png不允许为空
   **/
  path : string;

  /**
   * 文件大小
   **/
  size? : string;

  /**
   * 原始文件名称
   * 原始文件名称不允许为空
   **/
  name : string;

  /**
   * 文件类型
   * 文件类型不允许为空
   **/
  fileType : string;

  /**
   * 访问地址
   * 访问地址不允许为空
   **/
  url : string;

}

/** 客户端软件版本 **/
export interface TaSoftVersion extends BaseEntity{
  /**
   * 软件编码
   * 软件编码不允许为空
   **/
  softCode : string;

  /**
   * 软件名称
   * 软件名称不允许为空
   **/
  softName : string;

  /**
   * 软件版本
   * 软件版本不允许为空
   **/
  softVersion : string;

  /**
   * 下载地址
   * 下载地址不允许为空
   **/
  downloadUrl : string;

  /**
   * 是否强制更新
   **/
  forceUpdateFlag? : number;

  /**
   * 是否是当前版本
   **/
  currentFlag? : number;

  /**
   * 更新内容说明
   **/
  updateNote? : string;

  /**
   * 更新详细说明
   **/
  updateNoteHtml? : string;

  /**
   * 安装详细说明
   **/
  initNoteHtml? : string;

}

/** 辅材信息 **/
export interface HopsMaterialItemDocVO  {
  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 数量
   **/
  count? : string;

  /**
   * 单位
   **/
  unit? : string;

}

/** 单据记录分页查询条件 **/
export interface DdocRecordPageParam extends PageParam{
  /**
   * 模板id;关联单据模板
   **/
  templateId? : string;

  /**
   * 单据名称;单据名称
   **/
  name? : string;

  /**
   * 数据签名;针对单据字段进行md5运算出数据签名
   **/
  dataSign? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊医嘱单复用创建入参 **/
export interface HopsOrderSetReuseCommand  {
  /**
   * 门诊挂号id;关联门诊挂号
   * 门诊挂号id不允许为空
   **/
  registerId : string;

  /**
   * 复用的医嘱单id
   * 复用的医嘱单id不允许为空
   **/
  orderSetId : string;

}

/** 角色 **/
export interface TaAuthRole extends BaseEntity{
  /**
   * 应用id
   * 应用id不允许为空
   **/
  appId : string;

  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 权级;字典：AUTH_ROLE_GRADE
   * 权级;字典：AUTH_ROLE_GRADE不允许为空
   **/
  grade : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 登录Session VO **/
export interface AuthSessionVO  {
  /**
   * 接入令牌
   **/
  accessToken? : string;

  /**
   * 版本
   **/
  version? : string;

  /**
   * 登录签名
   **/
  loginSign? : string;

  /**
   * 登陆时间
   **/
  loginTime? : string;

  /**
   * 用户ID
   **/
  userId? : string;

  /**
   * 用户名称
   **/
  userName? : string;

  /**
   * 用户类型
   **/
  userType? : number;

  /**
   * 具有权限的应用信息
   **/
  apps? : any;

  /**
   * 请求的资源信息
   **/
  requests? : any;

  /**
   * 当前的应用id
   **/
  currentAppId? : string;

  /**
   * 当前角色id
   **/
  currentRoleId? : string;

  /**
   * 当前角色权级
   **/
  currentRoleGrade? : number;

  /**
   * 当前租户id
   **/
  currentTenantId? : string;

  /**
   * 当前选择的组织机构id
   **/
  currentOrgId? : string;

}

/** 医嘱模板节点修改入参 **/
export interface HopsOrderTemplateNodeEditParam  {
  /**
   * 模板id
   * 模板id不允许为空
   **/
  id : string;

  /**
   * 模板名称
   **/
  name? : string;

  /**
   * 父级模板id
   **/
  parentId? : string;

}

/** 门诊检查申请项目分页查询条件 **/
export interface HopsPacsApplyItemPageParam extends PageParam{
  /**
   * 开始时间
   **/
  startDate? : string;

  /**
   * 结束时间
   **/
  endDate? : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

}

/** 医嘱模板移动入参 **/
export interface HopsOrderTemplateMoveParam  {
  /**
   * 模板id
   * 模板id不允许为空
   **/
  id : string;

  /**
   * 父级模板id
   * 父级模板id不允许为空
   **/
  parentId : string;

}

/** 诊台分页查询条件 **/
export interface BaseHopsDeskPageParam extends PageParam{
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 诊室id
   **/
  roomId? : string;

  /**
   * 诊台id
   **/
  deskId? : string;

  /**
   * 科室ID
   * 科室ID不允许为空
   **/
  deptId : string;

  /**
   * 诊台名称、诊室名称搜索关键字
   **/
  keyword? : string;

}

/**  **/
export interface HopsMrecordHistoryVO  {
  /**
   *    **/
  id? : string;

  /**
   * 挂号id
   **/
  registerId? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 医生id
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 科室id
   **/
  deptId? : string;

  /**
   * 诊断
   **/
  diagnoseStr? : string;

  /**
   * 就诊完成时间
   **/
  registerCompleteTime? : string;

}

/** 药品批次查询参数 **/
export interface DrugBatchSearchPageParam extends PageParam{
  /**
   * 关键字
   **/
  keyword? : string;

  /**
   * 有效期开始日期
   **/
  validStartDate? : string;

  /**
   * 有效期结束日期
   **/
  validEndDate? : string;

  /**
   * 库存状态,1:不为0，2:为0，3：全部
   **/
  storageStatus? : number;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 抗菌药等级;字典：DRUG_ANTIBACTERIAL_LEVEL
   **/
  antibacterialLevel? : string;

  /**
   * 抗生素等级;字典：DRUG_ANTIBIOTICE_LEVEL
   **/
  antibioticsLevel? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

}

/** 医生收入月汇总数据VO **/
export interface DoctorIncomeMonthVO  {
  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 初诊人数
   **/
  firstVisitCount? : number;

  /**
   * 复诊人数
   **/
  againVisitCount? : number;

  /**
   * 西药费
   **/
  westernMedicinePrice? : string;

  /**
   * 中成药
   **/
  cpmPrice? : string;

  /**
   * 中草药
   **/
  tcmPrice? : string;

  /**
   * 诊察费
   **/
  examinationPrice? : string;

  /**
   * 化验费
   **/
  lisPrice? : string;

  /**
   * 检查费
   **/
  pacsPrice? : string;

  /**
   * 手术费
   **/
  opsPrice? : string;

  /**
   * 治疗费
   **/
  curePrice? : string;

  /**
   * 材料费
   **/
  materialPrice? : string;

  /**
   * 护理费
   **/
  nursePrice? : string;

  /**
   * 其他费
   **/
  otherPrice? : string;

  /**
   * 合计
   **/
  totalPrice? : string;

}

/** 医生排班停诊入参 **/
export interface ScheduleDoctorCloseParam  {
  /**
   * 医生排班ID
   * 医生排班ID为空
   **/
  id : string;

  /**
   * 停诊原因
   **/
  reason? : string;

}

/** 门诊诊断 **/
export interface TaHopsDiagnose extends BaseEntity{
  /**
   * 门诊挂号ID;关联门诊挂号
   * 门诊挂号ID;关联门诊挂号不允许为空
   **/
  registerId : string;

  /**
   * 患者id;关联患者id
   * 患者id;关联患者id不允许为空
   **/
  patientId : string;

  /**
   * 诊断id;关联诊断
   * 诊断id;关联诊断不允许为空
   **/
  diagnoseId : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * icd编码;镜像诊断字典
   **/
  icdCode? : string;

  /**
   * 诊断icd类型;镜像诊断字典，字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * icd亚目;镜像诊断字典
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称;镜像诊断字典
   **/
  icdName? : string;

  /**
   * 临床诊断名称;镜像诊断字典
   **/
  clinicalName? : string;

  /**
   * 中医症候id;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称;镜像症候，保留字段，理论上如果诊断为中医诊断需要携带中医症候
   **/
  tcmClinicalName? : string;

  /**
   * 主诊断标志
   **/
  mainFlag? : number;

  /**
   * 疑诊标志
   **/
  suspectFlag? : number;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 作废时间
   **/
  invalidTime? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : number;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

}

/**  **/
export interface HisPatientDynamicRecordsPageVO  {
  /**
   *    **/
  id? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 业务id
   **/
  busiId? : string;

  /**
   * 业务类型 1：门诊，2：住院，3：体检
   **/
  busiType? : string;

  /**
   * 类型;字典：DYNAMIC_RECORDS_TYPE
   **/
  type? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 发起人id
   **/
  originateUserId? : string;

  /**
   * 发起人姓名
   **/
  originateUserName? : string;

  /**
   * 发起时间
   **/
  originateTiem? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  patientGender? : string;

  /**
   * 出生日期
   **/
  patientBirthday? : string;

  /**
   * 年龄
   **/
  patientAge? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  patientIdcardType? : string;

  /**
   * 证件号码
   **/
  patientIdcardNo? : string;

  /**
   * 联系电话
   **/
  patientMobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 备注
   **/
  remarkList? : any;

}

/** 会诊信息for受邀医生VO **/
export interface PacsConsultationForTargetVO  {
  /**
   * 会诊ID
   **/
  id? : string;

  /**
   * 检查申请项目ID
   **/
  applyItemId? : string;

  /**
   * 患者ID
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 患者姓名
   **/
  age? : string;

  /**
   * 项目
   **/
  itemName? : string;

  /**
   * 诊断
   **/
  diagnose? : string;

  /**
   * 会诊说明
   **/
  remark? : string;

  /**
   * 发起人
   **/
  srcUserName? : string;

  /**
   * 发起科室
   **/
  srcDeptName? : string;

  /**
   * 发起时间
   **/
  startTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 是否紧急,字典：URGENT_FLAG
   **/
  urgentFlag? : number;

  /**
   * 处理建议
   **/
  advice? : string;

}

/** 检验项目分页查询条件 **/
export interface LisBaseItemPageParam extends PageParam{
  /**
   * 项目编码
   **/
  code? : string;

  /**
   * 项目名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 样本;字典：LIS_SPECIMENS
   **/
  specimen? : string;

  /**
   * 采样方式;字典：LIS_COLLECT_METHOD
   **/
  collectMethod? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊执行定义患者 VO **/
export interface HopsExeDefinePatientVO  {
  /**
   * 单日号;当日递增序列算法
   **/
  daySeqNum? : number;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 挂号编号;兼容非字符串挂号编号，默认为id
   **/
  registerNo? : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 是否急诊
   **/
  emergencyFlag? : number;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

  /**
   * 执行定义最后修改时间
   **/
  lastTime? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/** 用户消息分页查询条件 **/
export interface MessageUserPageParam extends PageParam{
  /**
   * 消息类型;字典：MESSAGE_TYPE
   **/
  messageType? : any;

  /**
   * 渠道类型;字典：MESSAGE_CHANNEL_TYPE
   **/
  channelType? : any;

  /**
   * 用户id;消息接受者
   **/
  userId? : string;

  /**
   * 是否阅读;1：是、0：否
   **/
  isRead? : number;

  /**
   * 是否归档;1：是、0：否
   **/
  isArchived? : number;

  /**
   * 执行开始时间
   **/
  startTime? : string;

  /**
   * 执行结束时间
   **/
  endTime? : string;

}

/** 执行实例分页查询条件 **/
export interface HopsExeInstancePageParam extends PageParam{
  /**
   * 执行实例类型;1：院内执行。2：退费拟执行，字典：HOPS_EXE_INSTANCE_TYPE
   **/
  instanceType? : string;

  /**
   * 执行定义id
   **/
  exeDefineId? : string;

  /**
   * 执行次数
   **/
  exeTimeNo? : number;

  /**
   * 执行开始时间
   **/
  startTime? : string;

  /**
   * 执行结束时间
   **/
  endTime? : string;

  /**
   * 执行人id
   **/
  exeUserId? : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 状态;字典：HOPS_EXE_INSTANCE_STATUS
   **/
  status? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效操作人id
   **/
  invalidUserId? : string;

  /**
   * 无效操作人姓名
   **/
  invalidUserName? : string;

}

/** 单据记录字段分页查询条件 **/
export interface DdocRecordFieldPageParam extends PageParam{
  /**
   * 单据id;关联单据模板
   **/
  recordId? : string;

  /**
   * 单据字段定义id
   **/
  fieldId? : string;

  /**
   * 字段编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 字段值
   **/
  dataValue? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 权限对码 VO **/
export interface AuthMatchingVO  {
  /**
   * 对码id
   **/
  id? : string;

  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   **/
  matchingType? : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   **/
  standardType? : string;

  /**
   * 内部编码
   **/
  intraCode? : string;

  /**
   * 内部名称
   **/
  intraCodeName? : string;

  /**
   * 标准编码
   **/
  standardCode? : string;

  /**
   * 标准名称
   **/
  standardName? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 检查项目分页查询条件 **/
export interface PacsBaseItemPageParam extends PageParam{
  /**
   * 检查类型;字典：PACS_TYPE
   **/
  pacsType? : string;

  /**
   * 项目编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 天津城乡居民汇总时间段 **/
export interface TjCxjmHopsTimeVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 时间段名称
   **/
  name? : string;

}

/** 医生排班资源号分页查询条件 **/
export interface ScheduleDoctorResourcePageParam extends PageParam{
  /**
   * 排班id;关联科室排班表
   **/
  scheduleId? : string;

  /**
   * 看诊序号
   **/
  seqNum? : number;

  /**
   * 预估时间
   **/
  estimatedTime? : string;

  /**
   * 看诊开始时间（预估）
   **/
  startTime? : string;

  /**
   * 看诊结束时间（预估）
   **/
  endTime? : string;

  /**
   * 是否可预约
   **/
  bookingFlag? : number;

  /**
   * 挂号预约渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  channel? : string;

  /**
   * 预约挂号确认时间
   **/
  sureTime? : string;

  /**
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS
   **/
  status? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 锁号时间
   **/
  lockTime? : string;

  /**
   * 解锁时间
   **/
  unlockTime? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 厂家分页查询条件 **/
export interface BaseCompanyPageParam extends PageParam{
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 消息发送入参 **/
export interface MessageSendPersonalParam  {
  /**
   * 发送者ID
   **/
  senderId? : string;

  /**
   * 接收者ID
   * 接收者ID不允许为空
   **/
  receiverId : string;

  /**
   * 消息标题
   **/
  name? : string;

  /**
   * 消息内容
   * 消息内容不允许为空
   **/
  content : string;

  /**
   * 消息类型
   * 消息类型不允许为空
   **/
  messageType : string;

  /**
   * 消息渠道类型
   * 消息渠道类型不允许为空
   **/
  channelType : string;

  /**
   * 通知样式
   * 通知样式不允许为空
   **/
  notificationStyle : string;

  /**
   * 附件的URL
   **/
  attachmentUrl? : string;

}

/** 检查申请项目分页查询条件 **/
export interface PacsApplyItemPageParam extends PageParam{
  /**
   * 日期类型 1.当天 2.近7天 3.更多
   **/
  dayType? : number;

  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

  /**
   * 状态 1.待缴费 2.已缴费 3.已完成 4.已作废
   **/
  status? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/**  **/
export interface TJMedinsRefundVO  {
  /**
   * 医保类型;2=城乡居民;3=城镇职工
   **/
  medinsType? : string;

  /**
   * 账单id
   **/
  billId? : string;

  /**
   * 支付id
   **/
  payId? : string;

  /**
   * 门诊序列号
   **/
  seqNum? : string;

  /**
   *    * 医院信息不允许为空
   **/
  hospital : HospitalParam;

  /**
   * 发生金额
   **/
  price? : string;

  /**
   * 申报金额
   **/
  declarePrice? : string;

  /**
   * 自费金额
   **/
  selfPayPrice? : string;

  /**
   * 增负金额
   **/
  increasedPrice? : string;

  /**
   * 专项基金社保支付
   **/
  specialFundSocialInsurancePayment? : string;

  /**
   * 补助金额
   **/
  subsidyPrice? : string;

  /**
   * 账户实际支付金额
   **/
  accountActualPay? : string;

  /**
   * 操作人
   **/
  operator? : string;

}

/** 应用分页查询条件 **/
export interface AuthAppPageParam extends PageParam{
  /**
   * 应用类型;字典：AUTH_APP_TYPE
   **/
  appType? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 关键字
   **/
  keyword? : string;

}

/** 测试加密分页查询条件 **/
export interface TestEncryptPageParam extends PageParam{
  /**
   * 姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 证件号码
   **/
  idcard? : string;

  /**
   * 地址
   **/
  address? : string;

}

/** 过敏项目 **/
export interface AllergyItemVO  {
  /**
   * 过敏源ID
   **/
  sourceId? : string;

  /**
   * 过敏源名称
   **/
  name? : string;

  /**
   * 过敏源类型
   **/
  type? : string;

  /**
   * 药品ID，非药品过敏项该值为空
   **/
  drugId? : string;

}

/** 门诊挂号 **/
export interface TaHopsRegister extends BaseEntity{
  /**
   * 挂号编号;兼容非字符串挂号编号，默认为id
   **/
  registerNo? : string;

  /**
   * 当日号;挂号当日递增序列算法
   **/
  daySeqNum? : string;

  /**
   * 患者id;关联患者
   * 患者id;关联患者不允许为空
   **/
  patientId : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址行政区划编码
   **/
  linkmanAreaCode? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 挂号类型;字典：HOPS_REGISTER_TYPE
   * 挂号类型;字典：HOPS_REGISTER_TYPE不允许为空
   **/
  registerType : string;

  /**
   * 号源;关联科室医生排班
   * 号源不允许为空
   **/
  resourceId : string;

  /**
   * 挂号日期
   * 挂号日期不允许为空
   **/
  registerDate : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  levelId : string;

  /**
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL不允许为空
   **/
  registerChannel : string;

  /**
   * 排班id;关联排班表
   * 排班id;关联排班表不允许为空
   **/
  scheduleId : string;

  /**
   * 排班类型;1：科室排班，2：医生排班；字典：HOPS_SCHEDULE_TYPE
   * 排班类型;1：科室排班，2：医生排班；字典：HOPS_SCHEDULE_TYPE不允许为空
   **/
  scheduleType : string;

  /**
   * 排班段名称
   * 排班段名称不允许为空
   **/
  timeName : string;

  /**
   * 看诊时间段开始时间
   * 看诊时间段开始时间不允许为空
   **/
  seeStartTime : string;

  /**
   * 看诊时间段结束时间
   * 看诊时间段结束时间不允许为空
   **/
  seeEndTime : string;

  /**
   * 看诊断预估时间
   * 看诊断预估时间不允许为空
   **/
  seeEstimatedTime : string;

  /**
   * 看诊断序号
   * 看诊断序号不允许为空
   **/
  seeSeqNum : number;

  /**
   * 科室id;关联组织架构
   * 科室id;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 科室名称
   * 科室名称不允许为空
   **/
  deptName : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 预约id
   **/
  bookingId? : number;

  /**
   * 是否初诊
   **/
  firstSeeFlag? : number;

  /**
   * 是否加号
   **/
  appendFlag? : number;

  /**
   * 是否急诊
   **/
  emergencyFlag? : number;

  /**
   * 是否加急
   **/
  urgentFlag? : number;

  /**
   * 状态;0：退号、1：锁号待支付、21.支付成功、20.支付取消、22：退号中、3.待看诊、4.已看诊
   **/
  status? : number;

  /**
   * 支付账单ID
   **/
  billId? : string;

  /**
   * 退费账单ID
   **/
  refundBillId? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 挂号级别名称
   **/
  levelName? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 实际看诊开始时间
   **/
  realStartSeeTime? : string;

  /**
   * 实际看诊结束时间
   **/
  realEndSeeTime? : string;

  /**
   * 诊台id
   **/
  deskId? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 诊室id
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

}

/** 发票发放入参 **/
export interface FeeInvoiceDistributeParam  {
  /**
   * 用户id
   * 用户id不允许为空
   **/
  userId : string;

  /**
   * 数量
   **/
  num? : number;

}

/** 医生模板查询条件 **/
export interface ScheduleTemplateConditionParam extends PageParam{
  /**
   * 星期几;1～7表示星期一到星期日
   **/
  week? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

}

/** 科室排班模板分页查询条件 **/
export interface ScheduleDeptTemplatePageParam extends PageParam{
  /**
   * 星期几;1～7表示星期一到星期日
   **/
  week? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 排班时间段;关联排班时间段
   **/
  timeId? : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 门诊收费入参 **/
export interface OutpatientsChargeCreateParam  {
  /**
   * registerId
   * 挂号id不允许为空
   **/
  registerId : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   * 挂号id不允许为空
   **/
  billingType : string;

}

/** 角色资源信息创建入参 **/
export interface AuthRoleResourceCreateParam  {
  /**
   * 角色id
   * 角色id不允许为空
   **/
  roleId : string;

  /**
   * 角色资源列表
   **/
  resourceIds? : any;

}

/** 检查申请项目分页查询条件 **/
export interface LisApplyItemPageParam extends PageParam{
  /**
   * 日期类型 1.当天 2.近7天 3.更多
   **/
  dayType? : number;

  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

  /**
   * 状态 1.待缴费 2.已缴费 3.已完成 4.已作废
   **/
  status? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/**  **/
export interface PacsApplyItemPageVO  {
  /**
   *    **/
  id? : string;

  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 检查项目id
   **/
  itemId? : string;

  /**
   * 检查项目编码
   **/
  itemCode? : string;

  /**
   * 检查项目名称
   **/
  itemName? : string;

  /**
   * 次数;一个医嘱执行多次时，保存多条记录并且从1开始递增次数
   **/
  timeNo? : number;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 报告审核科室id
   **/
  auditDeptId? : string;

  /**
   * 报告审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 报告审核医生id
   **/
  auditUserId? : string;

  /**
   * 报告审核医生名称
   **/
  auditUserName? : string;

  /**
   * 报告审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 执行人工号
   **/
  exeUserAccount? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 患者名称
   **/
  patientName? : string;

  /**
   * 患者手机号码
   **/
  patientMobile? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  patientGender? : string;

  /**
   * 年龄
   **/
  patientAge? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 患者头像taskId
   **/
  patientHeadImageTaskId? : string;

  /**
   * 患者头像url
   **/
  patientHeadImageUrl? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 模板id
   **/
  templateId? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

  /**
   *    **/
  busiId? : string;

}

/** 患者费用分类分页查询参数 **/
export interface PatientFeeTypeConditionParam  {
  /**
   * 开始日期
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * 结束日期
   * 结束日期不允许为空
   **/
  endDate : string;

  /**
   * 关键字：科室名称、医生名称、患者名称、患者ID、门诊号
   **/
  keyword? : string;

}

/**  **/
export interface LisApplyItemAuditParam  {
  /**
   * 检验申请项目ids
   * 检验申请项目ids不允许为空
   **/
  applyItemids : string;

  /**
   * 是否审核通过
   * 是否审核通过不允许为空
   **/
  audited : boolean;

  /**
   *  审核原因
   **/
  reason? : string;

  /**
   * 工号
   **/
  account? : string;

  /**
   * 密码
   **/
  password? : string;

}

/** 入库单操作参数 **/
export interface WarehouseInOperationParam  {
  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 随机数
   * 登陆签名错误
   **/
  random : string;

  /**
   * 令牌
   * 登陆签名错误
   **/
  token : string;

  /**
   * 入库单ID
   * 入库单ID不允许为空
   **/
  warehouseInId : string;

}

/** 记录交易结算信息入参 **/
export interface TJMedinsSettlementParam  {
  /**
   *  医保类型;2=城乡居民;3=城镇职工 
   *  医保类型不允许为空
   **/
  medinsType : string;

  /**
   * 账单id
   * 账单id不允许为空
   **/
  billId : string;

  /**
   * 支付id
   * 支付id不允许为空
   **/
  payId : string;

  /**
   * 药品费发生金额
   * 药品费发生金额不允许为空
   **/
  drugPrice : string;

  /**
   * 药品费申报金额
   * 药品费申报金额不允许为空
   **/
  drugDeclarePrice : string;

  /**
   * 检查费发生金额
   * 检查费发生金额不允许为空
   **/
  pacsPrice : string;

  /**
   * 检查费申报金额
   * 检查费申报金额不允许为空
   **/
  pacsDeclarePrice : string;

  /**
   * 治疗费发生金额
   * 治疗费发生金额不允许为空
   **/
  curePrice : string;

  /**
   * 治疗费申报金额
   * 治疗费申报金额不允许为空
   **/
  cureDeclarePrice : string;

  /**
   * 手术费发生金额
   * 手术费发生金额不允许为空
   **/
  opsPrice : string;

  /**
   * 手术费申报金额
   * 手术费申报金额不允许为空
   **/
  opsDeclarePrice : string;

  /**
   * 床位费发生金额
   * 床位费发生金额不允许为空
   **/
  bedPrice : string;

  /**
   * 床位费申报金额
   * 床位费申报金额不允许为空
   **/
  bedDeclarePrice : string;

  /**
   * 医用材料发生金额
   * 医用材料发生金额不允许为空
   **/
  materialPrice : string;

  /**
   * 医用材料申报金额
   * 医用材料申报金额不允许为空
   **/
  materialDeclarePrice : string;

  /**
   * 其他发生金额
   * 其他发生金额不允许为空
   **/
  otherPrice : string;

  /**
   * 其他申报金额
   * 其他申报金额不允许为空
   **/
  otherDeclarePrice : string;

  /**
   * 输全血发生金额
   * 输全血发生金额不允许为空
   **/
  wholeBloodTransPrice : string;

  /**
   * 输全血申报金额
   * 输全血申报金额不允许为空
   **/
  wholeBloodTransDeclarePrice : string;

  /**
   * 成分血发生金额
   * 成分血发生金额不允许为空
   **/
  componentBloodTransPrice : string;

  /**
   * 成分血申报金额
   * 成分血申报金额不允许为空
   **/
  componentBloodTransDeclarePrice : string;

  /**
   * 发生金额
   * 发生金额不允许为空
   **/
  price : string;

  /**
   * 申报金额
   * 申报金额不允许为空
   **/
  declarePrice : string;

  /**
   * 起付标准剩余额
   * 起付标准剩余额不允许为空
   **/
  deductibleRemainder : string;

  /**
   * 专项基金支付限额
   * 专项基金支付限额不允许为空
   **/
  specialFundPaymentLimit : string;

  /**
   * 起付标准
   * 起付标准不允许为空
   **/
  deductibleStandard : string;

  /**
   * 增负金额
   * 增负金额不允许为空
   **/
  increasedPrice : string;

  /**
   * 自费金额
   * 自费金额不允许为空
   **/
  selfPayPrice : string;

  /**
   * 起付标准以上自负比例金额
   * 起付标准以上自负比例金额不允许为空
   **/
  aboveDeductibleSelfPayPrice : string;

  /**
   * 输血自付金额
   * 输血自付金额不允许为空
   **/
  bloodTransSelfPayPrice : string;

  /**
   * 最高限额以上金额
   * 最高限额以上金额不允许为空
   **/
  aboveMaximumLimitPrice : string;

  /**
   * 专项基金社保支付
   * 专项基金社保支付不允许为空
   **/
  specialFundSocialInsurancePayment : string;

  /**
   * 社保对帐标志;0’ 门诊结算未上 传 ‘1’ 门诊结算上传 成功 ‘2’ 家庭签约结算 信息确认交易成功 ‘3’ 门诊结算确认 成功 ‘4’ 家庭签约对总 帐交易成功 ‘5’门诊对账成功
   * 社保对帐标志;0’ 门诊结算未上 传 ‘1’ 门诊结算上传 成功 ‘2’ 家庭签约结算 信息确认交易成功 ‘3’ 门诊结算确认 成功 ‘4’ 家庭签约对总 帐交易成功 ‘5’门诊对账成功不允许为空
   **/
  reconciliationFlag : string;

  /**
   * 中心交易时间
   * 中心交易时间不允许为空
   **/
  transactionTime : string;

  /**
   * 年度起付标准
   * 年度起付标准不允许为空
   **/
  annualDeductibleStandard : number;

  /**
   * 补助金额
   * 补助金额不允许为空
   **/
  subsidyPrice : string;

  /**
   * 付费方式;02 糖尿病人头付费 07 糖尿病人头付费 (药店取药) 08 新丙肝人头付费 09 腹膜透析人头付 费 10 谈判药品支付 不参与正常汇总表 数据汇总，按照各付 费方式单独汇总
   * 付费方式;02 糖尿病人头付费 07 糖尿病人头付费 (药店取药) 08 新丙肝人头付费 09 腹膜透析人头付 费 10 谈判药品支付 不参与正常汇总表 数据汇总，按照各付 费方式单独汇总不允许为空
   **/
  payType : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 账户可用余额
   **/
  accountAvailableBalance? : string;

  /**
   * 账户实际支付金额
   **/
  accountActualPay? : string;

}

/** 窗口配置分页查询条件 **/
export interface BaseWindowPageParam extends PageParam{
  /**
   * 名称
   **/
  name? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 门诊医嘱单预创建 DTO **/
export interface HopsOrderSetPreDTO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者id
   **/
  patientId? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医嘱单类型;诊疗医嘱单、西药医嘱单、中药医嘱单：字典：HOPS_ORDER_SET_TYPE
   **/
  orderSetType? : string;

  /**
   * 医嘱单序号
   **/
  orderSetNo? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 中草药-煎法;字典：TCM_BOIL_TYPE
   **/
  tcmBoilType? : string;

  /**
   * 医嘱单执行次数（草药剂数）
   * 执行次数不允许为空
   **/
  tcmExeCount : number;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 状态;医嘱单状态，字典：HOPS_ORDER_SET_STATUS
   **/
  status? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : string;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 医嘱组信息
   **/
  orderGroups? : any;

  /**
   * 取药科室id
   **/
  stockDeptId? : string;

  /**
   * 取药科室名称
   **/
  stockDeptName? : string;

  /**
   * 取药科室是否作废
   **/
  stockDeptInvalid? : number;

}

/** 门诊检验申请 DTO **/
export interface HopsLisApplyDTO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * lis检验申请id;lis系统返回
   **/
  lisApplyId? : string;

  /**
   * 挂号id
   **/
  registerId? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 患者名称
   **/
  name? : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   **/
  applyDeptId? : string;

  /**
   * 申请科室名称
   **/
  applyDeptName? : string;

  /**
   * 申请医生id
   **/
  applyDoctorId? : string;

  /**
   * 申请医生名称
   **/
  applyDoctorName? : string;

  /**
   * 申请医生工号
   **/
  applyDoctorAccount? : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

}

/** 医生排班模板 **/
export interface TaScheduleDoctorTemplate extends BaseEntity{
  /**
   * 星期几;1～7表示星期一到星期日
   * 星期几;1～7表示星期一到星期日不允许为空
   **/
  week : number;

  /**
   * 科室id;关联组织架构
   * 科室id;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 医生id;关联用户
   * 医生id;关联用户不允许为空
   **/
  doctorId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 排班时间段;关联排班时间段
   * 排班时间段;关联排班时间段不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   * 预约限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  bookingVolume : number;

  /**
   * 诊室;关联诊室
   * 诊室;关联诊室不允许为空
   **/
  roomId : string;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 门诊执行定义患者分页查询条件 **/
export interface HopsExeDefinePatientSearchParam extends PageParam{
  /**
   * 开始日期
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * 结束日期
   * 结束日期不允许为空
   **/
  endDate : string;

  /**
   * 类型 1=未执行列表 2=已执行列表
   * 查询类型不能为空
   **/
  type : string;

  /**
   * 关键字：唯一号、姓名、手机号、证件号码
   **/
  keyword? : string;

}

/** 诊断 **/
export interface TaBaseDiagnose extends BaseEntity{
  /**
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE不允许为空
   **/
  icdType : string;

  /**
   * icd编码
   * icd编码不允许为空
   **/
  icdCode : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   * icd诊断名称不允许为空
   **/
  icdName : string;

  /**
   * icd诊断名称拼音码
   **/
  icdPinyinCode? : string;

  /**
   * icd诊断名称五笔码
   **/
  icdWubiCode? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 临床诊断拼音码
   **/
  clinicalPinyinCode? : string;

  /**
   * 临床诊断五笔码
   **/
  clinicalWubiCode? : string;

  /**
   * 重大疾病标志
   **/
  criticalFlag? : number;

  /**
   * 单病种标志
   **/
  singleFlag? : number;

  /**
   * 临床路径标志
   **/
  pathwayFlag? : number;

  /**
   * 传染病标志
   * 传染病标志不允许为空
   **/
  infectFlag : number;

  /**
   * 肿瘤标志
   **/
  tumorFlag? : number;

  /**
   * 死亡标志
   **/
  deathFlag? : number;

  /**
   * 疑诊标记
   **/
  suspectFlag? : number;

  /**
   * 适用性别;1：男，2：女，12:全部，字典：GANDER_AREA
   **/
  ganderArea? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效理由
   **/
  invalidReason? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 门诊检查报告分页查询条件 **/
export interface HopsPacsReportPageParam extends PageParam{
  /**
   * 门诊检查申请id
   **/
  hopsApplyId? : string;

  /**
   * 门诊检查项目id
   **/
  hopsApplyItemId? : string;

  /**
   * PACS检查申请id;PACS系统返回
   **/
  pacsApplyId? : string;

  /**
   * PACS检验申请项目id;PACS系统返回
   **/
  pacsApplyItemId? : string;

  /**
   * 报告签名;PACS系统返回
   **/
  reportSign? : string;

  /**
   * 报告内容
   **/
  content? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 同步时间
   **/
  syncTime? : string;

}

/** 建档结果 **/
export interface RegisterPatientResultDTO  {
  /**
   * 患者唯一id
   **/
  hisPatId? : string;

}

/** 科室排班模板同步入参 **/
export interface ScheduleDeptTemplateSyncParam  {
  /**
   * 模板ID列表
   * 模板ID不能为空
   **/
  ids : any;

}

/** 医院 **/
export interface TaDictHospital extends BaseEntity{
  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 区域编码
   * 区域编码不允许为空
   **/
  areaCode : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 医保类型;天津=tj
   * 医保区域类型;天津=tj不允许为空
   **/
  areaType : string;

}

/** 检查申请分页查询条件 **/
export interface PacsApplyPageParam extends PageParam{
  /**
   * 申请渠道;1：门诊，2：住院，3：体检.字典：LIS_APPLY_CHANNEL
   **/
  applyChannel? : string;

  /**
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号
   **/
  busiId? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 患者名称
   **/
  name? : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   **/
  applyDeptId? : string;

  /**
   * 申请科室名称
   **/
  applyDeptName? : string;

  /**
   * 申请医生id
   **/
  applyDoctorId? : string;

  /**
   * 申请医生名称
   **/
  applyDoctorName? : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 药品过敏史保存参数 **/
export interface DrugAllergySourceSaveParam  {
  /**
   * 过敏原类型,字典:DRUG_ALLERGY_SOURCE_TYPE
   * 过敏原类型不允许为空
   **/
  allergySourceType : string;

  /**
   * 药品ID数组
   **/
  drugIds? : any;

}

/** 药房配置创建入参 **/
export interface BaseDispensaryCreateParam  {
  /**
   * 药房名称
   * 药房名称不允许为空
   **/
  name : string;

  /**
   * 科室id;关联科室
   * 科室id不允许为空
   **/
  deptId : string;

  /**
   * 药品类型;字典：DISPENSARY_DRUG_TYPE
   **/
  drugType? : any;

  /**
   * 药品性质;字典：DISPENSARY_DRUG_QUALITY
   **/
  drugQuality? : any;

  /**
   * 门诊住院标志;字典：DISPENSARY_HOPS_HIPS_FLAG
   **/
  hopsHipsFlag? : any;

  /**
   * 渠道;字典：DISPENSARY_CHANNEL
   **/
  channel? : any;

  /**
   * 发货方式;字典：DISPENSARY_DELIVERY_TYPE
   **/
  deliveryType? : any;

  /**
   * 库存标记;0：禁用库存, 1：启用库存
   * 库存标记不允许为空
   **/
  inventoryFlag : number;

  /**
   * 是否无效;0：否, 1：是
   * 是否无效不允许为空
   **/
  invalid : number;

}

/** 门诊医嘱单预创建 VO **/
export interface HopsOrderSetPreVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者id
   **/
  patientId? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医嘱单类型;诊疗医嘱单、西药医嘱单、中药医嘱单：字典：HOPS_ORDER_SET_TYPE
   **/
  orderSetType? : string;

  /**
   * 医嘱单序号
   **/
  orderSetNo? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 中草药-煎法;字典：TCM_BOIL_TYPE
   **/
  tcmBoilType? : string;

  /**
   * 医嘱单执行次数（草药剂数）
   * 执行次数不允许为空
   **/
  tcmExeCount : number;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 用法执行类型
   **/
  usageExeType? : string;

  /**
   * 状态;医嘱单状态，字典：HOPS_ORDER_SET_STATUS
   **/
  status? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : string;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 医嘱组信息
   **/
  orderGroups? : any;

  /**
   * 取药科室id
   **/
  stockDeptId? : string;

  /**
   * 取药科室名称
   **/
  stockDeptName? : string;

  /**
   * 取药科室是否作废
   **/
  stockDeptInvalid? : number;

}

/** 用户重置密码入参 **/
export interface AuthUserResetPwdParam  {
  /**
   * 用户ID
   * 用户ID不能为空
   **/
  id : string;

  /**
   * 新密码
   **/
  newPwd? : string;

}

/** 测试加密详情VO **/
export interface TestEncryptDetailVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * name
   **/
  name? : string;

  /**
   * address
   **/
  address? : string;

}

/** 诊断分页查询条件 **/
export interface BaseDiagnosePageParam extends PageParam{
  /**
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 关键字
   **/
  keyword? : string;

}

/** 门诊收费医嘱 VO **/
export interface OutpatientsOrderVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医嘱单id;关联医嘱单
   **/
  orderSetId? : string;

  /**
   * 处方单id;关联处方单
   **/
  recipeId? : string;

  /**
   * 紧急标记
   **/
  emergencyFlag? : number;

  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目类型;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 取药科室id
   **/
  stockDeptId? : string;

  /**
   * 取药科室名称
   **/
  stockDeptName? : string;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 开立医生id;关联用户
   **/
  openDoctorId? : string;

  /**
   * 开立医生名称
   **/
  openDoctorName? : string;

  /**
   * 审核医生id
   **/
  approvedDoctorId? : string;

  /**
   * 审核医生名称
   **/
  approvedDoctorName? : string;

  /**
   * 审核时间
   **/
  approvedTime? : string;

  /**
   * 审核状态
   **/
  approvedStatus? : number;

  /**
   * 是否需要计费
   **/
  chargeFlag? : number;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 药品包装单位
   **/
  drugPackageUnit? : string;

  /**
   * 药品包装数量
   **/
  drugPackageCount? : number;

  /**
   * 药品散装单位
   **/
  drugBulkUnit? : string;

  /**
   * 药品标准剂量
   **/
  drugStdDosage? : number;

  /**
   * 药品标准剂量单位
   **/
  drugStdDosageUnit? : string;

  /**
   * 药品剂型
   **/
  drugDosageForm? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

  /**
   * 药品取整方式;1：散装单位每次取整，2：散装单位总量取整，3：包装单位每次取整，4：包装单位总量取整。字典：DRUG_ROUND_TYPE
   **/
  drugRoundType? : string;

  /**
   * 辅材标志
   **/
  subMaterialFlag? : number;

  /**
   * 辅材带出类型;1：用法、2、诊疗项目 字典：ORDER_MATERIAL_TYPE
   **/
  subMaterialType? : string;

  /**
   * 辅材关联医嘱id;只有是辅材时才关联医嘱
   **/
  subMaterialMainOrderId? : string;

  /**
   * 是否展示
   **/
  showFlag? : number;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 组合号
   **/
  groupNo? : number;

  /**
   * 医嘱开立每次剂量
   **/
  orderOnceDosage? : number;

  /**
   * 医嘱开立每次剂量单位
   **/
  orderOnceDosageUnit? : string;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 用法执行类型
   **/
  usageExeType? : string;

  /**
   * 频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE
   **/
  frequencyCycleType? : string;

  /**
   * 周期数
   **/
  frequencyCycleCount? : number;

  /**
   * 周期执行数
   **/
  frequencyCycleExeCount? : number;

  /**
   * 天数
   **/
  exeDays? : number;

  /**
   * 总量
   **/
  totalQuantity? : number;

  /**
   * 退款量
   **/
  refundQuantity? : number;

  /**
   * 总收费量
   **/
  totalChargeQuantity? : number;

  /**
   * 总量单位
   **/
  totalUnit? : string;

  /**
   * 总量单位类型;1：散装单位、2包装单位
   **/
  totalUnitType? : string;

  /**
   * 总执行次数/草药剂数
   **/
  totalExeCount? : number;

  /**
   * 单价
   **/
  retailPrice? : string;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 总收费价格
   **/
  totalChargePrice? : string;

  /**
   * 退款金额
   **/
  refundPrice? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 皮试标志
   **/
  skinTestFlag? : number;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验标本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 中药用法;字典：TCM_USAGE_TYPE
   **/
  tcmUsageType? : string;

  /**
   * 状态;字典：HOPS_ORDER_STATUS
   **/
  status? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : string;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 账单项目id;关联费用账单项目
   **/
  billItemId? : string;

  /**
   * 提交id
   **/
  submitId? : string;

  /**
   * 是否允许退款标志 0：否 1：是
   **/
  isAllowRefund? : number;

  /**
   * 是否退款中标志; 1=是 0=否
   **/
  refundingFlag? : number;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

  /**
   *    **/
  confirmQuantity? : number;

}

/**  **/
export interface DeptDto  {
  /**
   * 科室id
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

}

/** 皮试 **/
export interface TaHopsSkinTest extends BaseEntity{
  /**
   * 执行定义id
   * 执行定义id不允许为空
   **/
  exeDefineId : string;

  /**
   * 执行定义与医嘱关系id
   * 执行定义与医嘱关系id不允许为空
   **/
  defineOrderId : string;

  /**
   * 医嘱id
   * 医嘱id不允许为空
   **/
  orderId : string;

  /**
   * 皮试结果;1：阳性，0：阴性
   **/
  skinTestResult? : number;

  /**
   * 皮试开始时间
   **/
  startTime? : string;

  /**
   * 皮试结束时间
   **/
  endTime? : string;

  /**
   * 执行人id
   * 执行人id不允许为空
   **/
  exeUserId : string;

  /**
   * 执行人姓名
   * 执行人姓名不允许为空
   **/
  exeUserName : string;

  /**
   * 核验人id
   **/
  checkUserId? : string;

  /**
   * 核验人姓名
   **/
  checkUserName? : string;

  /**
   * 核验时间
   **/
  checkTime? : string;

  /**
   * 核验状态
   **/
  checkStatus? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 无效原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效操作人id
   **/
  invalidUserId? : string;

  /**
   * 无效操作人姓名
   **/
  invalidUserName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 皮试执行状态;1：执行中、2：执行完成，3：执行中断,字典：HOPS_SKIN_TEST_STATUS
   * 皮试执行状态;1：执行中、2：执行完成，3：执行中断,字典：HOPS_SKIN_TEST_STATUS不允许为空
   **/
  status : string;

}

/** 文件上传VO **/
export interface FileUploadVO  {
  /**
   * 文件ID
   **/
  id? : string;

  /**
   * 访问地址
   **/
  url? : string;

}

/** 季度营业额与就诊人次统计表 **/
export interface QuarterIncomeAndRegisterVO  {
  /**
   * 项目
   **/
  itemName? : string;

  /**
   * 第一月
   **/
  firstMonthValue? : string;

  /**
   * 第二月
   **/
  secondMonthValue? : string;

  /**
   * 第三月
   **/
  thirdMonthValue? : string;

  /**
   * 季度合计
   **/
  quarterValue? : string;

  /**
   * 上季度合计
   **/
  lastQuarterValue? : string;

  /**
   * 环比
   **/
  q2qRatio? : string;

}

/** 复合项目明细分页查询条件 **/
export interface BaseCompositeItemPageParam extends PageParam{
  /**
   * 复合项目id
   * 复合项目id不允许为空
   **/
  compositeId : string;

}

/** 文件分页查询条件 **/
export interface FileItemPageParam extends PageParam{
  /**
   * 存储类型 字典：FILE_STORAGE_TYPE
   **/
  storageType? : string;

  /**
   * 存储路径 如:20230101/img/demo.png
   **/
  path? : string;

  /**
   * 文件大小
   **/
  size? : string;

  /**
   * 原始文件名称
   **/
  name? : string;

  /**
   * 文件类型
   **/
  fileType? : string;

  /**
   * 访问地址
   **/
  url? : string;

}

/** 检验医嘱 **/
export interface HopsLisOrderApplyDocVO  {
  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目数量
   **/
  count? : string;

  /**
   * 样本类型
   **/
  specimenText? : string;

}

/** 门诊收费账单信息VO **/
export interface OutpatientsChargeBillVO  {
  /**
   * 账单ID
   **/
  id? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 总金额（单位：毫，1分=100毫）
   **/
  totalPrice? : string;

  /**
   * 待支付金额（单位：毫，1分=100毫）
   **/
  waitPayPrice? : string;

  /**
   * 支付金额（单位：毫，1分=100毫）
   **/
  payTotalPrice? : string;

  /**
   * 退费金额（单位：毫，1分=100毫）
   **/
  refundPrice? : string;

  /**
   * 医保金额（单位：毫，1分=100毫）
   **/
  medinsPrice? : string;

  /**
   * 是否存在支付中的退款账单;0=否，1=是
   **/
  isRefunding? : number;

  /**
   * 退费中的账单id
   **/
  refundingBillId? : string;

  /**
   * 发票信息（退款账单为作废的发票信息）
   **/
  invoice? : FeeBillInvoiceDTO;

  /**
   * 支付总状态;1：待支付，2：支付中, 31：支付成功，32：支付取消，字典：FEE_PAY_STATUS
   **/
  payTotalStatus? : string;

  /**
   * 医嘱信息
   **/
  orderSets? : any;

  /**
   * 支付开始时间
   **/
  payStartTime? : string;

  /**
   * 支付完成时间
   **/
  payEndTime? : string;

  /**
   * 账单的所有支付信息
   **/
  pays? : any;

  /**
   * 支付信息说明
   **/
  payInfo? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

}

/** 治疗项目 **/
export interface HopsCureItemDocVO  {
  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 数量
   **/
  count? : string;

  /**
   * 单位
   **/
  unit? : string;

}

/** 检查申请入参 **/
export interface HopsPacsApplyCreateParam  {
  /**
   * 挂号id
   * 挂号id不允许为空
   **/
  registerId : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 检验医嘱id
   * 检验医嘱id不允许为空
   **/
  orderIds : any;

}

/** 用户消息 VO **/
export interface MessageVO  {
  /**
   *    **/
  id? : string;

  /**
   * 消息类型;字典：MESSAGE_TYPE
   **/
  messageType? : string;

  /**
   * 渠道类型;字典：MESSAGE_CHANNEL_TYPE
   **/
  channelType? : string;

  /**
   * 通知样式;字典：MESSAGE_NOTIFICATION_STYLE
   **/
  notificationStyle? : string;

  /**
   * 消息附件的URL
   **/
  attachmentUrl? : string;

  /**
   * 消息发送者ID
   **/
  senderId? : string;

  /**
   * 发送时间
   **/
  sendTime? : string;

  /**
   * 消息内容
   **/
  content? : string;

  /**
   * 是否阅读;1：是、0：否
   **/
  isRead? : number;

  /**
   * 阅读时间
   **/
  readAt? : string;

  /**
   * 是否归档;1：是、0：否
   **/
  isArchived? : number;

  /**
   * 归档时间
   **/
  archivedAt? : string;

}

/** 挂号级别 **/
export interface TaBaseRegisterLevel extends BaseEntity{
  /**
   * 级别名称
   * 级别名称不允许为空
   **/
  name : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否急诊
   **/
  emergency? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 执行实例 **/
export interface TaHopsExeInstance extends BaseEntity{
  /**
   * 执行实例类型;1：院内执行。2：退费拟执行，字典：HOPS_EXE_INSTANCE_TYPE
   * 执行实例类型;1：院内执行。2：退费拟执行，字典：HOPS_EXE_INSTANCE_TYPE不允许为空
   **/
  instanceType : string;

  /**
   * 执行定义id
   * 执行定义id不允许为空
   **/
  exeDefineId : string;

  /**
   * 执行次数
   * 执行次数不允许为空
   **/
  exeTimeNo : number;

  /**
   * 执行开始时间
   **/
  startTime? : string;

  /**
   * 执行结束时间
   **/
  endTime? : string;

  /**
   * 执行人id
   * 执行人id不允许为空
   **/
  exeUserId : string;

  /**
   * 执行人姓名
   **/
  exeUserName? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 状态;字典：HOPS_EXE_INSTANCE_STATUS
   **/
  status? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 无效操作人id
   **/
  invalidUserId? : string;

  /**
   * 无效操作人姓名
   **/
  invalidUserName? : string;

}

/** 排班创建入参 **/
export interface ScheduleSaveParam  {
  /**
   * 排班日期
   * 排班日期不允许为空
   **/
  scheduleDate : string;

  /**
   * 医生;关联用户
   **/
  doctorId? : string;

  /**
   * 科室;关联组织架构
   * 科室;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   * 时间段名称;镜像排班时间段的名称不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 检查申请项目 **/
export interface TaPacsApplyItem extends BaseEntity{
  /**
   * 申请id
   * 申请id不允许为空
   **/
  applyId : string;

  /**
   * 医嘱id
   **/
  orderId? : string;

  /**
   * 检查项目id
   **/
  itemId? : string;

  /**
   * 检查项目编码
   **/
  itemCode? : string;

  /**
   * 检查项目名称
   **/
  itemName? : string;

  /**
   * 次数;一个医嘱执行多次时，保存多条记录并且从1开始递增次数
   **/
  timeNo? : number;

  /**
   * 检验人id
   **/
  checkUserId? : string;

  /**
   * 检验人姓名
   **/
  checkUserName? : string;

  /**
   * 检验时间
   **/
  checkTime? : string;

  /**
   * 检验科室id
   **/
  checkDeptId? : string;

  /**
   * 检验科室名称
   **/
  checkDeptName? : string;

  /**
   * 报告人id
   **/
  reportUserId? : string;

  /**
   * 报告人姓名
   **/
  reportUserName? : string;

  /**
   * 报告时间
   **/
  reportTime? : string;

  /**
   * 报告科室id
   **/
  reportDeptId? : string;

  /**
   * 报告科室名称
   **/
  reportDeptName? : string;

  /**
   * 报告审核科室id
   **/
  auditDeptId? : string;

  /**
   * 报告审核科室名称
   **/
  auditDeptName? : string;

  /**
   * 报告审核医生id
   **/
  auditUserId? : string;

  /**
   * 报告审核医生名称
   **/
  auditUserName? : string;

  /**
   * 报告审核时间
   **/
  auditTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 检验人工号
   **/
  checkUserAccount? : string;

  /**
   * 报告人工号
   **/
  reportUserAccount? : string;

  /**
   * 审核医生工号
   **/
  auditUserAccount? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 是否需要报告，如果申请时没有项目则不需要报告
   **/
  needReport? : number;

  /**
   * 是否需要执行后才出报告
   **/
  needExe? : number;

}

/**  **/
export interface DictAreaTreeDto  {
  /**
   *    **/
  id? : string;

  /**
   * 上级行政区划编码
   **/
  parentId? : string;

  /**
   * 类型;字典：COMMON_AREA_TYPE
   * 类型;字典：COMMON_AREA_TYPE不允许为空
   **/
  type : number;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 全称
   **/
  fullName? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 是否作废
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   *    **/
  children? : any;

}

/** 检验申请 **/
export interface TaLisApply extends BaseEntity{
  /**
   * 申请渠道;1：门诊，2：住院，3：体检.字典：LIS_APPLY_CHANNEL
   * 申请渠道;1：门诊，2：住院，3：体检.字典：LIS_APPLY_CHANNEL不允许为空
   **/
  applyChannel : string;

  /**
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号不允许为空
   **/
  busiId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 患者名称
   * 患者名称不允许为空
   **/
  name : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   * 科室id;患者所在的科室id不允许为空
   **/
  deptId : string;

  /**
   * 科室名称;患者所在的科室名称
   * 科室名称;患者所在的科室名称不允许为空
   **/
  deptName : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   * 申请科室ID;申请科室id不允许为空
   **/
  applyDeptId : string;

  /**
   * 申请科室名称
   * 申请科室名称不允许为空
   **/
  applyDeptName : string;

  /**
   * 申请医生id
   * 申请医生id不允许为空
   **/
  applyDoctorId : string;

  /**
   * 申请医生名称
   * 申请医生名称不允许为空
   **/
  applyDoctorName : string;

  /**
   * 申请医生工号
   * 申请医生工号不允许为空
   **/
  applyDoctorAccount : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

}

/**  **/
export interface HopsFeeBillVO  {
  /**
   * 账单ID
   **/
  id? : string;

  /**
   * 医院ID
   **/
  hospitalId? : string;

  /**
   * 交易类型;1.收费，2：退费。字典：FEE_TRADE_TYPE
   **/
  tradeType? : string;

  /**
   * 业务种类;1. 门诊、2.住院、3：体检，字典：FEE_BUSI_KIND
   **/
  kindType? : string;

  /**
   * 种类业务id;业务种类为门诊,则为门诊id
   **/
  kindItemId? : string;

  /**
   * 业务类型;字典：FEE_BILL_ITEM_BUSI
   **/
  busiType? : string;

  /**
   * 务id;门诊id、住院id、医嘱id
   **/
  busiItemId? : string;

  /**
   * 目标人员id;针对门诊住院体检时，为患者id
   **/
  targetPersonId? : string;

  /**
   * 目标人员快照id;关联目标人员快照表
   **/
  personSnapshotId? : string;

  /**
   * 总金额
   **/
  totalPrice? : string;

  /**
   * 待支付金额
   **/
  waitPayPrice? : string;

  /**
   * 支付金额
   **/
  payTotalPrice? : string;

  /**
   * 支付开始时间
   **/
  payStartTime? : string;

  /**
   * 支付完成时间
   **/
  payEndTime? : string;

  /**
   * 支付总状态;1：待支付，2：支付中, 31：支付成功，32：支付取消，字典：FEE_PAY_STATUS
   **/
  payTotalStatus? : string;

  /**
   * 账单的所有支付信息
   **/
  pays? : any;

  /**
   * 支付信息说明
   **/
  payInfo? : string;

  /**
   * 账单的项目信息
   **/
  items? : any;

  /**
   * 账单的发票信息
   **/
  invoice? : FeeBillInvoiceDTO;

  /**
   * 患者信息
   **/
  hisPatient? : ApiHisPatientDTO;

}

/**  **/
export interface PacsBaseReportTemplatePageVO  {
  /**
   *    **/
  id? : string;

  /**
   * 检查类型;字典：PACS_TYPE
   **/
  pacsType? : string;

  /**
   * 模板编码
   **/
  code? : string;

  /**
   * 模板名称
   **/
  name? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 字典对码查询入参 **/
export interface DictItemMatchingParam extends PageParam{
  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   **/
  matchingType? : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   * 标准类型不允许为空
   **/
  standardType : string;

  /**
   * 关键字：字典名称、字典值
   **/
  keyword? : string;

}

/** 个人病历模板字段 **/
export interface MrecordPersonalCaseFieldVO  {
  /**
   * 字段编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 字段值
   **/
  dataValue? : string;

}

/** 排班分页查询条件 **/
export interface SchedulePagingParam extends PageParam{
  /**
   * 排班日期
   * 排班日期不允许为空
   **/
  scheduleDate : string;

  /**
   * 科室;关联组织架构
   **/
  deptId? : string;

}

/** 报告明细项 **/
export interface PatientReportItemDTO  {
  /**
   * 明细ID
   **/
  itemId? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 检查结果
   **/
  checkResult? : string;

  /**
   * 单位
   **/
  unitName? : string;

  /**
   * 是否正常, 0: 正常 1:异常
   **/
  isNormal? : number;

  /**
   * 异常备注
   **/
  meno? : string;

  /**
   * 参考值范围
   **/
  referenceRanges? : string;

}

/** 非药品导入入参 **/
export interface BaseNonDrugImportParam  {
  /**
   * 文件id
   **/
  fileId? : string;

}

/** 科室排班停诊入参 **/
export interface ScheduleAssembleTimeListParam  {
  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/**  **/
export interface PacsApplyItemAuditParam  {
  /**
   * 检验申请项目ids
   * 检验申请项目ids不允许为空
   **/
  applyItemids : string;

  /**
   * 是否审核通过
   * 是否审核通过不允许为空
   **/
  audited : boolean;

  /**
   *  审核原因
   **/
  reason? : string;

  /**
   * 工号
   **/
  account? : string;

  /**
   * 密码
   **/
  password? : string;

}

/** 诊台 **/
export interface TaBaseHopsDesk extends BaseEntity{
  /**
   * 诊室
   * 诊室不允许为空
   **/
  roomId : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 患者过敏史 **/
export interface PatientAllergyHistoryVO  {
  /**
   * 过敏历史id
   **/
  id? : string;

  /**
   * 患者ID
   **/
  patientId? : string;

  /**
   * 过敏源类型，字典：ALL_ALLERGY_SOURCE_TYPE
   **/
  allergySourceType? : string;

  /**
   * 过敏源ID
   **/
  sourceId? : string;

  /**
   * 过敏物名称
   **/
  name? : string;

  /**
   * 药品ID
   **/
  drugId? : string;

  /**
   * 上报用户名称
   **/
  submitUserName? : string;

  /**
   * 上报时间
   **/
  submitTime? : string;

  /**
   * 上报科室名称
   **/
  submitDeptName? : string;

  /**
   * 业务种类;1. 门诊、2.住院、3：体检，字典：PATIENT_ALLERGY_KIND_TYPE
   **/
  busiKindType? : string;

  /**
   * 业务类型;1：患者自述，2：医嘱皮试 ，字典：PATIENT_ALLERGY_BUSI_TYPE
   **/
  busiType? : string;

}

/** 字典标准id与name的vo **/
export interface DictStandardIdNameVO  {
  /**
   * 字典标准id
   **/
  id? : string;

  /**
   * 字典标准名称
   **/
  name? : string;

}

/** 排班预览 VO **/
export interface SchedulePreViewVO  {
  /**
   * 科室或医生名称
   **/
  name? : string;

  /**
   * 午别名称
   **/
  timeName? : string;

  /**
   * 开始时间;根据排班日期与排班时间段的开始时间生成具体日期时间
   **/
  startTime? : string;

  /**
   * 结束时间;根据排班日期与排班时间段的结束时间生成具体日期时间
   **/
  endTime? : string;

  /**
   * 周一排班详情
   **/
  mon? : any;

  /**
   * 周二排班详情
   **/
  tue? : any;

  /**
   * 周三排班详情
   **/
  wed? : any;

  /**
   * 周四排班详情
   **/
  thu? : any;

  /**
   * 周五排班详情
   **/
  fri? : any;

  /**
   * 周六排班详情
   **/
  sat? : any;

  /**
   * 周日排班详情
   **/
  sun? : any;

}

/** 医生排班VO **/
export interface ScheduleDoctorVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 科室;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   **/
  timeName? : string;

  /**
   * 开始时间;根据排班日期与排班时间段的开始时间生成具体日期时间
   **/
  startTime? : string;

  /**
   * 结束时间;根据排班日期与排班时间段的结束时间生成具体日期时间
   **/
  endTime? : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 挂号数
   **/
  registeredVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : number;

  /**
   * 预约数
   **/
  bookedVolume? : number;

  /**
   * 预约收费的预约数量
   **/
  usedBookingVolume? : number;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 排班明细
   **/
  resources? : any;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 字典标准 **/
export interface TaDictStandard extends BaseEntity{
  /**
   * 标准编码
   * 标准编码不允许为空
   **/
  code : string;

  /**
   * 标准名称
   * 标准名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 患者信息 **/
export interface GetPatientResultDTO  {
  /**
   * 患者ID
   **/
  hisPatId? : string;

  /**
   * 患者姓名
   **/
  realName? : string;

  /**
   * 身份证号
   **/
  idCard? : string;

  /**
   * 性别，1：男，2：女
   **/
  gender? : number;

  /**
   * 手机
   **/
  phone? : string;

  /**
   * 生日
   **/
  birthday? : string;

}

/** 当前登陆用户的菜单信息数据封装类 **/
export interface CurrentLoginMenuDTO  {
  /**
   * 资源id
   **/
  id? : string;

  /**
   * 上级资源id
   **/
  parentId? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 组件名称
   **/
  component? : string;

  /**
   * 组件重定向地址
   **/
  redirect? : string;

  /**
   * 界面打开target
   **/
  target? : string;

  /**
   * 资源类型;字典：AUTH_RESOURCE_TYPE
   **/
  resourceType? : number;

  /**
   * 资源键
   **/
  resourceKey? : string;

  /**
   * 请求地址
   **/
  requestUrl? : string;

  /**
   * 是否外链
   **/
  isFrame? : number;

  /**
   * 是否展示
   * 是否展示不允许为空
   **/
  visible : number;

  /**
   * icon
   **/
  icon? : string;

  /**
   * 排序字段
   * 排序字段不允许为空
   **/
  sortNo : number;

  /**
   * 子组织机构
   **/
  children? : any;

}

/** 患者追溯信息 **/
export interface TaHisPatientTrace extends BaseEntity{
  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 门诊号;采用分布式序列递增
   **/
  hopsId? : string;

  /**
   * 住院号;采用分布式序列递增
   **/
  hipsId? : string;

  /**
   * 病案号;采用分布式序列递增
   **/
  caseId? : string;

  /**
   * 是否三无人员
   **/
  noInfoPatient? : number;

  /**
   * 患者姓名
   * 患者姓名不允许为空
   **/
  name : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   * 性别;字典：COMMON_GENDER_TYPE不允许为空
   **/
  gender : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 变更描述
   **/
  changeRemark? : string;

  /**
   * 建档渠道;字典：PATIENT_CHANNEL
   **/
  createChannel? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 婚姻状况;字典：COMMON_MARITAL_STATUS
   **/
  maritalStatus? : string;

}

/** 药品 VO **/
export interface BaseDrugVO extends BaseEntity{
  /**
   * 主键
   **/
  id? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名
   **/
  commonName? : string;

  /**
   * 拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 五笔码
   **/
  commonWubiCode? : string;

  /**
   * 零售价;单位：毫，1分为100毫，除以10000为元
   **/
  retailPrice? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 药监局编码
   **/
  govCode? : string;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 病案分类;字典：ITEM_CASE_TYPE
   **/
  itemCaseType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 默认用法;关联用法
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 默认频次;关联频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 包装单位;字典：DRUG_PACKING_UNIT
   **/
  packageUnit? : string;

  /**
   * 包装数
   **/
  packageCount? : number;

  /**
   * 散装单位;字典：DRUG_BULK_UNIT
   **/
  bulkUnit? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 标准剂量
   **/
  stdDosage? : number;

  /**
   * 标准剂量单位;字典：DRUG_STANDARD_DOSE_UNIT
   **/
  stdDosageUnit? : string;

  /**
   * 医嘱剂量
   **/
  orderDosage? : number;

  /**
   * 医嘱剂量单位;字典：MEDICAL_ADVICE_DOSAGE_UNIT
   **/
  orderDosageUnit? : string;

  /**
   * 默认每次用量
   **/
  onceDosage? : number;

  /**
   * 每次用量单位;字典：ONCE_DOSAGE_UNIT
   **/
  onceDosageUnit? : string;

  /**
   * 默认使用天数
   **/
  useDays? : number;

  /**
   * 门诊取整方式;1：散装单位每次取整，2：散装单位总量取整，3：包装单位每次取整，4：包装单位总量取整。字典：DRUG_ROUND_TYPE
   **/
  hopsRoundType? : string;

  /**
   * 是否需要皮试
   **/
  skinTestFlag? : number;

  /**
   * 生产厂家id;关联生产厂家
   **/
  supplyProducerId? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 执行标准
   **/
  exeStandard? : string;

  /**
   * 说明书
   **/
  manual? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 批准文号
   **/
  approveNo? : string;

  /**
   * 批准日期
   **/
  approveDate? : string;

  /**
   * 批准信息
   **/
  approveInfo? : string;

  /**
   * 存储方式;字典：DRUG_STORAGE_TYPE
   **/
  storageType? : string;

  /**
   * 是否限制药物
   **/
  limitFlag? : number;

  /**
   * 限制天数
   **/
  limitDays? : number;

  /**
   * 限制说明
   **/
  limitMemo? : string;

  /**
   * 限制每日用量
   **/
  limitOnceDosage? : number;

  /**
   * 限制累计用量
   **/
  limitTotalDosage? : number;

  /**
   * ddd值
   **/
  ddd? : number;

  /**
   * 抗生素等级;字典：DRUG_ANTIBIOTICE_LEVEL
   **/
  antibioticsLevel? : string;

  /**
   * 抗菌药等级;字典：DRUG_ANTIBACTERIAL_LEVEL
   **/
  antibacterialLevel? : string;

  /**
   * 高危标志
   **/
  highRiskFlag? : number;

  /**
   * 妊娠等级;字典：DRUG_PREGNANCY_LEVEL
   **/
  pregnancyLevel? : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室名称
   **/
  openDeptNames? : any;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptNames? : any;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptNames? : any;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 国家编码
   **/
  nationalCode? : string;

  /**
   * 国际标准编码
   **/
  internationalStandardCode? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 药品统计属性;字典：DRUG_STATISTICAL_ATTR
   **/
  statisticalAttr? : string;

  /**
   * 毒理等级;字典：DRUG_TOXICOLOGY_GRADE
   **/
  toxicologyGrade? : string;

  /**
   * 产地内容;字典：DRUG_ORIGIN_CONTENT
   **/
  originContent? : string;

  /**
   * 过敏试验
   **/
  allergyTest? : string;

}

/** 药品批次查询结果 **/
export interface DrugBatchSearchResultVO  {
  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 通用名
   **/
  commonName? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 批次号
   **/
  batchNo? : string;

  /**
   * 有效日期
   **/
  validDate? : string;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 可用库存量
   **/
  useableStocksText? : string;

  /**
   * 实际库存量
   **/
  realStocksText? : string;

  /**
   * 实际库存量(数)
   **/
  realStocks? : number;

  /**
   * 散装可用库存量
   **/
  bulkUseableStocksText? : string;

  /**
   * 散装实际库存量
   **/
  bulkRealStocksText? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 货架号
   **/
  shelfCode? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 抗生素等级;字典：DRUG_ANTIBIOTICE_LEVEL
   **/
  antibioticsLevel? : string;

  /**
   * 抗菌药等级;字典：DRUG_ANTIBACTERIAL_LEVEL
   **/
  antibacterialLevel? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

  /**
   * 是否无效（停用）
   **/
  invalid? : number;

  /**
   * 是否过期，1：是。0：否
   **/
  overdue? : number;

  /**
   * 是否缺货，1：是。0：否
   **/
  outOfStock? : number;

}

/** 药品 **/
export interface TaBaseDrug extends BaseEntity{
  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名
   **/
  commonName? : string;

  /**
   * 拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 五笔码
   **/
  commonWubiCode? : string;

  /**
   * 零售价;单位：毫，1分为100毫，除以10000为元
   **/
  retailPrice? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 药监局编码
   **/
  govCode? : string;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 病案分类;字典：ITEM_CASE_TYPE
   **/
  itemCaseType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 默认用法;关联用法
   **/
  usageId? : string;

  /**
   * 默认频次;关联频次
   **/
  frequencyId? : string;

  /**
   * 包装单位
   **/
  packageUnit? : string;

  /**
   * 包装数
   **/
  packageCount? : number;

  /**
   * 散装单位
   **/
  bulkUnit? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 标准剂量
   **/
  stdDosage? : number;

  /**
   * 标准剂量单位
   **/
  stdDosageUnit? : string;

  /**
   * 医嘱剂量
   **/
  orderDosage? : number;

  /**
   * 医嘱剂量单位
   **/
  orderDosageUnit? : string;

  /**
   * 默认每次用量
   **/
  onceDosage? : number;

  /**
   * 每次用量单位
   **/
  onceDosageUnit? : string;

  /**
   * 默认使用天数
   **/
  useDays? : number;

  /**
   * 门诊取整方式;1：散装单位每次取整，2：散装单位总量取整，3：包装单位每次取整，4：包装单位总量取整。字典：DRUG_ROUND_TYPE
   **/
  hopsRoundType? : string;

  /**
   * 是否需要皮试
   **/
  skinTestFlag? : number;

  /**
   * 生产厂家id;关联生产厂家
   **/
  supplyProducerId? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 执行标准
   **/
  exeStandard? : string;

  /**
   * 说明书
   **/
  manual? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 批准文号
   **/
  approveNo? : string;

  /**
   * 批准日期
   **/
  approveDate? : string;

  /**
   * 批准信息
   **/
  approveInfo? : string;

  /**
   * 存储方式;字典：DRUG_STORAGE_TYPE
   **/
  storageType? : string;

  /**
   * 是否限制药物
   **/
  limitFlag? : number;

  /**
   * 限制天数
   **/
  limitDays? : number;

  /**
   * 限制说明
   **/
  limitMemo? : string;

  /**
   * 限制每日用量
   **/
  limitOnceDosage? : number;

  /**
   * 限制累计用量
   **/
  limitTotalDosage? : number;

  /**
   * ddd值
   **/
  ddd? : number;

  /**
   * 抗生素等级;字典：DRUG_ANTIBIOTICE_LEVEL
   **/
  antibioticsLevel? : string;

  /**
   * 抗菌药等级;字典：DRUG_ANTIBACTERIAL_LEVEL
   **/
  antibacterialLevel? : string;

  /**
   * 高危标志
   **/
  highRiskFlag? : number;

  /**
   * 妊娠等级;字典：DRUG_PREGNANCY_LEVEL
   **/
  pregnancyLevel? : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 国家编码
   **/
  nationalCode? : string;

  /**
   * 国际标准编码
   **/
  internationalStandardCode? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 药品统计属性
   **/
  statisticalAttr? : string;

  /**
   * 毒理等级
   **/
  toxicologyGrade? : string;

  /**
   * 产地内容
   **/
  originContent? : string;

  /**
   * 过敏试验
   **/
  allergyTest? : string;

}

/** 频次 **/
export interface TaBaseFrequency extends BaseEntity{
  /**
   * 频次编码
   * 频次编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE
   * 周期类型;字典：FREQUENCY_CYCLE_TYPE不允许为空
   **/
  cycleType : string;

  /**
   * 周期数
   * 周期数不允许为空
   **/
  cycleCount : number;

  /**
   * 周期执行数
   * 周期执行数不允许为空
   **/
  cycleExeCount : number;

}

/** 权限对码查询入参 **/
export interface AuthMatchingParam extends PageParam{
  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   * 对码类型;字典：MEDINS_MATCHING_TYPE;不允许为空
   **/
  matchingType : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   * 标准类型不允许为空
   **/
  standardType : string;

  /**
   * 关键字：科室名称、科室id
   **/
  keyword? : string;

}

/** 医嘱模板 VO **/
export interface HopsOrderTemplateNodeVO  {
  /**
   * 模板id
   **/
  id? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 上级模板id
   **/
  parentId? : string;

  /**
   * 树信息;从根节点到当前节点的主键拼接
   **/
  treeInfo? : string;

  /**
   * 是否目录 1=是,0=否
   **/
  isDirectory? : number;

  /**
   * 数量
   **/
  count? : number;

  /**
   * 子组织机构
   **/
  children? : any;

}

/** 医嘱项目分页查询条件 **/
export interface HopsOrderItemPageParam extends PageParam{
  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : any;

  /**
   * 医保分类;字典：MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : any;

  /**
   * 当前开立科室
   **/
  openDeptId? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : any;

  /**
   * 搜索关键字
   **/
  keyword? : string;

  /**
   * 药品类型; 11:西药 12:中草药 13:中草药
   **/
  drugType? : any;

  /**
   * 仓库id
   **/
  warehouseId? : string;

}

/** 目标组织机构树 **/
export interface TargetOrgTreeNodeVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 父级id
   **/
  parentId? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 下级结点
   **/
  children? : any;

}

/** 窗口配置 **/
export interface TaBaseWindow extends BaseEntity{
  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 药房id;关联药房配置
   **/
  dispensaryId? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** Excel导入结果 VO **/
export interface DictMatchingImportResultVO  {
  /**
   *    **/
  total? : number;

  /**
   *    **/
  success? : number;

  /**
   *    **/
  fail? : number;

  /**
   *    **/
  errorMsgs? : any;

}

/**  **/
export interface FeePayItemDTO  {
  /**
   *    **/
  id? : string;

  /**
   * 支付id
   * 支付id不允许为空
   **/
  payId : string;

  /**
   * 账单项目
   * 账单项目不允许为空
   **/
  billItemId : string;

  /**
   * 支付单价
   **/
  payPrice? : string;

  /**
   * 费用项目数量
   **/
  feeItemCount? : number;

  /**
   * 支付总价（单位：毫，1分=100毫）
   * 支付总价不允许为空
   **/
  payTotalPrice : string;

}

/** 挂号项目 **/
export interface RegisterFeeItem  {
  /**
   * 费用项目ID
   **/
  feeItemId? : string;

  /**
   * 费用项目名称
   **/
  feeItemName? : string;

  /**
   * 费用项目金额
   **/
  price? : string;

  /**
   * 浮动金额
   **/
  floatPrice? : string;

}

/** 患者分页查询条件 **/
export interface HisPatientPageParam extends PageParam{
  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 登记开始时间
   **/
  registerStartTime? : string;

  /**
   * 登记结束时间
   **/
  registerEndTime? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 门诊收费医嘱单 DTO **/
export interface OutpatientsOrderSetVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : string;

  /**
   * 患者id;关联患者id
   **/
  patientId? : string;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医嘱单类型;诊疗医嘱单、西药医嘱单、中药医嘱单：字典：HOPS_ORDER_SET_TYPE
   **/
  orderSetType? : string;

  /**
   * 医嘱单序号
   **/
  orderSetNo? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 中草药-煎法;字典：TCM_BOIL_TYPE
   **/
  tcmBoilType? : string;

  /**
   * 医嘱单执行次数（草药剂数）
   * 执行次数不允许为空
   **/
  tcmExeCount : number;

  /**
   * 用法id
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 状态;医嘱单状态，字典：HOPS_ORDER_SET_STATUS
   **/
  status? : string;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 作废人id
   **/
  invalidUserId? : string;

  /**
   * 作废人姓名
   **/
  invalidUserName? : string;

  /**
   * 总价
   **/
  totalPrice? : string;

  /**
   * 医嘱列表
   **/
  orders? : any;

  /**
   * 提交id
   **/
  submitId? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 挂号费分页查询条件 **/
export interface BaseRegisterFeePageParam extends PageParam{
  /**
   * 挂号级别id;关联挂号级别
   **/
  regLevelId? : string;

}

/** 执行定义皮试签名入参 **/
export interface HopsSkinTestParam extends HopsExeAccountParam{
  /**
   * 执行定义ID
   * 执行定义ID不允许为空
   **/
  exeDefineId : string;

  /**
   * 执行定义医嘱签名信息
   **/
  orderSigns? : any;

}

/** 门诊检查申请 **/
export interface TaHopsPacsApply extends BaseEntity{
  /**
   * 检查申请单id;pacs系统返回的id
   **/
  pacsApplyId? : string;

  /**
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号
   * 业务id;申请渠道为门诊，则为register，住院为住院流水号，体检为体检流水号不允许为空
   **/
  registerId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 患者名称
   * 患者名称不允许为空
   **/
  name : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   **/
  deptId? : string;

  /**
   * 科室名称;患者所在的科室名称
   **/
  deptName? : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   * 申请科室ID;申请科室id不允许为空
   **/
  applyDeptId : string;

  /**
   * 申请科室名称
   * 申请科室名称不允许为空
   **/
  applyDeptName : string;

  /**
   * 申请医生id
   * 申请医生id不允许为空
   **/
  applyDoctorId : string;

  /**
   * 申请医生名称
   * 申请医生名称不允许为空
   **/
  applyDoctorName : string;

  /**
   * 申请医生工号
   * 申请医生工号不允许为空
   **/
  applyDoctorAccount : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊医嘱信息创建入参 **/
export interface HopsOrderCreateParam  {
  /**
   * 门诊挂号id;关联门诊挂号
   * 门诊挂号id不允许为空
   **/
  registerId : string;

  /**
   * 病史
   **/
  medicalHistory? : string;

  /**
   * 体格检查
   **/
  bodyCheck? : string;

  /**
   * 辅助检查
   **/
  assistCheck? : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 创建入参不允许为空
   * 创建入参
   **/
  sets : any;

}

/** 字典组树节点VO **/
export interface DictGroupTreeNodeVO  {
  /**
   * 节点id
   **/
  id? : string;

  /**
   * 父节点id
   **/
  parentId? : string;

  /**
   * 字典组名称
   **/
  name? : string;

  /**
   * 下级字典组
   **/
  children? : any;

}

/** 门诊收费凭条 **/
export interface HopsFeeVoucherDocV2VO  {
  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 患者id
   **/
  patientId? : string;

  /**
   * 发票号
   **/
  invoiceNo? : string;

  /**
   * 缴费日期
   **/
  billTime? : string;

  /**
   * 结算类型
   **/
  billingTypeText? : string;

  /**
   * 本次费用总额
   **/
  totalPriceText? : string;

  /**
   * 预收金额
   **/
  prePayPriceText? : string;

  /**
   * 医保统筹金额
   **/
  medicalInsurancePriceText? : string;

  /**
   * 个人优惠减免
   **/
  preferentialPriceText? : string;

  /**
   * 个人缴纳金额
   **/
  ownPayPriceText? : string;

  /**
   * 实际缴金额
   **/
  realPayPriceText? : string;

  /**
   * 费用分类
   **/
  feeItems? : any;

  /**
   * 取药窗口
   **/
  stockWindows? : any;

}

/** 门诊病历模板分页查询条件 **/
export interface HopsMrecordTemplatePageParam extends PageParam{
  /**
   * 病历模板编码
   **/
  code? : string;

  /**
   * 病历模板名称
   **/
  name? : string;

  /**
   * 病历类型;字典：HOPS_MRECORD_TYPE
   **/
  mrecordType? : string;

  /**
   * 模板版本号
   **/
  templateVersion? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 用法提交参数，用于保存修改 **/
export interface BaseUsageSubmitParam  {
  /**
   * 用法ID
   **/
  id? : string;

  /**
   * 用法名称
   * 用法名称不允许为空
   **/
  name : string;

  /**
   * 执行分类;字典：USAGE_EXE_TYPE
   **/
  exeType? : string;

  /**
   * 项目分类，多选;字典：ITEM_SYS_TYPE
   **/
  itemSysTypes? : any;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 助记码
   **/
  customCode? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 普通出库制单参数 **/
export interface WarehouseCommonOutMakeParam  {
  /**
   * 出库类型
   **/
  outType? : string;

  /**
   * 发往部门id
   * 发往部门不允许为空
   **/
  deptId : string;

  /**
   * 单据备注
   **/
  makeRemark? : string;

  /**
   * 出库药品
   **/
  outDrugs? : any;

}

/**  **/
export interface ScheduleAssembleQueryConditionDTO  {
  /**
   * 排班id
   **/
  scheduleId? : string;

  /**
   * 排班类型 1.科室排班 2.医生排班
   **/
  scheduleType? : string;

  /**
   * 就诊地址
   **/
  outpatientAddress? : string;

  /**
   * 挂号科室
   **/
  deptList? : any;

  /**
   * 挂号级别
   **/
  regLevelList? : any;

  /**
   * 挂号医生
   **/
  doctorList? : any;

  /**
   * 时间段
   **/
  timeBucketList? : any;

  /**
   * 看诊序号
   **/
  resourceList? : any;

}

/** 检查报告 **/
export interface TaPacsReport extends BaseEntity{
  /**
   * 检查申请id
   * 检查申请id不允许为空
   **/
  applyId : string;

  /**
   * 检验申请项目id
   * 检验申请项目id不允许为空
   **/
  applyItemId : string;

  /**
   * 模板id
   * 模板id不允许为空
   **/
  templateId : string;

  /**
   * 报告签名;MD5(apply_item_id+content)
   **/
  reportSign? : string;

  /**
   * 报告内容
   **/
  content? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 医学影像taskId
   **/
  medicalImageTaskId? : string;

}

/** 非药品条件Vo **/
export interface BaseNondrugPageVo  {
  /**
   *    **/
  id? : string;

  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名称
   **/
  commonName? : string;

  /**
   * 通用名称五笔码
   **/
  commonWubiCode? : string;

  /**
   * 通用名称拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 自定义编码
   **/
  customCode? : string;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 国家编码
   **/
  nationCode? : string;

  /**
   * 国际标准编码
   **/
  internationalCode? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 病案分类;字典：ITEM_CASE_TYPE
   **/
  itemCaseType? : string;

  /**
   * 医保分类;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 默认天数
   **/
  defaultUsageDays? : number;

  /**
   * 基本用量
   **/
  baseUsageVolume? : number;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 零售价（单位：毫，1分=100毫）
   **/
  retailPrice? : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 采购价格（单位：毫，1分=100毫）
   **/
  purchasePrice? : string;

  /**
   * 生产厂家id
   **/
  supplyProducerId? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 注册码
   **/
  registerCode? : string;

  /**
   * 注册日期
   **/
  registerDate? : string;

  /**
   * 注册证有效期
   **/
  registerValidDay? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 报告说明
   **/
  reportMemo? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室名称
   **/
  openDeptNames? : any;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptNames? : any;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptNames? : any;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 是否贵重辅材
   **/
  isPrecious? : number;

  /**
   * 检查部位是否必填
   **/
  isCheckPointRequired? : number;

  /**
   * 检验样本是否必填
   **/
  isSpecimenRequired? : number;

}

/** 资源树VO **/
export interface AuthResourceTreeVO  {
  /**
   * 资源树
   **/
  resourceTree? : any;

  /**
   * 选择的资源
   **/
  checks? : any;

}

/** 排班模板同步入参 **/
export interface ScheduleTemplateSyncParam  {
  /**
   * 模板ID列表
   * 模板ID不能为空
   **/
  ids : any;

}

/** 单据记录 **/
export interface TaDdocRecord extends BaseEntity{
  /**
   * 模板id;关联单据模板
   * 模板id;关联单据模板不允许为空
   **/
  templateId : string;

  /**
   * 模板编码
   **/
  templateCode? : string;

  /**
   * 业务ID
   **/
  busiId? : string;

  /**
   * 单据名称;单据名称
   * 单据名称;单据名称不允许为空
   **/
  name : string;

  /**
   * 数据签名;针对单据字段进行md5运算出数据签名
   * 数据签名;针对单据字段进行md5运算出数据签名不允许为空
   **/
  dataSign : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 动态单据模板分页查询条件 **/
export interface DdocTemplatePageParam extends PageParam{
  /**
   * 编码
   **/
  code? : string;

  /**
   * 单据版本;需确保一个编码有且只有一个有效单据版本
   **/
  templateVersion? : number;

  /**
   * 单据类型;1：申请单。2：上报单。3：打印单，4：业务单。字典：DDOC_TYPE
   **/
  templateType? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 合并规则;1：单独、2：合并。冗余字段解决后续单据拆分规则
   **/
  mergeRule? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊执行定义患者统计 VO **/
export interface HopsExeDefineStaticVO  {
  /**
   *    **/
  type? : string;

  /**
   *    **/
  count? : number;

}

/** 医生排班模板同步入参 **/
export interface ScheduleDoctorTemplateSyncParam  {
  /**
   * 模板ID列表
   * 模板ID不能为空
   **/
  ids : any;

}

/** 患者追溯信息分页查询条件 **/
export interface HisPatientTracePageParam extends PageParam{
  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 字典组 **/
export interface TaDictGroup extends BaseEntity{
  /**
   * 上级节点id
   **/
  parentId? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 树信息
   **/
  treeInfo? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 患者分页查询参数 **/
export interface HopsRegisterSearchParam extends PageParam{
  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

  /**
   * 查询关键字
   **/
  keyword? : string;

}

/** 科室停诊入参 **/
export interface ScheduleCloseParam  {
  /**
   * 科室排班ID
   * 科室排班ID为空
   **/
  id : string;

  /**
   * 停诊原因
   **/
  reason? : string;

}

/** 复合项目明细 VO **/
export interface BaseCompositeItemVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 复合项目id
   * 复合项目id不允许为空
   **/
  compositeId : string;

  /**
   * 项目id
   * 项目id不允许为空
   **/
  itemId : string;

  /**
   * 项目编码
   * 编码不允许为空
   **/
  itemCode : string;

  /**
   * 项目名称
   * 项目名称不允许为空
   **/
  itemName : string;

  /**
   * 数量
   **/
  itemCount? : number;

  /**
   * 通用名称
   **/
  commonName? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 医保分类;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 零售价（单位：毫，1分=100毫））
   **/
  retailPrice? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 治疗单据数据 **/
export interface HopsCureDocVO  {
  /**
   * 医院名称
   **/
  hospitalName? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 性别
   **/
  genderText? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 结算类型
   **/
  billingTypeText? : string;

  /**
   * 唯一号
   **/
  patientId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorNo? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 开据日期
   **/
  openDate? : string;

  /**
   * 患者地址
   **/
  patientAddress? : string;

  /**
   * 患者手机
   **/
  patientMobile? : string;

  /**
   * 诊断
   **/
  diagnoseText? : string;

  /**
   * 治疗项目
   **/
  items? : any;

  /**
   * 总金额
   **/
  totalPriceText? : string;

}

/** 检查项目 **/
export interface TaPacsBaseItem extends BaseEntity{
  /**
   * 检查类型;字典：PACS_TYPE
   **/
  pacsType? : string;

  /**
   * 项目编码
   * 项目编码不允许为空
   **/
  code : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 应用 **/
export interface AuthAppVO  {
  /**
   * 应用id
   **/
  id? : string;

  /**
   * 中文名
   * 中文名不允许为空
   **/
  chnName : string;

  /**
   * 应用名
   * 应用名不允许为空
   **/
  appName : string;

  /**
   * 应用类型;字典：AUTH_APP_TYPE
   * 应用类型;字典：AUTH_APP_TYPE不允许为空
   **/
  appType : number;

  /**
   * 应用版本
   * 应用版本不允许为空
   **/
  appVersion : string;

  /**
   * 应用协议;字典：COMMON_HTTP_PROTOCOL
   **/
  protocol? : string;

  /**
   * 应用域名
   **/
  appHost? : string;

  /**
   * 应用端口
   **/
  appPort? : number;

  /**
   * 应用端点
   **/
  contextPath? : string;

  /**
   * 应用地址
   **/
  address? : string;

  /**
   * 图标
   **/
  icon? : string;

  /**
   * 图标地址
   **/
  iconUrl? : string;

  /**
   * 样式
   **/
  styleClass? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否展示
   **/
  isShow? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

  /**
   * 角色信息
   **/
  roles? : any;

}

/** 字典定义分页查询条件 **/
export interface DictDefineSearchParam  {
  /**
   * id
   **/
  id? : string;

  /**
   * 查询关键字
   **/
  keyword? : string;

}

/** 对码 **/
export interface TaDictMatching extends BaseEntity{
  /**
   * 对码类型;字典：MEDINS_MATCHING_TYPE;
   * 对码类型;字典：MEDINS_MATCHING_TYPE;不允许为空
   **/
  matchingType : string;

  /**
   * 标准类型;字典：MEDINS_STANDARD_TYPE;
   * 标准类型;字典：MEDINS_STANDARD_TYPE;不允许为空
   **/
  standardType : string;

  /**
   * 内部编码
   * 内部编码不允许为空
   **/
  intraCode : string;

  /**
   * 内部名称
   * 内部名称不允许为空
   **/
  intraCodeName : string;

  /**
   * 标准编码
   * 标准编码不允许为空
   **/
  standardCode : string;

  /**
   * 标准名称
   * 标准名称不允许为空
   **/
  standardName : string;

}

/** 诊室分页查询条件 **/
export interface BaseHopsRoomParam extends PageParam{
  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 护士站id;关联组织机构
   **/
  stationId? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 动态单据模板 **/
export interface TaDdocTemplate extends BaseEntity{
  /**
   * 编码
   * 编码不允许为空
   **/
  code : string;

  /**
   * 单据版本;需确保一个编码有且只有一个有效单据版本
   **/
  templateVersion? : number;

  /**
   * 单据类型;1：申请单。2：上报单。3：打印单，4：业务单。字典：DDOC_TYPE
   * 单据类型;1：申请单。2：上报单。3：打印单，4：业务单。字典：DDOC_TYPE不允许为空
   **/
  templateType : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 合并规则;1：单独、2：合并。冗余字段解决后续单据拆分规则
   **/
  mergeRule? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 备注
   **/
  remark? : string;

}

/** 门诊检验结果 DTO **/
export interface HopsLisResultDTO  {
  /**
   * 主键id
   **/
  id? : string;

  /**
   * 门诊检验申请id
   **/
  hopsApplyId? : string;

  /**
   * 门诊检验项目id
   **/
  hopsApplyItemId? : string;

  /**
   * 申请id;lis系统返回数据
   **/
  lisApplyId? : string;

  /**
   * 申请项目id;lis系统返回数据
   **/
  lisApplyItemId? : string;

  /**
   * 检验子项目id
   **/
  subItemId? : string;

  /**
   * 检验子项目名称
   **/
  subItemName? : string;

  /**
   * 检验子项目编码
   **/
  subItemCode? : string;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 结果签名;lis系统返回
   **/
  resultSign? : string;

  /**
   * 结果
   **/
  result? : string;

  /**
   * 结果单位
   **/
  unit? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : string;

  /**
   * 参考值
   **/
  referenceText? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : string;

  /**
   * 结果比较标记;字典：LIS_RESULT_COMPARE_FLAG
   **/
  compareFlag? : string;

  /**
   * 是否打印
   **/
  printFlag? : number;

  /**
   * 检验方法;字典：LIS_METHOD
   **/
  lisMethod? : string;

  /**
   * 同步时间
   **/
  syncTime? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 最后更新时间
   **/
  lastTime? : string;

  /**
   * 更新人姓名
   **/
  lastUserName? : string;

}

/** 门诊执行定义查询条件 **/
export interface HopsExeDefineSearchParam  {
  /**
   * 开始日期
   * 开始日期不允许为空
   **/
  startDate : string;

  /**
   * 结束日期
   * 结束日期不允许为空
   **/
  endDate : string;

  /**
   * 类型 1=未执行列表 2=已执行列表
   * 查询类型不能为空
   **/
  type : string;

  /**
   * 门诊ID
   * 挂号ID不允许为空
   **/
  registerId : string;

  /**
   * 执行类型;字典：USAGE_EXE_TYPE
   **/
  exeType? : string;

}

/** 当前登陆用户角色信息封装类 **/
export interface CurrentLoginRoleDTO  {
  /**
   * 角色ID
   **/
  id? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 权级;字典：AUTH_ROLE_GRADE
   **/
  grade? : number;

  /**
   * 管辖科室范围列表
   **/
  orgs? : any;

  /**
   * 操作的资源信息
   **/
  operators? : any;

  /**
   * 菜单和菜单组信息
   **/
  menus? : any;

  /**
   * 其他资源信息
   **/
  otherResources? : any;

}

/** 医嘱项目明细 VO **/
export interface HopsOrderItemVO  {
  /**
   * 项目类型;1：非药品项目、2药品项目 3复合项目 ;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 主键
   **/
  id? : string;

  /**
   * 编码
   **/
  code? : string;

  /**
   * 名称
   **/
  name? : string;

  /**
   * 英文名称
   **/
  englishName? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 通用名
   **/
  commonName? : string;

  /**
   * 拼音码
   **/
  commonPinyinCode? : string;

  /**
   * 五笔码
   **/
  commonWubiCode? : string;

  /**
   * 零售价;单位：毫，1分为100毫，除以10000为元
   **/
  retailPrice? : string;

  /**
   * 医保编码
   **/
  medicalInsuranceCode? : string;

  /**
   * 医保类型;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 药监局编码
   **/
  govCode? : string;

  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : string;

  /**
   * 药品性质;字典：DRUG_QUALITY
   **/
  drugQuality? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 病案分类;字典：ITEM_CASE_TYPE
   **/
  itemCaseType? : string;

  /**
   * 费用分类;字典：ITEM_FEE_TYPE
   **/
  itemFeeType? : string;

  /**
   * 国家药物标志;字典：DRUG_NATIONAL_DRUG_MARKING
   **/
  nationalDrugMarking? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 剂型
   **/
  dosageForm? : string;

  /**
   * 默认用法;关联用法
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 默认频次;关联频次
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 包装单位
   **/
  packageUnit? : string;

  /**
   * 包装数
   **/
  packageCount? : number;

  /**
   * 散装单位
   **/
  bulkUnit? : string;

  /**
   * 标准剂量
   * 标准剂量不允许为空
   **/
  stdDosage : number;

  /**
   * 标准剂量单位
   * 标准剂量单位不允许为空
   **/
  stdDosageUnit : string;

  /**
   * 医嘱剂量
   **/
  orderDosage? : number;

  /**
   * 医嘱剂量单位
   **/
  orderDosageUnit? : string;

  /**
   * 默认每次用量
   **/
  onceDosage? : number;

  /**
   * 每次用量单位
   **/
  onceDosageUnit? : string;

  /**
   * 默认使用天数
   **/
  useDays? : number;

  /**
   * 单位
   **/
  unit? : string;

  /**
   * 门诊取整方式;1：散装单位每次取整，2：散装单位总量取整，3：包装单位每次取整，4：包装单位总量取整。字典：DRUG_ROUND_TYPE
   * 门诊取整方式不允许为空
   **/
  hopsRoundType : string;

  /**
   * 是否需要皮试
   **/
  skinTestFlag? : number;

  /**
   * 生产厂家id;关联生产厂家
   **/
  supplyProducerId? : string;

  /**
   * 生产厂家名称
   **/
  supplyProducerName? : string;

  /**
   * 注意事项
   **/
  caution? : string;

  /**
   * 执行标准
   **/
  exeStandard? : string;

  /**
   * 说明书
   **/
  manual? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 批准文号
   **/
  approveNo? : string;

  /**
   * 批准日期
   **/
  approveDate? : string;

  /**
   * 批准信息
   **/
  approveInfo? : string;

  /**
   * 存储方式;字典：DRUG_STORAGE_TYPE
   **/
  storageType? : string;

  /**
   * 是否限制药物
   **/
  limitFlag? : number;

  /**
   * 限制天数
   **/
  limitDays? : number;

  /**
   * 限制说明
   **/
  limitMemo? : string;

  /**
   * 限制每日用量
   **/
  limitOnceDosage? : number;

  /**
   * 限制累计用量
   **/
  limitTotalDosage? : number;

  /**
   * ddd值
   **/
  ddd? : number;

  /**
   * 抗生素等级;字典：DRUG_ANTIBIOTICE_LEVEL
   **/
  antibioticsLevel? : string;

  /**
   * 抗菌药等级;字典：DRUG_ANTIBACTERIAL_LEVEL
   **/
  antibacterialLevel? : string;

  /**
   * 高危标志
   **/
  highRiskFlag? : number;

  /**
   * 妊娠等级;字典：DRUG_PREGNANCY_LEVEL
   **/
  pregnancyLevel? : string;

  /**
   * 项目比例
   **/
  priceRate? : number;

  /**
   * 条形码
   **/
  barCode? : string;

  /**
   * 二维码
   **/
  qrCode? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 允许开立科室;科室id以,分割拼接
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室名称
   **/
  openDeptNames? : any;

  /**
   * 是否紧急项目
   **/
  isUrgent? : number;

  /**
   * 门诊执行科室;科室id以,分割拼接
   **/
  hopsExeDepts? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptNames? : any;

  /**
   * 住院执行科室;科室id以,分割拼接
   **/
  hipsExeDepts? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptNames? : any;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 自定义编码
   **/
  customCode? : string;

  /**
   * 默认天数
   **/
  defaultUsageDays? : number;

  /**
   * 基本用量
   **/
  baseUsageVolume? : number;

  /**
   * 采购价格（单位：毫，1分=100毫）
   **/
  purchasePrice? : string;

  /**
   * 报告说明
   **/
  reportMemo? : string;

  /**
   * 检查部位;字典：PACS_CHECK_POINTS
   **/
  pacsCheckPoint? : string;

  /**
   * 检验样本;字典：LIS_SPECIMENS
   **/
  lisSpecimen? : string;

  /**
   * 检查部位是否必填
   **/
  isCheckPointRequired? : number;

  /**
   * 检验样本是否必填
   **/
  isSpecimenRequired? : number;

  /**
   * 辅材信息
   **/
  materials? : any;

  /**
   * 子项目信息
   **/
  subs? : any;

  /**
   * 可用库存信息
   **/
  usableValue? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 会诊信息for发起方VO **/
export interface PacsConsultationForSrcVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 检查申请项ID
   **/
  applyItemId? : string;

  /**
   * 发起人
   **/
  srcUserName? : string;

  /**
   * 邀请医生
   **/
  targetUserName? : string;

  /**
   * 邀请科室
   **/
  targetDeptName? : string;

  /**
   * 会诊备注
   **/
  remark? : string;

  /**
   * 会诊意见
   **/
  advice? : string;

  /**
   * 会诊发起时间
   **/
  startTime? : string;

  /**
   * 完成时间
   **/
  endTime? : string;

  /**
   * 状态
   **/
  status? : string;

}

/** 排班时间段 **/
export interface TaBaseHopsScheduleTime extends BaseEntity{
  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 开始时间;格式HH:mm
   * 开始时间;格式HH:mm不允许为空
   **/
  startTime : string;

  /**
   * 结束时间;格式HH:mm
   * 结束时间;格式HH:mm不允许为空
   **/
  endTime : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 推荐词VO **/
export interface SuggestWordVO  {
  /**
   * 推荐词类型，字典：SUGGEST_WORD_TYPE
   **/
  suggestWordType? : string;

  /**
   * 推荐词数组
   **/
  words? : any;

}

/** 供应商入库查询结果VO **/
export interface SupplyInSearchVO  {
  /**
   * 入库单据号
   **/
  id? : string;

  /**
   * 入库业务
   **/
  inBusi? : string;

  /**
   * 入库类型
   **/
  inType? : string;

  /**
   * 仓库名称
   **/
  warehouseName? : string;

  /**
   * 供应商
   **/
  companyName? : string;

  /**
   * 供应单号
   **/
  supplyCode? : string;

  /**
   * 制单人
   **/
  makeUserName? : string;

  /**
   * 制单时间
   **/
  makeTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 审核人
   **/
  auditUserName? : string;

  /**
   * 审核时间
   **/
  auditTime? : string;

  /**
   * 入账人
   **/
  sureUserName? : string;

  /**
   * 入账时间
   **/
  sureTime? : string;

  /**
   * 购入金额
   **/
  inTotalPrice? : string;

  /**
   * 零售金额
   **/
  retailTotalPrice? : string;

  /**
   * 差价总金额
   **/
  profitTotalPrice? : string;

  /**
   * 单据备注
   **/
  makeRemark? : string;

}

/** 排班模板修改入参 **/
export interface ScheduleTemplateEditParam  {
  /**
   * 模板id;科室模板id或医生模板id
   **/
  id? : string;

  /**
   * 星期几;1～7表示星期一到星期日
   * 星期几;1～7表示星期一到星期日不允许为空
   **/
  week : number;

  /**
   * 科室id;关联组织架构
   * 科室id;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 排班时间段;关联排班时间段
   * 排班时间段;关联排班时间段不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 排班同步入参 **/
export interface ScheduleSyncParam  {
  /**
   * 科室ID
   * 科室ID不能为空
   **/
  deptId : string;

  /**
   * 开始时间
   * 开始时间不能为空
   **/
  beginTime : string;

  /**
   * 结束时间
   * 结束时间不能为空
   **/
  endTime : string;

}

/** 门诊病历病史分页查询条件 **/
export interface HopsMrecordHistoryParam extends PageParam{
  /**
   * 门诊挂号id;关联门诊挂号
   **/
  registerId? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : number;

  /**
   * 挂号状态;0：退号、1：锁号待支付、21.支付成功、20.支付取消、22：退号中、3.待看诊、4.已看诊
   **/
  registerStatus? : number;

  /**
   * 开始时间
   **/
  startCompleteTime? : string;

  /**
   * 结束时间
   **/
  endCompleteTime? : string;

}

/** 科室排班模板 **/
export interface TaScheduleDeptTemplate extends BaseEntity{
  /**
   * 星期几;1～7表示星期一到星期日
   * 星期几;1～7表示星期一到星期日不允许为空
   **/
  week : number;

  /**
   * 科室id;关联组织架构
   * 科室id;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 排班时间段;关联排班时间段
   * 排班时间段;关联排班时间段不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   * 预约限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  bookingVolume : number;

  /**
   * 诊室;关联诊室
   * 诊室;关联诊室不允许为空
   **/
  roomId : string;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 科室排班资源号 **/
export interface TaScheduleDeptResource extends BaseEntity{
  /**
   * 排班id;关联科室排班表
   * 排班id;关联科室排班表不允许为空
   **/
  scheduleId : string;

  /**
   * 看诊序号
   * 看诊序号不允许为空
   **/
  seqNum : number;

  /**
   * 预估时间
   * 预估时间不允许为空
   **/
  estimatedTime : string;

  /**
   * 看诊开始时间（预估）
   * 看诊开始时间（预估）不允许为空
   **/
  startTime : string;

  /**
   * 看诊结束时间（预估）
   * 看诊结束时间（预估）不允许为空
   **/
  endTime : string;

  /**
   * 是否可预约
   **/
  bookingFlag? : number;

  /**
   * 挂号预约渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  channel? : string;

  /**
   * 预约挂号确认时间
   **/
  sureTime? : string;

  /**
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS不允许为空
   **/
  status : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 锁号时间
   **/
  lockTime? : string;

  /**
   * 解锁时间
   **/
  unlockTime? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 医生排班更新入参 **/
export interface ScheduleDoctorUpdateParam  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班日期
   * 排班日期不允许为空
   **/
  scheduleDate : string;

  /**
   * 医生;关联用户
   * 医生;关联用户不允许为空
   **/
  doctorId : string;

  /**
   * 科室;关联组织架构
   * 科室;关联组织架构不允许为空
   **/
  deptId : string;

  /**
   * 挂号级别;关联挂号级别
   * 挂号级别;关联挂号级别不允许为空
   **/
  regLevelId : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   * 时间段名称;镜像排班时间段的名称不允许为空
   **/
  timeId : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   * 挂号限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  registerVolume : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   * 预约限额数;如果挂号级别是急诊该字段无效不允许为空
   **/
  bookingVolume : number;

  /**
   * 诊台;关联诊台
   * 诊台;关联诊台不允许为空
   **/
  deskId : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 医生排班分页查询条件 **/
export interface ScheduleDoctorPageParam extends PageParam{
  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 科室;关联组织架构
   **/
  deptId? : string;

  /**
   * 医生;关联用户
   **/
  doctorId? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  regLevelId? : string;

  /**
   * 时间段名称;镜像排班时间段的名称
   **/
  timeName? : string;

  /**
   * 开始时间;根据排班日期与排班时间段的开始时间生成具体日期时间
   **/
  startTime? : string;

  /**
   * 结束时间;根据排班日期与排班时间段的结束时间生成具体日期时间
   **/
  endTime? : string;

  /**
   * 显示时间间隔;字典：SCHEDULE_SHOW_TIME_INTERVAL
   **/
  showTimeInterval? : number;

  /**
   * 挂号限额数;如果挂号级别是急诊该字段无效
   **/
  registerVolume? : number;

  /**
   * 预约限额数;如果挂号级别是急诊该字段无效
   **/
  bookingVolume? : string;

  /**
   * 诊室;关联诊室
   **/
  roomId? : string;

  /**
   * 诊台;关联诊台
   **/
  deskId? : string;

  /**
   * 允许加号
   **/
  appendFlag? : number;

  /**
   * 停诊原因
   **/
  closeReason? : string;

  /**
   * 停诊时间
   **/
  closeTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/**  **/
export interface ScheduleAssemblePageVo  {
  /**
   * id
   **/
  id? : string;

  /**
   * 排班日期
   **/
  scheduleDate? : string;

  /**
   * 科室id
   **/
  deptId? : string;

  /**
   * 挂号级别id
   **/
  regLevelId? : string;

  /**
   * 时间段名称
   **/
  timeName? : string;

  /**
   * 开始时间
   **/
  startTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

  /**
   * 剩余挂号数
   **/
  surplusRegisterVolume? : number;

  /**
   * 挂号限额数
   **/
  registerVolume? : number;

  /**
   * 医生id
   **/
  doctorId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 医生职称
   **/
  doctorTitle? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 排班类型 1.科室排班 2.医生排班
   **/
  scheduleType? : number;

  /**
   * 时间段名称
   **/
  timeBucketName? : string;

  /**
   * 医生头像url
   **/
  doctorHeadImageUrl? : string;

  /**
   * 医生性别
   **/
  doctorGender? : string;

}

/** 复合项目明细 DTO **/
export interface HopsCompositeItemDTO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 复合项目id
   * 复合项目id不允许为空
   **/
  compositeId : string;

  /**
   * 项目id
   * 项目id不允许为空
   **/
  itemId : string;

  /**
   * 项目编码
   * 编码不允许为空
   **/
  itemCode : string;

  /**
   * 项目名称
   * 项目名称不允许为空
   **/
  itemName : string;

  /**
   * 数量
   **/
  itemCount? : number;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 医保分类;字典：DRUG_MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : string;

  /**
   * 规格
   **/
  specs? : string;

  /**
   * 频次id;关联频次表
   **/
  frequencyId? : string;

  /**
   * 频次名称
   **/
  frequencyName? : string;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 零售价（单位：毫，1分=100毫））
   **/
  retailPrice? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 检验申请分页查询条件 **/
export interface LisApplyPageParam extends PageParam{
  /**
   * 申请开始时间
   **/
  applyStartTime? : string;

  /**
   * 申请结束时间
   **/
  applyEndTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 搜索关键字
   **/
  keyword? : string;

}

/** 病历模板(样例)树结点数据 **/
export interface MrecordPersonalCaseTreeNodeVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 上级id
   **/
  parentId? : string;

  /**
   * 模板/目录名称
   **/
  name? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 类型,1.目录,2.病历模板,字典:HOPS_MRECORD_CASE_TYPE
   **/
  caseType? : string;

  /**
   * 模板ID,只有是病历才有模板ID
   **/
  templateId? : string;

  /**
   * 下级节点
   **/
  children? : any;

}

/** 辅材带出规则项目明细 VO **/
export interface BaseMaterialRuleItemVO  {
  /**
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE
   * 规则业务类型;1：用法、2、药品、3、非药品，4、复合项目 字典：MATERIAL_RULE_BUSI_TYPE不允许为空
   **/
  ruleBusiType : string;

  /**
   * 规则业务id
   * 规则业务id不允许为空
   **/
  ruleBusiId : string;

  /**
   * 规则名称
   * 规则名称不允许为空
   **/
  name : string;

  /**
   * 备注
   * 备注不允许为空
   **/
  remark : string;

  /**
   * 辅材项目主键
   **/
  id? : string;

  /**
   * 辅材带出规则id
   **/
  materialRuleId? : string;

  /**
   * 用法;关联用法表
   **/
  usageId? : string;

  /**
   * 用法名称
   **/
  usageName? : string;

  /**
   * 允许开立科室;科室id以,分割拼接;空为所有科室
   **/
  openDeptIds? : string;

  /**
   * 允许开立科室啊名称;科室名称以,分割拼接;
   **/
  openDeptNames? : string;

  /**
   * 门诊执行科室
   **/
  hopsExeDept? : string;

  /**
   * 门诊执行科室名称
   **/
  hopsExeDeptName? : string;

  /**
   * 住院执行科室
   **/
  hipsExeDept? : string;

  /**
   * 住院执行科室名称
   **/
  hipsExeDeptName? : string;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : string;

  /**
   * 项目类型;1：非药品项目、2药品项目 3复合项目 ;字典：FEE_ITEM_TYPE
   **/
  itemType? : string;

  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : string;

  /**
   * 辅材数量
   **/
  itemCount? : number;

  /**
   * 项目规格
   **/
  itemSpecs? : string;

  /**
   * 项目单位
   **/
  itemUnit? : string;

  /**
   * 基本用量
   **/
  itemBaseUsageVolume? : number;

  /**
   * 辅材计算类型;1:固定数量、2、执行次数、3、按执行天数 字典：MATERIAL_ITEM_CAL_TYPE
   **/
  itemCalType? : string;

  /**
   * 是否默认带出;0：否 1：是
   **/
  isDefault? : number;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/**  **/
export interface LisApplyResultContrastParam  {
  /**
   * 限制的查询条数
   * 限制的查询条数不允许为空
   **/
  limitNum : number;

  /**
   * 检验子项目id
   * 检验子项目id不允许为空
   **/
  subItemId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 状态
   **/
  status? : string;

}

/** 字典定义ID和名字的VO **/
export interface DictDefineIdNameVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 字典定义名称
   **/
  name? : string;

}

/** 门诊检验申请 **/
export interface TaHopsLisApply extends BaseEntity{
  /**
   * lis检验申请id;lis系统返回
   **/
  lisApplyId? : string;

  /**
   * 挂号id
   * 挂号id不允许为空
   **/
  registerId : string;

  /**
   * 患者id
   * 患者id不允许为空
   **/
  patientId : string;

  /**
   * 患者名称
   * 患者名称不允许为空
   **/
  name : string;

  /**
   * 患者性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 年龄
   **/
  age? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 通讯地址行政区划
   **/
  addressAreaCode? : string;

  /**
   * 通讯地址
   **/
  address? : string;

  /**
   * 联系电话
   **/
  mobile? : string;

  /**
   * 科室id;患者所在的科室id
   * 科室id;患者所在的科室id不允许为空
   **/
  deptId : string;

  /**
   * 科室名称;患者所在的科室名称
   * 科室名称;患者所在的科室名称不允许为空
   **/
  deptName : string;

  /**
   * 护士站/病区id;护士站/病区id
   **/
  stationId? : string;

  /**
   * 护士站/病区名称
   **/
  stationName? : string;

  /**
   * icd编码
   **/
  icdCode? : string;

  /**
   * 诊断icd类型;字典：DIAGNOSE_ICD_TYPE
   **/
  icdType? : string;

  /**
   * icd亚目
   **/
  icdSuborder? : string;

  /**
   * icd诊断名称
   **/
  icdName? : string;

  /**
   * 临床诊断名称
   **/
  clinicalName? : string;

  /**
   * 中医症候id
   **/
  tcmSymptomId? : string;

  /**
   * 中医症候编码
   **/
  tcmSymptomCode? : string;

  /**
   * 中医症候名称
   **/
  tcmSymptomName? : string;

  /**
   * 中医症候临床名称
   **/
  tcmClinicalName? : string;

  /**
   * 采样备注
   **/
  collectRemark? : string;

  /**
   * 检验内容
   **/
  checkContent? : string;

  /**
   * 是否紧急
   **/
  emergencyFlag? : number;

  /**
   * 申请科室ID;申请科室id
   * 申请科室ID;申请科室id不允许为空
   **/
  applyDeptId : string;

  /**
   * 申请科室名称
   * 申请科室名称不允许为空
   **/
  applyDeptName : string;

  /**
   * 申请医生id
   * 申请医生id不允许为空
   **/
  applyDoctorId : string;

  /**
   * 申请医生名称
   * 申请医生名称不允许为空
   **/
  applyDoctorName : string;

  /**
   * 申请医生工号
   * 申请医生工号不允许为空
   **/
  applyDoctorAccount : string;

  /**
   * 申请时间
   **/
  applyTime? : string;

  /**
   * 状态
   **/
  status? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/** 病历查询参数 **/
export interface MrecordSearchDTO  {
  /**
   * 患者唯一ID
   **/
  hisPatId? : string;

  /**
   * 开始时间
   **/
  beginTime? : string;

  /**
   * 结束时间
   **/
  endTime? : string;

}

/** 字典定义完整信息VO **/
export interface DictDefineFullVO  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 字典组id;关联字典组
   **/
  groupId? : string;

  /**
   * 字典组名称
   **/
  groupName? : string;

  /**
   * 字典标准id;关联字典标准
   **/
  standardId? : string;

  /**
   * 字典标准名称
   **/
  standardName? : string;

  /**
   *    * 自定义编码不允许为空
   **/
  code : string;

  /**
   * 定义值;定义常数时使用
   **/
  defineValue? : string;

  /**
   * 标准编码
   **/
  standardCode? : string;

  /**
   *    * 名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/** 营收环比查询条件 **/
export interface RevenueMoMCondition  {
  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

}

/** 门诊执行定义辅材 VO **/
export interface HopsExeDefineMaterialVO  {
  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 执行科室id
   **/
  exeDeptId? : string;

  /**
   * 执行科室名称
   **/
  exeDeptName? : string;

  /**
   * 单价
   **/
  retailPrice? : string;

  /**
   * 医嘱开立每次剂量
   **/
  orderOnceDosage? : number;

  /**
   * 医嘱开立每次剂量单位
   **/
  orderOnceDosageUnit? : string;

  /**
   * 总量
   **/
  totalQuantity? : number;

  /**
   * 总量单位
   **/
  totalUnit? : string;

}

/** Excel导入结果 VO **/
export interface ExcelImportResultVO  {
  /**
   *    **/
  total? : number;

  /**
   *    **/
  success? : number;

  /**
   *    **/
  fail? : number;

  /**
   *    **/
  errorMsgs? : any;

}

/** 中医症候 **/
export interface TaBaseTcmSymptom extends BaseEntity{
  /**
   * 症候标准编码
   * 症候标准编码不允许为空
   **/
  code : string;

  /**
   * 症候标准名称
   * 症候标准名称不允许为空
   **/
  name : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 临床名称
   **/
  clinicalName? : string;

  /**
   * 临床名称拼音码
   **/
  clinicalPinyinCode? : string;

  /**
   * 临床名称五笔码
   **/
  clinicalWubiCode? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 停用原因
   **/
  invalidReason? : string;

  /**
   * 无效时间
   **/
  invalidTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/**  **/
export interface ResourceDto  {
  /**
   * 资源号id
   **/
  resourceId? : string;

  /**
   * 看诊序号
   **/
  seqNum? : number;

  /**
   * 预估时间
   **/
  estimatedTime? : string;

  /**
   * 资源号名称
   **/
  resourceName? : string;

}

/** 快捷操作推荐词 **/
export interface TaBaseSuggestWord extends BaseEntity{
  /**
   * 推荐业务;字典:SUGGEST_BUSI
   * 推荐业务;字典:SUGGEST_BUSI不允许为空
   **/
  suggestBusi : string;

  /**
   * 推荐词类型;字典:SUGGEST_WORD_TYPE
   * 推荐词类型;字典:SUGGEST_WORD_TYPE不允许为空
   **/
  suggestWordType : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 词
   * 词不允许为空
   **/
  word : string;

}

/** 快捷操作推荐词分页查询条件 **/
export interface BaseSuggestWordPageParam extends PageParam{
  /**
   * 推荐业务;字典:SUGGEST_BUSI
   **/
  suggestBusi? : string;

  /**
   * 推荐词类型;字典:SUGGEST_WORD_TYPE
   **/
  suggestWordType? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 词
   **/
  word? : string;

}

/** 门诊护士站科室关系分页查询条件 **/
export interface BaseHopsStationDeptPageParam extends PageParam{
  /**
   * 护士站id
   **/
  stationId? : string;

  /**
   * 科室id
   **/
  deptIds? : string;

}

/** 字典项 **/
export interface TaDictItem extends BaseEntity{
  /**
   * 字典定义id
   * 必须选择字典定义
   **/
  defineId : string;

  /**
   * 字典值
   * 字典值不允许为空
   **/
  itemValue : string;

  /**
   * 字典文本
   * 字典文本不允许为空
   **/
  itemText : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 级联下级字典定义id
   **/
  subDefineId? : string;

  /**
   * 排序
   **/
  sortNo? : number;

  /**
   * 是否默认
   **/
  isDefault? : number;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

}

/**  **/
export interface HopsLisApplyResultContrastVO  {
  /**
   * 检验结果
   **/
  resultList? : any;

  /**
   * 值类型;1:数字类，2：枚举类，3：文本。字典：LIS_SUB_ITEM_VALUE_TYPE
   **/
  valueType? : string;

  /**
   * 枚举字典定义编码;如果值类型为枚举类，则必须填写枚举编码
   **/
  enumDictCode? : string;

  /**
   * 参考值最小值
   **/
  referenceMin? : string;

  /**
   * 参考值最大值
   **/
  referenceMax? : string;

  /**
   * 结果单位
   **/
  unit? : string;

}

/** 发票分页查询条件 **/
export interface FeeInvoicePageParam extends PageParam{
  /**
   * 是否已使用;1：是 0：否
   **/
  isUse? : number;

  /**
   * 关键字
   **/
  keyword? : string;

}

/** 执行定义皮试签名入参 **/
export interface HopsExeSignParam extends HopsExeAccountParam{
  /**
   *    **/
  defineSigns? : any;

}

/** 检查申请与医嘱关联 **/
export interface TaHopsPacsApplyOrder extends BaseEntity{
  /**
   * 门诊检查申请单id
   * 门诊检查申请单id不允许为空
   **/
  hopsApplyId : string;

  /**
   * 医嘱id
   * 医嘱id不允许为空
   **/
  orderId : string;

}

/** 动态单据字段分页查询条件 **/
export interface DdocTemplateFieldPageParam extends PageParam{
  /**
   * 单据id;单据id
   **/
  ddocId? : string;

  /**
   * 字段编码
   **/
  code? : string;

  /**
   * 字段名称
   **/
  name? : string;

  /**
   * 数据类型;与java类型匹配字典：DDOC_FIELD_DATA_TYPE
   **/
  dataType? : string;

  /**
   * 表单类型;html组件与扩张自定义组件。字典：DDOC_FIELD_FORM_TYPE
   **/
  formType? : string;

  /**
   * 字典定义;如果是单选、多选、下拉时使用的字典定义
   **/
  dictDefineCode? : string;

  /**
   * 是否在表单可见
   **/
  formVisiable? : number;

  /**
   * 表单是否可以编辑;表单元素是否可编辑。
   **/
  formEditable? : number;

  /**
   * 是否必填
   **/
  requireFlag? : number;

  /**
   * 预览是否展示
   **/
  previewShowFlag? : number;

  /**
   * 数据来源类型;如患者、诊断、医嘱等。字典：DDOC_FIELD_DATA_SOURCE_TYPE
   **/
  dataSourceType? : string;

  /**
   * 数据来源el表达式;数据来源el表达式，如数据来源类型为患者，则#item.name表示患者的名称，如果数据来源类型为诊断，(#item.masterFlag == 1 ? '[主]':'')+ #item.name +(#item.invalid == 1 ? '[废]':'')+'。'为所有诊断的拼接
   **/
  dataSourceExpression? : string;

  /**
   * 排序
   **/
  sortNo? : number;

}

/** 职务分页查询条件 **/
export interface AuthDutyPageParam extends PageParam{
  /**
   * 组织机构id;0表示公共职务
   **/
  orgId? : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 关键字
   **/
  keyword? : string;

}

/** 门诊执行定义 **/
export interface TaHopsExeDefine extends BaseEntity{
  /**
   * 患者ID
   * 患者ID不允许为空
   **/
  patientId : string;

  /**
   * 门诊ID
   * 门诊ID不允许为空
   **/
  registerId : string;

  /**
   * 总共需要执行的次数
   * 总共需要执行的次数不允许为空
   **/
  totalExeCount : number;

  /**
   * 用法ID
   * 用法ID不允许为空
   **/
  usageId : string;

  /**
   * 用法名称
   * 用法名称不允许为空
   **/
  usageName : string;

  /**
   * 执行类型;字典：USAGE_EXE_TYPE
   * 执行类型;字典：USAGE_EXE_TYPE不允许为空
   **/
  exeType : string;

  /**
   * 频次ID
   * 频次ID不允许为空
   **/
  frequencyId : string;

  /**
   * 频次名称
   * 频次名称不允许为空
   **/
  frequencyName : string;

  /**
   * 频次周期类型;字典：FREQUENCY_CYCLE_TYPE
   * 频次周期类型;字典：FREQUENCY_CYCLE_TYPE不允许为空
   **/
  frequencyCycleType : string;

  /**
   * 周期数
   * 周期数不允许为空
   **/
  frequencyCycleCount : number;

  /**
   * 周期执行数
   * 周期执行数不允许为空
   **/
  frequencyCycleExeCount : number;

  /**
   * 执行天数
   * 执行天数不允许为空
   **/
  exeDays : number;

  /**
   * 开始执行时间
   **/
  startTime? : string;

  /**
   * 结束执行时间
   **/
  endTime? : string;

  /**
   * 是否需要皮试
   **/
  skinTestFlag? : number;

  /**
   * 皮试结果;1阳性，0阴性
   **/
  skinTestResult? : number;

  /**
   * 执行科室id
   * 执行科室id不允许为空
   **/
  exeDeptId : string;

  /**
   * 执行科室名称
   * 执行科室名称不允许为空
   **/
  exeDeptName : string;

  /**
   * 是否支付;1：已支付 0：未支付
   **/
  isPay? : number;

  /**
   * 支付时间
   **/
  payTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 状态;0：待执行1：执行中，2：执行完成，3：执行中断，字典：HOPS_EXE_DEFINE_STATUS
   * 状态;0：待执行1：执行中，2：执行完成，3：执行中断，字典：HOPS_EXE_DEFINE_STATUS不允许为空
   **/
  status : string;

}

/** 科室排班资源号DTO **/
export interface ScheduleDeptResourceDTO extends BaseEntity{
  /**
   * 主键
   **/
  id? : string;

  /**
   * 排班id;关联科室排班表
   * 排班id;关联科室排班表不允许为空
   **/
  scheduleId : string;

  /**
   * 看诊序号
   * 看诊序号不允许为空
   **/
  seqNum : number;

  /**
   * 预估时间
   * 预估时间不允许为空
   **/
  estimatedTime : string;

  /**
   * 看诊开始时间（预估）
   * 看诊开始时间（预估）不允许为空
   **/
  startTime : string;

  /**
   * 看诊结束时间（预估）
   * 看诊结束时间（预估）不允许为空
   **/
  endTime : string;

  /**
   * 是否可预约
   **/
  bookingFlag? : number;

  /**
   * 挂号预约渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  channel? : string;

  /**
   * 预约挂号确认时间
   **/
  sureTime? : string;

  /**
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS
   * 状态;1未使用21预约锁定22挂号锁定23人工锁定4预约5挂号，字典：SCHEDULE_RESOURCE_STATUS不允许为空
   **/
  status : string;

  /**
   * 是否无效
   **/
  invalid? : number;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 锁号时间
   **/
  lockTime? : string;

  /**
   * 解锁时间
   **/
  unlockTime? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 创建人id
   **/
  createUserId? : string;

  /**
   * 创建人姓名
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 最后修改人id
   **/
  lastUserId? : string;

  /**
   * 最后修改时间
   **/
  lastTime? : string;

  /**
   * 最后修改人姓名
   **/
  lastUserName? : string;

}

/** 患者建档参数 **/
export interface RegisterPatientDTO  {
  /**
   * 身份证号码
   **/
  idCard? : string;

  /**
   * 姓名
   **/
  realName? : string;

  /**
   * 性别，1：男，2：女
   * 性别不允许为空
   **/
  gender : number;

  /**
   * 电话
   **/
  phone? : string;

  /**
   * 出生日期，格式为：yyyy-MM-dd
   * 出生日期不允许为空
   **/
  birthday : string;

}

/** 非药品过敏项 **/
export interface HisAllergyNondrugSaveParam  {
  /**
   * 过敏源类型;字典：ALL_ALLERGY_SOURCE_TYPE
   * 过敏源类型;字典：ALL_ALLERGY_SOURCE_TYPE不允许为空
   **/
  allergySourceType : string;

  /**
   * 过敏源子类型;字典：ALL_ALLERGY_SOURCE_TYPE
   **/
  allergySourceSubType? : string;

  /**
   * 名称
   * 名称不允许为空
   **/
  name : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 排序字段
   **/
  sortNo? : number;

}

/** 患者费用分类报表项 **/
export interface PatientFeeTypeItemVO  {
  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 患者唯一号
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  patientName? : string;

  /**
   * 门诊号
   **/
  registerId? : string;

  /**
   * 看诊日期
   **/
  registerDate? : string;

  /**
   * 初诊/复诊，1：初诊断，2：复诊,字典：HOPS_DIAGNOSE_TYPE
   **/
  diagnoseType? : string;

  /**
   * 西药费
   **/
  westernMedicinePrice? : string;

  /**
   * 中成药
   **/
  cpmPrice? : string;

  /**
   * 中草药
   **/
  tcmPrice? : string;

  /**
   * 诊察费
   **/
  examinationPrice? : string;

  /**
   * 化验费
   **/
  lisPrice? : string;

  /**
   * 检查费
   **/
  pacsPrice? : string;

  /**
   * 手术费
   **/
  opsPrice? : string;

  /**
   * 治疗费
   **/
  cureTotakPrice? : string;

  /**
   * 材料费
   **/
  materialPrice? : string;

  /**
   * 护理费
   **/
  nursePrice? : string;

  /**
   * 其他费
   **/
  otherPrice? : string;

  /**
   * 总费用
   **/
  oneTotalrice? : string;

}

/**  **/
export interface LisApplyItemCountByStatusDTO  {
  /**
   * 状态
   **/
  status? : string;

  /**
   * 总数
   **/
  count? : string;

}

/** 医嘱模板保存入参 **/
export interface HopsOrderTemplateSaveParam  {
  /**
   * 模板名称
   * 模板名称不允许为空
   **/
  name : string;

  /**
   * 父级模板id
   * 父级模板id不允许为空
   **/
  parentId : string;

  /**
   * 是否目录 1=是,0=否
   * 是否目录不允许为空
   **/
  isDirectory : number;

  /**
   * 医嘱模板信息
   **/
  sets? : any;

}

/**  **/
export interface HopsRegisterReceptionParam  {
  /**
   * id
   * id不允许为空
   **/
  id : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生姓名
   **/
  doctorName? : string;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

}

/** 用户更新入参 **/
export interface AuthUserUpdateParam  {
  /**
   * 主键
   **/
  id? : string;

  /**
   * 账号
   * 账号不允许为空
   **/
  account : string;

  /**
   * 密码
   **/
  pwd? : string;

  /**
   * 姓名
   **/
  name? : string;

  /**
   * 五笔码
   **/
  wubiCode? : string;

  /**
   * 拼音码
   **/
  pinyinCode? : string;

  /**
   * 手机
   * 手机不允许为空
   **/
  mobile : string;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 生日
   **/
  birthday? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 电话
   **/
  tel? : string;

  /**
   * 邮箱
   **/
  email? : string;

  /**
   * 账号状态;1：正常，2：锁定
   **/
  accountStatus? : number;

  /**
   * 归属组织机构id
   * 归属组织机构id不允许为空
   **/
  orgId : string;

  /**
   * 职务id
   **/
  dutyId? : string;

  /**
   * 职称
   **/
  title? : string;

  /**
   * 婚姻状态
   **/
  maritalStatus? : string;

  /**
   * 教育程度
   **/
  eduLevel? : string;

  /**
   * 联系人
   **/
  linkPerson? : string;

  /**
   * 联系人电话
   **/
  linkPersonTel? : string;

  /**
   * 联系人地址
   **/
  linkPersonAddress? : string;

  /**
   * 描述
   **/
  description? : string;

  /**
   * 备注
   **/
  remark? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 签名图片
   **/
  signImage? : string;

  /**
   * 用户角色列表
   **/
  roleIds? : any;

}

/** 挂号返回对象 **/
export interface HopsRegisterDetailVO  {
  /**
   * id
   **/
  id? : string;

  /**
   * 挂号编号;兼容非字符串挂号编号，默认为id
   **/
  registerNo? : string;

  /**
   * 当日号;挂号当日递增序列算法
   **/
  daySeqNum? : string;

  /**
   * 患者id;关联患者
   **/
  patientId? : string;

  /**
   * 患者姓名
   **/
  name? : string;

  /**
   * 患者年龄
   **/
  age? : string;

  /**
   * 手机
   **/
  mobile? : string;

  /**
   * 现住地址行政区划编码
   **/
  presentAreaCode? : string;

  /**
   * 籍贯区域编码
   **/
  nativePlaceCode? : string;

  /**
   * 联系电话
   **/
  tel? : string;

  /**
   * 现住地址
   **/
  presentAddress? : string;

  /**
   * 现住地址邮政编码
   **/
  presentPostCode? : string;

  /**
   * 户籍地址
   **/
  registerAddress? : string;

  /**
   * 户籍地址邮政编码
   **/
  registerPostCode? : string;

  /**
   * 户籍地址行政区划编码
   **/
  registerAreaCode? : string;

  /**
   * 工单单位行政区划编码
   **/
  unitAreaCode? : string;

  /**
   * 工作单位名称
   **/
  unitName? : string;

  /**
   * 工作单位地址
   **/
  unitAddress? : string;

  /**
   * 工作单位邮政编码
   **/
  unitPostCode? : string;

  /**
   * 工作单位电话
   **/
  unitTel? : string;

  /**
   * 联系人姓名
   **/
  linkman? : string;

  /**
   * 联系人关系;字典：PERSON_RELATION
   **/
  linkmanRelation? : string;

  /**
   * 联系人手机
   **/
  linkmanMobile? : string;

  /**
   * 联系人地址行政区划编码
   **/
  linkmanAreaCode? : string;

  /**
   * 联系人地址
   **/
  linkmanAddress? : string;

  /**
   * 结算类别;字典：BILLING_TYPE
   **/
  billingType? : string;

  /**
   * 监护人姓名
   **/
  guardianName? : string;

  /**
   * 监护人证件类型;字典：COMMON_IDCARD_TYPE
   **/
  guardianIdcardType? : string;

  /**
   * 监护人证件号
   **/
  guardianIdcardNo? : string;

  /**
   * 监护人关系;字典：PERSON_RELATION
   **/
  guardianRelation? : string;

  /**
   * 医保号
   **/
  medicalInsuranceNo? : string;

  /**
   * 医保区域
   **/
  medicalInsuranceArea? : string;

  /**
   * 国籍;字典：COMMON_NATIONALITY
   **/
  nationalityCode? : string;

  /**
   * 民族;字典：COMMON_NATION
   **/
  nationCode? : string;

  /**
   * 职业;字典：COMMON_PROFESSION
   **/
  professionCode? : string;

  /**
   * 血型;字典：BLOOD_TYPE
   **/
  bloodType? : string;

  /**
   * 头像
   **/
  headImage? : string;

  /**
   * 头像url
   **/
  headImageUrl? : string;

  /**
   * 挂号类型;字典：HOPS_REGISTER_TYPE
   **/
  registerType? : string;

  /**
   * 号源;关联科室医生排班
   **/
  resourceId? : string;

  /**
   * 挂号日期
   **/
  registerDate? : string;

  /**
   * 挂号级别;关联挂号级别
   **/
  levelId? : string;

  /**
   * 挂号渠道;字典：REGISTER_BOOK_CHANNEL
   **/
  registerChannel? : string;

  /**
   * 排班id;关联排班表
   **/
  scheduleId? : string;

  /**
   * 排班类型;1：科室排班，2：医生排班；字典：HOPS_SCHEDULE_TYPE
   **/
  scheduleType? : string;

  /**
   * 排班段名称
   **/
  timeName? : string;

  /**
   * 看诊时间段开始时间
   **/
  seeStartTime? : string;

  /**
   * 看诊时间段结束时间
   **/
  seeEndTime? : string;

  /**
   * 看诊断预估时间
   **/
  seeEstimatedTime? : string;

  /**
   * 看诊断序号
   **/
  seeSeqNum? : number;

  /**
   * 科室id;关联组织架构
   **/
  deptId? : string;

  /**
   * 科室名称
   **/
  deptName? : string;

  /**
   * 医生id;关联用户
   **/
  doctorId? : string;

  /**
   * 医生名称
   **/
  doctorName? : string;

  /**
   * 预约id
   **/
  bookingId? : number;

  /**
   * 是否初诊
   **/
  firstSeeFlag? : number;

  /**
   * 是否加号
   **/
  appendFlag? : number;

  /**
   * 是否急诊
   **/
  emergencyFlag? : number;

  /**
   * 是否加急
   **/
  urgentFlag? : number;

  /**
   * 状态;0：无效、1：锁号待支付、21.支付成功、20.支付取消、3.待看诊、4.已接诊 5.已完成就诊
   **/
  status? : number;

  /**
   * 证件类型;字典：COMMON_IDCARD_TYPE
   **/
  idcardType? : string;

  /**
   * 证件号码
   **/
  idcardNo? : string;

  /**
   * 创建人
   **/
  createUserName? : string;

  /**
   * 创建时间
   **/
  createTime? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 性别;字典：COMMON_GENDER_TYPE
   **/
  gender? : string;

  /**
   * 诊室名称
   **/
  roomName? : string;

  /**
   * 诊台名称
   **/
  deskName? : string;

  /**
   * 科室地址
   **/
  deptAddress? : string;

  /**
   * 就诊地址
   **/
  outpatientAddress? : string;

  /**
   * 诊断类型 1.初诊 2.复诊
   **/
  diagnoseType? : number;

  /**
   * 诊断
   **/
  diagnoseStr? : string;

  /**
   * 过敏史
   **/
  allergicHistory? : string;

  /**
   * 账单信息
   **/
  feeBillDTOList? : any;

  /**
   * 医生工号
   **/
  doctorAccount? : string;

  /**
   * 挂号级别名称
   **/
  levelName? : string;

  /**
   * 出生日期
   **/
  birthday? : string;

  /**
   * 过敏信息
   **/
  allergyLine? : string;

}

/** 字典定义分页查询条件 **/
export interface DictDefinePageParam extends PageParam{
  /**
   * 字典组id;关联字典组
   **/
  groupId? : string;

  /**
   * 字典标准id;关联字典标准
   **/
  standardId? : string;

  /**
   * 查询关键字
   **/
  keyword? : string;

}

/** 检验申请与医嘱关联 **/
export interface TaHopsLisApplyOrder extends BaseEntity{
  /**
   * 门诊检验申请单id
   * 门诊检验申请单id不允许为空
   **/
  hopsApplyId : string;

  /**
   * 医嘱id
   * 医嘱id不允许为空
   **/
  orderId : string;

}

/** 检查报告分页查询条件 **/
export interface PacsReportPageParam extends PageParam{
  /**
   * 检查申请id
   **/
  applyId? : string;

  /**
   * 检验申请项目id
   **/
  applyItemId? : string;

  /**
   * 模板id
   **/
  templateId? : string;

  /**
   * 报告内容
   **/
  content? : string;

  /**
   * 备注
   **/
  remark? : string;

}

/**  **/
export interface RegLevelDTO  {
  /**
   * 挂号级别id
   **/
  regLevelId? : string;

  /**
   * 挂号级别名称
   **/
  regLevelName? : string;

  /**
   * 费用名称
   **/
  regFeeList? : any;

}

/** 门诊医嘱配发药退药信息 DTO **/
export interface HopsDispenseReturnInfoDTO  {
  /**
   * 项目id
   **/
  itemId? : string;

  /**
   * 项目编码
   **/
  itemCode? : string;

  /**
   * 项目名称
   **/
  itemName? : string;

  /**
   * 规格
   **/
  itemSpecs? : string;

  /**
   * 总量
   **/
  totalQuantity? : number;

  /**
   * 总退量
   **/
  totalReturnQuantity? : number;

  /**
   * 退款项目详情
   **/
  details? : any;

}

/** 患者检查项目分页参数 **/
export interface PatientPacsItemPageParam extends PageParam{
  /**
   * 患者唯一号，患者名称关键字搜索
   **/
  keyword? : string;

  /**
   * 开始日期
   **/
  startDate? : string;

  /**
   * 结束日期
   **/
  endDate? : string;

}

/** 药品分页查询条件 **/
export interface BaseDrugPageParam extends PageParam{
  /**
   * 药品类别;字典：DRUG_TYPE
   **/
  drugType? : any;

  /**
   * 项目分类;字典：ITEM_SYS_TYPE
   **/
  itemSysType? : any;

  /**
   * 医保分类;字典：MEDICAL_INSURANCE_TYPE
   **/
  medicalInsuranceType? : any;

  /**
   * 当前开立科室
   **/
  openDeptId? : string;

  /**
   * 开立不显示
   **/
  orderFlag? : number;

  /**
   * 门诊住院标志;1:门诊，2：住院，3：门诊和住院，字典：HOPS_HIOS_FLAG
   **/
  hopsHipsFlag? : any;

  /**
   * 关键字
   **/
  keyword? : string;

}



/** 以下是生成的Api对象 **/
/**
 * 验证码Api
 **/
export class HallCaptchaApi {
    /**
     * 获取验证码信息
     * 
     * @param arg0 
     **/
    public static async get( arg0? : any ) : Promise<HallCaptchaResult> {
        // baseUrl=/auth/v1.0.0/captch/get
        // httpMethod=post json 
        return await http.postJson<any, HallCaptchaResult>('/auth/v1.0.0/captch/get', {
            data:  arg0
        })
    }
    /**
     * 检查验证码信息
     * 
     * @param arg0 
     **/
    public static async check( arg0? : any ) : Promise<HallCaptchaResult> {
        // baseUrl=/auth/v1.0.0/captch/check
        // httpMethod=post json 
        return await http.postJson<any, HallCaptchaResult>('/auth/v1.0.0/captch/check', {
            data:  arg0
        })
    }
}
/**
 * 登录Api
 **/
export class AuthLoginApi {
    /**
     * 登录
     * 
     * @param arg0 
     **/
    public static async login( arg0? : AuthLoginParam ) : Promise<HallResult<AuthSessionVO>> {
        // baseUrl=/auth/v1.0.0/login
        // httpMethod=post json 
        return await http.postJson<AuthLoginParam, HallResult<AuthSessionVO>>('/auth/v1.0.0/login', {
            data:  arg0
        })
    }
    /**
     * 登陆V2
     * 
     * @param arg0 
     **/
    public static async loginV2( arg0? : AuthLoginParam ) : Promise<HallResult<CurrentLoginUserVO>> {
        // baseUrl=/auth/v1.0.0/login/v2
        // httpMethod=post json 
        return await http.postJson<AuthLoginParam, HallResult<CurrentLoginUserVO>>('/auth/v1.0.0/login/v2', {
            data:  arg0
        })
    }
    /**
     * 切换登录应用信息
     * 
     * @param arg0 
     **/
    public static async loginByApp( arg0? : AuthLoginChangeParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/login/_loginByApp
        // httpMethod=post json 
        return await http.postJson<AuthLoginChangeParam, HallResult<boolean>>('/auth/v1.0.0/login/_loginByApp', {
            data:  arg0
        })
    }
    /**
     * 获取授权信息
     * 
     * @param accessToken  必填 
     **/
    public static async getByAccessToken( accessToken : string ) : Promise<HallResult<CurrentLoginUserVO>> {
        // baseUrl=/auth/v1.0.0/login/_getByAccessToken
        // httpMethod=get
        return await http.get<any, HallResult<CurrentLoginUserVO>>('/auth/v1.0.0/login/_getByAccessToken', {
            params: {  accessToken            }
        })

    }
    /**
     * 退出登录
     * 
     **/
    public static async logOut() : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/login/_logOut
        // httpMethod=get
        return await http.get<any, HallResult<boolean>>('/auth/v1.0.0/login/_logOut', {
            params: {             }
        })

    }
    /**
     * 修改密码
     * 
     * @param arg0 
     **/
    public static async editPwd( arg0? : AuthUserEditPwdParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/login/_editPwd
        // httpMethod=put json 
        return await http.putJson<AuthUserEditPwdParam, HallResult<boolean>>('/auth/v1.0.0/login/_editPwd', {
            data:  arg0
        })
    }
}
/**
 * 资源Api
 **/
export class AuthResourceApi {
    /**
     * 修改资源
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaAuthResource ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/resource
        // httpMethod=put json 
        return await http.putJson<TaAuthResource, HallResult<boolean>>('/auth/v1.0.0/resource', {
            data:  arg0
        })
    }
    /**
     * 获取所有app跟resource
     * 
     **/
    public static async allResourcesExport() : Promise<HallResult<AllResourceExportVO>> {
        // baseUrl=/auth/v1.0.0/resource/allAppAndResources
        // httpMethod=get
        return await http.get<any, HallResult<AllResourceExportVO>>('/auth/v1.0.0/resource/allAppAndResources', {
            params: {             }
        })

    }
    /**
     * 删除资源
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/resource
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/auth/v1.0.0/resource', {
            params: {  id            }
        })
    }
    /**
     * 查询资源列表
     * 
     * @param arg0 
     **/
    public static async list( arg0? : AuthResourceListParam ) : Promise<HallResult<AuthResourceVO[]>> {
        // baseUrl=/auth/v1.0.0/resource/_list
        // httpMethod=get
        return await http.get<any, HallResult<AuthResourceVO[]>>('/auth/v1.0.0/resource/_list', {
            params: arg0
        })

    }
    /**
     * 保存资源
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaAuthResource ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/resource
        // httpMethod=post json 
        return await http.postJson<TaAuthResource, HallResult<boolean>>('/auth/v1.0.0/resource', {
            data:  arg0
        })
    }
}
/**
 * 职务Api
 **/
export class AuthDutyApi {
    /**
     * 职务详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaAuthDuty>> {
        // baseUrl=/auth/v1.0.0/duty
        // httpMethod=get
        return await http.get<any, HallResult<TaAuthDuty>>('/auth/v1.0.0/duty', {
            params: {  id            }
        })

    }
    /**
     * 修改职务
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaAuthDuty ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/duty
        // httpMethod=put json 
        return await http.putJson<TaAuthDuty, HallResult<boolean>>('/auth/v1.0.0/duty', {
            data:  arg0
        })
    }
    /**
     * 分页查询职务
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : AuthDutyPageParam ) : Promise<HallResult<Page<TaAuthDuty>>> {
        // baseUrl=/auth/v1.0.0/duty/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaAuthDuty>>>('/auth/v1.0.0/duty/_paging', {
            params: arg0
        })

    }
    /**
     * 删除职务
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/duty
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/auth/v1.0.0/duty', {
            params: {  id            }
        })
    }
    /**
     * 查询职务列表
     * 
     * @param arg0 
     **/
    public static async list( arg0? : AuthDutyPageParam ) : Promise<HallResult<Page<TaAuthDuty>>> {
        // baseUrl=/auth/v1.0.0/duty/_list
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaAuthDuty>>>('/auth/v1.0.0/duty/_list', {
            params: arg0
        })

    }
    /**
     * 保存职务
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaAuthDuty ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/duty
        // httpMethod=post json 
        return await http.postJson<TaAuthDuty, HallResult<boolean>>('/auth/v1.0.0/duty', {
            data:  arg0
        })
    }
}
/**
 * 角色Api
 **/
export class AuthRoleApi {
    /**
     * 角色详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<AuthRoleVO>> {
        // baseUrl=/auth/v1.0.0/role
        // httpMethod=get
        return await http.get<any, HallResult<AuthRoleVO>>('/auth/v1.0.0/role', {
            params: {  id            }
        })

    }
    /**
     * 修改角色
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaAuthRole ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/role
        // httpMethod=put json 
        return await http.putJson<TaAuthRole, HallResult<boolean>>('/auth/v1.0.0/role', {
            data:  arg0
        })
    }
    /**
     * 分页查询角色
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : AuthRolePageParam ) : Promise<HallResult<Page<TaAuthRole>>> {
        // baseUrl=/auth/v1.0.0/role/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaAuthRole>>>('/auth/v1.0.0/role/_paging', {
            params: arg0
        })

    }
    /**
     * 获取角色资源Tree
     * 
     * @param appId  必填 
     * @param roleId  必填 
     **/
    public static async getRoleResourceTree( appId : string , roleId : string ) : Promise<HallResult<AuthResourceTreeVO>> {
        // baseUrl=/auth/v1.0.0/role/_getRoleResourceTree
        // httpMethod=get
        return await http.get<any, HallResult<AuthResourceTreeVO>>('/auth/v1.0.0/role/_getRoleResourceTree', {
            params: {  appId, roleId            }
        })

    }
    /**
     * 保存角色资源信息
     * 
     * @param arg0 
     **/
    public static async saveRoleResource( arg0? : AuthRoleResourceCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/role/_saveRoleResource
        // httpMethod=post json 
        return await http.postJson<AuthRoleResourceCreateParam, HallResult<boolean>>('/auth/v1.0.0/role/_saveRoleResource', {
            data:  arg0
        })
    }
    /**
     * 保存角色管辖科室范围信息
     * 
     * @param arg0 
     **/
    public static async saveRoleOrg( arg0? : AuthRoleOrgCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/role/_saveRoleOrg
        // httpMethod=post json 
        return await http.postJson<AuthRoleOrgCreateParam, HallResult<boolean>>('/auth/v1.0.0/role/_saveRoleOrg', {
            data:  arg0
        })
    }
    /**
     * 获取角色组织Tree
     * 
     * @param roleId  必填 
     **/
    public static async getRoleOrgTree( roleId : string ) : Promise<HallResult<AuthOrgTreeVO>> {
        // baseUrl=/auth/v1.0.0/role/_getRoleOrgTree
        // httpMethod=get
        return await http.get<any, HallResult<AuthOrgTreeVO>>('/auth/v1.0.0/role/_getRoleOrgTree', {
            params: {  roleId            }
        })

    }
    /**
     * 删除角色
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/role
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/auth/v1.0.0/role', {
            params: {  id            }
        })
    }
    /**
     * 保存角色
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaAuthRole ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/role
        // httpMethod=post json 
        return await http.postJson<TaAuthRole, HallResult<boolean>>('/auth/v1.0.0/role', {
            data:  arg0
        })
    }
}
/**
 * 权限对码Api
 **/
export class AuthMatchingApi {
    /**
     * 对码分页接口
     * 
     * @param arg0 
     **/
    public static async matchPaging( arg0? : AuthMatchingParam ) : Promise<HallResult<Page<AuthMatchingVO>>> {
        // baseUrl=/auth/v1.0.0/matching/_matchPaging
        // httpMethod=get
        return await http.get<any, HallResult<Page<AuthMatchingVO>>>('/auth/v1.0.0/matching/_matchPaging', {
            params: arg0
        })

    }
}
/**
 * 代理接入信息Api
 **/
export class AuthAgentAccessApi {
    /**
     * 授权代理
     * 
     * @param arg0 
     **/
    public static async authorizationAgent( arg0? : AgentAuthParam ) : Promise<HallResult<AgentAccessVO>> {
        // baseUrl=/auth/v1.0.0/agent/access/authorizationAgent
        // httpMethod=post json 
        return await http.postJson<AgentAuthParam, HallResult<AgentAccessVO>>('/auth/v1.0.0/agent/access/authorizationAgent', {
            data:  arg0
        })
    }
    /**
     * 获取代理的accessToken
     * 
     * @param accessId  必填 
     * @param token  必填 
     * @param random  必填 
     **/
    public static async getAgentAccessToken( accessId : string , token : string , random : string ) : Promise<HallResult<string>> {
        // baseUrl=/auth/v1.0.0/agent/access/accessToken
        // httpMethod=get
        return await http.get<any, HallResult<string>>('/auth/v1.0.0/agent/access/accessToken', {
            params: {  accessId, token, random            }
        })

    }
}
/**
 * 组织机构Api
 **/
export class AuthOrgApi {
    /**
     * 修改组织机构
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaAuthOrg ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/org
        // httpMethod=put json 
        return await http.putJson<TaAuthOrg, HallResult<boolean>>('/auth/v1.0.0/org', {
            data:  arg0
        })
    }
    /**
     * 删除组织机构
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/org
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/auth/v1.0.0/org', {
            params: {  id            }
        })
    }
    /**
     * 查询组织机构列表
     * 
     * @param arg0 
     **/
    public static async list( arg0? : AuthOrgListParam ) : Promise<HallResult<AuthOrgVO[]>> {
        // baseUrl=/auth/v1.0.0/org/_list
        // httpMethod=get
        return await http.get<any, HallResult<AuthOrgVO[]>>('/auth/v1.0.0/org/_list', {
            params: arg0
        })

    }
    /**
     * 保存组织机构
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaAuthOrg ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/org
        // httpMethod=post json 
        return await http.postJson<TaAuthOrg, HallResult<boolean>>('/auth/v1.0.0/org', {
            data:  arg0
        })
    }
}
/**
 * 应用Api
 **/
export class AuthAppApi {
    /**
     * 应用详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<AuthAppVO>> {
        // baseUrl=/auth/v1.0.0/app
        // httpMethod=get
        return await http.get<any, HallResult<AuthAppVO>>('/auth/v1.0.0/app', {
            params: {  id            }
        })

    }
    /**
     * 修改应用
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : AuthAppUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/app
        // httpMethod=put json 
        return await http.putJson<AuthAppUpdateParam, HallResult<boolean>>('/auth/v1.0.0/app', {
            data:  arg0
        })
    }
    /**
     * 分页查询应用
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : AuthAppPageParam ) : Promise<HallResult<Page<AuthAppDTO>>> {
        // baseUrl=/auth/v1.0.0/app/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<AuthAppDTO>>>('/auth/v1.0.0/app/_paging', {
            params: arg0
        })

    }
    /**
     * 删除应用
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/app
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/auth/v1.0.0/app', {
            params: {  id            }
        })
    }
    /**
     * 查询应用列表
     * 
     * @param arg0 
     **/
    public static async list( arg0? : AuthAppPageParam ) : Promise<HallResult<AuthAppVO[]>> {
        // baseUrl=/auth/v1.0.0/app/_list
        // httpMethod=get
        return await http.get<any, HallResult<AuthAppVO[]>>('/auth/v1.0.0/app/_list', {
            params: arg0
        })

    }
    /**
     * 保存应用
     * 
     * @param arg0 
     **/
    public static async save( arg0? : AuthAppCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/app
        // httpMethod=post json 
        return await http.postJson<AuthAppCreateParam, HallResult<boolean>>('/auth/v1.0.0/app', {
            data:  arg0
        })
    }
}
/**
 * 缓存Api
 **/
export class OpsCacheApi {
    /**
     * 删除缓存，其中key为framework加密数据
     * 
     * @param key  必填 
     **/
    public static async del( key : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/ops/cache/del
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/auth/v1.0.0/ops/cache/del', {
            params: {  key            }
        })
    }
    /**
     * 获取缓存，其中key为framework加密数据
     * 
     * @param key  必填 
     **/
    public static async get( key : string ) : Promise<HallResult<string>> {
        // baseUrl=/auth/v1.0.0/ops/cache/get
        // httpMethod=get
        return await http.get<any, HallResult<string>>('/auth/v1.0.0/ops/cache/get', {
            params: {  key            }
        })

    }
    /**
     * 设置缓存，其中key和value为framework加密数据
     * 
     * @param arg0 
     **/
    public static async set( arg0? : CacheSetParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/ops/cache/set
        // httpMethod=post json 
        return await http.postJson<CacheSetParam, HallResult<boolean>>('/auth/v1.0.0/ops/cache/set', {
            data:  arg0
        })
    }
}
/**
 * 令牌Api
 **/
export class AuthTokenApi {
    /**
     * 获取一次性token
     * 
     **/
    public static async onceToken() : Promise<HallResult<string>> {
        // baseUrl=/auth/v1.0.0/token/_onceToken
        // httpMethod=get
        return await http.get<any, HallResult<string>>('/auth/v1.0.0/token/_onceToken', {
            params: {             }
        })

    }
}
/**
 * 用户Api
 **/
export class AuthUserApi {
    /**
     * 解锁用户
     * 
     * @param id  必填 
     **/
    public static async unlock( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user/_unlock
        // httpMethod=post
        return await http.post<any, HallResult<boolean>>('/auth/v1.0.0/user/_unlock', {
            params: {  id            }
    })
    }
    /**
     * 用户详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<AuthUserVO>> {
        // baseUrl=/auth/v1.0.0/user
        // httpMethod=get
        return await http.get<any, HallResult<AuthUserVO>>('/auth/v1.0.0/user', {
            params: {  id            }
        })

    }
    /**
     * 修改用户
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : AuthUserUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user
        // httpMethod=put json 
        return await http.putJson<AuthUserUpdateParam, HallResult<boolean>>('/auth/v1.0.0/user', {
            data:  arg0
        })
    }
    /**
     * 分页查询用户
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : AuthUserPageParam ) : Promise<HallResult<Page<AuthUserVO>>> {
        // baseUrl=/auth/v1.0.0/user/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<AuthUserVO>>>('/auth/v1.0.0/user/_paging', {
            params: arg0
        })

    }
    /**
     * 用户人员管辖科室编辑
     * 
     * @param arg0 
     **/
    public static async saveUserRoleOrg( arg0? : AuthUserRoleOrgCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user/_saveUserRoleOrg
        // httpMethod=post json 
        return await http.postJson<AuthUserRoleOrgCreateParam, HallResult<boolean>>('/auth/v1.0.0/user/_saveUserRoleOrg', {
            data:  arg0
        })
    }
    /**
     * 根据组织机构查询管辖此机构的用户列表
     * 
     * @param id  必填 
     **/
    public static async findScopeByOrgId( id : string ) : Promise<HallResult<AuthBaseUserVO[]>> {
        // baseUrl=/auth/v1.0.0/user/_findScopeByOrgId
        // httpMethod=get
        return await http.get<any, HallResult<AuthBaseUserVO[]>>('/auth/v1.0.0/user/_findScopeByOrgId', {
            params: {  id            }
        })

    }
    /**
     * 根据条件查询管辖此机构的用户列表
     * 
     * @param arg0 
     **/
    public static async findScopeByCondition( arg0? : AuthUserConditionParam ) : Promise<HallResult<AuthBaseUserVO[]>> {
        // baseUrl=/auth/v1.0.0/user/_findScopeByCondition
        // httpMethod=get
        return await http.get<any, HallResult<AuthBaseUserVO[]>>('/auth/v1.0.0/user/_findScopeByCondition', {
            params: arg0
        })

    }
    /**
     * 获取当前科室具有权限的用户信息
     * 
     **/
    public static async findCurrentDeptAuthUsers() : Promise<HallResult<UserIdAccountNameVO[]>> {
        // baseUrl=/auth/v1.0.0/user/_findCurrentDeptAuthUsers
        // httpMethod=get
        return await http.get<any, HallResult<UserIdAccountNameVO[]>>('/auth/v1.0.0/user/_findCurrentDeptAuthUsers', {
            params: {             }
        })

    }
    /**
     * 修改当前用户的密码
     * 
     * @param arg0 
     **/
    public static async editCurrentUserPwd( arg0? : AuthEditCurrentUserPwdParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user/_editCurrentUserPwd
        // httpMethod=put json 
        return await http.putJson<AuthEditCurrentUserPwdParam, HallResult<boolean>>('/auth/v1.0.0/user/_editCurrentUserPwd', {
            data:  arg0
        })
    }
    /**
     * 获取用户角色科室管辖树
     * 
     * @param arg0 
     **/
    public static async getOrgTree( arg0? : AuthUserRoleOrgListParam ) : Promise<HallResult<AuthOrgTreeVO>> {
        // baseUrl=/auth/v1.0.0/user/_getOrgTree
        // httpMethod=get
        return await http.get<any, HallResult<AuthOrgTreeVO>>('/auth/v1.0.0/user/_getOrgTree', {
            params: arg0
        })

    }
    /**
     * 锁定用户
     * 
     * @param id  必填 
     **/
    public static async lock( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user/_lock
        // httpMethod=post
        return await http.post<any, HallResult<boolean>>('/auth/v1.0.0/user/_lock', {
            params: {  id            }
    })
    }
    /**
     * 删除用户
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/auth/v1.0.0/user', {
            params: {  id            }
        })
    }
    /**
     * 保存用户
     * 
     * @param arg0 
     **/
    public static async save( arg0? : AuthUserCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user
        // httpMethod=post json 
        return await http.postJson<AuthUserCreateParam, HallResult<boolean>>('/auth/v1.0.0/user', {
            data:  arg0
        })
    }
    /**
     * 重置密码
     * 
     * @param arg0 
     **/
    public static async reset( arg0? : AuthUserResetPwdParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/auth/v1.0.0/user/_reset
        // httpMethod=post json 
        return await http.postJson<AuthUserResetPwdParam, HallResult<boolean>>('/auth/v1.0.0/user/_reset', {
            data:  arg0
        })
    }
}
/**
 * 行政区划Api
 **/
export class DictAreaApi {
    /**
     * 行政区划详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDictArea>> {
        // baseUrl=/dict/v1.0.0/area
        // httpMethod=get
        return await http.get<any, HallResult<TaDictArea>>('/dict/v1.0.0/area', {
            params: {  id            }
        })

    }
    /**
     * 更新所有字典的五笔码跟拼音码
     * 
     **/
    public static async updateWubiPinyinCode() : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/area/_updateWubiPinyinCode
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/dict/v1.0.0/area/_updateWubiPinyinCode', {
            params: {             }
        })
    }
    /**
     * 修改行政区划
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDictArea ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/area
        // httpMethod=put json 
        return await http.putJson<TaDictArea, HallResult<boolean>>('/dict/v1.0.0/area', {
            data:  arg0
        })
    }
    /**
     * 分页查询行政区划
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DictAreaPageParam ) : Promise<HallResult<Page<TaDictArea>>> {
        // baseUrl=/dict/v1.0.0/area/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDictArea>>>('/dict/v1.0.0/area/_paging', {
            params: arg0
        })

    }
    /**
     * 删除行政区划
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/area
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/area', {
            params: {  id            }
        })
    }
    /**
     * 保存行政区划
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDictArea ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/area
        // httpMethod=post json 
        return await http.postJson<TaDictArea, HallResult<boolean>>('/dict/v1.0.0/area', {
            data:  arg0
        })
    }
    /**
     * 根据关键字查询树结构数据
     * 
     * @param keyword 
     **/
    public static async tree( keyword? : string ) : Promise<HallResult<DictAreaTreeDto[]>> {
        // baseUrl=/dict/v1.0.0/area/_tree
        // httpMethod=get
        return await http.get<any, HallResult<DictAreaTreeDto[]>>('/dict/v1.0.0/area/_tree', {
            params: {  keyword            }
        })

    }
}
/**
 * 字典组Api
 **/
export class DictGroupApi {
    /**
     * 字典组详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<DictGroupFullVO>> {
        // baseUrl=/dict/v1.0.0/group
        // httpMethod=get
        return await http.get<any, HallResult<DictGroupFullVO>>('/dict/v1.0.0/group', {
            params: {  id            }
        })

    }
    /**
     * 修改字典组
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDictGroup ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/group
        // httpMethod=put json 
        return await http.putJson<TaDictGroup, HallResult<boolean>>('/dict/v1.0.0/group', {
            data:  arg0
        })
    }
    /**
     * 删除字典组
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/group
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/group', {
            params: {  id            }
        })
    }
    /**
     * 保存字典组
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDictGroup ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/group
        // httpMethod=post json 
        return await http.postJson<TaDictGroup, HallResult<boolean>>('/dict/v1.0.0/group', {
            data:  arg0
        })
    }
    /**
     * 根据关键字查询字典组树数据
     * 
     * @param arg0 
     **/
    public static async tree( arg0? : DictGroupTreeParam ) : Promise<HallResult<DictGroupTreeNodeVO[]>> {
        // baseUrl=/dict/v1.0.0/group/_tree
        // httpMethod=get
        return await http.get<any, HallResult<DictGroupTreeNodeVO[]>>('/dict/v1.0.0/group/_tree', {
            params: arg0
        })

    }
}
/**
 * 基础配置Api
 **/
export class ConfigApi {
    /**
     * 获取配置详情
     * 
     **/
    public static async configDetail() : Promise<HallResult<ConfigVO>> {
        // baseUrl=/dict/v1.0.0/config/_configDetail
        // httpMethod=get
        return await http.get<any, HallResult<ConfigVO>>('/dict/v1.0.0/config/_configDetail', {
            params: {             }
        })

    }
    /**
     * 更新配置
     * 
     * @param arg0 
     **/
    public static async update( arg0? : ConfigVO ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/config/_update
        // httpMethod=post json 
        return await http.postJson<ConfigVO, HallResult<boolean>>('/dict/v1.0.0/config/_update', {
            data:  arg0
        })
    }
}
/**
 * 测试加密Api
 **/
export class TestEncryptApi {
    /**
     * 测试加密详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaTestEncrypt>> {
        // baseUrl=/dict/v1.0.0/encrypt
        // httpMethod=get
        return await http.get<any, HallResult<TaTestEncrypt>>('/dict/v1.0.0/encrypt', {
            params: {  id            }
        })

    }
    /**
     * 查询简单的VOS
     * 
     **/
    public static async simpleVos() : Promise<HallResult<TestEncryptDetailVO[]>> {
        // baseUrl=/dict/v1.0.0/encrypt/_simpleVos
        // httpMethod=get
        return await http.get<any, HallResult<TestEncryptDetailVO[]>>('/dict/v1.0.0/encrypt/_simpleVos', {
            params: {             }
        })

    }
    /**
     * 修改名字
     * 
     * @param arg0 
     **/
    public static async editName( arg0? : TestEncryptEditNameParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/encrypt/_editName
        // httpMethod=put json 
        return await http.putJson<TestEncryptEditNameParam, HallResult<boolean>>('/dict/v1.0.0/encrypt/_editName', {
            data:  arg0
        })
    }
    /**
     * 修改测试加密
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaTestEncrypt ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/encrypt
        // httpMethod=put json 
        return await http.putJson<TaTestEncrypt, HallResult<boolean>>('/dict/v1.0.0/encrypt', {
            data:  arg0
        })
    }
    /**
     * 分页查询测试加密
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : TestEncryptPageParam ) : Promise<HallResult<Page<TaTestEncrypt>>> {
        // baseUrl=/dict/v1.0.0/encrypt/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaTestEncrypt>>>('/dict/v1.0.0/encrypt/_paging', {
            params: arg0
        })

    }
    /**
     * 删除测试加密
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/encrypt
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/encrypt', {
            params: {  id            }
        })
    }
    /**
     * 保存测试加密
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaTestEncrypt ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/encrypt
        // httpMethod=post json 
        return await http.postJson<TaTestEncrypt, HallResult<boolean>>('/dict/v1.0.0/encrypt', {
            data:  arg0
        })
    }
    /**
     * 根据条件查询全部
     * 
     * @param arg0 
     **/
    public static async search( arg0? : TestEncryptSearchParam ) : Promise<HallResult<TaTestEncrypt[]>> {
        // baseUrl=/dict/v1.0.0/encrypt/_search
        // httpMethod=get
        return await http.get<any, HallResult<TaTestEncrypt[]>>('/dict/v1.0.0/encrypt/_search', {
            params: arg0
        })

    }
}
/**
 * 字典标准Api
 **/
export class DictStandardApi {
    /**
     * 字典标准详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDictStandard>> {
        // baseUrl=/dict/v1.0.0/standard
        // httpMethod=get
        return await http.get<any, HallResult<TaDictStandard>>('/dict/v1.0.0/standard', {
            params: {  id            }
        })

    }
    /**
     * 修改字典标准
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDictStandard ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/standard
        // httpMethod=put json 
        return await http.putJson<TaDictStandard, HallResult<boolean>>('/dict/v1.0.0/standard', {
            data:  arg0
        })
    }
    /**
     * 分页查询字典标准
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DictStandardPageParam ) : Promise<HallResult<Page<TaDictStandard>>> {
        // baseUrl=/dict/v1.0.0/standard/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDictStandard>>>('/dict/v1.0.0/standard/_paging', {
            params: arg0
        })

    }
    /**
     * 获取全部字典标准
     * 
     **/
    public static async listAll() : Promise<HallResult<DictStandardIdNameVO[]>> {
        // baseUrl=/dict/v1.0.0/standard/_all
        // httpMethod=get
        return await http.get<any, HallResult<DictStandardIdNameVO[]>>('/dict/v1.0.0/standard/_all', {
            params: {             }
        })

    }
    /**
     * 删除字典标准
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/standard
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/standard', {
            params: {  id            }
        })
    }
    /**
     * 保存字典标准
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDictStandard ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/standard
        // httpMethod=post json 
        return await http.postJson<TaDictStandard, HallResult<boolean>>('/dict/v1.0.0/standard', {
            data:  arg0
        })
    }
}
/**
 * 医院Api
 **/
export class DictHospitalApi {
    /**
     * 医院详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDictHospital>> {
        // baseUrl=/dict/v1.0.0/hospital
        // httpMethod=get
        return await http.get<any, HallResult<TaDictHospital>>('/dict/v1.0.0/hospital', {
            params: {  id            }
        })

    }
    /**
     * 修改医院
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDictHospital ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/hospital
        // httpMethod=put json 
        return await http.putJson<TaDictHospital, HallResult<boolean>>('/dict/v1.0.0/hospital', {
            data:  arg0
        })
    }
    /**
     * 分页查询医院
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DictHospitalPageParam ) : Promise<HallResult<Page<TaDictHospital>>> {
        // baseUrl=/dict/v1.0.0/hospital/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDictHospital>>>('/dict/v1.0.0/hospital/_paging', {
            params: arg0
        })

    }
    /**
     * 删除医院
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/hospital
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/hospital', {
            params: {  id            }
        })
    }
    /**
     * 保存医院
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDictHospital ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/hospital
        // httpMethod=post json 
        return await http.postJson<TaDictHospital, HallResult<boolean>>('/dict/v1.0.0/hospital', {
            data:  arg0
        })
    }
}
/**
 * 字典定义Api
 **/
export class DictDefineApi {
    /**
     * 字典定义详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<DictDefineFullVO>> {
        // baseUrl=/dict/v1.0.0/define
        // httpMethod=get
        return await http.get<any, HallResult<DictDefineFullVO>>('/dict/v1.0.0/define', {
            params: {  id            }
        })

    }
    /**
     * 修改字典定义
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDictDefine ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/define
        // httpMethod=put json 
        return await http.putJson<TaDictDefine, HallResult<boolean>>('/dict/v1.0.0/define', {
            data:  arg0
        })
    }
    /**
     * 分页查询字典定义
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DictDefinePageParam ) : Promise<HallResult<Page<DictDefineFullVO>>> {
        // baseUrl=/dict/v1.0.0/define/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<DictDefineFullVO>>>('/dict/v1.0.0/define/_paging', {
            params: arg0
        })

    }
    /**
     * 根据多个字典定义获取多个字典数据
     * 
     * @param codes 字典定义编码，如果多个字典定义编码用英文的逗号(,)拼接 必填 
     **/
    public static async findByCodes( codes : string ) : Promise<HallResult<[string: any]>> {
        // baseUrl=/dict/v1.0.0/define/_mapByCodes
        // httpMethod=get
        return await http.get<any, HallResult<[string: any]>>('/dict/v1.0.0/define/_mapByCodes', {
            params: {  codes            }
        })

    }
    /**
     * 删除字典定义
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/define
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/define', {
            params: {  id            }
        })
    }
    /**
     * 保存字典定义
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDictDefine ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/define
        // httpMethod=post json 
        return await http.postJson<TaDictDefine, HallResult<boolean>>('/dict/v1.0.0/define', {
            data:  arg0
        })
    }
    /**
     * 查询字典定义
     * 
     * @param arg0 
     **/
    public static async search( arg0? : DictDefineSearchParam ) : Promise<HallResult<DictDefineIdNameVO[]>> {
        // baseUrl=/dict/v1.0.0/define/_search
        // httpMethod=get
        return await http.get<any, HallResult<DictDefineIdNameVO[]>>('/dict/v1.0.0/define/_search', {
            params: arg0
        })

    }
}
/**
 * 客户端软件版本Api
 **/
export class SoftVersionApi {
    /**
     * 客户端软件版本详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaSoftVersion>> {
        // baseUrl=/dict/v1.0.0/soft/version
        // httpMethod=get
        return await http.get<any, HallResult<TaSoftVersion>>('/dict/v1.0.0/soft/version', {
            params: {  id            }
        })

    }
    /**
     * 修改客户端软件版本
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaSoftVersion ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/soft/version
        // httpMethod=put json 
        return await http.putJson<TaSoftVersion, HallResult<boolean>>('/dict/v1.0.0/soft/version', {
            data:  arg0
        })
    }
    /**
     * 分页查询客户端软件版本
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : SoftVersionPageParam ) : Promise<HallResult<Page<TaSoftVersion>>> {
        // baseUrl=/dict/v1.0.0/soft/version/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaSoftVersion>>>('/dict/v1.0.0/soft/version/_paging', {
            params: arg0
        })

    }
    /**
     * 检查版本更新
     * 
     * @param softCode  必填 
     * @param softVersion  必填 
     **/
    public static async checkVersion( softCode : string , softVersion : string ) : Promise<HallResult<SoftVersionCheckResultVO>> {
        // baseUrl=/dict/v1.0.0/soft/version/checkVersion
        // httpMethod=get
        return await http.get<any, HallResult<SoftVersionCheckResultVO>>('/dict/v1.0.0/soft/version/checkVersion', {
            params: {  softCode, softVersion            }
        })

    }
    /**
     * 获取hall-agent的版本信息
     * 
     **/
    public static async getHallAgentVersion() : Promise<HallResult<SoftVersionCheckResultVO>> {
        // baseUrl=/dict/v1.0.0/soft/version/hallAgentVersion
        // httpMethod=get
        return await http.get<any, HallResult<SoftVersionCheckResultVO>>('/dict/v1.0.0/soft/version/hallAgentVersion', {
            params: {             }
        })

    }
    /**
     * 删除客户端软件版本
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/soft/version
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/soft/version', {
            params: {  id            }
        })
    }
    /**
     * 保存客户端软件版本
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaSoftVersion ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/soft/version
        // httpMethod=post json 
        return await http.postJson<TaSoftVersion, HallResult<boolean>>('/dict/v1.0.0/soft/version', {
            data:  arg0
        })
    }
}
/**
 * 字典项Api
 **/
export class DictItemApi {
    /**
     * 字典项详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDictItem>> {
        // baseUrl=/dict/v1.0.0/item
        // httpMethod=get
        return await http.get<any, HallResult<TaDictItem>>('/dict/v1.0.0/item', {
            params: {  id            }
        })

    }
    /**
     * 根据多个字典定义获取多个字典数据
     * 
     * @param defineCodes 字典定义编码，如果多个字典定义编码用英文的逗号(,)拼接 必填 
     **/
    public static async findByDefineCodes( defineCodes : string ) : Promise<HallResult<[string: [any: any]]>> {
        // baseUrl=/dict/v1.0.0/item/_mapByDefineCodes
        // httpMethod=get
        return await http.get<any, HallResult<[string: [any: any]]>>('/dict/v1.0.0/item/_mapByDefineCodes', {
            params: {  defineCodes            }
        })

    }
    /**
     * 查询字典项列表
     * 
     * @param defineCode  必填 
     **/
    public static async findByDefineCode( defineCode : string ) : Promise<HallResult<DictItemVo[]>> {
        // baseUrl=/dict/v1.0.0/item/_listByDefineCode
        // httpMethod=get
        return await http.get<any, HallResult<DictItemVo[]>>('/dict/v1.0.0/item/_listByDefineCode', {
            params: {  defineCode            }
        })

    }
    /**
     * 修改字典项
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDictItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/item
        // httpMethod=put json 
        return await http.putJson<TaDictItem, HallResult<boolean>>('/dict/v1.0.0/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询字典项
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DictItemPageParam ) : Promise<HallResult<Page<TaDictItem>>> {
        // baseUrl=/dict/v1.0.0/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDictItem>>>('/dict/v1.0.0/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除字典项
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/item', {
            params: {  id            }
        })
    }
    /**
     * 保存字典项
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDictItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/item
        // httpMethod=post json 
        return await http.postJson<TaDictItem, HallResult<boolean>>('/dict/v1.0.0/item', {
            data:  arg0
        })
    }
}
/**
 * 对码Api
 **/
export class DictMatchingApi {
    /**
     * 对码详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDictMatching>> {
        // baseUrl=/dict/v1.0.0/matching
        // httpMethod=get
        return await http.get<any, HallResult<TaDictMatching>>('/dict/v1.0.0/matching', {
            params: {  id            }
        })

    }
    /**
     * 保存或更新对码
     * 
     * @param arg0 
     **/
    public static async saveOrUpdate( arg0? : DictMatchingSaveOrUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/matching/_saveOrUpdate
        // httpMethod=post json 
        return await http.postJson<DictMatchingSaveOrUpdateParam, HallResult<boolean>>('/dict/v1.0.0/matching/_saveOrUpdate', {
            data:  arg0
        })
    }
    /**
     * 批量导入
     * 
     * @param arg0 
     **/
    public static async batchImport( arg0? : DictMatchingImportParam ) : Promise<HallResult<DictMatchingImportResultVO>> {
        // baseUrl=/dict/v1.0.0/matching/_batchImport
        // httpMethod=post json 
        return await http.postJson<DictMatchingImportParam, HallResult<DictMatchingImportResultVO>>('/dict/v1.0.0/matching/_batchImport', {
            data:  arg0
        })
    }
    /**
     * 修改对码
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDictMatching ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/matching
        // httpMethod=put json 
        return await http.putJson<TaDictMatching, HallResult<boolean>>('/dict/v1.0.0/matching', {
            data:  arg0
        })
    }
    /**
     * 分页查询对码
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DictMatchingPageParam ) : Promise<HallResult<Page<TaDictMatching>>> {
        // baseUrl=/dict/v1.0.0/matching/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDictMatching>>>('/dict/v1.0.0/matching/_paging', {
            params: arg0
        })

    }
    /**
     * 对码分页接口
     * 
     * @param arg0 
     **/
    public static async matchPaging( arg0? : DictItemMatchingParam ) : Promise<HallResult<Page<DictItemMatchingVO>>> {
        // baseUrl=/dict/v1.0.0/matching/_matchPaging
        // httpMethod=get
        return await http.get<any, HallResult<Page<DictItemMatchingVO>>>('/dict/v1.0.0/matching/_matchPaging', {
            params: arg0
        })

    }
    /**
     * 删除对码
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/matching
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/dict/v1.0.0/matching', {
            params: {  id            }
        })
    }
    /**
     * 保存对码
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDictMatching ) : Promise<HallResult<boolean>> {
        // baseUrl=/dict/v1.0.0/matching
        // httpMethod=post json 
        return await http.postJson<TaDictMatching, HallResult<boolean>>('/dict/v1.0.0/matching', {
            data:  arg0
        })
    }
}
/**
 * 科室排班Api
 **/
export class ScheduleDeptApi {
    /**
     * 科室排班详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<ScheduleDeptVO>> {
        // baseUrl=/hops/v1.0.0/dept
        // httpMethod=get
        return await http.get<any, HallResult<ScheduleDeptVO>>('/hops/v1.0.0/dept', {
            params: {  id            }
        })

    }
    /**
     * 修改科室排班
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : ScheduleDeptUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept
        // httpMethod=put json 
        return await http.putJson<ScheduleDeptUpdateParam, HallResult<boolean>>('/hops/v1.0.0/dept', {
            data:  arg0
        })
    }
    /**
     * 分页查询科室排班
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleDeptPageParam ) : Promise<HallResult<Page<ScheduleDeptVO>>> {
        // baseUrl=/hops/v1.0.0/dept/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<ScheduleDeptVO>>>('/hops/v1.0.0/dept/_paging', {
            params: arg0
        })

    }
    /**
     * 删除科室排班
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/dept', {
            params: {  id            }
        })
    }
    /**
     * 保存科室排班
     * 
     * @param arg0 
     **/
    public static async save( arg0? : ScheduleDeptCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept
        // httpMethod=post json 
        return await http.postJson<ScheduleDeptCreateParam, HallResult<boolean>>('/hops/v1.0.0/dept', {
            data:  arg0
        })
    }
    /**
     * 停诊
     * 
     * @param arg0 
     **/
    public static async close( arg0? : ScheduleDeptCloseParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/_close
        // httpMethod=post json 
        return await http.postJson<ScheduleDeptCloseParam, HallResult<boolean>>('/hops/v1.0.0/dept/_close', {
            data:  arg0
        })
    }
    /**
     * 启用
     * 
     * @param id  必填 
     **/
    public static async open( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/_open
        // httpMethod=post
        return await http.post<any, HallResult<boolean>>('/hops/v1.0.0/dept/_open', {
            params: {  id            }
    })
    }
    /**
     * 复制模板
     * 
     * @param arg0 
     **/
    public static async sync( arg0? : ScheduleSyncParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/_sync
        // httpMethod=post json 
        return await http.postJson<ScheduleSyncParam, HallResult<boolean>>('/hops/v1.0.0/dept/_sync', {
            data:  arg0
        })
    }
}
/**
 * 医生排班资源号Api
 **/
export class ScheduleDoctorResourceApi {
    /**
     * 医生排班资源号详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaScheduleDoctorResource>> {
        // baseUrl=/hops/v1.0.0/doctor/resource
        // httpMethod=get
        return await http.get<any, HallResult<TaScheduleDoctorResource>>('/hops/v1.0.0/doctor/resource', {
            params: {  id            }
        })

    }
    /**
     * 修改医生排班资源号
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaScheduleDoctorResource ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/resource
        // httpMethod=put json 
        return await http.putJson<TaScheduleDoctorResource, HallResult<boolean>>('/hops/v1.0.0/doctor/resource', {
            data:  arg0
        })
    }
    /**
     * 分页查询医生排班资源号
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleDoctorResourcePageParam ) : Promise<HallResult<Page<TaScheduleDoctorResource>>> {
        // baseUrl=/hops/v1.0.0/doctor/resource/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaScheduleDoctorResource>>>('/hops/v1.0.0/doctor/resource/_paging', {
            params: arg0
        })

    }
    /**
     * 删除医生排班资源号
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/resource
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/doctor/resource', {
            params: {  id            }
        })
    }
    /**
     * 保存医生排班资源号
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaScheduleDoctorResource ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/resource
        // httpMethod=post json 
        return await http.postJson<TaScheduleDoctorResource, HallResult<boolean>>('/hops/v1.0.0/doctor/resource', {
            data:  arg0
        })
    }
}
/**
 * 医生排班Api
 **/
export class ScheduleDoctorApi {
    /**
     * 医生排班详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<ScheduleDoctorVO>> {
        // baseUrl=/hops/v1.0.0/doctor
        // httpMethod=get
        return await http.get<any, HallResult<ScheduleDoctorVO>>('/hops/v1.0.0/doctor', {
            params: {  id            }
        })

    }
    /**
     * 修改医生排班
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : ScheduleDoctorUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor
        // httpMethod=put json 
        return await http.putJson<ScheduleDoctorUpdateParam, HallResult<boolean>>('/hops/v1.0.0/doctor', {
            data:  arg0
        })
    }
    /**
     * 分页查询医生排班
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleDoctorPageParam ) : Promise<HallResult<Page<ScheduleDoctorVO>>> {
        // baseUrl=/hops/v1.0.0/doctor/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<ScheduleDoctorVO>>>('/hops/v1.0.0/doctor/_paging', {
            params: arg0
        })

    }
    /**
     * 删除医生排班
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/doctor', {
            params: {  id            }
        })
    }
    /**
     * 保存医生排班
     * 
     * @param arg0 
     **/
    public static async save( arg0? : ScheduleDoctorCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor
        // httpMethod=post json 
        return await http.postJson<ScheduleDoctorCreateParam, HallResult<boolean>>('/hops/v1.0.0/doctor', {
            data:  arg0
        })
    }
    /**
     * 停诊
     * 
     * @param arg0 
     **/
    public static async close( arg0? : ScheduleDoctorCloseParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/_close
        // httpMethod=post json 
        return await http.postJson<ScheduleDoctorCloseParam, HallResult<boolean>>('/hops/v1.0.0/doctor/_close', {
            data:  arg0
        })
    }
    /**
     * 启用
     * 
     * @param id  必填 
     **/
    public static async open( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/_open
        // httpMethod=post
        return await http.post<any, HallResult<boolean>>('/hops/v1.0.0/doctor/_open', {
            params: {  id            }
    })
    }
    /**
     * 复制模板
     * 
     * @param arg0 
     **/
    public static async sync( arg0? : ScheduleSyncParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/_sync
        // httpMethod=post json 
        return await http.postJson<ScheduleSyncParam, HallResult<boolean>>('/hops/v1.0.0/doctor/_sync', {
            data:  arg0
        })
    }
}
/**
 * 排班模板Api
 **/
export class ScheduleTemplateApi {
    /**
     * 医生排班模板详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<ScheduleTemplateVO>> {
        // baseUrl=/hops/v1.0.0/schedule/template
        // httpMethod=get
        return await http.get<any, HallResult<ScheduleTemplateVO>>('/hops/v1.0.0/schedule/template', {
            params: {  id            }
        })

    }
    /**
     * 修改排班模板
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : ScheduleTemplateEditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/template
        // httpMethod=put json 
        return await http.putJson<ScheduleTemplateEditParam, HallResult<boolean>>('/hops/v1.0.0/schedule/template', {
            data:  arg0
        })
    }
    /**
     * 分页查询排班模板
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleTemplateConditionParam ) : Promise<HallResult<Page<ScheduleTemplateVO>>> {
        // baseUrl=/hops/v1.0.0/schedule/template/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<ScheduleTemplateVO>>>('/hops/v1.0.0/schedule/template/_paging', {
            params: arg0
        })

    }
    /**
     * 删除排班模板
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/template
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/schedule/template', {
            params: {  id            }
        })
    }
    /**
     * 保存排班模板
     * 
     * @param arg0 
     **/
    public static async save( arg0? : ScheduleTemplateSaveParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/template
        // httpMethod=post json 
        return await http.postJson<ScheduleTemplateSaveParam, HallResult<boolean>>('/hops/v1.0.0/schedule/template', {
            data:  arg0
        })
    }
    /**
     * 排班模板同步
     * 
     * @param arg0 
     **/
    public static async sync( arg0? : ScheduleTemplateSyncParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/template/_sync
        // httpMethod=post json 
        return await http.postJson<ScheduleTemplateSyncParam, HallResult<boolean>>('/hops/v1.0.0/schedule/template/_sync', {
            data:  arg0
        })
    }
}
/**
 * 科室排班资源号Api
 **/
export class ScheduleDeptResourceApi {
    /**
     * 科室排班资源号详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaScheduleDeptResource>> {
        // baseUrl=/hops/v1.0.0/dept/resource
        // httpMethod=get
        return await http.get<any, HallResult<TaScheduleDeptResource>>('/hops/v1.0.0/dept/resource', {
            params: {  id            }
        })

    }
    /**
     * 修改科室排班资源号
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaScheduleDeptResource ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/resource
        // httpMethod=put json 
        return await http.putJson<TaScheduleDeptResource, HallResult<boolean>>('/hops/v1.0.0/dept/resource', {
            data:  arg0
        })
    }
    /**
     * 分页查询科室排班资源号
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleDeptResourcePageParam ) : Promise<HallResult<Page<TaScheduleDeptResource>>> {
        // baseUrl=/hops/v1.0.0/dept/resource/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaScheduleDeptResource>>>('/hops/v1.0.0/dept/resource/_paging', {
            params: arg0
        })

    }
    /**
     * 删除科室排班资源号
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/resource
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/dept/resource', {
            params: {  id            }
        })
    }
    /**
     * 保存科室排班资源号
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaScheduleDeptResource ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/resource
        // httpMethod=post json 
        return await http.postJson<TaScheduleDeptResource, HallResult<boolean>>('/hops/v1.0.0/dept/resource', {
            data:  arg0
        })
    }
}
/**
 * 医生排班模板Api
 **/
export class ScheduleDoctorTemplateApi {
    /**
     * 医生排班模板详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<ScheduleDoctorTemplateVO>> {
        // baseUrl=/hops/v1.0.0/doctor/template
        // httpMethod=get
        return await http.get<any, HallResult<ScheduleDoctorTemplateVO>>('/hops/v1.0.0/doctor/template', {
            params: {  id            }
        })

    }
    /**
     * 修改医生排班模板
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaScheduleDoctorTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/template
        // httpMethod=put json 
        return await http.putJson<TaScheduleDoctorTemplate, HallResult<boolean>>('/hops/v1.0.0/doctor/template', {
            data:  arg0
        })
    }
    /**
     * 分页查询医生排班模板
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleDoctorTemplatePageParam ) : Promise<HallResult<Page<ScheduleDoctorTemplateVO>>> {
        // baseUrl=/hops/v1.0.0/doctor/template/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<ScheduleDoctorTemplateVO>>>('/hops/v1.0.0/doctor/template/_paging', {
            params: arg0
        })

    }
    /**
     * 删除医生排班模板
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/template
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/doctor/template', {
            params: {  id            }
        })
    }
    /**
     * 保存医生排班模板
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaScheduleDoctorTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/template
        // httpMethod=post json 
        return await http.postJson<TaScheduleDoctorTemplate, HallResult<boolean>>('/hops/v1.0.0/doctor/template', {
            data:  arg0
        })
    }
    /**
     * 科室排班模板同步
     * 
     * @param arg0 
     **/
    public static async sync( arg0? : ScheduleDoctorTemplateSyncParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/doctor/template/_sync
        // httpMethod=post json 
        return await http.postJson<ScheduleDoctorTemplateSyncParam, HallResult<boolean>>('/hops/v1.0.0/doctor/template/_sync', {
            data:  arg0
        })
    }
}
/**
 * 排班Api
 **/
export class ScheduleApi {
    /**
     * 排班详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<ScheduleVO>> {
        // baseUrl=/hops/v1.0.0/schedule
        // httpMethod=get
        return await http.get<any, HallResult<ScheduleVO>>('/hops/v1.0.0/schedule', {
            params: {  id            }
        })

    }
    /**
     * 排班预览
     * 
     * @param arg0 
     **/
    public static async preView( arg0? : SchedulePreViewParam ) : Promise<HallResult<SchedulePreViewVO[]>> {
        // baseUrl=/hops/v1.0.0/schedule/_preView
        // httpMethod=get
        return await http.get<any, HallResult<SchedulePreViewVO[]>>('/hops/v1.0.0/schedule/_preView', {
            params: arg0
        })

    }
    /**
     * 修改排班
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : ScheduleUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule
        // httpMethod=put json 
        return await http.putJson<ScheduleUpdateParam, HallResult<boolean>>('/hops/v1.0.0/schedule', {
            data:  arg0
        })
    }
    /**
     * 分页查询排班
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : SchedulePagingParam ) : Promise<HallResult<Page<ScheduleVO>>> {
        // baseUrl=/hops/v1.0.0/schedule/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<ScheduleVO>>>('/hops/v1.0.0/schedule/_paging', {
            params: arg0
        })

    }
    /**
     * 删除排班
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/schedule', {
            params: {  id            }
        })
    }
    /**
     * 保存排班
     * 
     * @param arg0 
     **/
    public static async save( arg0? : ScheduleSaveParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule
        // httpMethod=post json 
        return await http.postJson<ScheduleSaveParam, HallResult<boolean>>('/hops/v1.0.0/schedule', {
            data:  arg0
        })
    }
    /**
     * 停诊
     * 
     * @param arg0 
     **/
    public static async close( arg0? : ScheduleCloseParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/_close
        // httpMethod=post json 
        return await http.postJson<ScheduleCloseParam, HallResult<boolean>>('/hops/v1.0.0/schedule/_close', {
            data:  arg0
        })
    }
    /**
     * 启用
     * 
     * @param id  必填 
     **/
    public static async open( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/_open
        // httpMethod=post
        return await http.post<any, HallResult<boolean>>('/hops/v1.0.0/schedule/_open', {
            params: {  id            }
    })
    }
    /**
     * 复制模板
     * 
     * @param arg0 
     **/
    public static async sync( arg0? : ScheduleSyncParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/_sync
        // httpMethod=post json 
        return await http.postJson<ScheduleSyncParam, HallResult<boolean>>('/hops/v1.0.0/schedule/_sync', {
            data:  arg0
        })
    }
}
/**
 * 科室排班模板Api
 **/
export class ScheduleDeptTemplateApi {
    /**
     * 科室排班模板详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<ScheduleDeptTemplateVO>> {
        // baseUrl=/hops/v1.0.0/dept/template
        // httpMethod=get
        return await http.get<any, HallResult<ScheduleDeptTemplateVO>>('/hops/v1.0.0/dept/template', {
            params: {  id            }
        })

    }
    /**
     * 修改科室排班模板
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaScheduleDeptTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/template
        // httpMethod=put json 
        return await http.putJson<TaScheduleDeptTemplate, HallResult<boolean>>('/hops/v1.0.0/dept/template', {
            data:  arg0
        })
    }
    /**
     * 分页查询科室排班模板
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleDeptTemplatePageParam ) : Promise<HallResult<Page<ScheduleDeptTemplateVO>>> {
        // baseUrl=/hops/v1.0.0/dept/template/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<ScheduleDeptTemplateVO>>>('/hops/v1.0.0/dept/template/_paging', {
            params: arg0
        })

    }
    /**
     * 删除科室排班模板
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/template
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/dept/template', {
            params: {  id            }
        })
    }
    /**
     * 保存科室排班模板
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaScheduleDeptTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/template
        // httpMethod=post json 
        return await http.postJson<TaScheduleDeptTemplate, HallResult<boolean>>('/hops/v1.0.0/dept/template', {
            data:  arg0
        })
    }
    /**
     * 科室排班模板同步
     * 
     * @param arg0 
     **/
    public static async sync( arg0? : ScheduleDeptTemplateSyncParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dept/template/_sync
        // httpMethod=post json 
        return await http.postJson<ScheduleDeptTemplateSyncParam, HallResult<boolean>>('/hops/v1.0.0/dept/template/_sync', {
            data:  arg0
        })
    }
}
/**
 * 排班整合Api
 **/
export class ScheduleAssembleApi {
    /**
     * 排班整合分页查询
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : ScheduleAssemblePageParam ) : Promise<HallResult<Page<ScheduleAssemblePageVo>>> {
        // baseUrl=/hops/v1.0.0/schedule/assemble/paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<ScheduleAssemblePageVo>>>('/hops/v1.0.0/schedule/assemble/paging', {
            params: arg0
        })

    }
    /**
     * 排班筛选条件列表
     * 
     * @param arg0 
     **/
    public static async queryCondition( arg0? : ScheduleAssembleQueryConditionParam ) : Promise<HallResult<ScheduleAssembleQueryConditionDTO>> {
        // baseUrl=/hops/v1.0.0/schedule/assemble/_queryCondition
        // httpMethod=get
        return await http.get<any, HallResult<ScheduleAssembleQueryConditionDTO>>('/hops/v1.0.0/schedule/assemble/_queryCondition', {
            params: arg0
        })

    }
    /**
     * 排班整合时间段名称列表
     * 
     * @param arg0 
     **/
    public static async timeNameList( arg0? : ScheduleAssembleTimeListParam ) : Promise<HallResult<string[]>> {
        // baseUrl=/hops/v1.0.0/schedule/assemble/_timeNameList
        // httpMethod=get
        return await http.get<any, HallResult<string[]>>('/hops/v1.0.0/schedule/assemble/_timeNameList', {
            params: arg0
        })

    }
    /**
     * 锁号
     * 
     * @param arg0 
     **/
    public static async lockResource( arg0? : ResourceLockParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/schedule/assemble/_lockResource
        // httpMethod=put json 
        return await http.putJson<ResourceLockParam, HallResult<boolean>>('/hops/v1.0.0/schedule/assemble/_lockResource', {
            data:  arg0
        })
    }
}
/**
 * Api
 **/
export class OutpatientsAssembleApi {
    /**
     * 提交门诊就诊整合
     * 
     * @param arg0 
     **/
    public static async saveOrUpdate( arg0? : OutpatientsAssembleSaveParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_saveOrUpdate
        // httpMethod=post json 
        return await http.postJson<OutpatientsAssembleSaveParam, HallResult<boolean>>('/hops/v1.0.0/outpatients/assemble/_saveOrUpdate', {
            data:  arg0
        })
    }
    /**
     * 继续接诊
     * 
     * @param arg0 
     **/
    public static async continueReception( arg0? : HopsRegisterReceptionParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_continueReception
        // httpMethod=put json 
        return await http.putJson<HopsRegisterReceptionParam, HallResult<boolean>>('/hops/v1.0.0/outpatients/assemble/_continueReception', {
            data:  arg0
        })
    }
    /**
     * 详情
     * 
     * @param registerId  必填 
     **/
    public static async detailByRegisterId( registerId : string ) : Promise<HallResult<OutpatientsAssembleDetailVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_detailByRegisterId
        // httpMethod=get
        return await http.get<any, HallResult<OutpatientsAssembleDetailVO>>('/hops/v1.0.0/outpatients/assemble/_detailByRegisterId', {
            params: {  registerId            }
        })

    }
    /**
     * 完成接诊
     * 
     * @param arg0 
     **/
    public static async completeReception( arg0? : HopsRegisterReceptionParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_completeReception
        // httpMethod=put json 
        return await http.putJson<HopsRegisterReceptionParam, HallResult<boolean>>('/hops/v1.0.0/outpatients/assemble/_completeReception', {
            data:  arg0
        })
    }
    /**
     * 接诊
     * 
     * @param arg0 
     **/
    public static async reception( arg0? : HopsRegisterReceptionParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_reception
        // httpMethod=put json 
        return await http.putJson<HopsRegisterReceptionParam, HallResult<boolean>>('/hops/v1.0.0/outpatients/assemble/_reception', {
            data:  arg0
        })
    }
    /**
     * 取消就诊
     * 
     * @param arg0 
     **/
    public static async cancelReception( arg0? : HopsRegisterReceptionParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_cancelReception
        // httpMethod=put json 
        return await http.putJson<HopsRegisterReceptionParam, HallResult<boolean>>('/hops/v1.0.0/outpatients/assemble/_cancelReception', {
            data:  arg0
        })
    }
    /**
     * 已完成状态的详情
     * 
     * @param registerId  必填 
     **/
    public static async completedDetailByRegisterId( registerId : string ) : Promise<HallResult<OutpatientsAssembleDetailVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_completedDetailByRegisterId
        // httpMethod=get
        return await http.get<any, HallResult<OutpatientsAssembleDetailVO>>('/hops/v1.0.0/outpatients/assemble/_completedDetailByRegisterId', {
            params: {  registerId            }
        })

    }
    /**
     * 获取打印清单
     * 
     * @param registerId  必填 
     **/
    public static async getPrintList( registerId : string ) : Promise<HallResult<OutpatientsPrintTreeVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_getPrintList
        // httpMethod=get
        return await http.get<any, HallResult<OutpatientsPrintTreeVO>>('/hops/v1.0.0/outpatients/assemble/_getPrintList', {
            params: {  registerId            }
        })

    }
    /**
     * 获取打印清单详情
     * 
     * @param type  必填 
     * @param listId  必填 
     **/
    public static async getPrintDetail( type : string , listId : string ) : Promise<HallResult<any>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_getPrintDetail
        // httpMethod=get
        return await http.get<any, HallResult<any>>('/hops/v1.0.0/outpatients/assemble/_getPrintDetail', {
            params: {  type, listId            }
        })

    }
    /**
     * 查询历史患者诊疗记录
     * 
     * @param arg0 
     **/
    public static async pageHistoryPatientCures( arg0? : HistoryPatientCureInfoPageParam ) : Promise<HallResult<Page<HistoryPatientCureInfoVO>>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_pageHistoryPatientCures
        // httpMethod=get
        return await http.get<any, HallResult<Page<HistoryPatientCureInfoVO>>>('/hops/v1.0.0/outpatients/assemble/_pageHistoryPatientCures', {
            params: arg0
        })

    }
    /**
     * 作废过敏史
     * 
     * @param arg0 
     **/
    public static async invalidAllergyHistory( arg0? : AllergyHistoryInvalidParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_invalidAllergyHistory
        // httpMethod=put json 
        return await http.putJson<AllergyHistoryInvalidParam, HallResult<boolean>>('/hops/v1.0.0/outpatients/assemble/_invalidAllergyHistory', {
            data:  arg0
        })
    }
    /**
     * 清单打印
     * 
     * @param arg0 
     **/
    public static async print( arg0? : OutpatientsListPrintParam ) : Promise<HallResult<OutpatientsPrintResultVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/assemble/_print
        // httpMethod=post json 
        return await http.postJson<OutpatientsListPrintParam, HallResult<OutpatientsPrintResultVO>>('/hops/v1.0.0/outpatients/assemble/_print', {
            data:  arg0
        })
    }
}
/**
 * Api
 **/
export class OutpatientsChargeApi {
    /**
     * 取消支付
     * 
     * @param billId  必填 
     **/
    public static async cancel( billId : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_cancel
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/outpatients/charge/_cancel', {
            params: {  billId            }
        })
    }
    /**
     * 收费患者列表
     * 
     * @param arg0 
     **/
    public static async getPatientPage( arg0? : HopsOrderPatientPageParam ) : Promise<HallResult<Page<HopsOrderPatientChargeVO>>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_getPatientPage
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsOrderPatientChargeVO>>>('/hops/v1.0.0/outpatients/charge/_getPatientPage', {
            params: arg0
        })

    }
    /**
     * 已收费医嘱详情
     * 
     * @param registerId  必填 
     **/
    public static async chargedDetail( registerId : string ) : Promise<HallResult<OutpatientsChargeBillVO[]>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_chargedDetail
        // httpMethod=get
        return await http.get<any, HallResult<OutpatientsChargeBillVO[]>>('/hops/v1.0.0/outpatients/charge/_chargedDetail', {
            params: {  registerId            }
        })

    }
    /**
     * 收费
     * 
     * @param arg0 
     **/
    public static async charge( arg0? : OutpatientsChargeCreateParam ) : Promise<HallResult<HopsOrderFeeBillVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_charge
        // httpMethod=post json 
        return await http.postJson<OutpatientsChargeCreateParam, HallResult<HopsOrderFeeBillVO>>('/hops/v1.0.0/outpatients/charge/_charge', {
            data:  arg0
        })
    }
    /**
     * 创建支付
     * 
     * @param arg0 
     **/
    public static async createPay( arg0? : OutpatientsCreatePayParam ) : Promise<HallResult<OutpatientsFeePayVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_createPay
        // httpMethod=post json 
        return await http.postJson<OutpatientsCreatePayParam, HallResult<OutpatientsFeePayVO>>('/hops/v1.0.0/outpatients/charge/_createPay', {
            data:  arg0
        })
    }
    /**
     * 自费支付
     * 
     * @param arg0 
     **/
    public static async ownPay( arg0? : OutpatientsPayParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_ownPay
        // httpMethod=post json 
        return await http.postJson<OutpatientsPayParam, HallResult<boolean>>('/hops/v1.0.0/outpatients/charge/_ownPay', {
            data:  arg0
        })
    }
    /**
     * 支付
     * 
     * @param payId  必填 
     **/
    public static async getPayInfo( payId : string ) : Promise<HallResult<OutpatientsFeePayVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_getPayInfo
        // httpMethod=get
        return await http.get<any, HallResult<OutpatientsFeePayVO>>('/hops/v1.0.0/outpatients/charge/_getPayInfo', {
            params: {  payId            }
        })

    }
    /**
     * 获取账单信息
     * 
     * @param billId  必填 
     **/
    public static async getBillInfo( billId : string ) : Promise<HallResult<HopsOrderFeeBillVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_getBillInfo
        // httpMethod=get
        return await http.get<any, HallResult<HopsOrderFeeBillVO>>('/hops/v1.0.0/outpatients/charge/_getBillInfo', {
            params: {  billId            }
        })

    }
    /**
     * 未收费医嘱详情
     * 
     * @param registerId  必填 
     **/
    public static async notChargedDetail( registerId : string ) : Promise<HallResult<OutpatientsChargeBillVO[]>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_notChargedDetail
        // httpMethod=get
        return await http.get<any, HallResult<OutpatientsChargeBillVO[]>>('/hops/v1.0.0/outpatients/charge/_notChargedDetail', {
            params: {  registerId            }
        })

    }
    /**
     * 已退费医嘱详情
     * 
     * @param registerId  必填 
     **/
    public static async refundDetail( registerId : string ) : Promise<HallResult<OutpatientsChargeBillVO[]>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_refundDetail
        // httpMethod=get
        return await http.get<any, HallResult<OutpatientsChargeBillVO[]>>('/hops/v1.0.0/outpatients/charge/_refundDetail', {
            params: {  registerId            }
        })

    }
    /**
     * 医嘱退费
     * 
     * @param arg0 
     **/
    public static async refund( arg0? : OutpatientsRefundCreateParam ) : Promise<HallResult<OutpatientsChargeBillVO>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_refund
        // httpMethod=post json 
        return await http.postJson<OutpatientsRefundCreateParam, HallResult<OutpatientsChargeBillVO>>('/hops/v1.0.0/outpatients/charge/_refund', {
            data:  arg0
        })
    }
    /**
     * 统计
     * 
     * @param arg0 
     **/
    public static async countByStatus( arg0? : HopsOrderPatientPageParam ) : Promise<HallResult<HopsOrderPatientCountVO[]>> {
        // baseUrl=/hops/v1.0.0/outpatients/charge/_count
        // httpMethod=get
        return await http.get<any, HallResult<HopsOrderPatientCountVO[]>>('/hops/v1.0.0/outpatients/charge/_count', {
            params: arg0
        })

    }
}
/**
 * 门诊挂号Api
 **/
export class HopsRegisterApi {
    /**
     * 退号退款
     * 
     * @param arg0 
     **/
    public static async refundRegister( arg0? : RegisterRefundParam ) : Promise<HallResult<RegisterRefundVO>> {
        // baseUrl=/hops/v1.0.0/register/_refund
        // httpMethod=put json 
        return await http.putJson<RegisterRefundParam, HallResult<RegisterRefundVO>>('/hops/v1.0.0/register/_refund', {
            data:  arg0
        })
    }
    /**
     * 获取挂号单数据
     * 
     * @param registerId  必填 
     **/
    public static async loadRegistNotifyDoc( registerId : string ) : Promise<HallResult<RegistNotifyDocVO>> {
        // baseUrl=/hops/v1.0.0/register/_loadRegistNotifyDoc
        // httpMethod=get
        return await http.get<any, HallResult<RegistNotifyDocVO>>('/hops/v1.0.0/register/_loadRegistNotifyDoc', {
            params: {  registerId            }
        })

    }
    /**
     * 门诊挂号详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<HopsRegisterDetailVO>> {
        // baseUrl=/hops/v1.0.0/register
        // httpMethod=get
        return await http.get<any, HallResult<HopsRegisterDetailVO>>('/hops/v1.0.0/register', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊挂号
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsRegister ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/register
        // httpMethod=put json 
        return await http.putJson<TaHopsRegister, HallResult<boolean>>('/hops/v1.0.0/register', {
            data:  arg0
        })
    }
    /**
     * 获取退号详情
     * 
     * @param registerId  必填 
     **/
    public static async refundDetail( registerId : string ) : Promise<HallResult<RegisterRefundVO>> {
        // baseUrl=/hops/v1.0.0/register/_refundDetail
        // httpMethod=get
        return await http.get<any, HallResult<RegisterRefundVO>>('/hops/v1.0.0/register/_refundDetail', {
            params: {  registerId            }
        })

    }
    /**
     * 取消挂号
     * 
     * @param registerId  必填 
     **/
    public static async cancelRegister( registerId : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/register/_cancel
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/hops/v1.0.0/register/_cancel', {
            params: {  registerId            }
        })
    }
    /**
     * 根据状态统计总数
     * 
     * @param arg0 
     **/
    public static async countByStatus( arg0? : HopsRegisterInfoPageParam ) : Promise<HallResult<HopsRegisterCountByStatusVO[]>> {
        // baseUrl=/hops/v1.0.0/register/_countByStatus
        // httpMethod=get
        return await http.get<any, HallResult<HopsRegisterCountByStatusVO[]>>('/hops/v1.0.0/register/_countByStatus', {
            params: arg0
        })

    }
    /**
     * 分页查询门诊挂号
     * 
     * @param arg0 
     **/
    public static async pagingInfo( arg0? : HopsRegisterInfoPageParam ) : Promise<HallResult<Page<HopsRegisterInfoVO>>> {
        // baseUrl=/hops/v1.0.0/register/_pagingInfo
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsRegisterInfoVO>>>('/hops/v1.0.0/register/_pagingInfo', {
            params: arg0
        })

    }
    /**
     * 已挂号总数
     * 
     * @param arg0 
     **/
    public static async registeredCount( arg0? : HopsRegisterInfoPageParam ) : Promise<HallResult<number>> {
        // baseUrl=/hops/v1.0.0/register/_registeredCount
        // httpMethod=get
        return await http.get<any, HallResult<number>>('/hops/v1.0.0/register/_registeredCount', {
            params: arg0
        })

    }
    /**
     * 分页列表（关联病例）
     * 
     * @param arg0 
     **/
    public static async pagingRelationMrecord( arg0? : HopsRegisterInfoPageParam ) : Promise<HallResult<Page<HopsRegisterInfoVO>>> {
        // baseUrl=/hops/v1.0.0/register/_pagingRelationMrecord
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsRegisterInfoVO>>>('/hops/v1.0.0/register/_pagingRelationMrecord', {
            params: arg0
        })

    }
    /**
     * 分页查询挂号信息
     * 
     * @param arg0 
     **/
    public static async pagingSearch( arg0? : HopsRegisterSearchParam ) : Promise<HallResult<Page<HopsRegisterSearchResultVO>>> {
        // baseUrl=/hops/v1.0.0/register/_pagingSearch
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsRegisterSearchResultVO>>>('/hops/v1.0.0/register/_pagingSearch', {
            params: arg0
        })

    }
    /**
     * 取消退号，退费中状态时取消退号操作
     * 
     * @param registerId  必填 
     **/
    public static async cancelRefund( registerId : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/register/_cancelRefund
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/hops/v1.0.0/register/_cancelRefund', {
            params: {  registerId            }
        })
    }
    /**
     * 删除门诊挂号
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/register
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/register', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊挂号
     * 
     * @param arg0 
     **/
    public static async save( arg0? : HopsRegisterSaveParam ) : Promise<HallResult<HopsFeeBillVO>> {
        // baseUrl=/hops/v1.0.0/register
        // httpMethod=post json 
        return await http.postJson<HopsRegisterSaveParam, HallResult<HopsFeeBillVO>>('/hops/v1.0.0/register', {
            data:  arg0
        })
    }
}
/**
 * 复合项目Api
 **/
export class BaseCompositeApi {
    /**
     * 复合项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseCompositeVO>> {
        // baseUrl=/hops/v1.0.0/composite
        // httpMethod=get
        return await http.get<any, HallResult<BaseCompositeVO>>('/hops/v1.0.0/composite', {
            params: {  id            }
        })

    }
    /**
     * 修改复合项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseComposite ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/composite
        // httpMethod=put json 
        return await http.putJson<TaBaseComposite, HallResult<boolean>>('/hops/v1.0.0/composite', {
            data:  arg0
        })
    }
    /**
     * 分页查询复合项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseCompositePageParam ) : Promise<HallResult<Page<BaseCompositeVO>>> {
        // baseUrl=/hops/v1.0.0/composite/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseCompositeVO>>>('/hops/v1.0.0/composite/_paging', {
            params: arg0
        })

    }
    /**
     * 删除复合项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/composite
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/composite', {
            params: {  id            }
        })
    }
    /**
     * 保存复合项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseComposite ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/composite
        // httpMethod=post json 
        return await http.postJson<TaBaseComposite, HallResult<boolean>>('/hops/v1.0.0/composite', {
            data:  arg0
        })
    }
}
/**
 * 非药品Api
 **/
export class BaseNondrugApi {
    /**
     * 分页查询未设置费用非药品
     * 
     * @param arg0 
     **/
    public static async pagingNotSetFee( arg0? : BaseNondrugPageParam ) : Promise<HallResult<Page<BaseNondrugPageVo>>> {
        // baseUrl=/hops/v1.0.0/base/nondrug/_pagingNotSetFee
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseNondrugPageVo>>>('/hops/v1.0.0/base/nondrug/_pagingNotSetFee', {
            params: arg0
        })

    }
    /**
     * 非药品详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseNondrugVo>> {
        // baseUrl=/hops/v1.0.0/base/nondrug
        // httpMethod=get
        return await http.get<any, HallResult<BaseNondrugVo>>('/hops/v1.0.0/base/nondrug', {
            params: {  id            }
        })

    }
    /**
     * 非药品批量导入
     * 
     * @param arg0 
     **/
    public static async batchImport( arg0? : BaseNonDrugImportParam ) : Promise<HallResult<BaseExcelImportResultVO>> {
        // baseUrl=/hops/v1.0.0/base/nondrug/_batchImport
        // httpMethod=post json 
        return await http.postJson<BaseNonDrugImportParam, HallResult<BaseExcelImportResultVO>>('/hops/v1.0.0/base/nondrug/_batchImport', {
            data:  arg0
        })
    }
    /**
     * 批量删除非药品
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/nondrug/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/nondrug/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改非药品
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseNondrug ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/nondrug
        // httpMethod=put json 
        return await http.putJson<TaBaseNondrug, HallResult<boolean>>('/hops/v1.0.0/base/nondrug', {
            data:  arg0
        })
    }
    /**
     * 分页查询非药品
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseNondrugPageParam ) : Promise<HallResult<Page<BaseNondrugPageVo>>> {
        // baseUrl=/hops/v1.0.0/base/nondrug/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseNondrugPageVo>>>('/hops/v1.0.0/base/nondrug/_paging', {
            params: arg0
        })

    }
    /**
     * 保存非药品
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseNondrug ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/nondrug
        // httpMethod=post json 
        return await http.postJson<TaBaseNondrug, HallResult<boolean>>('/hops/v1.0.0/base/nondrug', {
            data:  arg0
        })
    }
}
/**
 * 辅材带出规则Api
 **/
export class BaseMaterialRuleApi {
    /**
     * 辅材带出规则详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseMaterialRule>> {
        // baseUrl=/hops/v1.0.0/material/rule
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseMaterialRule>>('/hops/v1.0.0/material/rule', {
            params: {  id            }
        })

    }
    /**
     * 修改辅材带出规则
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseMaterialRule ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/material/rule
        // httpMethod=put json 
        return await http.putJson<TaBaseMaterialRule, HallResult<boolean>>('/hops/v1.0.0/material/rule', {
            data:  arg0
        })
    }
    /**
     * 分页查询辅材带出规则
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseMaterialRulePageParam ) : Promise<HallResult<Page<TaBaseMaterialRule>>> {
        // baseUrl=/hops/v1.0.0/material/rule/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseMaterialRule>>>('/hops/v1.0.0/material/rule/_paging', {
            params: arg0
        })

    }
    /**
     * 删除辅材带出规则
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/material/rule
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/material/rule', {
            params: {  id            }
        })
    }
    /**
     * 保存辅材带出规则
     * 
     * @param arg0 
     **/
    public static async save( arg0? : BaseMaterialRuleCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/material/rule
        // httpMethod=post json 
        return await http.postJson<BaseMaterialRuleCreateParam, HallResult<boolean>>('/hops/v1.0.0/material/rule', {
            data:  arg0
        })
    }
}
/**
 * 辅材带出规则项目明细Api
 **/
export class BaseMaterialRuleItemApi {
    /**
     * 辅材带出规则项目明细详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseMaterialRuleItemVO>> {
        // baseUrl=/hops/v1.0.0/material/rule/item
        // httpMethod=get
        return await http.get<any, HallResult<BaseMaterialRuleItemVO>>('/hops/v1.0.0/material/rule/item', {
            params: {  id            }
        })

    }
    /**
     * 删除辅材带出规则项目明细
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : any ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/material/rule/item/_batchDelete
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/material/rule/item/_batchDelete', {
            params: {  ids            }
        })
    }
    /**
     * 修改辅材带出规则项目明细
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseMaterialRuleItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/material/rule/item
        // httpMethod=put json 
        return await http.putJson<TaBaseMaterialRuleItem, HallResult<boolean>>('/hops/v1.0.0/material/rule/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询辅材带出规则项目明细
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseMaterialRuleItemPageParam ) : Promise<HallResult<Page<BaseMaterialRuleItemVO>>> {
        // baseUrl=/hops/v1.0.0/material/rule/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseMaterialRuleItemVO>>>('/hops/v1.0.0/material/rule/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除辅材带出规则项目明细
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/material/rule/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/material/rule/item', {
            params: {  id            }
        })
    }
    /**
     * 保存辅材带出规则项目明细
     * 
     * @param arg0 
     **/
    public static async save( arg0? : BaseMaterialRuleItemCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/material/rule/item
        // httpMethod=post json 
        return await http.postJson<BaseMaterialRuleItemCreateParam, HallResult<boolean>>('/hops/v1.0.0/material/rule/item', {
            data:  arg0
        })
    }
}
/**
 * 厂家Api
 **/
export class BaseCompanyApi {
    /**
     * 厂家详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseCompany>> {
        // baseUrl=/hops/v1.0.0/base/company
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseCompany>>('/hops/v1.0.0/base/company', {
            params: {  id            }
        })

    }
    /**
     * 批量删除厂家
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/company/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/company/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改厂家
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseCompany ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/company
        // httpMethod=put json 
        return await http.putJson<TaBaseCompany, HallResult<boolean>>('/hops/v1.0.0/base/company', {
            data:  arg0
        })
    }
    /**
     * 分页查询厂家
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseCompanyPageParam ) : Promise<HallResult<Page<TaBaseCompany>>> {
        // baseUrl=/hops/v1.0.0/base/company/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseCompany>>>('/hops/v1.0.0/base/company/_paging', {
            params: arg0
        })

    }
    /**
     * 获取所有供应商数据
     * 
     **/
    public static async allSupply() : Promise<HallResult<SupplyCompanyIdNameVO[]>> {
        // baseUrl=/hops/v1.0.0/base/company/_allSupply
        // httpMethod=get
        return await http.get<any, HallResult<SupplyCompanyIdNameVO[]>>('/hops/v1.0.0/base/company/_allSupply', {
            params: {             }
        })

    }
    /**
     * 保存厂家
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseCompany ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/company
        // httpMethod=post json 
        return await http.postJson<TaBaseCompany, HallResult<boolean>>('/hops/v1.0.0/base/company', {
            data:  arg0
        })
    }
}
/**
 * hall配置信息Api
 **/
export class HallConfigApi {
    /**
     * 获取标题名称
     * 
     **/
    public static async title() : Promise<HallResult<TitleVO>> {
        // baseUrl=/hall/_title
        // httpMethod=get
        return await http.get<any, HallResult<TitleVO>>('/hall/_title', {
            params: {             }
        })

    }
}
/**
 * 诊室Api
 **/
export class BaseHopsRoomApi {
    /**
     * 查询诊室列表
     * 
     * @param arg0 
     **/
    public static async findList( arg0? : BaseHopsRoomParam ) : Promise<HallResult<TaBaseHopsRoom[]>> {
        // baseUrl=/hops/v1.0.0/base/room/_list
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseHopsRoom[]>>('/hops/v1.0.0/base/room/_list', {
            params: arg0
        })

    }
    /**
     * 诊室详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseHopsRoom>> {
        // baseUrl=/hops/v1.0.0/base/room
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseHopsRoom>>('/hops/v1.0.0/base/room', {
            params: {  id            }
        })

    }
    /**
     * 修改诊室
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseHopsRoom ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/room
        // httpMethod=put json 
        return await http.putJson<TaBaseHopsRoom, HallResult<boolean>>('/hops/v1.0.0/base/room', {
            data:  arg0
        })
    }
    /**
     * 分页查询诊室
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseHopsRoomParam ) : Promise<HallResult<Page<TaBaseHopsRoom>>> {
        // baseUrl=/hops/v1.0.0/base/room/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseHopsRoom>>>('/hops/v1.0.0/base/room/_paging', {
            params: arg0
        })

    }
    /**
     * 删除诊室
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/room
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/room', {
            params: {  id            }
        })
    }
    /**
     * 保存诊室
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseHopsRoom ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/room
        // httpMethod=post json 
        return await http.postJson<TaBaseHopsRoom, HallResult<boolean>>('/hops/v1.0.0/base/room', {
            data:  arg0
        })
    }
}
/**
 * 中医症候Api
 **/
export class BaseTcmSymptomApi {
    /**
     * 中医症候详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseTcmSymptom>> {
        // baseUrl=/hops/v1.0.0/base/symptom
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseTcmSymptom>>('/hops/v1.0.0/base/symptom', {
            params: {  id            }
        })

    }
    /**
     * 批量删除中医症候
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/symptom/_batchDelete
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/symptom/_batchDelete', {
            params: {  ids            }
        })
    }
    /**
     * 修改中医症候
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseTcmSymptom ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/symptom
        // httpMethod=put json 
        return await http.putJson<TaBaseTcmSymptom, HallResult<boolean>>('/hops/v1.0.0/base/symptom', {
            data:  arg0
        })
    }
    /**
     * 分页查询中医症候
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseTcmSymptomPageParam ) : Promise<HallResult<Page<TaBaseTcmSymptom>>> {
        // baseUrl=/hops/v1.0.0/base/symptom/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseTcmSymptom>>>('/hops/v1.0.0/base/symptom/_paging', {
            params: arg0
        })

    }
    /**
     * 删除中医症候
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/symptom
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/symptom', {
            params: {  id            }
        })
    }
    /**
     * 保存中医症候
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseTcmSymptom ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/symptom
        // httpMethod=post json 
        return await http.postJson<TaBaseTcmSymptom, HallResult<boolean>>('/hops/v1.0.0/base/symptom', {
            data:  arg0
        })
    }
}
/**
 * 复合项目明细Api
 **/
export class BaseCompositeItemApi {
    /**
     * 复合项目明细详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseCompositeItem>> {
        // baseUrl=/hops/v1.0.0/item
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseCompositeItem>>('/hops/v1.0.0/item', {
            params: {  id            }
        })

    }
    /**
     * 修改复合项目明细
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseCompositeItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/item
        // httpMethod=put json 
        return await http.putJson<TaBaseCompositeItem, HallResult<boolean>>('/hops/v1.0.0/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询复合项目明细
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseCompositeItemPageParam ) : Promise<HallResult<Page<BaseCompositeItemVO>>> {
        // baseUrl=/hops/v1.0.0/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseCompositeItemVO>>>('/hops/v1.0.0/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除复合项目明细
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/item', {
            params: {  id            }
        })
    }
    /**
     * 保存复合项目明细
     * 
     * @param arg0 
     **/
    public static async save( arg0? : BaseCompositeItemCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/item
        // httpMethod=post json 
        return await http.postJson<BaseCompositeItemCreateParam, HallResult<boolean>>('/hops/v1.0.0/item', {
            data:  arg0
        })
    }
}
/**
 * 门诊护士站科室关系Api
 **/
export class BaseHopsStationDeptApi {
    /**
     * 门诊护士站科室关系详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseHopsStationDeptVO>> {
        // baseUrl=/hops/v1.0.0/base/dept
        // httpMethod=get
        return await http.get<any, HallResult<BaseHopsStationDeptVO>>('/hops/v1.0.0/base/dept', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊护士站科室关系
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : BaseHopsStationDeptVO ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/dept
        // httpMethod=put json 
        return await http.putJson<BaseHopsStationDeptVO, HallResult<boolean>>('/hops/v1.0.0/base/dept', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊护士站科室关系
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseHopsStationDeptPageParam ) : Promise<HallResult<Page<BaseHopsStationDeptVO>>> {
        // baseUrl=/hops/v1.0.0/base/dept/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseHopsStationDeptVO>>>('/hops/v1.0.0/base/dept/_paging', {
            params: arg0
        })

    }
    /**
     * 根据护士站查询列表
     * 
     * @param stationId  必填 
     **/
    public static async findListByStationId( stationId : string ) : Promise<HallResult<BaseHopsStationDeptVO>> {
        // baseUrl=/hops/v1.0.0/base/dept/_findListByStationId
        // httpMethod=get
        return await http.get<any, HallResult<BaseHopsStationDeptVO>>('/hops/v1.0.0/base/dept/_findListByStationId', {
            params: {  stationId            }
        })

    }
}
/**
 * 快捷操作推荐词Api
 **/
export class BaseSuggestWordApi {
    /**
     * 查询中药医嘱单备注推荐词
     * 
     **/
    public static async findTcmRemarkWords() : Promise<HallResult<SuggestWordVO[]>> {
        // baseUrl=/hops/v1.0.0/word/_findTcmRemarkWords
        // httpMethod=get
        return await http.get<any, HallResult<SuggestWordVO[]>>('/hops/v1.0.0/word/_findTcmRemarkWords', {
            params: {             }
        })

    }
    /**
     * 快捷操作推荐词详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseSuggestWord>> {
        // baseUrl=/hops/v1.0.0/word
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseSuggestWord>>('/hops/v1.0.0/word', {
            params: {  id            }
        })

    }
    /**
     * 修改快捷操作推荐词
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseSuggestWord ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/word
        // httpMethod=put json 
        return await http.putJson<TaBaseSuggestWord, HallResult<boolean>>('/hops/v1.0.0/word', {
            data:  arg0
        })
    }
    /**
     * 分页查询快捷操作推荐词
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseSuggestWordPageParam ) : Promise<HallResult<Page<TaBaseSuggestWord>>> {
        // baseUrl=/hops/v1.0.0/word/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseSuggestWord>>>('/hops/v1.0.0/word/_paging', {
            params: arg0
        })

    }
    /**
     * 删除快捷操作推荐词
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/word
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/word', {
            params: {  id            }
        })
    }
    /**
     * 保存快捷操作推荐词
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseSuggestWord ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/word
        // httpMethod=post json 
        return await http.postJson<TaBaseSuggestWord, HallResult<boolean>>('/hops/v1.0.0/word', {
            data:  arg0
        })
    }
}
/**
 * 挂号级别Api
 **/
export class BaseRegisterLevelApi {
    /**
     * 挂号级别详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseRegisterLevel>> {
        // baseUrl=/hops/v1.0.0/base/level
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseRegisterLevel>>('/hops/v1.0.0/base/level', {
            params: {  id            }
        })

    }
    /**
     * 批量删除挂号级别
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/level/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/level/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改挂号级别
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseRegisterLevel ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/level
        // httpMethod=put json 
        return await http.putJson<TaBaseRegisterLevel, HallResult<boolean>>('/hops/v1.0.0/base/level', {
            data:  arg0
        })
    }
    /**
     * 分页查询挂号级别
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseRegisterLevelPageParam ) : Promise<HallResult<Page<TaBaseRegisterLevel>>> {
        // baseUrl=/hops/v1.0.0/base/level/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseRegisterLevel>>>('/hops/v1.0.0/base/level/_paging', {
            params: arg0
        })

    }
    /**
     * 保存挂号级别
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseRegisterLevel ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/level
        // httpMethod=post json 
        return await http.postJson<TaBaseRegisterLevel, HallResult<boolean>>('/hops/v1.0.0/base/level', {
            data:  arg0
        })
    }
}
/**
 * 诊台Api
 **/
export class BaseHopsDeskApi {
    /**
     * 诊台详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseHopsDesk>> {
        // baseUrl=/hops/v1.0.0/base/desk
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseHopsDesk>>('/hops/v1.0.0/base/desk', {
            params: {  id            }
        })

    }
    /**
     * 批量删除诊台
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/desk/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/desk/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改诊台
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseHopsDesk ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/desk
        // httpMethod=put json 
        return await http.putJson<TaBaseHopsDesk, HallResult<boolean>>('/hops/v1.0.0/base/desk', {
            data:  arg0
        })
    }
    /**
     * 分页查询诊台
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseHopsDeskPageParam ) : Promise<HallResult<Page<BaseHopsDeskVO>>> {
        // baseUrl=/hops/v1.0.0/base/desk/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseHopsDeskVO>>>('/hops/v1.0.0/base/desk/_paging', {
            params: arg0
        })

    }
    /**
     * 保存诊台
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseHopsDesk ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/desk
        // httpMethod=post json 
        return await http.postJson<TaBaseHopsDesk, HallResult<boolean>>('/hops/v1.0.0/base/desk', {
            data:  arg0
        })
    }
}
/**
 * 挂号费Api
 **/
export class BaseRegisterFeeApi {
    /**
     * 挂号费详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseRegisterFee>> {
        // baseUrl=/hops/v1.0.0/base/fee
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseRegisterFee>>('/hops/v1.0.0/base/fee', {
            params: {  id            }
        })

    }
    /**
     * 批量删除挂号费
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/fee/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/fee/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改挂号费
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseRegisterFee ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/fee
        // httpMethod=put json 
        return await http.putJson<TaBaseRegisterFee, HallResult<boolean>>('/hops/v1.0.0/base/fee', {
            data:  arg0
        })
    }
    /**
     * 分页查询挂号费
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseRegisterFeePageParam ) : Promise<HallResult<Page<BaseRegisterFeePageVo>>> {
        // baseUrl=/hops/v1.0.0/base/fee/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseRegisterFeePageVo>>>('/hops/v1.0.0/base/fee/_paging', {
            params: arg0
        })

    }
    /**
     * 批量保存挂号费
     * 
     * @param arg0 
     **/
    public static async batchSave( arg0? : any ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/fee/_batch
        // httpMethod=post json 
        return await http.postJson<any, HallResult<boolean>>('/hops/v1.0.0/base/fee/_batch', {
            data:  arg0
        })
    }
    /**
     * 保存挂号费
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseRegisterFee ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/fee
        // httpMethod=post json 
        return await http.postJson<TaBaseRegisterFee, HallResult<boolean>>('/hops/v1.0.0/base/fee', {
            data:  arg0
        })
    }
}
/**
 * 频次Api
 **/
export class BaseFrequencyApi {
    /**
     * 频次详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseFrequency>> {
        // baseUrl=/hops/v1.0.0/base/frequency
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseFrequency>>('/hops/v1.0.0/base/frequency', {
            params: {  id            }
        })

    }
    /**
     * 批量删除频次
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/frequency/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/frequency/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改频次
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseFrequency ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/frequency
        // httpMethod=put json 
        return await http.putJson<TaBaseFrequency, HallResult<boolean>>('/hops/v1.0.0/base/frequency', {
            data:  arg0
        })
    }
    /**
     * 分页查询频次
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseFrequencyPageParam ) : Promise<HallResult<Page<TaBaseFrequency>>> {
        // baseUrl=/hops/v1.0.0/base/frequency/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseFrequency>>>('/hops/v1.0.0/base/frequency/_paging', {
            params: arg0
        })

    }
    /**
     * 保存频次
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseFrequency ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/frequency
        // httpMethod=post json 
        return await http.postJson<TaBaseFrequency, HallResult<boolean>>('/hops/v1.0.0/base/frequency', {
            data:  arg0
        })
    }
}
/**
 * 基础配置对码Api
 **/
export class BaseMatchingApi {
    /**
     * 对码分页接口
     * 
     * @param arg0 
     **/
    public static async matchPaging( arg0? : BaseMatchingParam ) : Promise<HallResult<Page<BaseMatchingVO>>> {
        // baseUrl=/hops/v1.0.0/base/matching/_matchPaging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseMatchingVO>>>('/hops/v1.0.0/base/matching/_matchPaging', {
            params: arg0
        })

    }
}
/**
 * 用法Api
 **/
export class BaseUsageApi {
    /**
     * 用法详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseUsageDetailVO>> {
        // baseUrl=/hops/v1.0.0/base/usage
        // httpMethod=get
        return await http.get<any, HallResult<BaseUsageDetailVO>>('/hops/v1.0.0/base/usage', {
            params: {  id            }
        })

    }
    /**
     * 批量删除用法
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/usage/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/usage/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改用法
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : BaseUsageSubmitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/usage
        // httpMethod=put json 
        return await http.putJson<BaseUsageSubmitParam, HallResult<boolean>>('/hops/v1.0.0/base/usage', {
            data:  arg0
        })
    }
    /**
     * 分页查询用法
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseUsagePageParam ) : Promise<HallResult<Page<BaseUsageDetailVO>>> {
        // baseUrl=/hops/v1.0.0/base/usage/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseUsageDetailVO>>>('/hops/v1.0.0/base/usage/_paging', {
            params: arg0
        })

    }
    /**
     * 保存用法
     * 
     * @param arg0 
     **/
    public static async save( arg0? : BaseUsageSubmitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/usage
        // httpMethod=post json 
        return await http.postJson<BaseUsageSubmitParam, HallResult<boolean>>('/hops/v1.0.0/base/usage', {
            data:  arg0
        })
    }
}
/**
 * 诊断Api
 **/
export class BaseDiagnoseApi {
    /**
     * 诊断详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseDiagnose>> {
        // baseUrl=/hops/v1.0.0/base/diagnose
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseDiagnose>>('/hops/v1.0.0/base/diagnose', {
            params: {  id            }
        })

    }
    /**
     * 批量删除诊断
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/diagnose/_batchDelete
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/diagnose/_batchDelete', {
            params: {  ids            }
        })
    }
    /**
     * 修改诊断
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseDiagnose ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/diagnose
        // httpMethod=put json 
        return await http.putJson<TaBaseDiagnose, HallResult<boolean>>('/hops/v1.0.0/base/diagnose', {
            data:  arg0
        })
    }
    /**
     * 分页查询诊断
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseDiagnosePageParam ) : Promise<HallResult<Page<TaBaseDiagnose>>> {
        // baseUrl=/hops/v1.0.0/base/diagnose/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseDiagnose>>>('/hops/v1.0.0/base/diagnose/_paging', {
            params: arg0
        })

    }
    /**
     * 删除诊断
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/diagnose
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/diagnose', {
            params: {  id            }
        })
    }
    /**
     * 保存诊断
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseDiagnose ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/diagnose
        // httpMethod=post json 
        return await http.postJson<TaBaseDiagnose, HallResult<boolean>>('/hops/v1.0.0/base/diagnose', {
            data:  arg0
        })
    }
}
/**
 * 科室标签Api
 **/
export class BaseDeptTagApi {
    /**
     * 科室标签详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseDeptTag>> {
        // baseUrl=/hops/v1.0.0/base/tag
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseDeptTag>>('/hops/v1.0.0/base/tag', {
            params: {  id            }
        })

    }
    /**
     * 修改科室标签
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : BaseDeptTagVO ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/tag
        // httpMethod=put json 
        return await http.putJson<BaseDeptTagVO, HallResult<boolean>>('/hops/v1.0.0/base/tag', {
            data:  arg0
        })
    }
    /**
     * 分页查询科室标签
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseDeptTagPageParam ) : Promise<HallResult<Page<BaseDeptTagVO>>> {
        // baseUrl=/hops/v1.0.0/base/tag/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseDeptTagVO>>>('/hops/v1.0.0/base/tag/_paging', {
            params: arg0
        })

    }
    /**
     * 查询标签对应的科室列表
     * 
     * @param deptTag  必填 
     **/
    public static async deptListByDeptTag( deptTag : string ) : Promise<HallResult<TagDeptListVo[]>> {
        // baseUrl=/hops/v1.0.0/base/tag/_deptListByDeptTag
        // httpMethod=get
        return await http.get<any, HallResult<TagDeptListVo[]>>('/hops/v1.0.0/base/tag/_deptListByDeptTag', {
            params: {  deptTag            }
        })

    }
}
/**
 * 排班时间段Api
 **/
export class BaseHopsScheduleTimeApi {
    /**
     * 排班时间段详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaBaseHopsScheduleTime>> {
        // baseUrl=/hops/v1.0.0/base/time
        // httpMethod=get
        return await http.get<any, HallResult<TaBaseHopsScheduleTime>>('/hops/v1.0.0/base/time', {
            params: {  id            }
        })

    }
    /**
     * 批量删除排班时间段
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/time/_batch
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/base/time/_batch', {
            params: {  ids            }
        })
    }
    /**
     * 修改排班时间段
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseHopsScheduleTime ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/time
        // httpMethod=put json 
        return await http.putJson<TaBaseHopsScheduleTime, HallResult<boolean>>('/hops/v1.0.0/base/time', {
            data:  arg0
        })
    }
    /**
     * 分页查询排班时间段
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseHopsScheduleTimePageParam ) : Promise<HallResult<Page<TaBaseHopsScheduleTime>>> {
        // baseUrl=/hops/v1.0.0/base/time/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaBaseHopsScheduleTime>>>('/hops/v1.0.0/base/time/_paging', {
            params: arg0
        })

    }
    /**
     * 保存排班时间段
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseHopsScheduleTime ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/base/time
        // httpMethod=post json 
        return await http.postJson<TaBaseHopsScheduleTime, HallResult<boolean>>('/hops/v1.0.0/base/time', {
            data:  arg0
        })
    }
}
/**
 * 门诊检验申请项目Api
 **/
export class HopsLisApplyItemApi {
    /**
     * 门诊检验申请项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<HopsLisApplyItemVO>> {
        // baseUrl=/hops/v1.0.0/lis/apply/item
        // httpMethod=get
        return await http.get<any, HallResult<HopsLisApplyItemVO>>('/hops/v1.0.0/lis/apply/item', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊检验申请项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsLisApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply/item
        // httpMethod=put json 
        return await http.putJson<TaHopsLisApplyItem, HallResult<boolean>>('/hops/v1.0.0/lis/apply/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊检验申请项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsLisApplyItemPageParam ) : Promise<HallResult<Page<HopsLisApplyItemVO>>> {
        // baseUrl=/hops/v1.0.0/lis/apply/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsLisApplyItemVO>>>('/hops/v1.0.0/lis/apply/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊检验申请项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/lis/apply/item', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊检验申请项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsLisApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply/item
        // httpMethod=post json 
        return await http.postJson<TaHopsLisApplyItem, HallResult<boolean>>('/hops/v1.0.0/lis/apply/item', {
            data:  arg0
        })
    }
}
/**
 * 检验申请与医嘱关联Api
 **/
export class HopsLisApplyOrderApi {
    /**
     * 检验申请与医嘱关联详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsLisApplyOrder>> {
        // baseUrl=/hops/v1.0.0/lis/apply/order
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsLisApplyOrder>>('/hops/v1.0.0/lis/apply/order', {
            params: {  id            }
        })

    }
    /**
     * 修改检验申请与医嘱关联
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsLisApplyOrder ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply/order
        // httpMethod=put json 
        return await http.putJson<TaHopsLisApplyOrder, HallResult<boolean>>('/hops/v1.0.0/lis/apply/order', {
            data:  arg0
        })
    }
    /**
     * 分页查询检验申请与医嘱关联
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsLisApplyOrderPageParam ) : Promise<HallResult<Page<TaHopsLisApplyOrder>>> {
        // baseUrl=/hops/v1.0.0/lis/apply/order/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsLisApplyOrder>>>('/hops/v1.0.0/lis/apply/order/_paging', {
            params: arg0
        })

    }
    /**
     * 删除检验申请与医嘱关联
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply/order
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/lis/apply/order', {
            params: {  id            }
        })
    }
    /**
     * 保存检验申请与医嘱关联
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsLisApplyOrder ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply/order
        // httpMethod=post json 
        return await http.postJson<TaHopsLisApplyOrder, HallResult<boolean>>('/hops/v1.0.0/lis/apply/order', {
            data:  arg0
        })
    }
}
/**
 * 门诊检验申请Api
 **/
export class HopsLisApplyApi {
    /**
     * 门诊检验申请详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsLisApply>> {
        // baseUrl=/hops/v1.0.0/lis/apply
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsLisApply>>('/hops/v1.0.0/lis/apply', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊检验申请
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsLisApply ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply
        // httpMethod=put json 
        return await http.putJson<TaHopsLisApply, HallResult<boolean>>('/hops/v1.0.0/lis/apply', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊检验申请
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsLisApplyPageParam ) : Promise<HallResult<Page<TaHopsLisApply>>> {
        // baseUrl=/hops/v1.0.0/lis/apply/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsLisApply>>>('/hops/v1.0.0/lis/apply/_paging', {
            params: arg0
        })

    }
    /**
     * 根据申请ID获取检验申请单据数据
     * 
     * @param applyId  必填 
     **/
    public static async loadHopsListApplyDoc( applyId : string ) : Promise<HallResult<HopsLisApplyDocVO>> {
        // baseUrl=/hops/v1.0.0/lis/apply/_loadHopsListApplyDoc
        // httpMethod=get
        return await http.get<any, HallResult<HopsLisApplyDocVO>>('/hops/v1.0.0/lis/apply/_loadHopsListApplyDoc', {
            params: {  applyId            }
        })

    }
    /**
     * 删除门诊检验申请
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/lis/apply', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊检验申请
     * 
     * @param arg0 
     **/
    public static async save( arg0? : HopsLisApplyCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/apply
        // httpMethod=post json 
        return await http.postJson<HopsLisApplyCreateParam, HallResult<boolean>>('/hops/v1.0.0/lis/apply', {
            data:  arg0
        })
    }
}
/**
 * 门诊检验结果Api
 **/
export class HopsLisResultApi {
    /**
     * 门诊检验结果详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsLisResult>> {
        // baseUrl=/hops/v1.0.0/lis/result
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsLisResult>>('/hops/v1.0.0/lis/result', {
            params: {  id            }
        })

    }
    /**
     * 结果对比
     * 
     * @param arg0 
     **/
    public static async contrast( arg0? : HopsLisApplyResultCompareParam ) : Promise<HallResult<HopsLisApplyResultContrastVO>> {
        // baseUrl=/hops/v1.0.0/lis/result/_contrast
        // httpMethod=get
        return await http.get<any, HallResult<HopsLisApplyResultContrastVO>>('/hops/v1.0.0/lis/result/_contrast', {
            params: arg0
        })

    }
    /**
     * 根据项目id查询检验结果
     * 
     * @param applyItemId  必填 
     **/
    public static async listByItemId( applyItemId : string ) : Promise<HallResult<TaHopsLisResult[]>> {
        // baseUrl=/hops/v1.0.0/lis/result/_listByItemId
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsLisResult[]>>('/hops/v1.0.0/lis/result/_listByItemId', {
            params: {  applyItemId            }
        })

    }
    /**
     * 修改门诊检验结果
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsLisResult ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/result
        // httpMethod=put json 
        return await http.putJson<TaHopsLisResult, HallResult<boolean>>('/hops/v1.0.0/lis/result', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊检验结果
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsLisResultPageParam ) : Promise<HallResult<Page<TaHopsLisResult>>> {
        // baseUrl=/hops/v1.0.0/lis/result/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsLisResult>>>('/hops/v1.0.0/lis/result/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊检验结果
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/result
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/lis/result', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊检验结果
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsLisResult ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/lis/result
        // httpMethod=post json 
        return await http.postJson<TaHopsLisResult, HallResult<boolean>>('/hops/v1.0.0/lis/result', {
            data:  arg0
        })
    }
}
/**
 * 门诊支付Api
 **/
export class HopsFeeApi {
    /**
     * 自费支付
     * 
     * @param arg0 
     **/
    public static async ownPay( arg0? : HopsPayParam ) : Promise<HallResult<HopsFeeBillVO>> {
        // baseUrl=/hops/v1.0.0/fee/_ownPay
        // httpMethod=post json 
        return await http.postJson<HopsPayParam, HallResult<HopsFeeBillVO>>('/hops/v1.0.0/fee/_ownPay', {
            data:  arg0
        })
    }
    /**
     * 账单详情
     * 
     * @param arg0 
     **/
    public static async billDetail( arg0? : BillBaseParam ) : Promise<HallResult<HopsFeeBillVO>> {
        // baseUrl=/hops/v1.0.0/fee/_billDetail
        // httpMethod=get
        return await http.get<any, HallResult<HopsFeeBillVO>>('/hops/v1.0.0/fee/_billDetail', {
            params: arg0
        })

    }
    /**
     * 获取费用凭条打印信息，20231102标注未待下线接口
     * 
     * @param billId 账单ID 必填 
     **/
    public static async loadFeeVoucher( billId : string ) : Promise<HallResult<HopsFeeVoucherDocVO>> {
        // baseUrl=/hops/v1.0.0/fee/_loadFeeVoucher
        // httpMethod=get
        return await http.get<any, HallResult<HopsFeeVoucherDocVO>>('/hops/v1.0.0/fee/_loadFeeVoucher', {
            params: {  billId            }
        })

    }
    /**
     * 获取广东省医疗收费票据数据
     * 
     * @param billId 账单ID 必填 
     **/
    public static async loadGdMFD( billId : string ) : Promise<HallResult<GdMedicalFeeDocVO>> {
        // baseUrl=/hops/v1.0.0/fee/_loadGdMFD
        // httpMethod=get
        return await http.get<any, HallResult<GdMedicalFeeDocVO>>('/hops/v1.0.0/fee/_loadGdMFD', {
            params: {  billId            }
        })

    }
    /**
     * 获取门诊收据明细单据数据
     * 
     * @param billId 账单ID 必填 
     **/
    public static async loadFeeDetailDoc( billId : string ) : Promise<HallResult<HopsFeeDetailDocVO>> {
        // baseUrl=/hops/v1.0.0/fee/_loadFeeDetailDoc
        // httpMethod=get
        return await http.get<any, HallResult<HopsFeeDetailDocVO>>('/hops/v1.0.0/fee/_loadFeeDetailDoc', {
            params: {  billId            }
        })

    }
    /**
     * 获取费用凭条打印信息V2
     * 
     * @param billId 账单ID 必填 
     **/
    public static async loadFeeVoucherV2( billId : string ) : Promise<HallResult<HopsFeeVoucherDocV2VO>> {
        // baseUrl=/hops/v1.0.0/fee/_loadFeeVoucherV2
        // httpMethod=get
        return await http.get<any, HallResult<HopsFeeVoucherDocV2VO>>('/hops/v1.0.0/fee/_loadFeeVoucherV2', {
            params: {  billId            }
        })

    }
}
/**
 * 门诊病历Api
 **/
export class HopsMrecordApi {
    /**
     * 获取病历打印数据
     * 
     * @param registerId  必填 
     **/
    public static async loadMrecordDoc( registerId : string ) : Promise<HallResult<HopsMrecordDocVO>> {
        // baseUrl=/hops/v1.0.0/mrecord/_loadMrecordDoc
        // httpMethod=get
        return await http.get<any, HallResult<HopsMrecordDocVO>>('/hops/v1.0.0/mrecord/_loadMrecordDoc', {
            params: {  registerId            }
        })

    }
    /**
     * 获取病历打印数据
     * 
     * @param mrecordId  必填 
     **/
    public static async loadMrecordDocById( mrecordId : string ) : Promise<HallResult<HopsMrecordDocVO>> {
        // baseUrl=/hops/v1.0.0/mrecord/_loadMrecordDocById
        // httpMethod=get
        return await http.get<any, HallResult<HopsMrecordDocVO>>('/hops/v1.0.0/mrecord/_loadMrecordDocById', {
            params: {  mrecordId            }
        })

    }
    /**
     * 门诊病历详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsMrecord>> {
        // baseUrl=/hops/v1.0.0/mrecord
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsMrecord>>('/hops/v1.0.0/mrecord', {
            params: {  id            }
        })

    }
    /**
     * 病史
     * 
     * @param arg0 
     **/
    public static async history( arg0? : HopsMrecordHistoryParam ) : Promise<HallResult<Page<HopsMrecordHistoryVO>>> {
        // baseUrl=/hops/v1.0.0/mrecord/_historyPaging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsMrecordHistoryVO>>>('/hops/v1.0.0/mrecord/_historyPaging', {
            params: arg0
        })

    }
    /**
     * 修改门诊病历
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsMrecord ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord
        // httpMethod=put json 
        return await http.putJson<TaHopsMrecord, HallResult<boolean>>('/hops/v1.0.0/mrecord', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊病历
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsMrecordPageParam ) : Promise<HallResult<Page<TaHopsMrecord>>> {
        // baseUrl=/hops/v1.0.0/mrecord/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsMrecord>>>('/hops/v1.0.0/mrecord/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊病历
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/mrecord', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊病历
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsMrecord ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord
        // httpMethod=post json 
        return await http.postJson<TaHopsMrecord, HallResult<boolean>>('/hops/v1.0.0/mrecord', {
            data:  arg0
        })
    }
}
/**
 * 门诊病历模板Api
 **/
export class HopsMrecordTemplateApi {
    /**
     * 门诊病历模板详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsMrecordTemplate>> {
        // baseUrl=/hops/v1.0.0/template
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsMrecordTemplate>>('/hops/v1.0.0/template', {
            params: {  id            }
        })

    }
    /**
     * 获取所有的病历模板
     * 
     **/
    public static async findAll() : Promise<HallResult<TaHopsMrecordTemplate[]>> {
        // baseUrl=/hops/v1.0.0/template/findAll
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsMrecordTemplate[]>>('/hops/v1.0.0/template/findAll', {
            params: {             }
        })

    }
    /**
     * 修改门诊病历模板
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsMrecordTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/template
        // httpMethod=put json 
        return await http.putJson<TaHopsMrecordTemplate, HallResult<boolean>>('/hops/v1.0.0/template', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊病历模板
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsMrecordTemplatePageParam ) : Promise<HallResult<Page<TaHopsMrecordTemplate>>> {
        // baseUrl=/hops/v1.0.0/template/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsMrecordTemplate>>>('/hops/v1.0.0/template/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊病历模板
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/template
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/template', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊病历模板
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsMrecordTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/template
        // httpMethod=post json 
        return await http.postJson<TaHopsMrecordTemplate, HallResult<boolean>>('/hops/v1.0.0/template', {
            data:  arg0
        })
    }
}
/**
 * 门诊病历字段数据Api
 **/
export class HopsMrecordFieldApi {
    /**
     * 门诊病历字段数据详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsMrecordField>> {
        // baseUrl=/hops/v1.0.0/field
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsMrecordField>>('/hops/v1.0.0/field', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊病历字段数据
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsMrecordField ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/field
        // httpMethod=put json 
        return await http.putJson<TaHopsMrecordField, HallResult<boolean>>('/hops/v1.0.0/field', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊病历字段数据
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsMrecordFieldPageParam ) : Promise<HallResult<Page<TaHopsMrecordField>>> {
        // baseUrl=/hops/v1.0.0/field/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsMrecordField>>>('/hops/v1.0.0/field/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊病历字段数据
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/field
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/field', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊病历字段数据
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsMrecordField ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/field
        // httpMethod=post json 
        return await http.postJson<TaHopsMrecordField, HallResult<boolean>>('/hops/v1.0.0/field', {
            data:  arg0
        })
    }
}
/**
 * 病历个人模板(样例)Api
 **/
export class HopsMrecordPersonalCaseApi {
    /**
     * 删除
     * 
     * @param id  必填 
     **/
    public static async deleteById( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord/case
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/mrecord/case', {
            params: {  id            }
        })
    }
    /**
     * 修改病历模板字段
     * 
     * @param arg0 
     **/
    public static async editCaseFields( arg0? : MrecordPersonalCaseEditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_editCaseFields
        // httpMethod=put json 
        return await http.putJson<MrecordPersonalCaseEditParam, HallResult<boolean>>('/hops/v1.0.0/mrecord/case/_editCaseFields', {
            data:  arg0
        })
    }
    /**
     * 修改目录
     * 
     * @param arg0 
     **/
    public static async editDir( arg0? : MrecordPersonalCaseDirSubmitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_editDir
        // httpMethod=post json 
        return await http.postJson<MrecordPersonalCaseDirSubmitParam, HallResult<boolean>>('/hops/v1.0.0/mrecord/case/_editDir', {
            data:  arg0
        })
    }
    /**
     * 病历模板(样例)详情
     * 
     * @param id  必填 
     **/
    public static async detailCase( id : string ) : Promise<HallResult<MrecordPersonalCaseDetailVO>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_detailCase
        // httpMethod=get
        return await http.get<any, HallResult<MrecordPersonalCaseDetailVO>>('/hops/v1.0.0/mrecord/case/_detailCase', {
            params: {  id            }
        })

    }
    /**
     * 修改病历模板(样例),只允许修改名字跟目录
     * 
     * @param arg0 
     **/
    public static async editCase( arg0? : MrecordPersonalCaseSubmitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_editCase
        // httpMethod=put json 
        return await http.putJson<MrecordPersonalCaseSubmitParam, HallResult<boolean>>('/hops/v1.0.0/mrecord/case/_editCase', {
            data:  arg0
        })
    }
    /**
     * 获取当前用户所有病历个人模板目录树数据
     * 
     **/
    public static async allDTree() : Promise<HallResult<MrecordPersonalCaseTreeNodeVO[]>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_allDirTree
        // httpMethod=get
        return await http.get<any, HallResult<MrecordPersonalCaseTreeNodeVO[]>>('/hops/v1.0.0/mrecord/case/_allDirTree', {
            params: {             }
        })

    }
    /**
     * 新增目录
     * 
     * @param arg0 
     **/
    public static async addDir( arg0? : MrecordPersonalCaseDirSubmitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_addDir
        // httpMethod=post json 
        return await http.postJson<MrecordPersonalCaseDirSubmitParam, HallResult<boolean>>('/hops/v1.0.0/mrecord/case/_addDir', {
            data:  arg0
        })
    }
    /**
     * 增加病历模板(样例)
     * 
     * @param arg0 
     **/
    public static async addCase( arg0? : MrecordPersonalCaseSubmitParam ) : Promise<HallResult<string>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_addCase
        // httpMethod=post json 
        return await http.postJson<MrecordPersonalCaseSubmitParam, HallResult<string>>('/hops/v1.0.0/mrecord/case/_addCase', {
            data:  arg0
        })
    }
    /**
     * 获取当前用户所有病历个人模板树数据(包含目录与病历)
     * 
     **/
    public static async allTree() : Promise<HallResult<MrecordPersonalCaseTreeNodeVO[]>> {
        // baseUrl=/hops/v1.0.0/mrecord/case/_allTree
        // httpMethod=get
        return await http.get<any, HallResult<MrecordPersonalCaseTreeNodeVO[]>>('/hops/v1.0.0/mrecord/case/_allTree', {
            params: {             }
        })

    }
}
/**
 * 病历模板字段Api
 **/
export class HopsMrecordTemplateFieldApi {
    /**
     * 病历模板字段详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsMrecordTemplateField>> {
        // baseUrl=/hops/v1.0.0/template/field
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsMrecordTemplateField>>('/hops/v1.0.0/template/field', {
            params: {  id            }
        })

    }
    /**
     * 修改病历模板字段
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsMrecordTemplateField ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/template/field
        // httpMethod=put json 
        return await http.putJson<TaHopsMrecordTemplateField, HallResult<boolean>>('/hops/v1.0.0/template/field', {
            data:  arg0
        })
    }
    /**
     * 分页查询病历模板字段
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsMrecordTemplateFieldPageParam ) : Promise<HallResult<Page<TaHopsMrecordTemplateField>>> {
        // baseUrl=/hops/v1.0.0/template/field/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsMrecordTemplateField>>>('/hops/v1.0.0/template/field/_paging', {
            params: arg0
        })

    }
    /**
     * 删除病历模板字段
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/template/field
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/template/field', {
            params: {  id            }
        })
    }
    /**
     * 保存病历模板字段
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsMrecordTemplateField ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/template/field
        // httpMethod=post json 
        return await http.postJson<TaHopsMrecordTemplateField, HallResult<boolean>>('/hops/v1.0.0/template/field', {
            data:  arg0
        })
    }
}
/**
 * 门诊诊断Api
 **/
export class HopsDiagnoseApi {
    /**
     * 门诊诊断详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsDiagnose>> {
        // baseUrl=/hops/v1.0.0/diagnose
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsDiagnose>>('/hops/v1.0.0/diagnose', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊诊断
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsDiagnose ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/diagnose
        // httpMethod=put json 
        return await http.putJson<TaHopsDiagnose, HallResult<boolean>>('/hops/v1.0.0/diagnose', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊诊断
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsDiagnosePageParam ) : Promise<HallResult<Page<TaHopsDiagnose>>> {
        // baseUrl=/hops/v1.0.0/diagnose/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsDiagnose>>>('/hops/v1.0.0/diagnose/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊诊断
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/diagnose
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/diagnose', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊诊断
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsDiagnose ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/diagnose
        // httpMethod=post json 
        return await http.postJson<TaHopsDiagnose, HallResult<boolean>>('/hops/v1.0.0/diagnose', {
            data:  arg0
        })
    }
}
/**
 * 门诊中医症候Api
 **/
export class HopsTcmSymptomApi {
    /**
     * 门诊中医症候详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsTcmSymptom>> {
        // baseUrl=/hops/v1.0.0/symptom
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsTcmSymptom>>('/hops/v1.0.0/symptom', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊中医症候
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsTcmSymptom ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/symptom
        // httpMethod=put json 
        return await http.putJson<TaHopsTcmSymptom, HallResult<boolean>>('/hops/v1.0.0/symptom', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊中医症候
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsTcmSymptomPageParam ) : Promise<HallResult<Page<TaHopsTcmSymptom>>> {
        // baseUrl=/hops/v1.0.0/symptom/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsTcmSymptom>>>('/hops/v1.0.0/symptom/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊中医症候
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/symptom
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/symptom', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊中医症候
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsTcmSymptom ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/symptom
        // httpMethod=post json 
        return await http.postJson<TaHopsTcmSymptom, HallResult<boolean>>('/hops/v1.0.0/symptom', {
            data:  arg0
        })
    }
}
/**
 * 门诊医嘱配发药Api
 **/
export class HopsDispenseInterApi {
    /**
     * 门诊医嘱配发药审核
     * 
     * @param arg0 
     **/
    public static async audit( arg0? : HopsDispenseAuditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dispense/_audit
        // httpMethod=post json 
        return await http.postJson<HopsDispenseAuditParam, HallResult<boolean>>('/hops/v1.0.0/dispense/_audit', {
            data:  arg0
        })
    }
    /**
     * 门诊医嘱配发药详情
     * 
     * @param type  必填 
     * @param id  必填 
     **/
    public static async detail( type : string , id : string ) : Promise<HallResult<HopsDispenseVO>> {
        // baseUrl=/hops/v1.0.0/dispense
        // httpMethod=get
        return await http.get<any, HallResult<HopsDispenseVO>>('/hops/v1.0.0/dispense', {
            params: {  type, id            }
        })

    }
    /**
     * 根据处方编号门诊医嘱配发药详情
     * 
     * @param recipeCode  必填 
     **/
    public static async findByRecipeCode( recipeCode : string ) : Promise<HallResult<HopsDispenseVO>> {
        // baseUrl=/hops/v1.0.0/dispense/_findByRecipeCode
        // httpMethod=get
        return await http.get<any, HallResult<HopsDispenseVO>>('/hops/v1.0.0/dispense/_findByRecipeCode', {
            params: {  recipeCode            }
        })

    }
    /**
     * 门诊医嘱配发药自动审核
     * 
     * @param arg0 
     **/
    public static async autoAudit( arg0? : HopsDispenseBaseAuditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dispense/_autoAudit
        // httpMethod=post json 
        return await http.postJson<HopsDispenseBaseAuditParam, HallResult<boolean>>('/hops/v1.0.0/dispense/_autoAudit', {
            data:  arg0
        })
    }
    /**
     * 门诊医嘱配退药审核
     * 
     * @param arg0 
     **/
    public static async returnAudit( arg0? : HopsDispenseReturnAuditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dispense/_returnAudit
        // httpMethod=post json 
        return await http.postJson<HopsDispenseReturnAuditParam, HallResult<boolean>>('/hops/v1.0.0/dispense/_returnAudit', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊医嘱配发药
     * 
     * @param arg0 
     **/
    public static async patientPaging( arg0? : HopsDispensePageParam ) : Promise<HallResult<Page<HopsDispensePatientVO>>> {
        // baseUrl=/hops/v1.0.0/dispense/_patientPaging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsDispensePatientVO>>>('/hops/v1.0.0/dispense/_patientPaging', {
            params: arg0
        })

    }
    /**
     * 患者配发药单数量统计
     * 
     * @param arg0 
     **/
    public static async patientStatic( arg0? : HopsDispensePageParam ) : Promise<HallResult<HopsDispensePatientStaticVO[]>> {
        // baseUrl=/hops/v1.0.0/dispense/_patientStatic
        // httpMethod=get
        return await http.get<any, HallResult<HopsDispensePatientStaticVO[]>>('/hops/v1.0.0/dispense/_patientStatic', {
            params: arg0
        })

    }
    /**
     * 根据当前科室查询库房信息(窗口)
     * 
     * @param deptId  必填 
     **/
    public static async findDispensary( deptId : string ) : Promise<HallResult<HopsDispensaryVO>> {
        // baseUrl=/hops/v1.0.0/dispense/_findDispensary
        // httpMethod=get
        return await http.get<any, HallResult<HopsDispensaryVO>>('/hops/v1.0.0/dispense/_findDispensary', {
            params: {  deptId            }
        })

    }
    /**
     * 配药单打印信息
     * 
     * @param ids  必填 
     **/
    public static async printDispense( ids : any ) : Promise<HallResult<HopsDispensePrintVO>> {
        // baseUrl=/hops/v1.0.0/dispense/_printDispense
        // httpMethod=put
        return await http.put<any, HallResult<HopsDispensePrintVO>>('/hops/v1.0.0/dispense/_printDispense', {
            params: {  ids            }
        })
    }
    /**
     * 删除门诊医嘱配发药
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dispense
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/dispense', {
            params: {  id            }
        })
    }
}
/**
 * 医嘱Api
 **/
export class HopsOrderInterApi {
    /**
     * 作废医嘱
     * 
     * @param id  必填 
     **/
    public static async invalid( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/order/_invalidate
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/order/_invalidate', {
            params: {  id            }
        })
    }
    /**
     * 根据挂号ID查询医嘱详情(不包含辅材医嘱)
     * 
     * @param registerId  必填 
     **/
    public static async findByRegisterId( registerId : string ) : Promise<HallResult<HopsOrderSetPreVO[]>> {
        // baseUrl=/hops/v1.0.0/order/_findByRegisterId
        // httpMethod=get
        return await http.get<any, HallResult<HopsOrderSetPreVO[]>>('/hops/v1.0.0/order/_findByRegisterId', {
            params: {  registerId            }
        })

    }
    /**
     * 预创建医嘱
     * 
     * @param arg0 
     **/
    public static async preCreate( arg0? : HopsOrderSetPreCreateCommand ) : Promise<HallResult<HopsOrderSetPreVO>> {
        // baseUrl=/hops/v1.0.0/order/_preCreate
        // httpMethod=post json 
        return await http.postJson<HopsOrderSetPreCreateCommand, HallResult<HopsOrderSetPreVO>>('/hops/v1.0.0/order/_preCreate', {
            data:  arg0
        })
    }
    /**
     * 批量预创建医嘱
     * 
     * @param arg0 
     **/
    public static async batchPreCreate( arg0? : any ) : Promise<HallResult<HopsOrderSetPreVO[]>> {
        // baseUrl=/hops/v1.0.0/order/_batchPreCreate
        // httpMethod=post json 
        return await http.postJson<any, HallResult<HopsOrderSetPreVO[]>>('/hops/v1.0.0/order/_batchPreCreate', {
            data:  arg0
        })
    }
    /**
     * 获取辅材单打印数据
     * 
     * @param submitId  必填 
     **/
    public static async loadMaterialDoc( submitId : string ) : Promise<HallResult<HopsMaterialDocVO>> {
        // baseUrl=/hops/v1.0.0/order/_loadMaterialDoc
        // httpMethod=get
        return await http.get<any, HallResult<HopsMaterialDocVO>>('/hops/v1.0.0/order/_loadMaterialDoc', {
            params: {  submitId            }
        })

    }
    /**
     * 获取治疗单打印数据
     * 
     * @param submitId  必填 
     **/
    public static async loadCureDoc( submitId : string ) : Promise<HallResult<HopsCureDocVO>> {
        // baseUrl=/hops/v1.0.0/order/_loadCureDoc
        // httpMethod=get
        return await http.get<any, HallResult<HopsCureDocVO>>('/hops/v1.0.0/order/_loadCureDoc', {
            params: {  submitId            }
        })

    }
    /**
     * 获取治疗单申请单打印数据
     * 
     * @param submitId  必填 
     **/
    public static async loadCureApplyDoc( submitId : string ) : Promise<HallResult<HopsCureApplyDocVO>> {
        // baseUrl=/hops/v1.0.0/order/_loadCureApplyDoc
        // httpMethod=get
        return await http.get<any, HallResult<HopsCureApplyDocVO>>('/hops/v1.0.0/order/_loadCureApplyDoc', {
            params: {  submitId            }
        })

    }
    /**
     * 复用医嘱单
     * 
     * @param arg0 
     **/
    public static async reuseOrderSet( arg0? : HopsOrderSetReuseCommand ) : Promise<HallResult<HopsOrderSetPreVO>> {
        // baseUrl=/hops/v1.0.0/order/_reuseOrderSet
        // httpMethod=post json 
        return await http.postJson<HopsOrderSetReuseCommand, HallResult<HopsOrderSetPreVO>>('/hops/v1.0.0/order/_reuseOrderSet', {
            data:  arg0
        })
    }
    /**
     * 保存医嘱
     * 
     * @param arg0 
     **/
    public static async save( arg0? : HopsOrderCreateCommand ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/order
        // httpMethod=post json 
        return await http.postJson<HopsOrderCreateCommand, HallResult<boolean>>('/hops/v1.0.0/order', {
            data:  arg0
        })
    }
}
/**
 * 医嘱项目Api
 **/
export class HopsOrderItemInterApi {
    /**
     * 分页查询医嘱项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsOrderItemPageParam ) : Promise<HallResult<Page<HopsOrderItemVO>>> {
        // baseUrl=/hops/v1.0.0/order/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsOrderItemVO>>>('/hops/v1.0.0/order/item/_paging', {
            params: arg0
        })

    }
    /**
     * 根据药品类型查询库房
     * 
     * @param drugType  必填 
     **/
    public static async findDispensaryByType( drugType : any ) : Promise<HallResult<HopsDispensaryVO[]>> {
        // baseUrl=/hops/v1.0.0/order/item/_findDispensaryByType
        // httpMethod=get
        return await http.get<any, HallResult<HopsDispensaryVO[]>>('/hops/v1.0.0/order/item/_findDispensaryByType', {
            params: drugType
        })

    }
}
/**
 * 门诊医嘱配发药项目Api
 **/
export class HopsDispenseItemInterApi {
    /**
     * 门诊医嘱配发药项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsDispenseItem>> {
        // baseUrl=/hops/v1.0.0/dispense/item
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsDispenseItem>>('/hops/v1.0.0/dispense/item', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊医嘱配发药项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsDispenseItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dispense/item
        // httpMethod=put json 
        return await http.putJson<TaHopsDispenseItem, HallResult<boolean>>('/hops/v1.0.0/dispense/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊医嘱配发药项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsDispenseItemPageParam ) : Promise<HallResult<Page<TaHopsDispenseItem>>> {
        // baseUrl=/hops/v1.0.0/dispense/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsDispenseItem>>>('/hops/v1.0.0/dispense/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊医嘱配发药项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dispense/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/dispense/item', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊医嘱配发药项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsDispenseItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/dispense/item
        // httpMethod=post json 
        return await http.postJson<TaHopsDispenseItem, HallResult<boolean>>('/hops/v1.0.0/dispense/item', {
            data:  arg0
        })
    }
}
/**
 * 医嘱模板Api
 **/
export class HopsOrderTemplateInterApi {
    /**
     * 移动模板
     * 
     * @param arg0 
     **/
    public static async move( arg0? : HopsOrderTemplateMoveParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/order/template/_move
        // httpMethod=put json 
        return await http.putJson<HopsOrderTemplateMoveParam, HallResult<boolean>>('/hops/v1.0.0/order/template/_move', {
            data:  arg0
        })
    }
    /**
     * 修改模板
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : HopsOrderTemplateEditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/order/template
        // httpMethod=put json 
        return await http.putJson<HopsOrderTemplateEditParam, HallResult<boolean>>('/hops/v1.0.0/order/template', {
            data:  arg0
        })
    }
    /**
     * 修改模板节点
     * 
     * @param arg0 
     **/
    public static async editNode( arg0? : HopsOrderTemplateNodeEditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/order/template/_editNode
        // httpMethod=put json 
        return await http.putJson<HopsOrderTemplateNodeEditParam, HallResult<boolean>>('/hops/v1.0.0/order/template/_editNode', {
            data:  arg0
        })
    }
    /**
     * 模板详情
     * 
     * @param id  必填 
     **/
    public static async get( id : string ) : Promise<HallResult<HopsOrderTemplateVO>> {
        // baseUrl=/hops/v1.0.0/order/template
        // httpMethod=get
        return await http.get<any, HallResult<HopsOrderTemplateVO>>('/hops/v1.0.0/order/template', {
            params: {  id            }
        })

    }
    /**
     * 删除模板
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/order/template
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/order/template', {
            params: {  id            }
        })
    }
    /**
     * 模板列表
     * 
     * @param arg0 
     **/
    public static async list( arg0? : HopsOrderTemplateSearchParam ) : Promise<HallResult<HopsOrderTemplateNodeVO[]>> {
        // baseUrl=/hops/v1.0.0/order/template/_list
        // httpMethod=get
        return await http.get<any, HallResult<HopsOrderTemplateNodeVO[]>>('/hops/v1.0.0/order/template/_list', {
            params: arg0
        })

    }
    /**
     * 保存模板
     * 
     * @param arg0 
     **/
    public static async save( arg0? : HopsOrderTemplateSaveParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/order/template
        // httpMethod=post json 
        return await http.postJson<HopsOrderTemplateSaveParam, HallResult<boolean>>('/hops/v1.0.0/order/template', {
            data:  arg0
        })
    }
}
/**
 * 执行定义与医嘱关系Api
 **/
export class HopsExeDefineOrderApi {
    /**
     * 执行定义与医嘱关系详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsExeDefineOrder>> {
        // baseUrl=/hops/v1.0.0/exe/order
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsExeDefineOrder>>('/hops/v1.0.0/exe/order', {
            params: {  id            }
        })

    }
    /**
     * 修改执行定义与医嘱关系
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsExeDefineOrder ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/order
        // httpMethod=put json 
        return await http.putJson<TaHopsExeDefineOrder, HallResult<boolean>>('/hops/v1.0.0/exe/order', {
            data:  arg0
        })
    }
    /**
     * 分页查询执行定义与医嘱关系
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsExeDefineOrderPageParam ) : Promise<HallResult<Page<TaHopsExeDefineOrder>>> {
        // baseUrl=/hops/v1.0.0/exe/order/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsExeDefineOrder>>>('/hops/v1.0.0/exe/order/_paging', {
            params: arg0
        })

    }
    /**
     * 删除执行定义与医嘱关系
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/order
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/exe/order', {
            params: {  id            }
        })
    }
    /**
     * 保存执行定义与医嘱关系
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsExeDefineOrder ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/order
        // httpMethod=post json 
        return await http.postJson<TaHopsExeDefineOrder, HallResult<boolean>>('/hops/v1.0.0/exe/order', {
            data:  arg0
        })
    }
}
/**
 * 执行实例Api
 **/
export class HopsExeInstanceApi {
    /**
     * 作废实例
     * 
     * @param id  必填 
     **/
    public static async invalid( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/instance/_invalid
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/exe/instance/_invalid', {
            params: {  id            }
        })
    }
    /**
     * 执行实例详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsExeInstance>> {
        // baseUrl=/hops/v1.0.0/exe/instance
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsExeInstance>>('/hops/v1.0.0/exe/instance', {
            params: {  id            }
        })

    }
    /**
     * 修改执行实例
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsExeInstance ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/instance
        // httpMethod=put json 
        return await http.putJson<TaHopsExeInstance, HallResult<boolean>>('/hops/v1.0.0/exe/instance', {
            data:  arg0
        })
    }
    /**
     * 分页查询执行实例
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsExeInstancePageParam ) : Promise<HallResult<Page<TaHopsExeInstance>>> {
        // baseUrl=/hops/v1.0.0/exe/instance/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsExeInstance>>>('/hops/v1.0.0/exe/instance/_paging', {
            params: arg0
        })

    }
    /**
     * 根据执行id查询执行实例列表
     * 
     * @param exeDefineId  必填 
     **/
    public static async findByExeDefineId( exeDefineId : string ) : Promise<HallResult<HopsExeInstanceVO[]>> {
        // baseUrl=/hops/v1.0.0/exe/instance/_findByExeDefineId
        // httpMethod=get
        return await http.get<any, HallResult<HopsExeInstanceVO[]>>('/hops/v1.0.0/exe/instance/_findByExeDefineId', {
            params: {  exeDefineId            }
        })

    }
    /**
     * 删除执行实例
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/instance
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/exe/instance', {
            params: {  id            }
        })
    }
    /**
     * 保存执行实例
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsExeInstance ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/instance
        // httpMethod=post json 
        return await http.postJson<TaHopsExeInstance, HallResult<boolean>>('/hops/v1.0.0/exe/instance', {
            data:  arg0
        })
    }
}
/**
 * 门诊执行定义Api
 **/
export class HopsExeDefineApi {
    /**
     * 门诊执行定义详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsExeDefine>> {
        // baseUrl=/hops/v1.0.0/exe/define
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsExeDefine>>('/hops/v1.0.0/exe/define', {
            params: {  id            }
        })

    }
    /**
     * 根据条件查询执行定义列表
     * 
     * @param arg0 
     **/
    public static async findByCondition( arg0? : HopsExeDefineSearchParam ) : Promise<HallResult<HopsExeDefineVO[]>> {
        // baseUrl=/hops/v1.0.0/exe/define/_findByCondition
        // httpMethod=get
        return await http.get<any, HallResult<HopsExeDefineVO[]>>('/hops/v1.0.0/exe/define/_findByCondition', {
            params: arg0
        })

    }
    /**
     * 修改门诊执行定义
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsExeDefine ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/define
        // httpMethod=put json 
        return await http.putJson<TaHopsExeDefine, HallResult<boolean>>('/hops/v1.0.0/exe/define', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊执行定义
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsExeDefinePageParam ) : Promise<HallResult<Page<TaHopsExeDefine>>> {
        // baseUrl=/hops/v1.0.0/exe/define/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsExeDefine>>>('/hops/v1.0.0/exe/define/_paging', {
            params: arg0
        })

    }
    /**
     * 根据id查询执行定义列表
     * 
     * @param ids  必填 
     **/
    public static async findByIds( ids : any ) : Promise<HallResult<HopsExeDefineVO[]>> {
        // baseUrl=/hops/v1.0.0/exe/define/_findByIds
        // httpMethod=get
        return await http.get<any, HallResult<HopsExeDefineVO[]>>('/hops/v1.0.0/exe/define/_findByIds', {
            params: ids
        })

    }
    /**
     * 患者执行分页查询
     * 
     * @param arg0 
     **/
    public static async patientPaging( arg0? : HopsExeDefinePatientSearchParam ) : Promise<HallResult<Page<HopsExeDefinePatientVO>>> {
        // baseUrl=/hops/v1.0.0/exe/define/_patientPaging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsExeDefinePatientVO>>>('/hops/v1.0.0/exe/define/_patientPaging', {
            params: arg0
        })

    }
    /**
     * 患者统计查询
     * 
     * @param arg0 
     **/
    public static async patientStatic( arg0? : HopsExeDefinePatientStaticParam ) : Promise<HallResult<HopsExeDefineStaticVO[]>> {
        // baseUrl=/hops/v1.0.0/exe/define/_patientStatic
        // httpMethod=get
        return await http.get<any, HallResult<HopsExeDefineStaticVO[]>>('/hops/v1.0.0/exe/define/_patientStatic', {
            params: arg0
        })

    }
    /**
     * 根据id查询辅材列表
     * 
     * @param id  必填 
     **/
    public static async findMaterialById( id : string ) : Promise<HallResult<HopsExeDefineMaterialVO[]>> {
        // baseUrl=/hops/v1.0.0/exe/define/_findMaterialById
        // httpMethod=get
        return await http.get<any, HallResult<HopsExeDefineMaterialVO[]>>('/hops/v1.0.0/exe/define/_findMaterialById', {
            params: {  id            }
        })

    }
    /**
     * 皮试签名
     * 
     * @param arg0 
     **/
    public static async skinTestSign( arg0? : HopsSkinTestParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/define/_skinTestSign
        // httpMethod=post json 
        return await http.postJson<HopsSkinTestParam, HallResult<boolean>>('/hops/v1.0.0/exe/define/_skinTestSign', {
            data:  arg0
        })
    }
    /**
     * 执行签名
     * 
     * @param arg0 
     **/
    public static async exeSign( arg0? : HopsExeSignParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/define/_exeSign
        // httpMethod=post json 
        return await http.postJson<HopsExeSignParam, HallResult<boolean>>('/hops/v1.0.0/exe/define/_exeSign', {
            data:  arg0
        })
    }
    /**
     * 删除门诊执行定义
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/define
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/exe/define', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊执行定义
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsExeDefine ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/define
        // httpMethod=post json 
        return await http.postJson<TaHopsExeDefine, HallResult<boolean>>('/hops/v1.0.0/exe/define', {
            data:  arg0
        })
    }
}
/**
 * 皮试Api
 **/
export class HopsSkinTestApi {
    /**
     * 作废皮试记录
     * 
     * @param id  必填 
     **/
    public static async invalid( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/test/_invalid
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/exe/test/_invalid', {
            params: {  id            }
        })
    }
    /**
     * 皮试详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsSkinTest>> {
        // baseUrl=/hops/v1.0.0/exe/test
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsSkinTest>>('/hops/v1.0.0/exe/test', {
            params: {  id            }
        })

    }
    /**
     * 修改皮试
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsSkinTest ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/test
        // httpMethod=put json 
        return await http.putJson<TaHopsSkinTest, HallResult<boolean>>('/hops/v1.0.0/exe/test', {
            data:  arg0
        })
    }
    /**
     * 分页查询皮试
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsSkinTestPageParam ) : Promise<HallResult<Page<TaHopsSkinTest>>> {
        // baseUrl=/hops/v1.0.0/exe/test/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsSkinTest>>>('/hops/v1.0.0/exe/test/_paging', {
            params: arg0
        })

    }
    /**
     * 根据执行id查询皮试列表
     * 
     * @param exeDefineId  必填 
     **/
    public static async findByExeDefineId( exeDefineId : string ) : Promise<HallResult<HopsSkinTestVO[]>> {
        // baseUrl=/hops/v1.0.0/exe/test/_findByExeDefineId
        // httpMethod=get
        return await http.get<any, HallResult<HopsSkinTestVO[]>>('/hops/v1.0.0/exe/test/_findByExeDefineId', {
            params: {  exeDefineId            }
        })

    }
    /**
     * 删除皮试
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/test
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/exe/test', {
            params: {  id            }
        })
    }
    /**
     * 保存皮试
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsSkinTest ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/exe/test
        // httpMethod=post json 
        return await http.postJson<TaHopsSkinTest, HallResult<boolean>>('/hops/v1.0.0/exe/test', {
            data:  arg0
        })
    }
}
/**
 * 检查申请与医嘱关联Api
 **/
export class HopsPacsApplyOrderApi {
    /**
     * 检查申请与医嘱关联详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsPacsApplyOrder>> {
        // baseUrl=/hops/v1.0.0/pacs/order
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsPacsApplyOrder>>('/hops/v1.0.0/pacs/order', {
            params: {  id            }
        })

    }
    /**
     * 修改检查申请与医嘱关联
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsPacsApplyOrder ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/order
        // httpMethod=put json 
        return await http.putJson<TaHopsPacsApplyOrder, HallResult<boolean>>('/hops/v1.0.0/pacs/order', {
            data:  arg0
        })
    }
    /**
     * 分页查询检查申请与医嘱关联
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsPacsApplyOrderPageParam ) : Promise<HallResult<Page<TaHopsPacsApplyOrder>>> {
        // baseUrl=/hops/v1.0.0/pacs/order/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsPacsApplyOrder>>>('/hops/v1.0.0/pacs/order/_paging', {
            params: arg0
        })

    }
    /**
     * 删除检查申请与医嘱关联
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/order
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/pacs/order', {
            params: {  id            }
        })
    }
    /**
     * 保存检查申请与医嘱关联
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsPacsApplyOrder ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/order
        // httpMethod=post json 
        return await http.postJson<TaHopsPacsApplyOrder, HallResult<boolean>>('/hops/v1.0.0/pacs/order', {
            data:  arg0
        })
    }
}
/**
 * 门诊检查申请项目Api
 **/
export class HopsPacsApplyItemApi {
    /**
     * 门诊检查申请项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<HopsPacsApplyItemVO>> {
        // baseUrl=/hops/v1.0.0/pacs/apply/item
        // httpMethod=get
        return await http.get<any, HallResult<HopsPacsApplyItemVO>>('/hops/v1.0.0/pacs/apply/item', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊检查申请项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsPacsApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/apply/item
        // httpMethod=put json 
        return await http.putJson<TaHopsPacsApplyItem, HallResult<boolean>>('/hops/v1.0.0/pacs/apply/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊检查申请项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsPacsApplyItemPageParam ) : Promise<HallResult<Page<HopsPacsApplyItemVO>>> {
        // baseUrl=/hops/v1.0.0/pacs/apply/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsPacsApplyItemVO>>>('/hops/v1.0.0/pacs/apply/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除门诊检查申请项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/apply/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/pacs/apply/item', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊检查申请项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsPacsApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/apply/item
        // httpMethod=post json 
        return await http.postJson<TaHopsPacsApplyItem, HallResult<boolean>>('/hops/v1.0.0/pacs/apply/item', {
            data:  arg0
        })
    }
}
/**
 * 门诊检查申请Api
 **/
export class HopsPacsApplyApi {
    /**
     * 门诊检查申请详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsPacsApply>> {
        // baseUrl=/hops/v1.0.0/pacs/apply
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsPacsApply>>('/hops/v1.0.0/pacs/apply', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊检查申请
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsPacsApply ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/apply
        // httpMethod=put json 
        return await http.putJson<TaHopsPacsApply, HallResult<boolean>>('/hops/v1.0.0/pacs/apply', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊检查申请
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsPacsApplyPageParam ) : Promise<HallResult<Page<TaHopsPacsApply>>> {
        // baseUrl=/hops/v1.0.0/pacs/apply/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsPacsApply>>>('/hops/v1.0.0/pacs/apply/_paging', {
            params: arg0
        })

    }
    /**
     * 获取检查申请单
     * 
     * @param applyId  必填 
     **/
    public static async loadPacsApplyDoc( applyId : string ) : Promise<HallResult<HopsPacsApplyDocVO>> {
        // baseUrl=/hops/v1.0.0/pacs/apply/_loadPacsApplyDoc
        // httpMethod=get
        return await http.get<any, HallResult<HopsPacsApplyDocVO>>('/hops/v1.0.0/pacs/apply/_loadPacsApplyDoc', {
            params: {  applyId            }
        })

    }
    /**
     * 删除门诊检查申请
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/apply
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/pacs/apply', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊检查申请
     * 
     * @param arg0 
     **/
    public static async save( arg0? : HopsPacsApplyCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/apply
        // httpMethod=post json 
        return await http.postJson<HopsPacsApplyCreateParam, HallResult<boolean>>('/hops/v1.0.0/pacs/apply', {
            data:  arg0
        })
    }
}
/**
 * 门诊检查报告Api
 **/
export class HopsPacsReportApi {
    /**
     * 门诊检查报告详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaHopsPacsReport>> {
        // baseUrl=/hops/v1.0.0/pacs/report
        // httpMethod=get
        return await http.get<any, HallResult<TaHopsPacsReport>>('/hops/v1.0.0/pacs/report', {
            params: {  id            }
        })

    }
    /**
     * 修改门诊检查报告
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHopsPacsReport ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/report
        // httpMethod=put json 
        return await http.putJson<TaHopsPacsReport, HallResult<boolean>>('/hops/v1.0.0/pacs/report', {
            data:  arg0
        })
    }
    /**
     * 分页查询门诊检查报告
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HopsPacsReportPageParam ) : Promise<HallResult<Page<TaHopsPacsReport>>> {
        // baseUrl=/hops/v1.0.0/pacs/report/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHopsPacsReport>>>('/hops/v1.0.0/pacs/report/_paging', {
            params: arg0
        })

    }
    /**
     * 根据项目id查询检查结果
     * 
     * @param applyItemId  必填 
     **/
    public static async getByItemId( applyItemId : string ) : Promise<HallResult<HopsPacsReportVO>> {
        // baseUrl=/hops/v1.0.0/pacs/report/_getByItemId
        // httpMethod=get
        return await http.get<any, HallResult<HopsPacsReportVO>>('/hops/v1.0.0/pacs/report/_getByItemId', {
            params: {  applyItemId            }
        })

    }
    /**
     * 删除门诊检查报告
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/report
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/hops/v1.0.0/pacs/report', {
            params: {  id            }
        })
    }
    /**
     * 保存门诊检查报告
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHopsPacsReport ) : Promise<HallResult<boolean>> {
        // baseUrl=/hops/v1.0.0/pacs/report
        // httpMethod=post json 
        return await http.postJson<TaHopsPacsReport, HallResult<boolean>>('/hops/v1.0.0/pacs/report', {
            data:  arg0
        })
    }
}
/**
 * 文件Api
 **/
export class FileItemApi {
    /**
     * 文件详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaFileItem>> {
        // baseUrl=/file/v1.0.0/item
        // httpMethod=get
        return await http.get<any, HallResult<TaFileItem>>('/file/v1.0.0/item', {
            params: {  id            }
        })

    }
    /**
     * 下载文件
     * 
     * @param id  必填 
     **/
    public static async downLoad( id : string ) : Promise<any> {
        // baseUrl=/file/v1.0.0/item/_downLoad
        // httpMethod=get
        return await http.get<any, any>('/file/v1.0.0/item/_downLoad', {
            params: {  id            }
        })

    }
    /**
     * 上传文件
     * 
     * @param file  必填 
     **/
    public static async upload( file : any ) : Promise<HallResult<FileUploadVO>> {
        // baseUrl=/file/v1.0.0/item/_upload
        // httpMethod=post
        return await http.post<any, HallResult<FileUploadVO>>('/file/v1.0.0/item/_upload', {
            params: {  file            }
    })
    }
    /**
     * 分页查询文件
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : FileItemPageParam ) : Promise<HallResult<Page<TaFileItem>>> {
        // baseUrl=/file/v1.0.0/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaFileItem>>>('/file/v1.0.0/item/_paging', {
            params: arg0
        })

    }
    /**
     * 上传DICOM文件
     * 
     * @param file  必填 
     **/
    public static async uploadDicom( file : any ) : Promise<HallResult<FileUploadVO>> {
        // baseUrl=/file/v1.0.0/item/_uploadDicom
        // httpMethod=post
        return await http.post<any, HallResult<FileUploadVO>>('/file/v1.0.0/item/_uploadDicom', {
            params: {  file            }
    })
    }
}
/**
 * excelApi
 **/
export class HallTemplateApi {
    /**
     * 模板下载
     * 
     * @param type  必填 
     * @param arg1 
     **/
    public static async download( type : string , arg1? : string ) : Promise<any> {
        // baseUrl=/excel/v1.0.0/base/template/_download
        // httpMethod=get
        return await http.get<any, any>('/excel/v1.0.0/base/template/_download', {
            params: {  type, arg1            }
        })

    }
    /**
     * 根据业务获取模板信息
     * 
     * @param type  必填 
     **/
    public static async getTemplate( type : string ) : Promise<HallResult<ExcelTemplateVO>> {
        // baseUrl=/excel/v1.0.0/base/template
        // httpMethod=get
        return await http.get<any, HallResult<ExcelTemplateVO>>('/excel/v1.0.0/base/template', {
            params: {  type            }
        })

    }
}
/**
 * 患者动态记录Api
 **/
export class HisPatientDynamicRecordsApi {
    /**
     * 分页查询患者动态记录
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HisPatientDynamicRecordsPageParam ) : Promise<HallResult<Page<HisPatientDynamicRecordsPageVO>>> {
        // baseUrl=/patient/v1.0.0/dynamic/records/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HisPatientDynamicRecordsPageVO>>>('/patient/v1.0.0/dynamic/records/_paging', {
            params: arg0
        })

    }
}
/**
 * 患者过敏史Api
 **/
export class HisAllergyHistoryApi {
    /**
     * 检查患者药品过敏信息
     * 
     * @param arg0 
     **/
    public static async checkDrug( arg0? : PatientDrugAllergyCheckParam ) : Promise<HallResult<PatientDrugCheckResultVO>> {
        // baseUrl=/patient/v1.0.0/allergy/history/_checkDrug
        // httpMethod=post json 
        return await http.postJson<PatientDrugAllergyCheckParam, HallResult<PatientDrugCheckResultVO>>('/patient/v1.0.0/allergy/history/_checkDrug', {
            data:  arg0
        })
    }
    /**
     * 分页查询患者过敏历史信息
     * 
     * @param arg0 
     **/
    public static async pagingPatientAllergyHistory( arg0? : PatientAllergyHistorySearchPageParam ) : Promise<HallResult<Page<AllergyHistoryItemVO>>> {
        // baseUrl=/patient/v1.0.0/allergy/history/_pagingPatientAllergyHistory
        // httpMethod=get
        return await http.get<any, HallResult<Page<AllergyHistoryItemVO>>>('/patient/v1.0.0/allergy/history/_pagingPatientAllergyHistory', {
            params: arg0
        })

    }
    /**
     * 检查患者药品过敏信息
     * 
     * @param arg0 
     **/
    public static async checkDrugs( arg0? : any ) : Promise<HallResult<PatientDrugCheckResultVO[]>> {
        // baseUrl=/patient/v1.0.0/allergy/history/_checkDrugs
        // httpMethod=post json 
        return await http.postJson<any, HallResult<PatientDrugCheckResultVO[]>>('/patient/v1.0.0/allergy/history/_checkDrugs', {
            data:  arg0
        })
    }
    /**
     * 获取患者的过敏信息
     * 
     * @param patientId  必填 
     **/
    public static async findAllergyHistorys( patientId : string ) : Promise<HallResult<PatientAllergyHistoryVO[]>> {
        // baseUrl=/patient/v1.0.0/allergy/history/_findAllergyHistorys
        // httpMethod=get
        return await http.get<any, HallResult<PatientAllergyHistoryVO[]>>('/patient/v1.0.0/allergy/history/_findAllergyHistorys', {
            params: {  patientId            }
        })

    }
}
/**
 * 过敏源(药品-非药品)Api
 **/
export class HisAllergyItemApi {
    /**
     * 过敏源（药品-非药品）搜索
     * 
     * @param keyword 
     **/
    public static async search( keyword? : string ) : Promise<HallResult<AllergyItemSearchResultVO>> {
        // baseUrl=/patient/v1.0.0/allergy/item/_search
        // httpMethod=get
        return await http.get<any, HallResult<AllergyItemSearchResultVO>>('/patient/v1.0.0/allergy/item/_search', {
            params: {  keyword            }
        })

    }
}
/**
 * 非药品过敏项Api
 **/
export class HisAllergyNondrugApi {
    /**
     * 保存非药品过敏项
     * 
     * @param arg0 
     **/
    public static async save( arg0? : HisAllergyNondrugSaveParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/patient/v1.0.0/allergy/nondrug
        // httpMethod=post json 
        return await http.postJson<HisAllergyNondrugSaveParam, HallResult<boolean>>('/patient/v1.0.0/allergy/nondrug', {
            data:  arg0
        })
    }
}
/**
 * 患者Api
 **/
export class HisPatientApi {
    /**
     * 患者详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<HisPatientDto>> {
        // baseUrl=/patient/v1.0.0/patient
        // httpMethod=get
        return await http.get<any, HallResult<HisPatientDto>>('/patient/v1.0.0/patient', {
            params: {  id            }
        })

    }
    /**
     * 修改患者
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaHisPatient ) : Promise<HallResult<boolean>> {
        // baseUrl=/patient/v1.0.0/patient
        // httpMethod=put json 
        return await http.putJson<TaHisPatient, HallResult<boolean>>('/patient/v1.0.0/patient', {
            data:  arg0
        })
    }
    /**
     * 分页查询患者
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HisPatientPageParam ) : Promise<HallResult<Page<HisPatientDto>>> {
        // baseUrl=/patient/v1.0.0/patient/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<HisPatientDto>>>('/patient/v1.0.0/patient/_paging', {
            params: arg0
        })

    }
    /**
     * 删除患者
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/patient/v1.0.0/patient
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/patient/v1.0.0/patient', {
            params: {  id            }
        })
    }
    /**
     * 保存患者
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaHisPatient ) : Promise<HallResult<string>> {
        // baseUrl=/patient/v1.0.0/patient
        // httpMethod=post json 
        return await http.postJson<TaHisPatient, HallResult<string>>('/patient/v1.0.0/patient', {
            data:  arg0
        })
    }
}
/**
 * 患者追溯信息Api
 **/
export class HisPatientTraceApi {
    /**
     * 分页查询患者追溯信息
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : HisPatientTracePageParam ) : Promise<HallResult<Page<TaHisPatientTrace>>> {
        // baseUrl=/patient/v1.0.0/trace/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaHisPatientTrace>>>('/patient/v1.0.0/trace/_paging', {
            params: arg0
        })

    }
}
/**
 * 天津城乡居民门诊支付时间Api
 **/
export class TjCxjmHopsTimeApi {
    /**
     * 获取所有天津城乡居民门诊支付时间段
     * 
     **/
    public static async allTimes() : Promise<HallResult<TjCxjmHopsTimeVO[]>> {
        // baseUrl=/fee/v1.0.0/tj/cxjm/hops/time/allTimes
        // httpMethod=get
        return await http.get<any, HallResult<TjCxjmHopsTimeVO[]>>('/fee/v1.0.0/tj/cxjm/hops/time/allTimes', {
            params: {             }
        })

    }
}
/**
 * 天津医保Api
 **/
export class TJMedinsApi {
    /**
     * 记录交易结算信息
     * 
     * @param arg0 
     **/
    public static async settlement( arg0? : TJMedinsSettlementParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/medins/tj/_settlement
        // httpMethod=post json 
        return await http.postJson<TJMedinsSettlementParam, HallResult<boolean>>('/fee/v1.0.0/medins/tj/_settlement', {
            data:  arg0
        })
    }
    /**
     * 批量记录项目费用分割
     * 
     * @param arg0 
     **/
    public static async batchFeeSplit( arg0? : TJMedinsBatchItemSplitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/medins/tj/_batchFeeSplit
        // httpMethod=post json 
        return await http.postJson<TJMedinsBatchItemSplitParam, HallResult<boolean>>('/fee/v1.0.0/medins/tj/_batchFeeSplit', {
            data:  arg0
        })
    }
    /**
     * 医保支付取消
     * 
     * @param arg0 
     **/
    public static async payCancel( arg0? : TJMedinsPayCancelParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/medins/tj/_payCancel
        // httpMethod=post json 
        return await http.postJson<TJMedinsPayCancelParam, HallResult<boolean>>('/fee/v1.0.0/medins/tj/_payCancel', {
            data:  arg0
        })
    }
    /**
     * 记录刷卡信息
     * 
     * @param arg0 
     **/
    public static async swipe( arg0? : TJMedinsCardParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/medins/tj/_swipe
        // httpMethod=post json 
        return await http.postJson<TJMedinsCardParam, HallResult<boolean>>('/fee/v1.0.0/medins/tj/_swipe', {
            data:  arg0
        })
    }
    /**
     * 记录退费交易结算信息
     * 
     * @param arg0 
     **/
    public static async refundSettlement( arg0? : TJMedinsSettlementParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/medins/tj/_refundSettlement
        // httpMethod=post json 
        return await http.postJson<TJMedinsSettlementParam, HallResult<boolean>>('/fee/v1.0.0/medins/tj/_refundSettlement', {
            data:  arg0
        })
    }
    /**
     * 对账
     * 
     * @param arg0 
     **/
    public static async reconciliation( arg0? : TJMedinsReconciliationParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/medins/tj/_reconciliation
        // httpMethod=post json 
        return await http.postJson<TJMedinsReconciliationParam, HallResult<boolean>>('/fee/v1.0.0/medins/tj/_reconciliation', {
            data:  arg0
        })
    }
    /**
     * 待支付的退款请求列表
     * 
     **/
    public static async listRefundPays() : Promise<HallResult<TJMedinsRefundVO[]>> {
        // baseUrl=/fee/v1.0.0/medins/tj/_listRefundPays
        // httpMethod=post
        return await http.post<any, HallResult<TJMedinsRefundVO[]>>('/fee/v1.0.0/medins/tj/_listRefundPays', {
            params: {             }
    })
    }
}
/**
 * 发票Api
 **/
export class FeeInvoiceApi {
    /**
     * 发票发放
     * 
     * @param arg0 
     **/
    public static async distribute( arg0? : FeeInvoiceDistributeParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/invoice/_distribute
        // httpMethod=post json 
        return await http.postJson<FeeInvoiceDistributeParam, HallResult<boolean>>('/fee/v1.0.0/invoice/_distribute', {
            data:  arg0
        })
    }
    /**
     * 发票作废
     * 
     * @param arg0 
     **/
    public static async invalid( arg0? : FeeInvoiceInvalidParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/invoice/_invalid
        // httpMethod=post json 
        return await http.postJson<FeeInvoiceInvalidParam, HallResult<boolean>>('/fee/v1.0.0/invoice/_invalid', {
            data:  arg0
        })
    }
    /**
     * 分页查询发票
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : FeeInvoicePageParam ) : Promise<HallResult<Page<FeeInvoiceVO>>> {
        // baseUrl=/fee/v1.0.0/invoice/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<FeeInvoiceVO>>>('/fee/v1.0.0/invoice/_paging', {
            params: arg0
        })

    }
    /**
     * 查询当前用户可用发票列表
     * 
     **/
    public static async findByCurrentUser() : Promise<HallResult<FeeInvoiceVO[]>> {
        // baseUrl=/fee/v1.0.0/invoice/_findByCurrentUser
        // httpMethod=get
        return await http.get<any, HallResult<FeeInvoiceVO[]>>('/fee/v1.0.0/invoice/_findByCurrentUser', {
            params: {             }
        })

    }
    /**
     * 发票初始化
     * 
     * @param arg0 
     **/
    public static async init( arg0? : FeeInvoiceInitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/invoice/_init
        // httpMethod=post json 
        return await http.postJson<FeeInvoiceInitParam, HallResult<boolean>>('/fee/v1.0.0/invoice/_init', {
            data:  arg0
        })
    }
}
/**
 * 天津城乡居民门诊支付统计Api
 **/
export class TjCxjmHopsPayStatisticsApi {
    /**
     * 天津城乡居民门诊支付统计
     * 
     * @param batchNo  必填 
     **/
    public static async index( batchNo : string ) : Promise<HallResult<TjCxjmHopsPayStatisticsItemVO[]>> {
        // baseUrl=/fee/v1.0.0/tj/cxjm/hops/statistics
        // httpMethod=get
        return await http.get<any, HallResult<TjCxjmHopsPayStatisticsItemVO[]>>('/fee/v1.0.0/tj/cxjm/hops/statistics', {
            params: {  batchNo            }
        })

    }
}
/**
 * 费用报表Api
 **/
export class FeeReportApi {
    /**
     * 门诊费用明细
     * 
     * @param arg0 
     **/
    public static async reportHopsFeeDetail( arg0? : HopsFeeDetailPageParam ) : Promise<HallResult<Page<HopsFeeDetailVO>>> {
        // baseUrl=/fee/v1.0.0/report/_reportHopsFeeDetail
        // httpMethod=get
        return await http.get<any, HallResult<Page<HopsFeeDetailVO>>>('/fee/v1.0.0/report/_reportHopsFeeDetail', {
            params: arg0
        })

    }
}
/**
 * 费用数据Api
 **/
export class FeeDataApi {
    /**
     * 更新费用人员快照信息
     * 
     **/
    public static async updatePersonSnapshotData() : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/data/_updatePersonSnapshotData
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/fee/v1.0.0/data/_updatePersonSnapshotData', {
            params: {             }
        })
    }
    /**
     * 更新费用项目快照信息
     * 
     **/
    public static async updateFeeItemSnapshotData() : Promise<HallResult<boolean>> {
        // baseUrl=/fee/v1.0.0/data/_updateFeeItemSnapshotData
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/fee/v1.0.0/data/_updateFeeItemSnapshotData', {
            params: {             }
        })
    }
}
/**
 * 检验项目Api
 **/
export class LisBaseItemApi {
    /**
     * 检验项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaLisBaseItem>> {
        // baseUrl=/lis/v1.0.0/base/item
        // httpMethod=get
        return await http.get<any, HallResult<TaLisBaseItem>>('/lis/v1.0.0/base/item', {
            params: {  id            }
        })

    }
    /**
     * 修改检验项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaLisBaseItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/base/item
        // httpMethod=put json 
        return await http.putJson<TaLisBaseItem, HallResult<boolean>>('/lis/v1.0.0/base/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询检验项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : LisBaseItemPageParam ) : Promise<HallResult<Page<TaLisBaseItem>>> {
        // baseUrl=/lis/v1.0.0/base/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaLisBaseItem>>>('/lis/v1.0.0/base/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除检验项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/base/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/lis/v1.0.0/base/item', {
            params: {  id            }
        })
    }
    /**
     * 保存检验项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaLisBaseItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/base/item
        // httpMethod=post json 
        return await http.postJson<TaLisBaseItem, HallResult<boolean>>('/lis/v1.0.0/base/item', {
            data:  arg0
        })
    }
}
/**
 * 检验项目子项目Api
 **/
export class LisBaseSubItemApi {
    /**
     * 检验项目子项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaLisBaseSubItem>> {
        // baseUrl=/lis/v1.0.0/base/sub/item
        // httpMethod=get
        return await http.get<any, HallResult<TaLisBaseSubItem>>('/lis/v1.0.0/base/sub/item', {
            params: {  id            }
        })

    }
    /**
     * 修改检验项目子项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaLisBaseSubItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/base/sub/item
        // httpMethod=put json 
        return await http.putJson<TaLisBaseSubItem, HallResult<boolean>>('/lis/v1.0.0/base/sub/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询检验项目子项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : LisBaseSubItemPageParam ) : Promise<HallResult<Page<TaLisBaseSubItem>>> {
        // baseUrl=/lis/v1.0.0/base/sub/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaLisBaseSubItem>>>('/lis/v1.0.0/base/sub/item/_paging', {
            params: arg0
        })

    }
    /**
     * 
     * 
     * @param itemId  必填 
     **/
    public static async findByItemId( itemId : string ) : Promise<HallResult<TaLisBaseSubItem[]>> {
        // baseUrl=/lis/v1.0.0/base/sub/item/findByItemId
        // httpMethod=get
        return await http.get<any, HallResult<TaLisBaseSubItem[]>>('/lis/v1.0.0/base/sub/item/findByItemId', {
            params: {  itemId            }
        })

    }
    /**
     * 删除检验项目子项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/base/sub/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/lis/v1.0.0/base/sub/item', {
            params: {  id            }
        })
    }
    /**
     * 保存检验项目子项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaLisBaseSubItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/base/sub/item
        // httpMethod=post json 
        return await http.postJson<TaLisBaseSubItem, HallResult<boolean>>('/lis/v1.0.0/base/sub/item', {
            data:  arg0
        })
    }
}
/**
 * 检验结果Api
 **/
export class LisResultApi {
    /**
     * 检验结果详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaLisResult>> {
        // baseUrl=/lis/v1.0.0/result
        // httpMethod=get
        return await http.get<any, HallResult<TaLisResult>>('/lis/v1.0.0/result', {
            params: {  id            }
        })

    }
    /**
     * 结果比对
     * 
     * @param arg0 
     **/
    public static async contrast( arg0? : LisApplyResultContrastParam ) : Promise<HallResult<LisApplyResultContrastVO>> {
        // baseUrl=/lis/v1.0.0/result/_contrast
        // httpMethod=get
        return await http.get<any, HallResult<LisApplyResultContrastVO>>('/lis/v1.0.0/result/_contrast', {
            params: arg0
        })

    }
    /**
     * 修改检验结果
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaLisResult ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/result
        // httpMethod=put json 
        return await http.putJson<TaLisResult, HallResult<boolean>>('/lis/v1.0.0/result', {
            data:  arg0
        })
    }
    /**
     * 分页查询检验结果
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : LisResultPageParam ) : Promise<HallResult<Page<TaLisResult>>> {
        // baseUrl=/lis/v1.0.0/result/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaLisResult>>>('/lis/v1.0.0/result/_paging', {
            params: arg0
        })

    }
    /**
     * 根据检验申请子项目id查询列表
     * 
     * @param applyItemId  必填 
     **/
    public static async findByApplyItemId( applyItemId : string ) : Promise<HallResult<TaLisResult[]>> {
        // baseUrl=/lis/v1.0.0/result/_findByApplyItemId
        // httpMethod=get
        return await http.get<any, HallResult<TaLisResult[]>>('/lis/v1.0.0/result/_findByApplyItemId', {
            params: {  applyItemId            }
        })

    }
    /**
     * 删除检验结果
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/result
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/lis/v1.0.0/result', {
            params: {  id            }
        })
    }
    /**
     * 保存检验结果
     * 
     * @param arg0 
     **/
    public static async save( arg0? : LisResultCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/result
        // httpMethod=post json 
        return await http.postJson<LisResultCreateParam, HallResult<boolean>>('/lis/v1.0.0/result', {
            data:  arg0
        })
    }
}
/**
 * 检验申请项目Api
 **/
export class LisApplyItemApi {
    /**
     * 检查申请项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<LisApplyAndItemDetailVO>> {
        // baseUrl=/lis/v1.0.0/apply/item
        // httpMethod=get
        return await http.get<any, HallResult<LisApplyAndItemDetailVO>>('/lis/v1.0.0/apply/item', {
            params: {  id            }
        })

    }
    /**
     * 修改检查申请项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaLisApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/apply/item
        // httpMethod=put json 
        return await http.putJson<TaLisApplyItem, HallResult<boolean>>('/lis/v1.0.0/apply/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询检查申请项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : LisApplyItemPageParam ) : Promise<HallResult<Page<LisApplyItemPageVO>>> {
        // baseUrl=/lis/v1.0.0/apply/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<LisApplyItemPageVO>>>('/lis/v1.0.0/apply/item/_paging', {
            params: arg0
        })

    }
    /**
     * 根据状态统计
     * 
     * @param arg0 
     **/
    public static async countByStatus( arg0? : LisApplyItemPageParam ) : Promise<HallResult<LisApplyItemCountByStatusDTO[]>> {
        // baseUrl=/lis/v1.0.0/apply/item/_countByStatus
        // httpMethod=get
        return await http.get<any, HallResult<LisApplyItemCountByStatusDTO[]>>('/lis/v1.0.0/apply/item/_countByStatus', {
            params: arg0
        })

    }
    /**
     * 批量审核
     * 
     * @param arg0 
     **/
    public static async batchAudit( arg0? : LisApplyItemAuditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/apply/item/_batchAudit
        // httpMethod=post json 
        return await http.postJson<LisApplyItemAuditParam, HallResult<boolean>>('/lis/v1.0.0/apply/item/_batchAudit', {
            data:  arg0
        })
    }
    /**
     * 删除检查申请项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/apply/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/lis/v1.0.0/apply/item', {
            params: {  id            }
        })
    }
    /**
     * 保存检查申请项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaLisApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/apply/item
        // httpMethod=post json 
        return await http.postJson<TaLisApplyItem, HallResult<boolean>>('/lis/v1.0.0/apply/item', {
            data:  arg0
        })
    }
}
/**
 * 检验申请Api
 **/
export class LisApplyApi {
    /**
     * 检验申请详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaLisApply>> {
        // baseUrl=/lis/v1.0.0/apply
        // httpMethod=get
        return await http.get<any, HallResult<TaLisApply>>('/lis/v1.0.0/apply', {
            params: {  id            }
        })

    }
    /**
     * 修改检验申请
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaLisApply ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/apply
        // httpMethod=put json 
        return await http.putJson<TaLisApply, HallResult<boolean>>('/lis/v1.0.0/apply', {
            data:  arg0
        })
    }
    /**
     * 分页查询检验申请
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : LisApplyPageParam ) : Promise<HallResult<Page<TaLisApply>>> {
        // baseUrl=/lis/v1.0.0/apply/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaLisApply>>>('/lis/v1.0.0/apply/_paging', {
            params: arg0
        })

    }
    /**
     * 删除检验申请
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/apply
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/lis/v1.0.0/apply', {
            params: {  id            }
        })
    }
    /**
     * 保存检验申请
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaLisApply ) : Promise<HallResult<boolean>> {
        // baseUrl=/lis/v1.0.0/apply
        // httpMethod=post json 
        return await http.postJson<TaLisApply, HallResult<boolean>>('/lis/v1.0.0/apply', {
            data:  arg0
        })
    }
}
/**
 * PACS会诊Api
 **/
export class PacsConsultationApi {
    /**
     * 取消会诊
     * 
     * @param id  必填 
     **/
    public static async cancel( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/consultation/_cancel
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/pacs/v1.0.0/consultation/_cancel', {
            params: {  id            }
        })
    }
    /**
     * 获取详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaPacsConsultation>> {
        // baseUrl=/pacs/v1.0.0/consultation
        // httpMethod=get
        return await http.get<any, HallResult<TaPacsConsultation>>('/pacs/v1.0.0/consultation', {
            params: {  id            }
        })

    }
    /**
     * 修改
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaPacsConsultation ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/consultation
        // httpMethod=put json 
        return await http.putJson<TaPacsConsultation, HallResult<boolean>>('/pacs/v1.0.0/consultation', {
            data:  arg0
        })
    }
    /**
     * 查询发起的会诊信息
     * 
     * @param applyItemId  必填 
     **/
    public static async findSrcVOS( applyItemId : string ) : Promise<HallResult<PacsConsultationForSrcVO[]>> {
        // baseUrl=/pacs/v1.0.0/consultation/_findSrcVOS
        // httpMethod=get
        return await http.get<any, HallResult<PacsConsultationForSrcVO[]>>('/pacs/v1.0.0/consultation/_findSrcVOS', {
            params: {  applyItemId            }
        })

    }
    /**
     * 分页查询受邀人的会诊信息
     * 
     * @param arg0 
     **/
    public static async pagingForTarget( arg0? : PacsConsultationForTargetPageParam ) : Promise<HallResult<Page<PacsConsultationForTargetVO>>> {
        // baseUrl=/pacs/v1.0.0/consultation/_pagingForTarget
        // httpMethod=get
        return await http.get<any, HallResult<Page<PacsConsultationForTargetVO>>>('/pacs/v1.0.0/consultation/_pagingForTarget', {
            params: arg0
        })

    }
    /**
     * 提交会诊建议
     * 
     * @param arg0 
     **/
    public static async doctorAdvice( arg0? : PacsConsultationAdviceParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/consultation/_doctorAdvice
        // httpMethod=put json 
        return await http.putJson<PacsConsultationAdviceParam, HallResult<boolean>>('/pacs/v1.0.0/consultation/_doctorAdvice', {
            data:  arg0
        })
    }
    /**
     * 获取会诊详情for受邀请人
     * 
     * @param id  必填 
     **/
    public static async detailForTarget( id : string ) : Promise<HallResult<PacsConsultationForTargetVO>> {
        // baseUrl=/pacs/v1.0.0/consultation/_detailForTarget
        // httpMethod=get
        return await http.get<any, HallResult<PacsConsultationForTargetVO>>('/pacs/v1.0.0/consultation/_detailForTarget', {
            params: {  id            }
        })

    }
    /**
     * 查询会诊科室
     * 
     **/
    public static async findConsultationOrg() : Promise<HallResult<ConsultationOrgNodeVO[]>> {
        // baseUrl=/pacs/v1.0.0/consultation/_findConsultationOrg
        // httpMethod=get
        return await http.get<any, HallResult<ConsultationOrgNodeVO[]>>('/pacs/v1.0.0/consultation/_findConsultationOrg', {
            params: {             }
        })

    }
    /**
     * 根据科室ID查询会诊医生
     * 
     * @param orgId 科室ID 必填 
     **/
    public static async findConsultationDoctors( orgId : string ) : Promise<HallResult<ConsultationDoctorVO[]>> {
        // baseUrl=/pacs/v1.0.0/consultation/_findConsultationDoctors
        // httpMethod=get
        return await http.get<any, HallResult<ConsultationDoctorVO[]>>('/pacs/v1.0.0/consultation/_findConsultationDoctors', {
            params: {  orgId            }
        })

    }
    /**
     * 申请会诊
     * 
     * @param arg0 
     **/
    public static async apply( arg0? : PacsConsultationApplyParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/consultation/_apply
        // httpMethod=post json 
        return await http.postJson<PacsConsultationApplyParam, HallResult<boolean>>('/pacs/v1.0.0/consultation/_apply', {
            data:  arg0
        })
    }
}
/**
 * 报告模板Api
 **/
export class PacsBaseReportTemplateApi {
    /**
     * 报告模板详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaPacsBaseReportTemplate>> {
        // baseUrl=/pacs/v1.0.0/base/report/template
        // httpMethod=get
        return await http.get<any, HallResult<TaPacsBaseReportTemplate>>('/pacs/v1.0.0/base/report/template', {
            params: {  id            }
        })

    }
    /**
     * 修改报告模板
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaPacsBaseReportTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/base/report/template
        // httpMethod=put json 
        return await http.putJson<TaPacsBaseReportTemplate, HallResult<boolean>>('/pacs/v1.0.0/base/report/template', {
            data:  arg0
        })
    }
    /**
     * 分页查询报告模板
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : PacsBaseReportTemplatePageParam ) : Promise<HallResult<Page<PacsBaseReportTemplatePageVO>>> {
        // baseUrl=/pacs/v1.0.0/base/report/template/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<PacsBaseReportTemplatePageVO>>>('/pacs/v1.0.0/base/report/template/_paging', {
            params: arg0
        })

    }
    /**
     * 删除报告模板
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/base/report/template
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/pacs/v1.0.0/base/report/template', {
            params: {  id            }
        })
    }
    /**
     * 保存报告模板
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaPacsBaseReportTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/base/report/template
        // httpMethod=post json 
        return await http.postJson<TaPacsBaseReportTemplate, HallResult<boolean>>('/pacs/v1.0.0/base/report/template', {
            data:  arg0
        })
    }
}
/**
 * dicom浏览器Api
 **/
export class PacsDicomViewerApi {
    /**
     * dicom浏览器详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaPacsDicomViewer>> {
        // baseUrl=/pacs/v1.0.0/viewer
        // httpMethod=get
        return await http.get<any, HallResult<TaPacsDicomViewer>>('/pacs/v1.0.0/viewer', {
            params: {  id            }
        })

    }
    /**
     * 修改dicom浏览器
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaPacsDicomViewer ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/viewer
        // httpMethod=put json 
        return await http.putJson<TaPacsDicomViewer, HallResult<boolean>>('/pacs/v1.0.0/viewer', {
            data:  arg0
        })
    }
    /**
     * 分页查询dicom浏览器
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : PacsDicomViewerPageParam ) : Promise<HallResult<Page<TaPacsDicomViewer>>> {
        // baseUrl=/pacs/v1.0.0/viewer/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaPacsDicomViewer>>>('/pacs/v1.0.0/viewer/_paging', {
            params: arg0
        })

    }
    /**
     * 删除dicom浏览器
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/viewer
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/pacs/v1.0.0/viewer', {
            params: {  id            }
        })
    }
    /**
     * 保存dicom浏览器
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaPacsDicomViewer ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/viewer
        // httpMethod=post json 
        return await http.postJson<TaPacsDicomViewer, HallResult<boolean>>('/pacs/v1.0.0/viewer', {
            data:  arg0
        })
    }
}
/**
 * 检查申请Api
 **/
export class PacsApplyApi {
    /**
     * 检查申请详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaPacsApply>> {
        // baseUrl=/pacs/v1.0.0/apply
        // httpMethod=get
        return await http.get<any, HallResult<TaPacsApply>>('/pacs/v1.0.0/apply', {
            params: {  id            }
        })

    }
    /**
     * 修改检查申请
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaPacsApply ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/apply
        // httpMethod=put json 
        return await http.putJson<TaPacsApply, HallResult<boolean>>('/pacs/v1.0.0/apply', {
            data:  arg0
        })
    }
    /**
     * 分页查询检查申请
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : PacsApplyPageParam ) : Promise<HallResult<Page<TaPacsApply>>> {
        // baseUrl=/pacs/v1.0.0/apply/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaPacsApply>>>('/pacs/v1.0.0/apply/_paging', {
            params: arg0
        })

    }
    /**
     * 删除检查申请
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/apply
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/pacs/v1.0.0/apply', {
            params: {  id            }
        })
    }
    /**
     * 保存检查申请
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaPacsApply ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/apply
        // httpMethod=post json 
        return await http.postJson<TaPacsApply, HallResult<boolean>>('/pacs/v1.0.0/apply', {
            data:  arg0
        })
    }
}
/**
 * 检查申请项目Api
 **/
export class PacsApplyItemApi {
    /**
     * 检查申请项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<PacsApplyAndItemDetailVO>> {
        // baseUrl=/pacs/v1.0.0/apply/item
        // httpMethod=get
        return await http.get<any, HallResult<PacsApplyAndItemDetailVO>>('/pacs/v1.0.0/apply/item', {
            params: {  id            }
        })

    }
    /**
     * 修改检查申请项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaPacsApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/apply/item
        // httpMethod=put json 
        return await http.putJson<TaPacsApplyItem, HallResult<boolean>>('/pacs/v1.0.0/apply/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询检查申请项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : PacsApplyItemPageParam ) : Promise<HallResult<Page<PacsApplyItemPageVO>>> {
        // baseUrl=/pacs/v1.0.0/apply/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<PacsApplyItemPageVO>>>('/pacs/v1.0.0/apply/item/_paging', {
            params: arg0
        })

    }
    /**
     * 根据状态统计
     * 
     * @param arg0 
     **/
    public static async countByStatus( arg0? : PacsApplyItemPageParam ) : Promise<HallResult<PacsApplyItemCountByStatusDTO[]>> {
        // baseUrl=/pacs/v1.0.0/apply/item/_countByStatus
        // httpMethod=get
        return await http.get<any, HallResult<PacsApplyItemCountByStatusDTO[]>>('/pacs/v1.0.0/apply/item/_countByStatus', {
            params: arg0
        })

    }
    /**
     * 批量审核
     * 
     * @param arg0 
     **/
    public static async batchAudit( arg0? : PacsApplyItemAuditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/apply/item/_batchAudit
        // httpMethod=post json 
        return await http.postJson<PacsApplyItemAuditParam, HallResult<boolean>>('/pacs/v1.0.0/apply/item/_batchAudit', {
            data:  arg0
        })
    }
    /**
     * 查询患者检查项目
     * 
     * @param arg0 
     **/
    public static async pagingPatientPacsItem( arg0? : PatientPacsItemPageParam ) : Promise<HallResult<Page<PatientPacsItemVO>>> {
        // baseUrl=/pacs/v1.0.0/apply/item/_pagingPatientPacsItem
        // httpMethod=get
        return await http.get<any, HallResult<Page<PatientPacsItemVO>>>('/pacs/v1.0.0/apply/item/_pagingPatientPacsItem', {
            params: arg0
        })

    }
    /**
     * 删除检查申请项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/apply/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/pacs/v1.0.0/apply/item', {
            params: {  id            }
        })
    }
    /**
     * 保存检查申请项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaPacsApplyItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/apply/item
        // httpMethod=post json 
        return await http.postJson<TaPacsApplyItem, HallResult<boolean>>('/pacs/v1.0.0/apply/item', {
            data:  arg0
        })
    }
}
/**
 * 检查项目Api
 **/
export class PacsBaseItemApi {
    /**
     * 检查项目详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaPacsBaseItem>> {
        // baseUrl=/pacs/v1.0.0/item
        // httpMethod=get
        return await http.get<any, HallResult<TaPacsBaseItem>>('/pacs/v1.0.0/item', {
            params: {  id            }
        })

    }
    /**
     * 修改检查项目
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaPacsBaseItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/item
        // httpMethod=put json 
        return await http.putJson<TaPacsBaseItem, HallResult<boolean>>('/pacs/v1.0.0/item', {
            data:  arg0
        })
    }
    /**
     * 分页查询检查项目
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : PacsBaseItemPageParam ) : Promise<HallResult<Page<TaPacsBaseItem>>> {
        // baseUrl=/pacs/v1.0.0/item/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaPacsBaseItem>>>('/pacs/v1.0.0/item/_paging', {
            params: arg0
        })

    }
    /**
     * 删除检查项目
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/item
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/pacs/v1.0.0/item', {
            params: {  id            }
        })
    }
    /**
     * 保存检查项目
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaPacsBaseItem ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/item
        // httpMethod=post json 
        return await http.postJson<TaPacsBaseItem, HallResult<boolean>>('/pacs/v1.0.0/item', {
            data:  arg0
        })
    }
}
/**
 * 检查报告Api
 **/
export class PacsReportApi {
    /**
     * 检查报告详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaPacsReport>> {
        // baseUrl=/pacs/v1.0.0/report
        // httpMethod=get
        return await http.get<any, HallResult<TaPacsReport>>('/pacs/v1.0.0/report', {
            params: {  id            }
        })

    }
    /**
     * 保存或修改检查申请项目
     * 
     * @param arg0 
     **/
    public static async saveOrUpdate( arg0? : PacsReportSaveOrUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/report/_saveOrUpdate
        // httpMethod=post json 
        return await http.postJson<PacsReportSaveOrUpdateParam, HallResult<boolean>>('/pacs/v1.0.0/report/_saveOrUpdate', {
            data:  arg0
        })
    }
    /**
     * 修改检查报告
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaPacsReport ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/report
        // httpMethod=put json 
        return await http.putJson<TaPacsReport, HallResult<boolean>>('/pacs/v1.0.0/report', {
            data:  arg0
        })
    }
    /**
     * 分页查询检查报告
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : PacsReportPageParam ) : Promise<HallResult<Page<TaPacsReport>>> {
        // baseUrl=/pacs/v1.0.0/report/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaPacsReport>>>('/pacs/v1.0.0/report/_paging', {
            params: arg0
        })

    }
    /**
     * 查询报告详情(没报告查询报告模板)
     * 
     * @param arg0 
     **/
    public static async findReportOrTemplate( arg0? : PacsReportDetailsParam ) : Promise<HallResult<PacsReportDetailsVO>> {
        // baseUrl=/pacs/v1.0.0/report/_reportOrTemplate
        // httpMethod=get
        return await http.get<any, HallResult<PacsReportDetailsVO>>('/pacs/v1.0.0/report/_reportOrTemplate', {
            params: arg0
        })

    }
    /**
     * 根据申请项目ID获取报告
     * 
     * @param applyItemId  必填 
     **/
    public static async findReportByApplyItemId( applyItemId : string ) : Promise<HallResult<PacsReportDetailsVO>> {
        // baseUrl=/pacs/v1.0.0/report/_findReportByApplyItemId
        // httpMethod=get
        return await http.get<any, HallResult<PacsReportDetailsVO>>('/pacs/v1.0.0/report/_findReportByApplyItemId', {
            params: {  applyItemId            }
        })

    }
    /**
     * 根据dicom文件ID获取dicom浏览器url
     * 
     * @param medicalImageTaskId  必填 
     **/
    public static async loadDicomViewUrl( medicalImageTaskId : string ) : Promise<HallResult<string>> {
        // baseUrl=/pacs/v1.0.0/report/_loadDicomViewUrl
        // httpMethod=get
        return await http.get<any, HallResult<string>>('/pacs/v1.0.0/report/_loadDicomViewUrl', {
            params: {  medicalImageTaskId            }
        })

    }
    /**
     * 删除检查报告
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/report
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/pacs/v1.0.0/report', {
            params: {  id            }
        })
    }
    /**
     * 保存检查报告
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaPacsReport ) : Promise<HallResult<boolean>> {
        // baseUrl=/pacs/v1.0.0/report
        // httpMethod=post json 
        return await http.postJson<TaPacsReport, HallResult<boolean>>('/pacs/v1.0.0/report', {
            data:  arg0
        })
    }
}
/**
 * 互联网医院接口Api
 **/
export class EhosApiProvider {
    /**
     * 测试联通
     * 
     * @param arg0 
     **/
    public static async ping( arg0? : string ) : Promise<HallResult<string>> {
        // baseUrl=/ehos/api/v1.0.0/ping
        // httpMethod=post json 
        return await http.postJson<string, HallResult<string>>('/ehos/api/v1.0.0/ping', {
            data:  arg0
        })
    }
    /**
     * 患者信息查询
     * 
     * @param arg0 
     **/
    public static async patInfo( arg0? : GetPatientDTO ) : Promise<HallResult<GetPatientResultDTO>> {
        // baseUrl=/ehos/api/v1.0.0/his/getPatInfo
        // httpMethod=post json 
        return await http.postJson<GetPatientDTO, HallResult<GetPatientResultDTO>>('/ehos/api/v1.0.0/his/getPatInfo', {
            data:  arg0
        })
    }
    /**
     * 患者报告查询
     * 
     * @param arg0 
     **/
    public static async searchReport( arg0? : PatientReportSearchDTO ) : Promise<HallResult<PatientReportDTO[]>> {
        // baseUrl=/ehos/api/v1.0.0/his/examineReport
        // httpMethod=post json 
        return await http.postJson<PatientReportSearchDTO, HallResult<PatientReportDTO[]>>('/ehos/api/v1.0.0/his/examineReport', {
            data:  arg0
        })
    }
    /**
     * 患者病历查询
     * 
     * @param arg0 
     **/
    public static async sarchMrecords( arg0? : MrecordSearchDTO ) : Promise<HallResult<MrecordItem[]>> {
        // baseUrl=/ehos/api/v1.0.0/his/medicalNote
        // httpMethod=post json 
        return await http.postJson<MrecordSearchDTO, HallResult<MrecordItem[]>>('/ehos/api/v1.0.0/his/medicalNote', {
            data:  arg0
        })
    }
    /**
     * 患者建档
     * 
     * @param arg0 
     **/
    public static async registerPatient( arg0? : RegisterPatientDTO ) : Promise<HallResult<RegisterPatientResultDTO>> {
        // baseUrl=/ehos/api/v1.0.0/his/registerPatient
        // httpMethod=post json 
        return await http.postJson<RegisterPatientDTO, HallResult<RegisterPatientResultDTO>>('/ehos/api/v1.0.0/his/registerPatient', {
            data:  arg0
        })
    }
    /**
     * 患者处方查询
     * 
     * @param arg0 
     **/
    public static async searchRecipes( arg0? : RecipeSearchDTO ) : Promise<HallResult<RecipeDTO[]>> {
        // baseUrl=/ehos/api/v1.0.0/his/treatmentOrder
        // httpMethod=post json 
        return await http.postJson<RecipeSearchDTO, HallResult<RecipeDTO[]>>('/ehos/api/v1.0.0/his/treatmentOrder', {
            data:  arg0
        })
    }
}
/**
 * 互联网医院Api
 **/
export class EhosApi {
    /**
     * 获取互联网医院嵌入地址
     * 
     * @param idcardNo  必填 
     **/
    public static async generateEhosFrameUrl( idcardNo : string ) : Promise<HallResult<string>> {
        // baseUrl=/ehos/v1.0.0/_frameUrl
        // httpMethod=get
        return await http.get<any, HallResult<string>>('/ehos/v1.0.0/_frameUrl', {
            params: {  idcardNo            }
        })

    }
}
/**
 * 动态类Api
 **/
export class DdocStructureClazzApi {
    /**
     * 详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<ClazzVO>> {
        // baseUrl=/ddoc/v1.0.0/structure/clazz
        // httpMethod=get
        return await http.get<any, HallResult<ClazzVO>>('/ddoc/v1.0.0/structure/clazz', {
            params: {  id            }
        })

    }
    /**
     * 增加动态类
     * 
     * @param arg0 
     **/
    public static async add( arg0? : ClazzAddParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/structure/clazz
        // httpMethod=post json 
        return await http.postJson<ClazzAddParam, HallResult<boolean>>('/ddoc/v1.0.0/structure/clazz', {
            data:  arg0
        })
    }
}
/**
 * 单据数据Api
 **/
export class DdocDataApi {
}
/**
 * 单据业务关联Api
 **/
export class DdocBusiApi {
    /**
     * 单据业务关联详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDdocBusi>> {
        // baseUrl=/ddoc/v1.0.0/busi
        // httpMethod=get
        return await http.get<any, HallResult<TaDdocBusi>>('/ddoc/v1.0.0/busi', {
            params: {  id            }
        })

    }
    /**
     * 修改单据业务关联
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDdocBusi ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/busi
        // httpMethod=put json 
        return await http.putJson<TaDdocBusi, HallResult<boolean>>('/ddoc/v1.0.0/busi', {
            data:  arg0
        })
    }
    /**
     * 分页查询单据业务关联
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DdocBusiPageParam ) : Promise<HallResult<Page<TaDdocBusi>>> {
        // baseUrl=/ddoc/v1.0.0/busi/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDdocBusi>>>('/ddoc/v1.0.0/busi/_paging', {
            params: arg0
        })

    }
    /**
     * 删除单据业务关联
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/busi
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/ddoc/v1.0.0/busi', {
            params: {  id            }
        })
    }
    /**
     * 保存单据业务关联
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDdocBusi ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/busi
        // httpMethod=post json 
        return await http.postJson<TaDdocBusi, HallResult<boolean>>('/ddoc/v1.0.0/busi', {
            data:  arg0
        })
    }
}
/**
 * 动态单据模板Api
 **/
export class DdocTemplateApi {
    /**
     * 分页查询动态单据模板
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DdocTemplatePageParam ) : Promise<HallResult<Page<TaDdocTemplate>>> {
        // baseUrl=/ddoc/v1.0.0/template/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDdocTemplate>>>('/ddoc/v1.0.0/template/_paging', {
            params: arg0
        })

    }
    /**
     * 保存动态单据模板
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDdocTemplate ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/template
        // httpMethod=post json 
        return await http.postJson<TaDdocTemplate, HallResult<boolean>>('/ddoc/v1.0.0/template', {
            data:  arg0
        })
    }
}
/**
 * 动态单据字段Api
 **/
export class DdocTemplateFieldApi {
    /**
     * 动态单据字段详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDdocTemplateField>> {
        // baseUrl=/ddoc/v1.0.0/field
        // httpMethod=get
        return await http.get<any, HallResult<TaDdocTemplateField>>('/ddoc/v1.0.0/field', {
            params: {  id            }
        })

    }
    /**
     * 修改动态单据字段
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDdocTemplateField ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/field
        // httpMethod=put json 
        return await http.putJson<TaDdocTemplateField, HallResult<boolean>>('/ddoc/v1.0.0/field', {
            data:  arg0
        })
    }
    /**
     * 分页查询动态单据字段
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DdocTemplateFieldPageParam ) : Promise<HallResult<Page<TaDdocTemplateField>>> {
        // baseUrl=/ddoc/v1.0.0/field/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDdocTemplateField>>>('/ddoc/v1.0.0/field/_paging', {
            params: arg0
        })

    }
    /**
     * 删除动态单据字段
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/field
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/ddoc/v1.0.0/field', {
            params: {  id            }
        })
    }
    /**
     * 保存动态单据字段
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDdocTemplateField ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/field
        // httpMethod=post json 
        return await http.postJson<TaDdocTemplateField, HallResult<boolean>>('/ddoc/v1.0.0/field', {
            data:  arg0
        })
    }
}
/**
 * 单据记录Api
 **/
export class DdocRecordApi {
    /**
     * 单据记录详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDdocRecord>> {
        // baseUrl=/ddoc/v1.0.0/record
        // httpMethod=get
        return await http.get<any, HallResult<TaDdocRecord>>('/ddoc/v1.0.0/record', {
            params: {  id            }
        })

    }
    /**
     * 修改单据记录
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDdocRecord ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/record
        // httpMethod=put json 
        return await http.putJson<TaDdocRecord, HallResult<boolean>>('/ddoc/v1.0.0/record', {
            data:  arg0
        })
    }
    /**
     * 分页查询单据记录
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DdocRecordPageParam ) : Promise<HallResult<Page<TaDdocRecord>>> {
        // baseUrl=/ddoc/v1.0.0/record/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDdocRecord>>>('/ddoc/v1.0.0/record/_paging', {
            params: arg0
        })

    }
    /**
     * 删除单据记录
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/record
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/ddoc/v1.0.0/record', {
            params: {  id            }
        })
    }
    /**
     * 保存单据记录
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDdocRecord ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/record
        // httpMethod=post json 
        return await http.postJson<TaDdocRecord, HallResult<boolean>>('/ddoc/v1.0.0/record', {
            data:  arg0
        })
    }
}
/**
 * 单据记录字段Api
 **/
export class DdocRecordFieldApi {
    /**
     * 单据记录字段详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<TaDdocRecordField>> {
        // baseUrl=/ddoc/v1.0.0/record/field
        // httpMethod=get
        return await http.get<any, HallResult<TaDdocRecordField>>('/ddoc/v1.0.0/record/field', {
            params: {  id            }
        })

    }
    /**
     * 修改单据记录字段
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaDdocRecordField ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/record/field
        // httpMethod=put json 
        return await http.putJson<TaDdocRecordField, HallResult<boolean>>('/ddoc/v1.0.0/record/field', {
            data:  arg0
        })
    }
    /**
     * 分页查询单据记录字段
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DdocRecordFieldPageParam ) : Promise<HallResult<Page<TaDdocRecordField>>> {
        // baseUrl=/ddoc/v1.0.0/record/field/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<TaDdocRecordField>>>('/ddoc/v1.0.0/record/field/_paging', {
            params: arg0
        })

    }
    /**
     * 删除单据记录字段
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/record/field
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/ddoc/v1.0.0/record/field', {
            params: {  id            }
        })
    }
    /**
     * 保存单据记录字段
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaDdocRecordField ) : Promise<HallResult<boolean>> {
        // baseUrl=/ddoc/v1.0.0/record/field
        // httpMethod=post json 
        return await http.postJson<TaDdocRecordField, HallResult<boolean>>('/ddoc/v1.0.0/record/field', {
            data:  arg0
        })
    }
}
/**
 * 库房对码Api
 **/
export class WarehouseMatchingApi {
    /**
     * 对码分页接口
     * 
     * @param arg0 
     **/
    public static async matchPaging( arg0? : WarehouseMatchingParam ) : Promise<HallResult<Page<WarehouseMatchingVO>>> {
        // baseUrl=/warehouse/v1.0.0/matching/_matchPaging
        // httpMethod=get
        return await http.get<any, HallResult<Page<WarehouseMatchingVO>>>('/warehouse/v1.0.0/matching/_matchPaging', {
            params: arg0
        })

    }
}
/**
 * 药房配置Api
 **/
export class BaseDispensaryApi {
    /**
     * 药房配置详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseDispensaryVO>> {
        // baseUrl=/warehouse/v1.0.0/dispensary
        // httpMethod=get
        return await http.get<any, HallResult<BaseDispensaryVO>>('/warehouse/v1.0.0/dispensary', {
            params: {  id            }
        })

    }
    /**
     * 批量删除药房配置
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : any ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/dispensary/_batchDelete
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/dispensary/_batchDelete', {
            params: {  ids            }
        })
    }
    /**
     * 修改药房配置
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : BaseDispensaryUpdateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/dispensary
        // httpMethod=put json 
        return await http.putJson<BaseDispensaryUpdateParam, HallResult<boolean>>('/warehouse/v1.0.0/dispensary', {
            data:  arg0
        })
    }
    /**
     * 分页查询药房配置
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseDispensaryPageParam ) : Promise<HallResult<Page<BaseDispensaryVO>>> {
        // baseUrl=/warehouse/v1.0.0/dispensary/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseDispensaryVO>>>('/warehouse/v1.0.0/dispensary/_paging', {
            params: arg0
        })

    }
    /**
     * 删除药房配置
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/dispensary
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/dispensary', {
            params: {  id            }
        })
    }
    /**
     * 查询所有药房配置
     * 
     * @param arg0 
     **/
    public static async list( arg0? : BaseDispensaryPageParam ) : Promise<HallResult<BaseDispensaryVO[]>> {
        // baseUrl=/warehouse/v1.0.0/dispensary/_list
        // httpMethod=get
        return await http.get<any, HallResult<BaseDispensaryVO[]>>('/warehouse/v1.0.0/dispensary/_list', {
            params: arg0
        })

    }
    /**
     * 保存药房配置
     * 
     * @param arg0 
     **/
    public static async save( arg0? : BaseDispensaryCreateParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/dispensary
        // httpMethod=post json 
        return await http.postJson<BaseDispensaryCreateParam, HallResult<boolean>>('/warehouse/v1.0.0/dispensary', {
            data:  arg0
        })
    }
}
/**
 * 药品过敏源Api
 **/
export class BaseDrugAllergySourceApi {
    /**
     * 批量删除
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : any ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/drug/allergy/_batchDelete
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/drug/allergy/_batchDelete', {
            params: {  ids            }
        })
    }
    /**
     * 修改
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : DrugAllergySourceEditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/drug/allergy
        // httpMethod=put json 
        return await http.putJson<DrugAllergySourceEditParam, HallResult<boolean>>('/warehouse/v1.0.0/drug/allergy', {
            data:  arg0
        })
    }
    /**
     * 根据过敏源类型分页获取药品
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : DrugAllergySourceSearchPageParam ) : Promise<HallResult<Page<DrugAllergySourceSearchResultVo>>> {
        // baseUrl=/warehouse/v1.0.0/drug/allergy/_pagig
        // httpMethod=get
        return await http.get<any, HallResult<Page<DrugAllergySourceSearchResultVo>>>('/warehouse/v1.0.0/drug/allergy/_pagig', {
            params: arg0
        })

    }
    /**
     * 根据过敏源类型分页获取未新增的药品
     * 
     * @param arg0 
     **/
    public static async paginDrug( arg0? : DrugAllergySourceSearchPageParam ) : Promise<HallResult<Page<DrugForAllergySourceSearchResutlVO>>> {
        // baseUrl=/warehouse/v1.0.0/drug/allergy/_pagigDrug
        // httpMethod=get
        return await http.get<any, HallResult<Page<DrugForAllergySourceSearchResutlVO>>>('/warehouse/v1.0.0/drug/allergy/_pagigDrug', {
            params: arg0
        })

    }
    /**
     * 保存
     * 
     * @param arg0 
     **/
    public static async save( arg0? : DrugAllergySourceSaveParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/drug/allergy
        // httpMethod=post json 
        return await http.postJson<DrugAllergySourceSaveParam, HallResult<boolean>>('/warehouse/v1.0.0/drug/allergy', {
            data:  arg0
        })
    }
}
/**
 * 药品Api
 **/
export class BaseDrugApi {
    /**
     * 药品详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseDrugVO>> {
        // baseUrl=/warehouse/v1.0.0/drug
        // httpMethod=get
        return await http.get<any, HallResult<BaseDrugVO>>('/warehouse/v1.0.0/drug', {
            params: {  id            }
        })

    }
    /**
     * 批量导入
     * 
     * @param arg0 
     **/
    public static async batchImport( arg0? : BaseDrugImportParam ) : Promise<HallResult<ExcelImportResultVO>> {
        // baseUrl=/warehouse/v1.0.0/drug/_batchImport
        // httpMethod=post json 
        return await http.postJson<BaseDrugImportParam, HallResult<ExcelImportResultVO>>('/warehouse/v1.0.0/drug/_batchImport', {
            data:  arg0
        })
    }
    /**
     * 修改药品
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseDrug ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/drug
        // httpMethod=put json 
        return await http.putJson<TaBaseDrug, HallResult<boolean>>('/warehouse/v1.0.0/drug', {
            data:  arg0
        })
    }
    /**
     * 分页查询药品
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseDrugPageParam ) : Promise<HallResult<Page<BaseDrugVO>>> {
        // baseUrl=/warehouse/v1.0.0/drug/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseDrugVO>>>('/warehouse/v1.0.0/drug/_paging', {
            params: arg0
        })

    }
    /**
     * 
     * 
     **/
    public static async updateWuBiPinYin() : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/drug/_updateWuBiPinYin
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/warehouse/v1.0.0/drug/_updateWuBiPinYin', {
            params: {             }
        })
    }
    /**
     * 删除药品
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/drug
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/drug', {
            params: {  id            }
        })
    }
    /**
     * 保存药品
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseDrug ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/drug
        // httpMethod=post json 
        return await http.postJson<TaBaseDrug, HallResult<boolean>>('/warehouse/v1.0.0/drug', {
            data:  arg0
        })
    }
}
/**
 * 窗口配置Api
 **/
export class BaseWindowApi {
    /**
     * 窗口配置详情
     * 
     * @param id  必填 
     **/
    public static async detail( id : string ) : Promise<HallResult<BaseWindowVO>> {
        // baseUrl=/warehouse/v1.0.0/window
        // httpMethod=get
        return await http.get<any, HallResult<BaseWindowVO>>('/warehouse/v1.0.0/window', {
            params: {  id            }
        })

    }
    /**
     * 批量删除窗口配置
     * 
     * @param ids  必填 
     **/
    public static async batchDelete( ids : any ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/window/_batchDelete
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/window/_batchDelete', {
            params: {  ids            }
        })
    }
    /**
     * 修改窗口配置
     * 
     * @param arg0 
     **/
    public static async edit( arg0? : TaBaseWindow ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/window
        // httpMethod=put json 
        return await http.putJson<TaBaseWindow, HallResult<boolean>>('/warehouse/v1.0.0/window', {
            data:  arg0
        })
    }
    /**
     * 分页查询窗口配置
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : BaseWindowPageParam ) : Promise<HallResult<Page<BaseWindowVO>>> {
        // baseUrl=/warehouse/v1.0.0/window/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<BaseWindowVO>>>('/warehouse/v1.0.0/window/_paging', {
            params: arg0
        })

    }
    /**
     * 删除窗口配置
     * 
     * @param id  必填 
     **/
    public static async delete( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/window
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/window', {
            params: {  id            }
        })
    }
    /**
     * 保存窗口配置
     * 
     * @param arg0 
     **/
    public static async save( arg0? : TaBaseWindow ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/window
        // httpMethod=post json 
        return await http.postJson<TaBaseWindow, HallResult<boolean>>('/warehouse/v1.0.0/window', {
            data:  arg0
        })
    }
    /**
     * 关闭窗口
     * 
     * @param id  必填 
     **/
    public static async close( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/window/_close
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/warehouse/v1.0.0/window/_close', {
            params: {  id            }
        })
    }
    /**
     * 打开窗口
     * 
     * @param id  必填 
     **/
    public static async open( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/window/_open
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/warehouse/v1.0.0/window/_open', {
            params: {  id            }
        })
    }
}
/**
 * Event测试Api
 **/
export class EventTestApi {
    /**
     * 发布实时Event
     * 
     **/
    public static async publishRealTime() : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/event/_publishRealTime
        // httpMethod=post
        return await http.post<any, HallResult<boolean>>('/warehouse/v1.0.0/event/_publishRealTime', {
            params: {             }
    })
    }
}
/**
 * 库存查询Api
 **/
export class WarehouseSearchApi {
    /**
     * 仓库日志查询
     * 
     * @param arg0 
     **/
    public static async searchLog( arg0? : WarehouseLogSearchPageParam ) : Promise<HallResult<Page<WarehouseLogSearchResultVO>>> {
        // baseUrl=/warehouse/v1.0.0/search/_logs
        // httpMethod=get
        return await http.get<any, HallResult<Page<WarehouseLogSearchResultVO>>>('/warehouse/v1.0.0/search/_logs', {
            params: arg0
        })

    }
    /**
     * 库存批次查询
     * 
     * @param arg0 
     **/
    public static async searchBatch( arg0? : DrugBatchSearchPageParam ) : Promise<HallResult<Page<DrugBatchSearchResultVO>>> {
        // baseUrl=/warehouse/v1.0.0/search/_batchs
        // httpMethod=get
        return await http.get<any, HallResult<Page<DrugBatchSearchResultVO>>>('/warehouse/v1.0.0/search/_batchs', {
            params: arg0
        })

    }
    /**
     * 测试最大值
     * 
     **/
    public static async testMaxId() : Promise<HallResult<string>> {
        // baseUrl=/warehouse/v1.0.0/search/_testMaxId
        // httpMethod=get
        return await http.get<any, HallResult<string>>('/warehouse/v1.0.0/search/_testMaxId', {
            params: {             }
        })

    }
    /**
     * 药品库存查询
     * 
     * @param arg0 
     **/
    public static async search( arg0? : DrugSearchPageParam ) : Promise<HallResult<Page<DrugSearchResultVO>>> {
        // baseUrl=/warehouse/v1.0.0/search/_drugs
        // httpMethod=get
        return await http.get<any, HallResult<Page<DrugSearchResultVO>>>('/warehouse/v1.0.0/search/_drugs', {
            params: arg0
        })

    }
}
/**
 * 入库单Api
 **/
export class WarehouseInApi {
    /**
     * 审核通过
     * 
     * @param arg0 
     **/
    public static async audit( arg0? : WarehouseInOperationParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/in/_audit
        // httpMethod=put json 
        return await http.putJson<WarehouseInOperationParam, HallResult<boolean>>('/warehouse/v1.0.0/in/_audit', {
            data:  arg0
        })
    }
    /**
     * 取消审核
     * 
     * @param arg0 
     **/
    public static async cancelAudit( arg0? : WarehouseInOperationParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/in/_cancelAudit
        // httpMethod=put json 
        return await http.putJson<WarehouseInOperationParam, HallResult<boolean>>('/warehouse/v1.0.0/in/_cancelAudit', {
            data:  arg0
        })
    }
    /**
     * 入账
     * 
     * @param arg0 
     **/
    public static async sureWarehouseIn( arg0? : WarehouseInOperationParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/in/_sure
        // httpMethod=put json 
        return await http.putJson<WarehouseInOperationParam, HallResult<boolean>>('/warehouse/v1.0.0/in/_sure', {
            data:  arg0
        })
    }
    /**
     * 获取供应入库单详情
     * 
     * @param id  必填 
     **/
    public static async detailSupplyIn( id : string ) : Promise<HallResult<SupplyInDetailVO>> {
        // baseUrl=/warehouse/v1.0.0/in/_detailSupplyIn
        // httpMethod=get
        return await http.get<any, HallResult<SupplyInDetailVO>>('/warehouse/v1.0.0/in/_detailSupplyIn', {
            params: {  id            }
        })

    }
    /**
     * 修改供应入库单
     * 
     * @param arg0 
     **/
    public static async editSupplyIn( arg0? : SupplyInEditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/in/_editSupplyIn
        // httpMethod=post json 
        return await http.postJson<SupplyInEditParam, HallResult<boolean>>('/warehouse/v1.0.0/in/_editSupplyIn', {
            data:  arg0
        })
    }
    /**
     * 供应入库制单
     * 
     * @param arg0 
     **/
    public static async makeSupplyIn( arg0? : SupplyInSubmitParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/in/_makeSupplyIn
        // httpMethod=post json 
        return await http.postJson<SupplyInSubmitParam, HallResult<boolean>>('/warehouse/v1.0.0/in/_makeSupplyIn', {
            data:  arg0
        })
    }
    /**
     * 分页查询供应入库单
     * 
     * @param arg0 
     **/
    public static async pagingSupplyIn( arg0? : WarehouseInSearchPageParam ) : Promise<HallResult<Page<SupplyInSearchVO>>> {
        // baseUrl=/warehouse/v1.0.0/in/_pagingSupplyIn
        // httpMethod=get
        return await http.get<any, HallResult<Page<SupplyInSearchVO>>>('/warehouse/v1.0.0/in/_pagingSupplyIn', {
            params: arg0
        })

    }
    /**
     * 删除入库单
     * 
     * @param id  必填 
     **/
    public static async deleteWarehouseIn( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/in
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/in', {
            params: {  id            }
        })
    }
}
/**
 * 入库药品Api
 **/
export class WarehouseInDrugApi {
    /**
     * 分页查询入库药品
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : WarehouseInDrugPageParam ) : Promise<HallResult<Page<WarehouseInDrugVO>>> {
        // baseUrl=/warehouse/v1.0.0/in/drug/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<WarehouseInDrugVO>>>('/warehouse/v1.0.0/in/drug/_paging', {
            params: arg0
        })

    }
}
/**
 * 出库单Api
 **/
export class WarehouseOutApi {
    /**
     * 审核通过
     * 
     * @param arg0 
     **/
    public static async audit( arg0? : WarehouseOutOperationParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/out/_audit
        // httpMethod=put json 
        return await http.putJson<WarehouseOutOperationParam, HallResult<boolean>>('/warehouse/v1.0.0/out/_audit', {
            data:  arg0
        })
    }
    /**
     * 分页查询出库药品
     * 
     * @param arg0 
     **/
    public static async paginOutDrug( arg0? : WarehouseOutDrugPageParam ) : Promise<HallResult<Page<WarehouseOutDrugVO>>> {
        // baseUrl=/warehouse/v1.0.0/out/_paginOutDrug
        // httpMethod=get
        return await http.get<any, HallResult<Page<WarehouseOutDrugVO>>>('/warehouse/v1.0.0/out/_paginOutDrug', {
            params: arg0
        })

    }
    /**
     * 修改普通出库单
     * 
     * @param arg0 
     **/
    public static async editCommonOut( arg0? : WarehouseCommonOutEditParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/out/_editCommonOut
        // httpMethod=post json 
        return await http.postJson<WarehouseCommonOutEditParam, HallResult<boolean>>('/warehouse/v1.0.0/out/_editCommonOut', {
            data:  arg0
        })
    }
    /**
     * 普通出库制单
     * 
     * @param arg0 
     **/
    public static async makeCommonOut( arg0? : WarehouseCommonOutMakeParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/out/_makeCommonOut
        // httpMethod=post json 
        return await http.postJson<WarehouseCommonOutMakeParam, HallResult<boolean>>('/warehouse/v1.0.0/out/_makeCommonOut', {
            data:  arg0
        })
    }
    /**
     * 普通出库详情
     * 
     * @param id 出库单id 必填 
     **/
    public static async commonOutDetail( id : string ) : Promise<HallResult<WarehouseOutDetailVO>> {
        // baseUrl=/warehouse/v1.0.0/out/_commonOutDetail
        // httpMethod=get
        return await http.get<any, HallResult<WarehouseOutDetailVO>>('/warehouse/v1.0.0/out/_commonOutDetail', {
            params: {  id            }
        })

    }
    /**
     * 删除入库单。只有新制、审核通过状态才允许删除
     * 
     * @param id 出库单id 必填 
     **/
    public static async deleteCommonOut( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/out/_deleteCommonOut
        // httpMethod=delete
        return await http.delete<any, HallResult<boolean>>('/warehouse/v1.0.0/out/_deleteCommonOut', {
            params: {  id            }
        })
    }
    /**
     * 分页查询普通出库单
     * 
     * @param arg0 
     **/
    public static async pagingCommonOut( arg0? : WarehouseCommonOutSearchParam ) : Promise<HallResult<Page<WarehouseCommonOutSearchResultVO>>> {
        // baseUrl=/warehouse/v1.0.0/out/_pagingCommonOut
        // httpMethod=get
        return await http.get<any, HallResult<Page<WarehouseCommonOutSearchResultVO>>>('/warehouse/v1.0.0/out/_pagingCommonOut', {
            params: arg0
        })

    }
    /**
     * 入账
     * 
     * @param arg0 
     **/
    public static async sureWarehouseOut( arg0? : WarehouseOutOperationParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/out/_sure
        // httpMethod=put json 
        return await http.putJson<WarehouseOutOperationParam, HallResult<boolean>>('/warehouse/v1.0.0/out/_sure', {
            data:  arg0
        })
    }
    /**
     * 加载所有目标科室
     * 
     **/
    public static async allTargetOrgs() : Promise<HallResult<TargetOrgTreeNodeVO[]>> {
        // baseUrl=/warehouse/v1.0.0/out/_allTargetOrgs
        // httpMethod=get
        return await http.get<any, HallResult<TargetOrgTreeNodeVO[]>>('/warehouse/v1.0.0/out/_allTargetOrgs', {
            params: {             }
        })

    }
    /**
     * 取消审核
     * 
     * @param arg0 
     **/
    public static async cancelAudit( arg0? : WarehouseOutOperationParam ) : Promise<HallResult<boolean>> {
        // baseUrl=/warehouse/v1.0.0/out/_cancelAudit
        // httpMethod=put json 
        return await http.putJson<WarehouseOutOperationParam, HallResult<boolean>>('/warehouse/v1.0.0/out/_cancelAudit', {
            data:  arg0
        })
    }
}
/**
 * 报表：费用Api
 **/
export class FeeReportV2Api {
    /**
     * 患者费用分类报表
     * 
     * @param arg0 
     **/
    public static async patientFeeTypeReport( arg0? : PatientFeeTypePageParam ) : Promise<HallResult<PatientFeeTypeReportResult>> {
        // baseUrl=/report/v1.0.0/fee/_patientFeeTypeReport
        // httpMethod=get
        return await http.get<any, HallResult<PatientFeeTypeReportResult>>('/report/v1.0.0/fee/_patientFeeTypeReport', {
            params: arg0
        })

    }
    /**
     * 科室营收明细日报表
     * 
     * @param day 查询日期 必填 
     **/
    public static async revenueDeptDayDetailReport( day : string ) : Promise<HallResult<RevenueDeptDayDetailVO[]>> {
        // baseUrl=/report/v1.0.0/fee/_revenueDeptDayDetailReport
        // httpMethod=get
        return await http.get<any, HallResult<RevenueDeptDayDetailVO[]>>('/report/v1.0.0/fee/_revenueDeptDayDetailReport', {
            params: {  day            }
        })

    }
    /**
     * 医生月收入汇总表
     * 
     * @param startDate  必填 
     **/
    public static async doctorIncomeMonthReport( startDate : string ) : Promise<HallResult<DoctorIncomeMonthVO[]>> {
        // baseUrl=/report/v1.0.0/fee/_doctorIncomeMonthReport
        // httpMethod=get
        return await http.get<any, HallResult<DoctorIncomeMonthVO[]>>('/report/v1.0.0/fee/_doctorIncomeMonthReport', {
            params: {  startDate            }
        })

    }
    /**
     * 医生收入周报表
     * 
     * @param arg0 
     **/
    public static async doctorIncomeWeekReport( arg0? : DoctorIncomeWeekPageParam ) : Promise<HallResult<Page<DoctorIncomeWeekVO>>> {
        // baseUrl=/report/v1.0.0/fee/_doctorIncomeWeekReport
        // httpMethod=get
        return await http.get<any, HallResult<Page<DoctorIncomeWeekVO>>>('/report/v1.0.0/fee/_doctorIncomeWeekReport', {
            params: arg0
        })

    }
    /**
     * 季度营业额与就诊人次统计表
     * 
     * @param startDate  必填 
     * @param endDate  必填 
     **/
    public static async quarterIncomeAndRegisterReport( startDate : string , endDate : string ) : Promise<HallResult<QuarterIncomeAndRegisterVO[]>> {
        // baseUrl=/report/v1.0.0/fee/_quarterIncomeAndRegisterReport
        // httpMethod=get
        return await http.get<any, HallResult<QuarterIncomeAndRegisterVO[]>>('/report/v1.0.0/fee/_quarterIncomeAndRegisterReport', {
            params: {  startDate, endDate            }
        })

    }
    /**
     * 门诊收费日结
     * 
     * @param startTime  必填 
     * @param endTime  必填 
     * @param collctorId  必填 
     **/
    public static async hopsChargeDaily( startTime : string , endTime : string , collctorId : string ) : Promise<HallResult<HopsChargeDailyResultVO>> {
        // baseUrl=/report/v1.0.0/fee/hopsChargeDaily
        // httpMethod=get
        return await http.get<any, HallResult<HopsChargeDailyResultVO>>('/report/v1.0.0/fee/hopsChargeDaily', {
            params: {  startTime, endTime, collctorId            }
        })

    }
    /**
     * 门诊挂号日结-根据时间获取收费员信息
     * 
     * @param startTime  必填 
     * @param endTime  必填 
     **/
    public static async findRegisterTollCollctors( startTime : string , endTime : string ) : Promise<HallResult<HopsTollCollectorVO[]>> {
        // baseUrl=/report/v1.0.0/fee/hopsRegisterDaily/_findTollCollctors
        // httpMethod=get
        return await http.get<any, HallResult<HopsTollCollectorVO[]>>('/report/v1.0.0/fee/hopsRegisterDaily/_findTollCollctors', {
            params: {  startTime, endTime            }
        })

    }
    /**
     * 门诊挂号日结
     * 
     * @param startTime  必填 
     * @param endTime  必填 
     * @param collctorId  必填 
     **/
    public static async hopsRegisterDaily( startTime : string , endTime : string , collctorId : string ) : Promise<HallResult<HopsChargeDailyResultVO>> {
        // baseUrl=/report/v1.0.0/fee/hopsRegisterDaily
        // httpMethod=get
        return await http.get<any, HallResult<HopsChargeDailyResultVO>>('/report/v1.0.0/fee/hopsRegisterDaily', {
            params: {  startTime, endTime, collctorId            }
        })

    }
    /**
     * 门诊收费日结-根据时间获取收费员信息
     * 
     * @param startTime  必填 
     * @param endTime  必填 
     **/
    public static async findTollCollctors( startTime : string , endTime : string ) : Promise<HallResult<HopsTollCollectorVO[]>> {
        // baseUrl=/report/v1.0.0/fee/hopsChargeDaily/_findTollCollctors
        // httpMethod=get
        return await http.get<any, HallResult<HopsTollCollectorVO[]>>('/report/v1.0.0/fee/hopsChargeDaily/_findTollCollctors', {
            params: {  startTime, endTime            }
        })

    }
    /**
     * 营收分析表-数据
     * 
     * @param arg0 
     **/
    public static async revenueMomReport( arg0? : RevenueMoMCondition ) : Promise<HallResult<RevenueMoMItemVO[]>> {
        // baseUrl=/report/v1.0.0/fee/_revenueMomReport
        // httpMethod=get
        return await http.get<any, HallResult<RevenueMoMItemVO[]>>('/report/v1.0.0/fee/_revenueMomReport', {
            params: arg0
        })

    }
    /**
     * 营业收入统计月报表
     * 
     * @param month 查询月份，格式：yyyy-MM-01 必填 
     **/
    public static async incomeFeeMonthReport( month : string ) : Promise<HallResult<IncomeFeeMonthItemVO[]>> {
        // baseUrl=/report/v1.0.0/fee/_incomeFeeMonthReport
        // httpMethod=get
        return await http.get<any, HallResult<IncomeFeeMonthItemVO[]>>('/report/v1.0.0/fee/_incomeFeeMonthReport', {
            params: {  month            }
        })

    }
}
/**
 * sse消息推送Api
 **/
export class MessageSseApi {
    /**
     * 发送消息
     * 
     * @param arg0 
     **/
    public static async send( arg0? : MessageSendPersonalParam ) : Promise<any> {
        // baseUrl=/message/v1.0.0/sse/_send
        // httpMethod=post json 
        return await http.postJson<MessageSendPersonalParam, any>('/message/v1.0.0/sse/_send', {
            data:  arg0
        })
    }
    /**
     * 发送全局消息
     * 
     * @param arg0 
     **/
    public static async sendGlobal( arg0? : MessageSendGlobalParam ) : Promise<any> {
        // baseUrl=/message/v1.0.0/sse/_sendGroup
        // httpMethod=post json 
        return await http.postJson<MessageSendGlobalParam, any>('/message/v1.0.0/sse/_sendGroup', {
            data:  arg0
        })
    }
    /**
     * 创建连接
     * 
     * @param userId  必填 
     **/
    public static async createConnect( userId : string ) : Promise<any> {
        // baseUrl=/message/v1.0.0/sse/_createConnect
        // httpMethod=get
        return await http.get<any, any>('/message/v1.0.0/sse/_createConnect', {
            params: {  userId            }
        })

    }
    /**
     * 关闭连接
     * 
     * @param userId  必填 
     * @param clientId  必填 
     **/
    public static async closeConnect( userId : string , clientId : string ) : Promise<any> {
        // baseUrl=/message/v1.0.0/sse/_closeConnect
        // httpMethod=get
        return await http.get<any, any>('/message/v1.0.0/sse/_closeConnect', {
            params: {  userId, clientId            }
        })

    }
    /**
     * 获取当前连接
     * 
     * @param userId  必填 
     **/
    public static async getConnect( userId : string ) : Promise<HallResult<string[]>> {
        // baseUrl=/message/v1.0.0/sse/_getConnect
        // httpMethod=get
        return await http.get<any, HallResult<string[]>>('/message/v1.0.0/sse/_getConnect', {
            params: {  userId            }
        })

    }
}
/**
 * 消息Api
 **/
export class MessageApi {
    /**
     * 消息分页接口
     * 
     * @param arg0 
     **/
    public static async paging( arg0? : MessageUserPageParam ) : Promise<HallResult<Page<MessageVO>>> {
        // baseUrl=/message/v1.0.0/_paging
        // httpMethod=get
        return await http.get<any, HallResult<Page<MessageVO>>>('/message/v1.0.0/_paging', {
            params: arg0
        })

    }
    /**
     * 阅读消息
     * 
     * @param id  必填 
     **/
    public static async read( id : string ) : Promise<HallResult<boolean>> {
        // baseUrl=/message/v1.0.0/_read
        // httpMethod=put
        return await http.put<any, HallResult<boolean>>('/message/v1.0.0/_read', {
            params: {  id            }
        })
    }
}
/**
 * Typescript代码Api
 **/
export class TsCodeApi {
}
/**
 * Api
 **/
export class GlobalFilterExceptionHandler {
    /**
     * filter 全局异常处理
     * 
     * @param arg0 
     **/
    public static async throwErr( arg0? : any ) : Promise<any> {
        // baseUrl=/filter/err
        // httpMethod=get
        return await http.get<any, any>('/filter/err', {
            params: arg0
        })

    }
}


